(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6577"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6577"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5kZqT", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $3e2e794bcf86f27e$export$ffb0004e005737fa; }, function (v) { return $3e2e794bcf86f27e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $3e2e794bcf86f27e$export$34b9dba7ce09269b; }, function (v) { return $3e2e794bcf86f27e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $3e2e794bcf86f27e$export$25062201e9e25d76; }, function (v) { return $3e2e794bcf86f27e$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3e2e794bcf86f27e$export$ffb0004e005737fa;
var $3e2e794bcf86f27e$export$34b9dba7ce09269b;
var $3e2e794bcf86f27e$export$25062201e9e25d76;
"use strict";
parcelRequire("hpDe0");

var $a2gHv = parcelRequire("a2gHv");
var $3e2e794bcf86f27e$var$g = 60103;
$3e2e794bcf86f27e$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $3e2e794bcf86f27e$var$h = Symbol.for;
    $3e2e794bcf86f27e$var$g = $3e2e794bcf86f27e$var$h("react.element");
    $3e2e794bcf86f27e$export$ffb0004e005737fa = $3e2e794bcf86f27e$var$h("react.fragment");
}
var $3e2e794bcf86f27e$var$m = $a2gHv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $3e2e794bcf86f27e$var$n = Object.prototype.hasOwnProperty, $3e2e794bcf86f27e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $3e2e794bcf86f27e$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$3e2e794bcf86f27e$var$n.call(a, b) && !$3e2e794bcf86f27e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $3e2e794bcf86f27e$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $3e2e794bcf86f27e$var$m.current
    };
}
$3e2e794bcf86f27e$export$34b9dba7ce09269b = $3e2e794bcf86f27e$var$q;
$3e2e794bcf86f27e$export$25062201e9e25d76 = $3e2e794bcf86f27e$var$q;

});
parcelRegister("hpDe0", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $cad332bd109e2adb$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $cad332bd109e2adb$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $cad332bd109e2adb$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $cad332bd109e2adb$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $cad332bd109e2adb$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $cad332bd109e2adb$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $cad332bd109e2adb$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($cad332bd109e2adb$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($cad332bd109e2adb$var$getOwnPropertySymbols) {
            symbols = $cad332bd109e2adb$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($cad332bd109e2adb$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("a2gHv", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4isOs"));

});
parcelRegister("4isOs", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $320f3178a2e7ed8c$export$ffb0004e005737fa; }, function (v) { return $320f3178a2e7ed8c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $320f3178a2e7ed8c$export$5f8d39834fd61797; }, function (v) { return $320f3178a2e7ed8c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $320f3178a2e7ed8c$export$e2c29f18771995cb; }, function (v) { return $320f3178a2e7ed8c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $320f3178a2e7ed8c$export$74bf444e3cd11ea5; }, function (v) { return $320f3178a2e7ed8c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $320f3178a2e7ed8c$export$dca3b0875bd9a954; }, function (v) { return $320f3178a2e7ed8c$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $320f3178a2e7ed8c$export$16fa2f45be04daa8; }, function (v) { return $320f3178a2e7ed8c$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $320f3178a2e7ed8c$export$221d75b3f55bb0bd; }, function (v) { return $320f3178a2e7ed8c$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $320f3178a2e7ed8c$export$ae55be85d98224ed; }, function (v) { return $320f3178a2e7ed8c$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $320f3178a2e7ed8c$export$e530037191fcd5d7; }, function (v) { return $320f3178a2e7ed8c$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $320f3178a2e7ed8c$export$fd42f52fd3ae1109; }, function (v) { return $320f3178a2e7ed8c$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $320f3178a2e7ed8c$export$c8a8987d4410bf2d; }, function (v) { return $320f3178a2e7ed8c$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $320f3178a2e7ed8c$export$d38cd72104c1f0e9; }, function (v) { return $320f3178a2e7ed8c$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $320f3178a2e7ed8c$export$7d1e3a5e95ceca43; }, function (v) { return $320f3178a2e7ed8c$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $320f3178a2e7ed8c$export$257a8862b851cb5b; }, function (v) { return $320f3178a2e7ed8c$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $320f3178a2e7ed8c$export$a8257692ac88316c; }, function (v) { return $320f3178a2e7ed8c$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $320f3178a2e7ed8c$export$488013bae63b21da; }, function (v) { return $320f3178a2e7ed8c$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $320f3178a2e7ed8c$export$7c73462e0d25e514; }, function (v) { return $320f3178a2e7ed8c$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $320f3178a2e7ed8c$export$35808ee640e87ca7; }, function (v) { return $320f3178a2e7ed8c$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $320f3178a2e7ed8c$export$fae74005e78b1a27; }, function (v) { return $320f3178a2e7ed8c$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $320f3178a2e7ed8c$export$dc8fbce3eb94dc1e; }, function (v) { return $320f3178a2e7ed8c$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $320f3178a2e7ed8c$export$6d9c69b0de29b591; }, function (v) { return $320f3178a2e7ed8c$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $320f3178a2e7ed8c$export$d5a552a76deda3c2; }, function (v) { return $320f3178a2e7ed8c$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $320f3178a2e7ed8c$export$e5c5a5f917a5871c; }, function (v) { return $320f3178a2e7ed8c$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $320f3178a2e7ed8c$export$1538c33de8887b59; }, function (v) { return $320f3178a2e7ed8c$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $320f3178a2e7ed8c$export$13e3392192263954; }, function (v) { return $320f3178a2e7ed8c$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $320f3178a2e7ed8c$export$b8f5890fc79d6aca; }, function (v) { return $320f3178a2e7ed8c$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $320f3178a2e7ed8c$export$60241385465d0a34; }, function (v) { return $320f3178a2e7ed8c$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $320f3178a2e7ed8c$export$83d89fbfd8236492; }, function (v) { return $320f3178a2e7ed8c$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $320f3178a2e7ed8c$export$ffb0004e005737fa;
var $320f3178a2e7ed8c$export$5f8d39834fd61797;
var $320f3178a2e7ed8c$export$e2c29f18771995cb;
var $320f3178a2e7ed8c$export$74bf444e3cd11ea5;
var $320f3178a2e7ed8c$export$dca3b0875bd9a954;
var $320f3178a2e7ed8c$export$16fa2f45be04daa8;
var $320f3178a2e7ed8c$export$221d75b3f55bb0bd;
var $320f3178a2e7ed8c$export$ae55be85d98224ed;
var $320f3178a2e7ed8c$export$e530037191fcd5d7;
var $320f3178a2e7ed8c$export$fd42f52fd3ae1109;
var $320f3178a2e7ed8c$export$c8a8987d4410bf2d;
var $320f3178a2e7ed8c$export$d38cd72104c1f0e9;
var $320f3178a2e7ed8c$export$7d1e3a5e95ceca43;
var $320f3178a2e7ed8c$export$257a8862b851cb5b;
var $320f3178a2e7ed8c$export$a8257692ac88316c;
var $320f3178a2e7ed8c$export$488013bae63b21da;
var $320f3178a2e7ed8c$export$7c73462e0d25e514;
var $320f3178a2e7ed8c$export$35808ee640e87ca7;
var $320f3178a2e7ed8c$export$fae74005e78b1a27;
var $320f3178a2e7ed8c$export$dc8fbce3eb94dc1e;
var $320f3178a2e7ed8c$export$6d9c69b0de29b591;
var $320f3178a2e7ed8c$export$d5a552a76deda3c2;
var $320f3178a2e7ed8c$export$e5c5a5f917a5871c;
var $320f3178a2e7ed8c$export$1538c33de8887b59;
var $320f3178a2e7ed8c$export$13e3392192263954;
var $320f3178a2e7ed8c$export$b8f5890fc79d6aca;
var $320f3178a2e7ed8c$export$60241385465d0a34;
var $320f3178a2e7ed8c$export$83d89fbfd8236492;
"use strict";

var $hpDe0 = parcelRequire("hpDe0");
var $320f3178a2e7ed8c$var$n = 60103, $320f3178a2e7ed8c$var$p = 60106;
$320f3178a2e7ed8c$export$ffb0004e005737fa = 60107;
$320f3178a2e7ed8c$export$5f8d39834fd61797 = 60108;
$320f3178a2e7ed8c$export$e2c29f18771995cb = 60114;
var $320f3178a2e7ed8c$var$q = 60109, $320f3178a2e7ed8c$var$r = 60110, $320f3178a2e7ed8c$var$t = 60112;
$320f3178a2e7ed8c$export$74bf444e3cd11ea5 = 60113;
var $320f3178a2e7ed8c$var$u = 60115, $320f3178a2e7ed8c$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $320f3178a2e7ed8c$var$w = Symbol.for;
    $320f3178a2e7ed8c$var$n = $320f3178a2e7ed8c$var$w("react.element");
    $320f3178a2e7ed8c$var$p = $320f3178a2e7ed8c$var$w("react.portal");
    $320f3178a2e7ed8c$export$ffb0004e005737fa = $320f3178a2e7ed8c$var$w("react.fragment");
    $320f3178a2e7ed8c$export$5f8d39834fd61797 = $320f3178a2e7ed8c$var$w("react.strict_mode");
    $320f3178a2e7ed8c$export$e2c29f18771995cb = $320f3178a2e7ed8c$var$w("react.profiler");
    $320f3178a2e7ed8c$var$q = $320f3178a2e7ed8c$var$w("react.provider");
    $320f3178a2e7ed8c$var$r = $320f3178a2e7ed8c$var$w("react.context");
    $320f3178a2e7ed8c$var$t = $320f3178a2e7ed8c$var$w("react.forward_ref");
    $320f3178a2e7ed8c$export$74bf444e3cd11ea5 = $320f3178a2e7ed8c$var$w("react.suspense");
    $320f3178a2e7ed8c$var$u = $320f3178a2e7ed8c$var$w("react.memo");
    $320f3178a2e7ed8c$var$v = $320f3178a2e7ed8c$var$w("react.lazy");
}
var $320f3178a2e7ed8c$var$x = "function" === typeof Symbol && Symbol.iterator;
function $320f3178a2e7ed8c$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $320f3178a2e7ed8c$var$x && a[$320f3178a2e7ed8c$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $320f3178a2e7ed8c$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $320f3178a2e7ed8c$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $320f3178a2e7ed8c$var$B = {};
function $320f3178a2e7ed8c$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $320f3178a2e7ed8c$var$B;
    this.updater = c || $320f3178a2e7ed8c$var$A;
}
$320f3178a2e7ed8c$var$C.prototype.isReactComponent = {};
$320f3178a2e7ed8c$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($320f3178a2e7ed8c$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$320f3178a2e7ed8c$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $320f3178a2e7ed8c$var$D() {}
$320f3178a2e7ed8c$var$D.prototype = $320f3178a2e7ed8c$var$C.prototype;
function $320f3178a2e7ed8c$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $320f3178a2e7ed8c$var$B;
    this.updater = c || $320f3178a2e7ed8c$var$A;
}
var $320f3178a2e7ed8c$var$F = $320f3178a2e7ed8c$var$E.prototype = new $320f3178a2e7ed8c$var$D;
$320f3178a2e7ed8c$var$F.constructor = $320f3178a2e7ed8c$var$E;
$hpDe0($320f3178a2e7ed8c$var$F, $320f3178a2e7ed8c$var$C.prototype);
$320f3178a2e7ed8c$var$F.isPureReactComponent = !0;
var $320f3178a2e7ed8c$var$G = {
    current: null
}, $320f3178a2e7ed8c$var$H = Object.prototype.hasOwnProperty, $320f3178a2e7ed8c$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $320f3178a2e7ed8c$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$320f3178a2e7ed8c$var$H.call(b, e) && !$320f3178a2e7ed8c$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $320f3178a2e7ed8c$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $320f3178a2e7ed8c$var$G.current
    };
}
function $320f3178a2e7ed8c$var$K(a, b) {
    return {
        $$typeof: $320f3178a2e7ed8c$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $320f3178a2e7ed8c$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $320f3178a2e7ed8c$var$n;
}
function $320f3178a2e7ed8c$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $320f3178a2e7ed8c$var$M = /\/+/g;
function $320f3178a2e7ed8c$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $320f3178a2e7ed8c$var$escape("" + a.key) : b.toString(36);
}
function $320f3178a2e7ed8c$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $320f3178a2e7ed8c$var$n:
                case $320f3178a2e7ed8c$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $320f3178a2e7ed8c$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($320f3178a2e7ed8c$var$M, "$&/") + "/"), $320f3178a2e7ed8c$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($320f3178a2e7ed8c$var$L(d) && (d = $320f3178a2e7ed8c$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($320f3178a2e7ed8c$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $320f3178a2e7ed8c$var$N(k, g);
        h += $320f3178a2e7ed8c$var$O(k, b, c, f, d);
    }
    else if (f = $320f3178a2e7ed8c$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $320f3178a2e7ed8c$var$N(k, g++), h += $320f3178a2e7ed8c$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($320f3178a2e7ed8c$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $320f3178a2e7ed8c$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $320f3178a2e7ed8c$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $320f3178a2e7ed8c$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $320f3178a2e7ed8c$var$R = {
    current: null
};
function $320f3178a2e7ed8c$var$S() {
    var a = $320f3178a2e7ed8c$var$R.current;
    if (null === a) throw Error($320f3178a2e7ed8c$var$z(321));
    return a;
}
var $320f3178a2e7ed8c$var$T = {
    ReactCurrentDispatcher: $320f3178a2e7ed8c$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $320f3178a2e7ed8c$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $hpDe0
};
$320f3178a2e7ed8c$export$dca3b0875bd9a954 = {
    map: $320f3178a2e7ed8c$var$P,
    forEach: function(a, b, c) {
        $320f3178a2e7ed8c$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $320f3178a2e7ed8c$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $320f3178a2e7ed8c$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$320f3178a2e7ed8c$var$L(a)) throw Error($320f3178a2e7ed8c$var$z(143));
        return a;
    }
};
$320f3178a2e7ed8c$export$16fa2f45be04daa8 = $320f3178a2e7ed8c$var$C;
$320f3178a2e7ed8c$export$221d75b3f55bb0bd = $320f3178a2e7ed8c$var$E;
$320f3178a2e7ed8c$export$ae55be85d98224ed = $320f3178a2e7ed8c$var$T;
$320f3178a2e7ed8c$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($320f3178a2e7ed8c$var$z(267, a));
    var e = $hpDe0({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $320f3178a2e7ed8c$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$320f3178a2e7ed8c$var$H.call(b, f) && !$320f3178a2e7ed8c$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $320f3178a2e7ed8c$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$320f3178a2e7ed8c$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $320f3178a2e7ed8c$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $320f3178a2e7ed8c$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$320f3178a2e7ed8c$export$c8a8987d4410bf2d = $320f3178a2e7ed8c$var$J;
$320f3178a2e7ed8c$export$d38cd72104c1f0e9 = function(a) {
    var b = $320f3178a2e7ed8c$var$J.bind(null, a);
    b.type = a;
    return b;
};
$320f3178a2e7ed8c$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$320f3178a2e7ed8c$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $320f3178a2e7ed8c$var$t,
        render: a
    };
};
$320f3178a2e7ed8c$export$a8257692ac88316c = $320f3178a2e7ed8c$var$L;
$320f3178a2e7ed8c$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $320f3178a2e7ed8c$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $320f3178a2e7ed8c$var$Q
    };
};
$320f3178a2e7ed8c$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $320f3178a2e7ed8c$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$320f3178a2e7ed8c$export$35808ee640e87ca7 = function(a, b) {
    return $320f3178a2e7ed8c$var$S().useCallback(a, b);
};
$320f3178a2e7ed8c$export$fae74005e78b1a27 = function(a, b) {
    return $320f3178a2e7ed8c$var$S().useContext(a, b);
};
$320f3178a2e7ed8c$export$dc8fbce3eb94dc1e = function() {};
$320f3178a2e7ed8c$export$6d9c69b0de29b591 = function(a, b) {
    return $320f3178a2e7ed8c$var$S().useEffect(a, b);
};
$320f3178a2e7ed8c$export$d5a552a76deda3c2 = function(a, b, c) {
    return $320f3178a2e7ed8c$var$S().useImperativeHandle(a, b, c);
};
$320f3178a2e7ed8c$export$e5c5a5f917a5871c = function(a, b) {
    return $320f3178a2e7ed8c$var$S().useLayoutEffect(a, b);
};
$320f3178a2e7ed8c$export$1538c33de8887b59 = function(a, b) {
    return $320f3178a2e7ed8c$var$S().useMemo(a, b);
};
$320f3178a2e7ed8c$export$13e3392192263954 = function(a, b, c) {
    return $320f3178a2e7ed8c$var$S().useReducer(a, b, c);
};
$320f3178a2e7ed8c$export$b8f5890fc79d6aca = function(a) {
    return $320f3178a2e7ed8c$var$S().useRef(a);
};
$320f3178a2e7ed8c$export$60241385465d0a34 = function(a) {
    return $320f3178a2e7ed8c$var$S().useState(a);
};
$320f3178a2e7ed8c$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("dPbfa", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $a2gHv = parcelRequire("a2gHv");

var $hpDe0 = parcelRequire("hpDe0");

var $lWWJR = parcelRequire("lWWJR");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$a2gHv) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $a2gHv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $hpDe0({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $a2gHv.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $hpDe0({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $hpDe0({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $hpDe0({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $lWWJR.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $lWWJR.unstable_scheduleCallback($lWWJR.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $lWWJR.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $lWWJR.unstable_UserBlockingPriority, ed = $lWWJR.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $hpDe0(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $hpDe0({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $hpDe0({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $hpDe0({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $hpDe0({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $hpDe0({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $hpDe0({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $hpDe0({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $hpDe0({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $hpDe0({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $hpDe0({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $hpDe0({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $hpDe0({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $hpDe0({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $lWWJR.unstable_runWithPriority, Of = $lWWJR.unstable_scheduleCallback, Pf = $lWWJR.unstable_cancelCallback, Qf = $lWWJR.unstable_shouldYield, Rf = $lWWJR.unstable_requestPaint, Sf = $lWWJR.unstable_now, Tf = $lWWJR.unstable_getCurrentPriorityLevel, Uf = $lWWJR.unstable_ImmediatePriority, Vf = $lWWJR.unstable_UserBlockingPriority, Wf = $lWWJR.unstable_NormalPriority, Xf = $lWWJR.unstable_LowPriority, Yf = $lWWJR.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $hpDe0({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $hpDe0({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $a2gHv.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $hpDe0({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $hpDe0({}, e, {
                    value: void 0
                });
                d = $hpDe0({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $hpDe0({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("lWWJR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5iRJs"));

});
parcelRegister("5iRJs", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $3dc850473688b457$export$c4744153514ff05d; }, function (v) { return $3dc850473688b457$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $3dc850473688b457$export$b5836b71941fa3ed; }, function (v) { return $3dc850473688b457$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $3dc850473688b457$export$d66a1c1c77bd778b; }, function (v) { return $3dc850473688b457$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $3dc850473688b457$export$3e506c1ccc9cc1a7; }, function (v) { return $3dc850473688b457$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $3dc850473688b457$export$e26fe2ed2fa76875; }, function (v) { return $3dc850473688b457$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $3dc850473688b457$export$502329bbf4b505b1; }, function (v) { return $3dc850473688b457$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $3dc850473688b457$export$6e3807111c4874c4; }, function (v) { return $3dc850473688b457$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $3dc850473688b457$export$c27134553091fb3a; }, function (v) { return $3dc850473688b457$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $3dc850473688b457$export$33ee1acdc04fd2a2; }, function (v) { return $3dc850473688b457$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $3dc850473688b457$export$b00a404bbd5edef2; }, function (v) { return $3dc850473688b457$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $3dc850473688b457$export$8352ce38b91d0c62; }, function (v) { return $3dc850473688b457$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $3dc850473688b457$export$d3dfb8e4810cb555; }, function (v) { return $3dc850473688b457$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $3dc850473688b457$export$839f9183b0465a69; }, function (v) { return $3dc850473688b457$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $3dc850473688b457$export$72fdf0e06517287b; }, function (v) { return $3dc850473688b457$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $3dc850473688b457$export$4b844e58a3e414b4; }, function (v) { return $3dc850473688b457$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $3dc850473688b457$export$816d2913ae6b83b1; }, function (v) { return $3dc850473688b457$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $3dc850473688b457$export$61bcfe829111a1d0; }, function (v) { return $3dc850473688b457$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $3dc850473688b457$export$7ee8c9beb337bc3f; }, function (v) { return $3dc850473688b457$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $3dc850473688b457$export$cf845f2c119da08a; }, function (v) { return $3dc850473688b457$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3dc850473688b457$export$c4744153514ff05d;
var $3dc850473688b457$export$b5836b71941fa3ed;
var $3dc850473688b457$export$d66a1c1c77bd778b;
var $3dc850473688b457$export$3e506c1ccc9cc1a7;
var $3dc850473688b457$export$e26fe2ed2fa76875;
var $3dc850473688b457$export$502329bbf4b505b1;
var $3dc850473688b457$export$6e3807111c4874c4;
var $3dc850473688b457$export$c27134553091fb3a;
var $3dc850473688b457$export$33ee1acdc04fd2a2;
var $3dc850473688b457$export$b00a404bbd5edef2;
var $3dc850473688b457$export$8352ce38b91d0c62;
var $3dc850473688b457$export$d3dfb8e4810cb555;
var $3dc850473688b457$export$839f9183b0465a69;
var $3dc850473688b457$export$72fdf0e06517287b;
var $3dc850473688b457$export$4b844e58a3e414b4;
var $3dc850473688b457$export$816d2913ae6b83b1;
var $3dc850473688b457$export$61bcfe829111a1d0;
var $3dc850473688b457$export$7ee8c9beb337bc3f;
var $3dc850473688b457$export$cf845f2c119da08a;
"use strict";
var $3dc850473688b457$var$f, $3dc850473688b457$var$g, $3dc850473688b457$var$h, $3dc850473688b457$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3dc850473688b457$var$l = performance;
    $3dc850473688b457$export$c4744153514ff05d = function() {
        return $3dc850473688b457$var$l.now();
    };
} else {
    var $3dc850473688b457$var$p = Date, $3dc850473688b457$var$q = $3dc850473688b457$var$p.now();
    $3dc850473688b457$export$c4744153514ff05d = function() {
        return $3dc850473688b457$var$p.now() - $3dc850473688b457$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $3dc850473688b457$var$t = null, $3dc850473688b457$var$u = null, $3dc850473688b457$var$w = function() {
        if (null !== $3dc850473688b457$var$t) try {
            var a = $3dc850473688b457$export$c4744153514ff05d();
            $3dc850473688b457$var$t(!0, a);
            $3dc850473688b457$var$t = null;
        } catch (b) {
            throw setTimeout($3dc850473688b457$var$w, 0), b;
        }
    };
    $3dc850473688b457$var$f = function(a) {
        null !== $3dc850473688b457$var$t ? setTimeout($3dc850473688b457$var$f, 0, a) : ($3dc850473688b457$var$t = a, setTimeout($3dc850473688b457$var$w, 0));
    };
    $3dc850473688b457$var$g = function(a, b) {
        $3dc850473688b457$var$u = setTimeout(a, b);
    };
    $3dc850473688b457$var$h = function() {
        clearTimeout($3dc850473688b457$var$u);
    };
    $3dc850473688b457$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $3dc850473688b457$var$k = $3dc850473688b457$export$d66a1c1c77bd778b = function() {};
} else {
    var $3dc850473688b457$var$x = window.setTimeout, $3dc850473688b457$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $3dc850473688b457$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $3dc850473688b457$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $3dc850473688b457$var$A = !1, $3dc850473688b457$var$B = null, $3dc850473688b457$var$C = -1, $3dc850473688b457$var$D = 5, $3dc850473688b457$var$E = 0;
    $3dc850473688b457$export$b5836b71941fa3ed = function() {
        return $3dc850473688b457$export$c4744153514ff05d() >= $3dc850473688b457$var$E;
    };
    $3dc850473688b457$var$k = function() {};
    $3dc850473688b457$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3dc850473688b457$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $3dc850473688b457$var$F = new MessageChannel, $3dc850473688b457$var$G = $3dc850473688b457$var$F.port2;
    $3dc850473688b457$var$F.port1.onmessage = function() {
        if (null !== $3dc850473688b457$var$B) {
            var a = $3dc850473688b457$export$c4744153514ff05d();
            $3dc850473688b457$var$E = a + $3dc850473688b457$var$D;
            try {
                $3dc850473688b457$var$B(!0, a) ? $3dc850473688b457$var$G.postMessage(null) : ($3dc850473688b457$var$A = !1, $3dc850473688b457$var$B = null);
            } catch (b) {
                throw $3dc850473688b457$var$G.postMessage(null), b;
            }
        } else $3dc850473688b457$var$A = !1;
    };
    $3dc850473688b457$var$f = function(a) {
        $3dc850473688b457$var$B = a;
        $3dc850473688b457$var$A || ($3dc850473688b457$var$A = !0, $3dc850473688b457$var$G.postMessage(null));
    };
    $3dc850473688b457$var$g = function(a, b) {
        $3dc850473688b457$var$C = $3dc850473688b457$var$x(function() {
            a($3dc850473688b457$export$c4744153514ff05d());
        }, b);
    };
    $3dc850473688b457$var$h = function() {
        $3dc850473688b457$var$y($3dc850473688b457$var$C);
        $3dc850473688b457$var$C = -1;
    };
}
function $3dc850473688b457$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $3dc850473688b457$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3dc850473688b457$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $3dc850473688b457$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $3dc850473688b457$var$I(n, c)) void 0 !== r && 0 > $3dc850473688b457$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $3dc850473688b457$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $3dc850473688b457$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $3dc850473688b457$var$L = [], $3dc850473688b457$var$M = [], $3dc850473688b457$var$N = 1, $3dc850473688b457$var$O = null, $3dc850473688b457$var$P = 3, $3dc850473688b457$var$Q = !1, $3dc850473688b457$var$R = !1, $3dc850473688b457$var$S = !1;
function $3dc850473688b457$var$T(a) {
    for(var b = $3dc850473688b457$var$J($3dc850473688b457$var$M); null !== b;){
        if (null === b.callback) $3dc850473688b457$var$K($3dc850473688b457$var$M);
        else if (b.startTime <= a) $3dc850473688b457$var$K($3dc850473688b457$var$M), b.sortIndex = b.expirationTime, $3dc850473688b457$var$H($3dc850473688b457$var$L, b);
        else break;
        b = $3dc850473688b457$var$J($3dc850473688b457$var$M);
    }
}
function $3dc850473688b457$var$U(a) {
    $3dc850473688b457$var$S = !1;
    $3dc850473688b457$var$T(a);
    if (!$3dc850473688b457$var$R) {
        if (null !== $3dc850473688b457$var$J($3dc850473688b457$var$L)) $3dc850473688b457$var$R = !0, $3dc850473688b457$var$f($3dc850473688b457$var$V);
        else {
            var b = $3dc850473688b457$var$J($3dc850473688b457$var$M);
            null !== b && $3dc850473688b457$var$g($3dc850473688b457$var$U, b.startTime - a);
        }
    }
}
function $3dc850473688b457$var$V(a, b) {
    $3dc850473688b457$var$R = !1;
    $3dc850473688b457$var$S && ($3dc850473688b457$var$S = !1, $3dc850473688b457$var$h());
    $3dc850473688b457$var$Q = !0;
    var c = $3dc850473688b457$var$P;
    try {
        $3dc850473688b457$var$T(b);
        for($3dc850473688b457$var$O = $3dc850473688b457$var$J($3dc850473688b457$var$L); null !== $3dc850473688b457$var$O && (!($3dc850473688b457$var$O.expirationTime > b) || a && !$3dc850473688b457$export$b5836b71941fa3ed());){
            var d = $3dc850473688b457$var$O.callback;
            if ("function" === typeof d) {
                $3dc850473688b457$var$O.callback = null;
                $3dc850473688b457$var$P = $3dc850473688b457$var$O.priorityLevel;
                var e = d($3dc850473688b457$var$O.expirationTime <= b);
                b = $3dc850473688b457$export$c4744153514ff05d();
                "function" === typeof e ? $3dc850473688b457$var$O.callback = e : $3dc850473688b457$var$O === $3dc850473688b457$var$J($3dc850473688b457$var$L) && $3dc850473688b457$var$K($3dc850473688b457$var$L);
                $3dc850473688b457$var$T(b);
            } else $3dc850473688b457$var$K($3dc850473688b457$var$L);
            $3dc850473688b457$var$O = $3dc850473688b457$var$J($3dc850473688b457$var$L);
        }
        if (null !== $3dc850473688b457$var$O) var m = !0;
        else {
            var n = $3dc850473688b457$var$J($3dc850473688b457$var$M);
            null !== n && $3dc850473688b457$var$g($3dc850473688b457$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $3dc850473688b457$var$O = null, $3dc850473688b457$var$P = c, $3dc850473688b457$var$Q = !1;
    }
}
var $3dc850473688b457$var$W = $3dc850473688b457$var$k;
$3dc850473688b457$export$3e506c1ccc9cc1a7 = 5;
$3dc850473688b457$export$e26fe2ed2fa76875 = 1;
$3dc850473688b457$export$502329bbf4b505b1 = 4;
$3dc850473688b457$export$6e3807111c4874c4 = 3;
$3dc850473688b457$export$c27134553091fb3a = null;
$3dc850473688b457$export$33ee1acdc04fd2a2 = 2;
$3dc850473688b457$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3dc850473688b457$export$8352ce38b91d0c62 = function() {
    $3dc850473688b457$var$R || $3dc850473688b457$var$Q || ($3dc850473688b457$var$R = !0, $3dc850473688b457$var$f($3dc850473688b457$var$V));
};
$3dc850473688b457$export$d3dfb8e4810cb555 = function() {
    return $3dc850473688b457$var$P;
};
$3dc850473688b457$export$839f9183b0465a69 = function() {
    return $3dc850473688b457$var$J($3dc850473688b457$var$L);
};
$3dc850473688b457$export$72fdf0e06517287b = function(a) {
    switch($3dc850473688b457$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3dc850473688b457$var$P;
    }
    var c = $3dc850473688b457$var$P;
    $3dc850473688b457$var$P = b;
    try {
        return a();
    } finally{
        $3dc850473688b457$var$P = c;
    }
};
$3dc850473688b457$export$4b844e58a3e414b4 = function() {};
$3dc850473688b457$export$816d2913ae6b83b1 = $3dc850473688b457$var$W;
$3dc850473688b457$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3dc850473688b457$var$P;
    $3dc850473688b457$var$P = a;
    try {
        return b();
    } finally{
        $3dc850473688b457$var$P = c;
    }
};
$3dc850473688b457$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3dc850473688b457$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3dc850473688b457$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3dc850473688b457$var$H($3dc850473688b457$var$M, a), null === $3dc850473688b457$var$J($3dc850473688b457$var$L) && a === $3dc850473688b457$var$J($3dc850473688b457$var$M) && ($3dc850473688b457$var$S ? $3dc850473688b457$var$h() : $3dc850473688b457$var$S = !0, $3dc850473688b457$var$g($3dc850473688b457$var$U, c - d))) : (a.sortIndex = e, $3dc850473688b457$var$H($3dc850473688b457$var$L, a), $3dc850473688b457$var$R || $3dc850473688b457$var$Q || ($3dc850473688b457$var$R = !0, $3dc850473688b457$var$f($3dc850473688b457$var$V)));
    return a;
};
$3dc850473688b457$export$cf845f2c119da08a = function(a) {
    var b = $3dc850473688b457$var$P;
    return function() {
        var c = $3dc850473688b457$var$P;
        $3dc850473688b457$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3dc850473688b457$var$P = c;
        }
    };
};

});



parcelRegister("69fdi", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $479f626fb558ab39$export$2b8d127b894957b9; }, function (v) { return $479f626fb558ab39$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $479f626fb558ab39$export$cea3a54a6425200c; }, function (v) { return $479f626fb558ab39$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $479f626fb558ab39$export$a7c73072b1a182ae; }, function (v) { return $479f626fb558ab39$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $479f626fb558ab39$export$9f27bc3417b4524d; }, function (v) { return $479f626fb558ab39$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $479f626fb558ab39$export$db77ccec0bb4ccac; }, function (v) { return $479f626fb558ab39$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $479f626fb558ab39$export$8392c0c9d3dcbd35; }, function (v) { return $479f626fb558ab39$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $479f626fb558ab39$export$ffb0004e005737fa; }, function (v) { return $479f626fb558ab39$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $479f626fb558ab39$export$b624eff549462981; }, function (v) { return $479f626fb558ab39$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $479f626fb558ab39$export$7897aa7841a5380c; }, function (v) { return $479f626fb558ab39$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $479f626fb558ab39$export$602eac185826482c; }, function (v) { return $479f626fb558ab39$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $479f626fb558ab39$export$e2c29f18771995cb; }, function (v) { return $479f626fb558ab39$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $479f626fb558ab39$export$5f8d39834fd61797; }, function (v) { return $479f626fb558ab39$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $479f626fb558ab39$export$74bf444e3cd11ea5; }, function (v) { return $479f626fb558ab39$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $479f626fb558ab39$export$92387174baf9b227; }, function (v) { return $479f626fb558ab39$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $479f626fb558ab39$export$ec112efeb987d9c6; }, function (v) { return $479f626fb558ab39$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $479f626fb558ab39$export$b706b080d889d2c9; }, function (v) { return $479f626fb558ab39$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $479f626fb558ab39$export$5be5a87408f70ddc; }, function (v) { return $479f626fb558ab39$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $479f626fb558ab39$export$45a5e7f76e0caa8d; }, function (v) { return $479f626fb558ab39$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $479f626fb558ab39$export$455c2e768291efa6; }, function (v) { return $479f626fb558ab39$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $479f626fb558ab39$export$9522e17588c12572; }, function (v) { return $479f626fb558ab39$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $479f626fb558ab39$export$2110ac352bb060b9; }, function (v) { return $479f626fb558ab39$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $479f626fb558ab39$export$56885ab8b9c456ab; }, function (v) { return $479f626fb558ab39$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $479f626fb558ab39$export$d927fcb6adf8f9de; }, function (v) { return $479f626fb558ab39$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $479f626fb558ab39$export$b82d16f27459e05a; }, function (v) { return $479f626fb558ab39$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $479f626fb558ab39$export$522c17b4f5e123e8; }, function (v) { return $479f626fb558ab39$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $479f626fb558ab39$export$1aabd8a0274ecfd6; }, function (v) { return $479f626fb558ab39$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $479f626fb558ab39$export$9b621391a187a31a; }, function (v) { return $479f626fb558ab39$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $479f626fb558ab39$export$f5bbd400c2f4426f; }, function (v) { return $479f626fb558ab39$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $479f626fb558ab39$export$2b8d127b894957b9;
var $479f626fb558ab39$export$cea3a54a6425200c;
var $479f626fb558ab39$export$a7c73072b1a182ae;
var $479f626fb558ab39$export$9f27bc3417b4524d;
var $479f626fb558ab39$export$db77ccec0bb4ccac;
var $479f626fb558ab39$export$8392c0c9d3dcbd35;
var $479f626fb558ab39$export$ffb0004e005737fa;
var $479f626fb558ab39$export$b624eff549462981;
var $479f626fb558ab39$export$7897aa7841a5380c;
var $479f626fb558ab39$export$602eac185826482c;
var $479f626fb558ab39$export$e2c29f18771995cb;
var $479f626fb558ab39$export$5f8d39834fd61797;
var $479f626fb558ab39$export$74bf444e3cd11ea5;
var $479f626fb558ab39$export$92387174baf9b227;
var $479f626fb558ab39$export$ec112efeb987d9c6;
var $479f626fb558ab39$export$b706b080d889d2c9;
var $479f626fb558ab39$export$5be5a87408f70ddc;
var $479f626fb558ab39$export$45a5e7f76e0caa8d;
var $479f626fb558ab39$export$455c2e768291efa6;
var $479f626fb558ab39$export$9522e17588c12572;
var $479f626fb558ab39$export$2110ac352bb060b9;
var $479f626fb558ab39$export$56885ab8b9c456ab;
var $479f626fb558ab39$export$d927fcb6adf8f9de;
var $479f626fb558ab39$export$b82d16f27459e05a;
var $479f626fb558ab39$export$522c17b4f5e123e8;
var $479f626fb558ab39$export$1aabd8a0274ecfd6;
var $479f626fb558ab39$export$9b621391a187a31a;
var $479f626fb558ab39$export$f5bbd400c2f4426f;
"use strict";
var $479f626fb558ab39$var$b = "function" === typeof Symbol && Symbol.for, $479f626fb558ab39$var$c = $479f626fb558ab39$var$b ? Symbol.for("react.element") : 60103, $479f626fb558ab39$var$d = $479f626fb558ab39$var$b ? Symbol.for("react.portal") : 60106, $479f626fb558ab39$var$e = $479f626fb558ab39$var$b ? Symbol.for("react.fragment") : 60107, $479f626fb558ab39$var$f = $479f626fb558ab39$var$b ? Symbol.for("react.strict_mode") : 60108, $479f626fb558ab39$var$g = $479f626fb558ab39$var$b ? Symbol.for("react.profiler") : 60114, $479f626fb558ab39$var$h = $479f626fb558ab39$var$b ? Symbol.for("react.provider") : 60109, $479f626fb558ab39$var$k = $479f626fb558ab39$var$b ? Symbol.for("react.context") : 60110, $479f626fb558ab39$var$l = $479f626fb558ab39$var$b ? Symbol.for("react.async_mode") : 60111, $479f626fb558ab39$var$m = $479f626fb558ab39$var$b ? Symbol.for("react.concurrent_mode") : 60111, $479f626fb558ab39$var$n = $479f626fb558ab39$var$b ? Symbol.for("react.forward_ref") : 60112, $479f626fb558ab39$var$p = $479f626fb558ab39$var$b ? Symbol.for("react.suspense") : 60113, $479f626fb558ab39$var$q = $479f626fb558ab39$var$b ? Symbol.for("react.suspense_list") : 60120, $479f626fb558ab39$var$r = $479f626fb558ab39$var$b ? Symbol.for("react.memo") : 60115, $479f626fb558ab39$var$t = $479f626fb558ab39$var$b ? Symbol.for("react.lazy") : 60116, $479f626fb558ab39$var$v = $479f626fb558ab39$var$b ? Symbol.for("react.block") : 60121, $479f626fb558ab39$var$w = $479f626fb558ab39$var$b ? Symbol.for("react.fundamental") : 60117, $479f626fb558ab39$var$x = $479f626fb558ab39$var$b ? Symbol.for("react.responder") : 60118, $479f626fb558ab39$var$y = $479f626fb558ab39$var$b ? Symbol.for("react.scope") : 60119;
function $479f626fb558ab39$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $479f626fb558ab39$var$c:
                switch(a = a.type, a){
                    case $479f626fb558ab39$var$l:
                    case $479f626fb558ab39$var$m:
                    case $479f626fb558ab39$var$e:
                    case $479f626fb558ab39$var$g:
                    case $479f626fb558ab39$var$f:
                    case $479f626fb558ab39$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $479f626fb558ab39$var$k:
                            case $479f626fb558ab39$var$n:
                            case $479f626fb558ab39$var$t:
                            case $479f626fb558ab39$var$r:
                            case $479f626fb558ab39$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $479f626fb558ab39$var$d:
                return u;
        }
    }
}
function $479f626fb558ab39$var$A(a) {
    return $479f626fb558ab39$var$z(a) === $479f626fb558ab39$var$m;
}
$479f626fb558ab39$export$2b8d127b894957b9 = $479f626fb558ab39$var$l;
$479f626fb558ab39$export$cea3a54a6425200c = $479f626fb558ab39$var$m;
$479f626fb558ab39$export$a7c73072b1a182ae = $479f626fb558ab39$var$k;
$479f626fb558ab39$export$9f27bc3417b4524d = $479f626fb558ab39$var$h;
$479f626fb558ab39$export$db77ccec0bb4ccac = $479f626fb558ab39$var$c;
$479f626fb558ab39$export$8392c0c9d3dcbd35 = $479f626fb558ab39$var$n;
$479f626fb558ab39$export$ffb0004e005737fa = $479f626fb558ab39$var$e;
$479f626fb558ab39$export$b624eff549462981 = $479f626fb558ab39$var$t;
$479f626fb558ab39$export$7897aa7841a5380c = $479f626fb558ab39$var$r;
$479f626fb558ab39$export$602eac185826482c = $479f626fb558ab39$var$d;
$479f626fb558ab39$export$e2c29f18771995cb = $479f626fb558ab39$var$g;
$479f626fb558ab39$export$5f8d39834fd61797 = $479f626fb558ab39$var$f;
$479f626fb558ab39$export$74bf444e3cd11ea5 = $479f626fb558ab39$var$p;
$479f626fb558ab39$export$92387174baf9b227 = function(a) {
    return $479f626fb558ab39$var$A(a) || $479f626fb558ab39$var$z(a) === $479f626fb558ab39$var$l;
};
$479f626fb558ab39$export$ec112efeb987d9c6 = $479f626fb558ab39$var$A;
$479f626fb558ab39$export$b706b080d889d2c9 = function(a) {
    return $479f626fb558ab39$var$z(a) === $479f626fb558ab39$var$k;
};
$479f626fb558ab39$export$5be5a87408f70ddc = function(a) {
    return $479f626fb558ab39$var$z(a) === $479f626fb558ab39$var$h;
};
$479f626fb558ab39$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $479f626fb558ab39$var$c;
};
$479f626fb558ab39$export$455c2e768291efa6 = function(a) {
    return $479f626fb558ab39$var$z(a) === $479f626fb558ab39$var$n;
};
$479f626fb558ab39$export$9522e17588c12572 = function(a) {
    return $479f626fb558ab39$var$z(a) === $479f626fb558ab39$var$e;
};
$479f626fb558ab39$export$2110ac352bb060b9 = function(a) {
    return $479f626fb558ab39$var$z(a) === $479f626fb558ab39$var$t;
};
$479f626fb558ab39$export$56885ab8b9c456ab = function(a) {
    return $479f626fb558ab39$var$z(a) === $479f626fb558ab39$var$r;
};
$479f626fb558ab39$export$d927fcb6adf8f9de = function(a) {
    return $479f626fb558ab39$var$z(a) === $479f626fb558ab39$var$d;
};
$479f626fb558ab39$export$b82d16f27459e05a = function(a) {
    return $479f626fb558ab39$var$z(a) === $479f626fb558ab39$var$g;
};
$479f626fb558ab39$export$522c17b4f5e123e8 = function(a) {
    return $479f626fb558ab39$var$z(a) === $479f626fb558ab39$var$f;
};
$479f626fb558ab39$export$1aabd8a0274ecfd6 = function(a) {
    return $479f626fb558ab39$var$z(a) === $479f626fb558ab39$var$p;
};
$479f626fb558ab39$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $479f626fb558ab39$var$e || a === $479f626fb558ab39$var$m || a === $479f626fb558ab39$var$g || a === $479f626fb558ab39$var$f || a === $479f626fb558ab39$var$p || a === $479f626fb558ab39$var$q || "object" === typeof a && null !== a && (a.$$typeof === $479f626fb558ab39$var$t || a.$$typeof === $479f626fb558ab39$var$r || a.$$typeof === $479f626fb558ab39$var$h || a.$$typeof === $479f626fb558ab39$var$k || a.$$typeof === $479f626fb558ab39$var$n || a.$$typeof === $479f626fb558ab39$var$w || a.$$typeof === $479f626fb558ab39$var$x || a.$$typeof === $479f626fb558ab39$var$y || a.$$typeof === $479f626fb558ab39$var$v);
};
$479f626fb558ab39$export$f5bbd400c2f4426f = $479f626fb558ab39$var$z;

});

parcelRegister("b9AqM", function(module, exports) {

$parcel$export(module.exports, "createRule", function () { return createRule; });
$parcel$export(module.exports, "toCssValue", function () { return toCssValue; });
$parcel$export(module.exports, "RuleList", function () { return RuleList; });
$parcel$export(module.exports, "create", function () { return createJss; });
$parcel$export(module.exports, "hasCSSTOMSupport", function () { return hasCSSTOMSupport; });
$parcel$export(module.exports, "getDynamicStyles", function () { return getDynamicStyles; });

var $kO11b = parcelRequire("kO11b");

var $jMQug = parcelRequire("jMQug");

var $i7DUg = parcelRequire("i7DUg");

var $5ly4m = parcelRequire("5ly4m");

var $8XKFn = parcelRequire("8XKFn");

var $eKk9x = parcelRequire("eKk9x");

var $lqlJt = parcelRequire("lqlJt");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== "object") return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = "unnamed";
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = "";
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === "!important") break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ""; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += join(value[i], " ");
    }
    else cssValue = join(value, ", "); // Add !important, because it was ignored.
    if (value[value.length - 1] === "!important") cssValue += " !important";
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: "",
        space: ""
    };
    return {
        linebreak: "\n",
        space: " "
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = "";
    for(var index = 0; index < indent; index++)result += "  ";
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = "";
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== "fallbacks") {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr("}", indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, "\\$1");
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = "style";
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $8XKFn.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $eKk9x.default)((0, $eKk9x.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== "object") json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $kO11b.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $5ly4m.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === "@" || options.parent && options.parent.type === "keyframes") return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = "conditional";
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : "unknown"; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $kO11b.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = "keyframes";
        this.at = "@keyframes";
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = "noname";
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $kO11b.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $kO11b.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === "string") return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === "string" && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style" || !sheet) return style;
        if ("animation-name" in style) replaceRef(style, "animation-name", sheet.keyframes);
        if ("animation" in style) replaceRef(style, "animation", sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case "animation":
                return findReferencedKeyframe(val, sheet.keyframes);
            case "animation-name":
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $8XKFn.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $kO11b.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === "keyframes") return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = "font-face";
        this.at = "@font-face";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = "";
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = "viewport";
        this.at = "@viewport";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === "@viewport" || key === "@-ms-viewport" ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = "simple";
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = "";
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += "\n";
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    "@charset": true,
    "@import": true,
    "@namespace": true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $kO11b.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $kO11b.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $kO11b.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === "object" ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: "external"
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $lqlJt.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = "";
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $5ly4m.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = "";
        var prefix = "";
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || "c") + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return "";
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf("!important") : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? "important" : "");
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector("head");
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute("content") : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ("insertRule" in container) container.insertRule(rule, index);
        else if ("appendRule" in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement("style"); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = "\n";
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute("data-jss", "");
        if (media) this.element.setAttribute("media", media);
        if (meta) this.element.setAttribute("data-meta", meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute("nonce", nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = "\n";
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === "conditional" || rule.type === "keyframes") {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $jMQug.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: "internal"
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $kO11b.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ("Renderer" in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== "number") index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $kO11b.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === "object") return this.createRule(undefined, name, style);
        var ruleOptions = (0, $kO11b.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $i7DUg.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $i7DUg.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $5ly4m.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === "object" && CSS != null && "number" in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === "function") {
            if (!to) to = {};
            to[key] = value;
        } else if (type === "object" && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $81eccb6bc43a7352$export$2e2bcd8739ae039 = index;

});
parcelRegister("kO11b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2594453fbb59da3$export$2e2bcd8739ae039; });
function $f2594453fbb59da3$export$2e2bcd8739ae039() {
    $f2594453fbb59da3$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f2594453fbb59da3$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("jMQug", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e67b36dc6844095f$export$2e2bcd8739ae039; });
var $e67b36dc6844095f$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $e67b36dc6844095f$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $e67b36dc6844095f$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $e67b36dc6844095f$var$_typeof(document)) === "object" && document.nodeType === 9;
var $e67b36dc6844095f$export$2e2bcd8739ae039 = $e67b36dc6844095f$export$4e09c449d6c407f7;

});

parcelRegister("i7DUg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d317d60511366eaa$export$2e2bcd8739ae039; });
var $d317d60511366eaa$var$isProduction = true;
function $d317d60511366eaa$var$warning(condition, message) {
    if (!$d317d60511366eaa$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $d317d60511366eaa$export$2e2bcd8739ae039 = $d317d60511366eaa$var$warning;

});

parcelRegister("5ly4m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e49575cce258d93$export$2e2bcd8739ae039; });

var $aO4E3 = parcelRequire("aO4E3");
function $3e49575cce258d93$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $aO4E3.default)(descriptor.key), descriptor);
    }
}
function $3e49575cce258d93$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $3e49575cce258d93$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3e49575cce258d93$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});
parcelRegister("aO4E3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7de22d53b8c6574a$export$2e2bcd8739ae039; });

var $gvXaa = parcelRequire("gvXaa");

var $3I0Ii = parcelRequire("3I0Ii");
function $7de22d53b8c6574a$export$2e2bcd8739ae039(t) {
    var i = (0, $3I0Ii.default)(t, "string");
    return "symbol" == (0, $gvXaa.default)(i) ? i : i + "";
}

});
parcelRegister("gvXaa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c05d6f242d227473$export$2e2bcd8739ae039; });
function $c05d6f242d227473$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $c05d6f242d227473$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c05d6f242d227473$export$2e2bcd8739ae039(o);
}

});

parcelRegister("3I0Ii", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b3608d415cf9146$export$2e2bcd8739ae039; });

var $gvXaa = parcelRequire("gvXaa");
function $2b3608d415cf9146$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $gvXaa.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $gvXaa.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("8XKFn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $686808604b0cfedd$export$2e2bcd8739ae039; });

var $3VKaJ = parcelRequire("3VKaJ");
function $686808604b0cfedd$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $3VKaJ.default)(subClass, superClass);
}

});
parcelRegister("3VKaJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dca82c88af57c1c$export$2e2bcd8739ae039; });
function $2dca82c88af57c1c$export$2e2bcd8739ae039(o, p) {
    $2dca82c88af57c1c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2dca82c88af57c1c$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("eKk9x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abc4fe8612c782d2$export$2e2bcd8739ae039; });
function $abc4fe8612c782d2$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("lqlJt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f98ce245b2b3538d$export$2e2bcd8739ae039; });
function $f98ce245b2b3538d$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("byMj2", function(module, exports) {
"use strict";
// This file describes the messages that the Client can send to the Server
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SelectGameMessage = module.exports.ContestantSubmission = module.exports.ContestantWager = module.exports.ContestantSpectate = module.exports.ContestantJoin = module.exports.ContestantBuzzIn = module.exports.ContestantRemoveMessage = module.exports.RevealMessage = module.exports.CloseSubmissionsMessage = module.exports.CloseWagersMessage = module.exports.OpenBuzzer = module.exports.CloseClueMessage = module.exports.SetScoreMessage = module.exports.ModifyScoreMessage = module.exports.SelectClueMessage = module.exports.StartGameMessage = module.exports.TrebekJoinMessage = module.exports.ClientMessage = module.exports.ClientMessageType = void 0;
var $86a85743d17354e4$var$ClientMessageType;
(function(ClientMessageType) {
    ClientMessageType[ClientMessageType["START_GAME"] = 0] = "START_GAME";
    ClientMessageType[ClientMessageType["SELECT_CLUE"] = 1] = "SELECT_CLUE";
    ClientMessageType[ClientMessageType["TREBEK_JOIN"] = 2] = "TREBEK_JOIN";
    ClientMessageType[ClientMessageType["MODIFY_SCORE"] = 3] = "MODIFY_SCORE";
    ClientMessageType[ClientMessageType["SET_SCORE"] = 4] = "SET_SCORE";
    ClientMessageType[ClientMessageType["CONTESTANT_JOIN"] = 5] = "CONTESTANT_JOIN";
    ClientMessageType[ClientMessageType["CONTESTANT_BUZZ"] = 6] = "CONTESTANT_BUZZ";
    ClientMessageType[ClientMessageType["CONTESTANT_WAGER"] = 7] = "CONTESTANT_WAGER";
    ClientMessageType[ClientMessageType["CONTESTANT_SPECTATE"] = 8] = "CONTESTANT_SPECTATE";
    ClientMessageType[ClientMessageType["CONTESTANT_SUBMISSION"] = 9] = "CONTESTANT_SUBMISSION";
    ClientMessageType[ClientMessageType["CONTESTANT_REMOVE"] = 10] = "CONTESTANT_REMOVE";
    ClientMessageType[ClientMessageType["CLOSE_CLUE"] = 11] = "CLOSE_CLUE";
    ClientMessageType[ClientMessageType["CLOSE_SUBMISSIONS"] = 12] = "CLOSE_SUBMISSIONS";
    ClientMessageType[ClientMessageType["CLOSE_WAGERING"] = 13] = "CLOSE_WAGERING";
    ClientMessageType[ClientMessageType["OPEN_BUZZER"] = 14] = "OPEN_BUZZER";
    ClientMessageType[ClientMessageType["REVEAL"] = 15] = "REVEAL";
    ClientMessageType[ClientMessageType["SELECT_GAME"] = 16] = "SELECT_GAME";
})($86a85743d17354e4$var$ClientMessageType || (module.exports.ClientMessageType = $86a85743d17354e4$var$ClientMessageType = {}));
class $86a85743d17354e4$var$ClientMessage {
    constructor(id){
        this.id = id;
    }
}
module.exports.ClientMessage = $86a85743d17354e4$var$ClientMessage;
/* ====================== Trebek Side ================== */ class $86a85743d17354e4$var$TrebekJoinMessage extends $86a85743d17354e4$var$ClientMessage {
    constructor(id){
        super(id);
        this.type = $86a85743d17354e4$var$ClientMessageType.TREBEK_JOIN;
    }
}
module.exports.TrebekJoinMessage = $86a85743d17354e4$var$TrebekJoinMessage;
// Tells the server to make a new game with game id <id>
class $86a85743d17354e4$var$StartGameMessage extends $86a85743d17354e4$var$ClientMessage {
    constructor(id, airdate){
        super(id);
        this.type = $86a85743d17354e4$var$ClientMessageType.START_GAME;
        this.airdate = airdate;
    }
}
module.exports.StartGameMessage = $86a85743d17354e4$var$StartGameMessage;
// Tells the server to transition a clue on a jeopardy board to the INPLAY state
class $86a85743d17354e4$var$SelectClueMessage extends $86a85743d17354e4$var$ClientMessage {
    constructor(id, clueId){
        super(id);
        this.clueId = clueId;
        this.type = $86a85743d17354e4$var$ClientMessageType.SELECT_CLUE;
    }
}
module.exports.SelectClueMessage = $86a85743d17354e4$var$SelectClueMessage;
// Modify Score
class $86a85743d17354e4$var$ModifyScoreMessage extends $86a85743d17354e4$var$ClientMessage {
    constructor(id, scoreDelta, teamName){
        super(id);
        this.teamName = teamName;
        this.scoreDelta = scoreDelta;
        this.type = $86a85743d17354e4$var$ClientMessageType.MODIFY_SCORE;
    }
}
module.exports.ModifyScoreMessage = $86a85743d17354e4$var$ModifyScoreMessage;
// Set Score
class $86a85743d17354e4$var$SetScoreMessage extends $86a85743d17354e4$var$ClientMessage {
    constructor(id, newScore, teamName){
        super(id);
        this.teamName = teamName;
        this.newScore = newScore;
        this.type = $86a85743d17354e4$var$ClientMessageType.SET_SCORE;
    }
}
module.exports.SetScoreMessage = $86a85743d17354e4$var$SetScoreMessage;
// Close Clue
class $86a85743d17354e4$var$CloseClueMessage extends $86a85743d17354e4$var$ClientMessage {
    constructor(id){
        super(id);
        this.type = $86a85743d17354e4$var$ClientMessageType.CLOSE_CLUE;
    }
}
module.exports.CloseClueMessage = $86a85743d17354e4$var$CloseClueMessage;
// Trebek allows contestants to buzz in
class $86a85743d17354e4$var$OpenBuzzer extends $86a85743d17354e4$var$ClientMessage {
    constructor(id){
        super(id);
        this.type = $86a85743d17354e4$var$ClientMessageType.OPEN_BUZZER;
    }
}
module.exports.OpenBuzzer = $86a85743d17354e4$var$OpenBuzzer;
// End current wagering period
class $86a85743d17354e4$var$CloseWagersMessage extends $86a85743d17354e4$var$ClientMessage {
    constructor(id){
        super(id);
        this.type = $86a85743d17354e4$var$ClientMessageType.CLOSE_WAGERING;
    }
}
module.exports.CloseWagersMessage = $86a85743d17354e4$var$CloseWagersMessage;
// End period where contestants submit responses
class $86a85743d17354e4$var$CloseSubmissionsMessage extends $86a85743d17354e4$var$ClientMessage {
    constructor(id){
        super(id);
        this.type = $86a85743d17354e4$var$ClientMessageType.CLOSE_SUBMISSIONS;
    }
}
module.exports.CloseSubmissionsMessage = $86a85743d17354e4$var$CloseSubmissionsMessage;
class $86a85743d17354e4$var$RevealMessage extends $86a85743d17354e4$var$ClientMessage {
    constructor(id, teamName){
        super(id);
        this.teamName = teamName;
        this.type = $86a85743d17354e4$var$ClientMessageType.REVEAL;
    }
}
module.exports.RevealMessage = $86a85743d17354e4$var$RevealMessage;
// Remove a contestant from a Jeopardy session
class $86a85743d17354e4$var$ContestantRemoveMessage extends $86a85743d17354e4$var$ClientMessage {
    constructor(id, teamName){
        super(id);
        this.teamName = teamName;
        this.type = $86a85743d17354e4$var$ClientMessageType.CONTESTANT_REMOVE;
    }
}
module.exports.ContestantRemoveMessage = $86a85743d17354e4$var$ContestantRemoveMessage;
/* ==================== Contestant Side ============================ */ class $86a85743d17354e4$var$ContestantBuzzIn extends $86a85743d17354e4$var$ClientMessage {
    constructor(id, teamName, timeToBuzz){
        super(id);
        this.teamName = teamName;
        this.timeToBuzz = timeToBuzz;
        this.type = $86a85743d17354e4$var$ClientMessageType.CONTESTANT_BUZZ;
    }
}
module.exports.ContestantBuzzIn = $86a85743d17354e4$var$ContestantBuzzIn;
class $86a85743d17354e4$var$ContestantJoin extends $86a85743d17354e4$var$ClientMessage {
    constructor(id, teamName, playerName){
        super(id);
        this.teamName = teamName;
        this.playerName = playerName;
        this.type = $86a85743d17354e4$var$ClientMessageType.CONTESTANT_JOIN;
    }
}
module.exports.ContestantJoin = $86a85743d17354e4$var$ContestantJoin;
class $86a85743d17354e4$var$ContestantSpectate extends $86a85743d17354e4$var$ClientMessage {
    constructor(id){
        super(id);
        this.type = $86a85743d17354e4$var$ClientMessageType.CONTESTANT_SPECTATE;
    }
}
module.exports.ContestantSpectate = $86a85743d17354e4$var$ContestantSpectate;
class $86a85743d17354e4$var$ContestantWager extends $86a85743d17354e4$var$ClientMessage {
    constructor(id, teamName, wager){
        super(id);
        this.wager = wager;
        this.teamName = teamName;
        this.type = $86a85743d17354e4$var$ClientMessageType.CONTESTANT_WAGER;
    }
}
module.exports.ContestantWager = $86a85743d17354e4$var$ContestantWager;
class $86a85743d17354e4$var$ContestantSubmission extends $86a85743d17354e4$var$ClientMessage {
    constructor(id, teamName, submission){
        super(id);
        this.teamName = teamName;
        this.submission = submission;
        this.type = $86a85743d17354e4$var$ClientMessageType.CONTESTANT_SUBMISSION;
    }
}
module.exports.ContestantSubmission = $86a85743d17354e4$var$ContestantSubmission;
class $86a85743d17354e4$var$SelectGameMessage extends $86a85743d17354e4$var$ClientMessage {
    constructor(id, gameName){
        super(id);
        this.gameName = gameName;
        this.type = $86a85743d17354e4$var$ClientMessageType.SELECT_GAME;
    }
}
module.exports.SelectGameMessage = $86a85743d17354e4$var$SelectGameMessage;

});

parcelRegister("4x7K3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GamesListMessage = module.exports.ErrorMessage = module.exports.DailyDoubleWagerMessage = module.exports.OpenBuzzerMessage = module.exports.StateUpdateMessage = module.exports.ServerMessage = module.exports.ServerMessageType = void 0;
var $34d03fdc9d7a7ad1$var$ServerMessageType;
(function(ServerMessageType) {
    ServerMessageType[ServerMessageType["OPEN_BUZZER"] = 0] = "OPEN_BUZZER";
    ServerMessageType[ServerMessageType["STATE_UPDATE"] = 1] = "STATE_UPDATE";
    ServerMessageType[ServerMessageType["DAILY_DOUBLE_WAGER"] = 2] = "DAILY_DOUBLE_WAGER";
    ServerMessageType[ServerMessageType["ERROR"] = 3] = "ERROR";
    ServerMessageType[ServerMessageType["GAMES_LIST"] = 4] = "GAMES_LIST";
})($34d03fdc9d7a7ad1$var$ServerMessageType || (module.exports.ServerMessageType = $34d03fdc9d7a7ad1$var$ServerMessageType = {}));
class $34d03fdc9d7a7ad1$var$ServerMessage {
    constructor(type){
        this.type = type;
    }
}
module.exports.ServerMessage = $34d03fdc9d7a7ad1$var$ServerMessage;
class $34d03fdc9d7a7ad1$var$StateUpdateMessage extends $34d03fdc9d7a7ad1$var$ServerMessage {
    constructor(newState){
        super($34d03fdc9d7a7ad1$var$ServerMessageType.STATE_UPDATE);
        this.newState = newState;
    }
}
module.exports.StateUpdateMessage = $34d03fdc9d7a7ad1$var$StateUpdateMessage;
class $34d03fdc9d7a7ad1$var$OpenBuzzerMessage extends $34d03fdc9d7a7ad1$var$ServerMessage {
    constructor(newState){
        super($34d03fdc9d7a7ad1$var$ServerMessageType.OPEN_BUZZER);
        this.newState = newState;
    }
}
module.exports.OpenBuzzerMessage = $34d03fdc9d7a7ad1$var$OpenBuzzerMessage;
class $34d03fdc9d7a7ad1$var$DailyDoubleWagerMessage extends $34d03fdc9d7a7ad1$var$ServerMessage {
    constructor(newState){
        super($34d03fdc9d7a7ad1$var$ServerMessageType.DAILY_DOUBLE_WAGER);
        this.newState = newState;
    }
}
module.exports.DailyDoubleWagerMessage = $34d03fdc9d7a7ad1$var$DailyDoubleWagerMessage;
class $34d03fdc9d7a7ad1$var$ErrorMessage extends $34d03fdc9d7a7ad1$var$ServerMessage {
    constructor(message){
        super($34d03fdc9d7a7ad1$var$ServerMessageType.ERROR);
        this.error = message;
    }
}
module.exports.ErrorMessage = $34d03fdc9d7a7ad1$var$ErrorMessage;
class $34d03fdc9d7a7ad1$var$GamesListMessage extends $34d03fdc9d7a7ad1$var$ServerMessage {
    constructor(games){
        super($34d03fdc9d7a7ad1$var$ServerMessageType.GAMES_LIST);
        this.games = games;
    }
}
module.exports.GamesListMessage = $34d03fdc9d7a7ad1$var$GamesListMessage;

});

parcelRegister("lir4a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GUIUserType = module.exports.NO_FINAL_JEOPARDY_SUBMISSION = module.exports.NO_FINAL_JEOPARDY_WAGER = module.exports.NO_DAILY_DOUBLE_WAGER = module.exports.NO_BUZZ_IN_TIME = module.exports.NO_QUESTION = module.exports.Status = module.exports.Round = void 0;
var $f8104637d49d5e6e$var$Round;
(function(Round) {
    Round[Round["SINGLE"] = 0] = "SINGLE";
    Round[Round["DOUBLE"] = 1] = "DOUBLE";
    Round[Round["FINAL"] = 2] = "FINAL";
    Round[Round["DONE"] = 3] = "DONE";
})($f8104637d49d5e6e$var$Round || (module.exports.Round = $f8104637d49d5e6e$var$Round = {}));
var $f8104637d49d5e6e$var$Status;
(function(Status) {
    Status[Status["UNPLAYED"] = 0] = "UNPLAYED";
    Status[Status["INPLAY"] = 1] = "INPLAY";
    Status[Status["PLAYED"] = 2] = "PLAYED";
})($f8104637d49d5e6e$var$Status || (module.exports.Status = $f8104637d49d5e6e$var$Status = {}));
module.exports.NO_QUESTION = -1;
module.exports.NO_BUZZ_IN_TIME = -1;
module.exports.NO_DAILY_DOUBLE_WAGER = -1;
module.exports.NO_FINAL_JEOPARDY_WAGER = -1;
module.exports.NO_FINAL_JEOPARDY_SUBMISSION = "___no submission yet___";
var $f8104637d49d5e6e$var$GUIUserType;
(function(GUIUserType) {
    GUIUserType[GUIUserType["UNDEFINED"] = 0] = "UNDEFINED";
    GUIUserType[GUIUserType["ADMIN"] = 1] = "ADMIN";
    GUIUserType[GUIUserType["PLAYER"] = 2] = "PLAYER";
    GUIUserType[GUIUserType["OBSERVER"] = 3] = "OBSERVER";
})($f8104637d49d5e6e$var$GUIUserType || (module.exports.GUIUserType = $f8104637d49d5e6e$var$GUIUserType = {}));

});

parcelRegister("7Pq3L", function(module, exports) {

var $lLWva = parcelRequire("lLWva");
var $5b3182bea2919cf8$var$wordList = [
    // Borrowed from xkcd password generator which borrowed it from wherever
    "ability",
    "able",
    "aboard",
    "about",
    "above",
    "accept",
    "accident",
    "according",
    "account",
    "accurate",
    "acres",
    "across",
    "act",
    "action",
    "active",
    "activity",
    "actual",
    "actually",
    "add",
    "addition",
    "additional",
    "adjective",
    "adult",
    "adventure",
    "advice",
    "affect",
    "afraid",
    "after",
    "afternoon",
    "again",
    "against",
    "age",
    "ago",
    "agree",
    "ahead",
    "aid",
    "air",
    "airplane",
    "alike",
    "alive",
    "all",
    "allow",
    "almost",
    "alone",
    "along",
    "aloud",
    "alphabet",
    "already",
    "also",
    "although",
    "am",
    "among",
    "amount",
    "ancient",
    "angle",
    "angry",
    "animal",
    "announced",
    "another",
    "answer",
    "ants",
    "any",
    "anybody",
    "anyone",
    "anything",
    "anyway",
    "anywhere",
    "apart",
    "apartment",
    "appearance",
    "apple",
    "applied",
    "appropriate",
    "are",
    "area",
    "arm",
    "army",
    "around",
    "arrange",
    "arrangement",
    "arrive",
    "arrow",
    "art",
    "article",
    "as",
    "aside",
    "ask",
    "asleep",
    "at",
    "ate",
    "atmosphere",
    "atom",
    "atomic",
    "attached",
    "attack",
    "attempt",
    "attention",
    "audience",
    "author",
    "automobile",
    "available",
    "average",
    "avoid",
    "aware",
    "away",
    "baby",
    "back",
    "bad",
    "badly",
    "bag",
    "balance",
    "ball",
    "balloon",
    "band",
    "bank",
    "bar",
    "bare",
    "bark",
    "barn",
    "base",
    "baseball",
    "basic",
    "basis",
    "basket",
    "bat",
    "battle",
    "be",
    "bean",
    "bear",
    "beat",
    "beautiful",
    "beauty",
    "became",
    "because",
    "become",
    "becoming",
    "bee",
    "been",
    "before",
    "began",
    "beginning",
    "begun",
    "behavior",
    "behind",
    "being",
    "believed",
    "bell",
    "belong",
    "below",
    "belt",
    "bend",
    "beneath",
    "bent",
    "beside",
    "best",
    "bet",
    "better",
    "between",
    "beyond",
    "bicycle",
    "bigger",
    "biggest",
    "bill",
    "birds",
    "birth",
    "birthday",
    "bit",
    "bite",
    "black",
    "blank",
    "blanket",
    "blew",
    "blind",
    "block",
    "blood",
    "blow",
    "blue",
    "board",
    "boat",
    "body",
    "bone",
    "book",
    "border",
    "born",
    "both",
    "bottle",
    "bottom",
    "bound",
    "bow",
    "bowl",
    "box",
    "boy",
    "brain",
    "branch",
    "brass",
    "brave",
    "bread",
    "break",
    "breakfast",
    "breath",
    "breathe",
    "breathing",
    "breeze",
    "brick",
    "bridge",
    "brief",
    "bright",
    "bring",
    "broad",
    "broke",
    "broken",
    "brother",
    "brought",
    "brown",
    "brush",
    "buffalo",
    "build",
    "building",
    "built",
    "buried",
    "burn",
    "burst",
    "bus",
    "bush",
    "business",
    "busy",
    "but",
    "butter",
    "buy",
    "by",
    "cabin",
    "cage",
    "cake",
    "call",
    "calm",
    "came",
    "camera",
    "camp",
    "can",
    "canal",
    "cannot",
    "cap",
    "capital",
    "captain",
    "captured",
    "car",
    "carbon",
    "card",
    "care",
    "careful",
    "carefully",
    "carried",
    "carry",
    "case",
    "cast",
    "castle",
    "cat",
    "catch",
    "cattle",
    "caught",
    "cause",
    "cave",
    "cell",
    "cent",
    "center",
    "central",
    "century",
    "certain",
    "certainly",
    "chain",
    "chair",
    "chamber",
    "chance",
    "change",
    "changing",
    "chapter",
    "character",
    "characteristic",
    "charge",
    "chart",
    "check",
    "cheese",
    "chemical",
    "chest",
    "chicken",
    "chief",
    "child",
    "children",
    "choice",
    "choose",
    "chose",
    "chosen",
    "church",
    "circle",
    "circus",
    "citizen",
    "city",
    "class",
    "classroom",
    "claws",
    "clay",
    "clean",
    "clear",
    "clearly",
    "climate",
    "climb",
    "clock",
    "close",
    "closely",
    "closer",
    "cloth",
    "clothes",
    "clothing",
    "cloud",
    "club",
    "coach",
    "coal",
    "coast",
    "coat",
    "coffee",
    "cold",
    "collect",
    "college",
    "colony",
    "color",
    "column",
    "combination",
    "combine",
    "come",
    "comfortable",
    "coming",
    "command",
    "common",
    "community",
    "company",
    "compare",
    "compass",
    "complete",
    "completely",
    "complex",
    "composed",
    "composition",
    "compound",
    "concerned",
    "condition",
    "congress",
    "connected",
    "consider",
    "consist",
    "consonant",
    "constantly",
    "construction",
    "contain",
    "continent",
    "continued",
    "contrast",
    "control",
    "conversation",
    "cook",
    "cookies",
    "cool",
    "copper",
    "copy",
    "corn",
    "corner",
    "correct",
    "correctly",
    "cost",
    "cotton",
    "could",
    "count",
    "country",
    "couple",
    "courage",
    "course",
    "court",
    "cover",
    "cow",
    "cowboy",
    "crack",
    "cream",
    "create",
    "creature",
    "crew",
    "crop",
    "cross",
    "crowd",
    "cry",
    "cup",
    "curious",
    "current",
    "curve",
    "customs",
    "cut",
    "cutting",
    "daily",
    "damage",
    "dance",
    "danger",
    "dangerous",
    "dark",
    "darkness",
    "date",
    "daughter",
    "dawn",
    "day",
    "dead",
    "deal",
    "dear",
    "death",
    "decide",
    "declared",
    "deep",
    "deeply",
    "deer",
    "definition",
    "degree",
    "depend",
    "depth",
    "describe",
    "desert",
    "design",
    "desk",
    "detail",
    "determine",
    "develop",
    "development",
    "diagram",
    "diameter",
    "did",
    "die",
    "differ",
    "difference",
    "different",
    "difficult",
    "difficulty",
    "dig",
    "dinner",
    "direct",
    "direction",
    "directly",
    "dirt",
    "dirty",
    "disappear",
    "discover",
    "discovery",
    "discuss",
    "discussion",
    "disease",
    "dish",
    "distance",
    "distant",
    "divide",
    "division",
    "do",
    "doctor",
    "does",
    "dog",
    "doing",
    "doll",
    "dollar",
    "done",
    "donkey",
    "door",
    "dot",
    "double",
    "doubt",
    "down",
    "dozen",
    "draw",
    "drawn",
    "dream",
    "dress",
    "drew",
    "dried",
    "drink",
    "drive",
    "driven",
    "driver",
    "driving",
    "drop",
    "dropped",
    "drove",
    "dry",
    "duck",
    "due",
    "dug",
    "dull",
    "during",
    "dust",
    "duty",
    "each",
    "eager",
    "ear",
    "earlier",
    "early",
    "earn",
    "earth",
    "easier",
    "easily",
    "east",
    "easy",
    "eat",
    "eaten",
    "edge",
    "education",
    "effect",
    "effort",
    "egg",
    "eight",
    "either",
    "electric",
    "electricity",
    "element",
    "elephant",
    "eleven",
    "else",
    "empty",
    "end",
    "enemy",
    "energy",
    "engine",
    "engineer",
    "enjoy",
    "enough",
    "enter",
    "entire",
    "entirely",
    "environment",
    "equal",
    "equally",
    "equator",
    "equipment",
    "escape",
    "especially",
    "essential",
    "establish",
    "even",
    "evening",
    "event",
    "eventually",
    "ever",
    "every",
    "everybody",
    "everyone",
    "everything",
    "everywhere",
    "evidence",
    "exact",
    "exactly",
    "examine",
    "example",
    "excellent",
    "except",
    "exchange",
    "excited",
    "excitement",
    "exciting",
    "exclaimed",
    "exercise",
    "exist",
    "expect",
    "experience",
    "experiment",
    "explain",
    "explanation",
    "explore",
    "express",
    "expression",
    "extra",
    "eye",
    "face",
    "facing",
    "fact",
    "factor",
    "factory",
    "failed",
    "fair",
    "fairly",
    "fall",
    "fallen",
    "familiar",
    "family",
    "famous",
    "far",
    "farm",
    "farmer",
    "farther",
    "fast",
    "fastened",
    "faster",
    "fat",
    "father",
    "favorite",
    "fear",
    "feathers",
    "feature",
    "fed",
    "feed",
    "feel",
    "feet",
    "fell",
    "fellow",
    "felt",
    "fence",
    "few",
    "fewer",
    "field",
    "fierce",
    "fifteen",
    "fifth",
    "fifty",
    "fight",
    "fighting",
    "figure",
    "fill",
    "film",
    "final",
    "finally",
    "find",
    "fine",
    "finest",
    "finger",
    "finish",
    "fire",
    "fireplace",
    "firm",
    "first",
    "fish",
    "five",
    "fix",
    "flag",
    "flame",
    "flat",
    "flew",
    "flies",
    "flight",
    "floating",
    "floor",
    "flow",
    "flower",
    "fly",
    "fog",
    "folks",
    "follow",
    "food",
    "foot",
    "football",
    "for",
    "force",
    "foreign",
    "forest",
    "forget",
    "forgot",
    "forgotten",
    "form",
    "former",
    "fort",
    "forth",
    "forty",
    "forward",
    "fought",
    "found",
    "four",
    "fourth",
    "fox",
    "frame",
    "free",
    "freedom",
    "frequently",
    "fresh",
    "friend",
    "friendly",
    "frighten",
    "frog",
    "from",
    "front",
    "frozen",
    "fruit",
    "fuel",
    "full",
    "fully",
    "fun",
    "function",
    "funny",
    "fur",
    "furniture",
    "further",
    "future",
    "gain",
    "game",
    "garage",
    "garden",
    "gas",
    "gasoline",
    "gate",
    "gather",
    "gave",
    "general",
    "generally",
    "gentle",
    "gently",
    "get",
    "getting",
    "giant",
    "gift",
    "girl",
    "give",
    "given",
    "giving",
    "glad",
    "glass",
    "globe",
    "go",
    "goes",
    "gold",
    "golden",
    "gone",
    "good",
    "goose",
    "got",
    "government",
    "grabbed",
    "grade",
    "gradually",
    "grain",
    "grandfather",
    "grandmother",
    "graph",
    "grass",
    "gravity",
    "gray",
    "great",
    "greater",
    "greatest",
    "greatly",
    "green",
    "grew",
    "ground",
    "group",
    "grow",
    "grown",
    "growth",
    "guard",
    "guess",
    "guide",
    "gulf",
    "gun",
    "habit",
    "had",
    "hair",
    "half",
    "halfway",
    "hall",
    "hand",
    "handle",
    "handsome",
    "hang",
    "happen",
    "happened",
    "happily",
    "happy",
    "harbor",
    "hard",
    "harder",
    "hardly",
    "has",
    "hat",
    "have",
    "having",
    "hay",
    "he",
    "headed",
    "heading",
    "health",
    "heard",
    "hearing",
    "heart",
    "heat",
    "heavy",
    "height",
    "held",
    "hello",
    "help",
    "helpful",
    "her",
    "herd",
    "here",
    "herself",
    "hidden",
    "hide",
    "high",
    "higher",
    "highest",
    "highway",
    "hill",
    "him",
    "himself",
    "his",
    "history",
    "hit",
    "hold",
    "hole",
    "hollow",
    "home",
    "honor",
    "hope",
    "horn",
    "horse",
    "hospital",
    "hot",
    "hour",
    "house",
    "how",
    "however",
    "huge",
    "human",
    "hundred",
    "hung",
    "hungry",
    "hunt",
    "hunter",
    "hurried",
    "hurry",
    "hurt",
    "husband",
    "ice",
    "idea",
    "identity",
    "if",
    "ill",
    "image",
    "imagine",
    "immediately",
    "importance",
    "important",
    "impossible",
    "improve",
    "in",
    "inch",
    "include",
    "including",
    "income",
    "increase",
    "indeed",
    "independent",
    "indicate",
    "individual",
    "industrial",
    "industry",
    "influence",
    "information",
    "inside",
    "instance",
    "instant",
    "instead",
    "instrument",
    "interest",
    "interior",
    "into",
    "introduced",
    "invented",
    "involved",
    "iron",
    "is",
    "island",
    "it",
    "its",
    "itself",
    "jack",
    "jar",
    "jet",
    "job",
    "join",
    "joined",
    "journey",
    "joy",
    "judge",
    "jump",
    "jungle",
    "just",
    "keep",
    "kept",
    "key",
    "kids",
    "kill",
    "kind",
    "kitchen",
    "knew",
    "knife",
    "know",
    "knowledge",
    "known",
    "label",
    "labor",
    "lack",
    "lady",
    "laid",
    "lake",
    "lamp",
    "land",
    "language",
    "large",
    "larger",
    "largest",
    "last",
    "late",
    "later",
    "laugh",
    "law",
    "lay",
    "layers",
    "lead",
    "leader",
    "leaf",
    "learn",
    "least",
    "leather",
    "leave",
    "leaving",
    "led",
    "left",
    "leg",
    "length",
    "lesson",
    "let",
    "letter",
    "level",
    "library",
    "lie",
    "life",
    "lift",
    "light",
    "like",
    "likely",
    "limited",
    "line",
    "lion",
    "lips",
    "liquid",
    "list",
    "listen",
    "little",
    "live",
    "living",
    "load",
    "local",
    "locate",
    "location",
    "log",
    "lonely",
    "long",
    "longer",
    "look",
    "loose",
    "lose",
    "loss",
    "lost",
    "lot",
    "loud",
    "love",
    "lovely",
    "low",
    "lower",
    "luck",
    "lucky",
    "lunch",
    "lungs",
    "lying",
    "machine",
    "machinery",
    "mad",
    "made",
    "magic",
    "magnet",
    "mail",
    "main",
    "mainly",
    "major",
    "make",
    "making",
    "man",
    "managed",
    "manner",
    "manufacturing",
    "many",
    "map",
    "mark",
    "market",
    "married",
    "mass",
    "massage",
    "master",
    "material",
    "mathematics",
    "matter",
    "may",
    "maybe",
    "me",
    "meal",
    "mean",
    "means",
    "meant",
    "measure",
    "meat",
    "medicine",
    "meet",
    "melted",
    "member",
    "memory",
    "men",
    "mental",
    "merely",
    "met",
    "metal",
    "method",
    "mice",
    "middle",
    "might",
    "mighty",
    "mile",
    "military",
    "milk",
    "mill",
    "mind",
    "mine",
    "minerals",
    "minute",
    "mirror",
    "missing",
    "mission",
    "mistake",
    "mix",
    "mixture",
    "model",
    "modern",
    "molecular",
    "moment",
    "money",
    "monkey",
    "month",
    "mood",
    "moon",
    "more",
    "morning",
    "most",
    "mostly",
    "mother",
    "motion",
    "motor",
    "mountain",
    "mouse",
    "mouth",
    "move",
    "movement",
    "movie",
    "moving",
    "mud",
    "muscle",
    "music",
    "musical",
    "must",
    "my",
    "myself",
    "mysterious",
    "nails",
    "name",
    "nation",
    "national",
    "native",
    "natural",
    "naturally",
    "nature",
    "near",
    "nearby",
    "nearer",
    "nearest",
    "nearly",
    "necessary",
    "neck",
    "needed",
    "needle",
    "needs",
    "negative",
    "neighbor",
    "neighborhood",
    "nervous",
    "nest",
    "never",
    "new",
    "news",
    "newspaper",
    "next",
    "nice",
    "night",
    "nine",
    "no",
    "nobody",
    "nodded",
    "noise",
    "none",
    "noon",
    "nor",
    "north",
    "nose",
    "not",
    "note",
    "noted",
    "nothing",
    "notice",
    "noun",
    "now",
    "number",
    "numeral",
    "nuts",
    "object",
    "observe",
    "obtain",
    "occasionally",
    "occur",
    "ocean",
    "of",
    "off",
    "offer",
    "office",
    "officer",
    "official",
    "oil",
    "old",
    "older",
    "oldest",
    "on",
    "once",
    "one",
    "only",
    "onto",
    "open",
    "operation",
    "opinion",
    "opportunity",
    "opposite",
    "or",
    "orange",
    "orbit",
    "order",
    "ordinary",
    "organization",
    "organized",
    "origin",
    "original",
    "other",
    "ought",
    "our",
    "ourselves",
    "out",
    "outer",
    "outline",
    "outside",
    "over",
    "own",
    "owner",
    "oxygen",
    "pack",
    "package",
    "page",
    "paid",
    "pain",
    "paint",
    "pair",
    "palace",
    "pale",
    "pan",
    "paper",
    "paragraph",
    "parallel",
    "parent",
    "park",
    "part",
    "particles",
    "particular",
    "particularly",
    "partly",
    "parts",
    "party",
    "pass",
    "passage",
    "past",
    "path",
    "pattern",
    "pay",
    "peace",
    "pen",
    "pencil",
    "people",
    "per",
    "percent",
    "perfect",
    "perfectly",
    "perhaps",
    "period",
    "person",
    "personal",
    "pet",
    "phrase",
    "physical",
    "piano",
    "pick",
    "picture",
    "pictured",
    "pie",
    "piece",
    "pig",
    "pile",
    "pilot",
    "pine",
    "pink",
    "pipe",
    "pitch",
    "place",
    "plain",
    "plan",
    "plane",
    "planet",
    "planned",
    "planning",
    "plant",
    "plastic",
    "plate",
    "plates",
    "play",
    "pleasant",
    "please",
    "pleasure",
    "plenty",
    "plural",
    "plus",
    "pocket",
    "poem",
    "poet",
    "poetry",
    "point",
    "pole",
    "police",
    "policeman",
    "political",
    "pond",
    "pony",
    "pool",
    "poor",
    "popular",
    "population",
    "porch",
    "port",
    "position",
    "positive",
    "possible",
    "possibly",
    "post",
    "pot",
    "potatoes",
    "pound",
    "pour",
    "powder",
    "power",
    "powerful",
    "practical",
    "practice",
    "prepare",
    "present",
    "president",
    "press",
    "pressure",
    "pretty",
    "prevent",
    "previous",
    "price",
    "pride",
    "primitive",
    "principal",
    "principle",
    "printed",
    "private",
    "prize",
    "probably",
    "problem",
    "process",
    "produce",
    "product",
    "production",
    "program",
    "progress",
    "promised",
    "proper",
    "properly",
    "property",
    "protection",
    "proud",
    "prove",
    "provide",
    "public",
    "pull",
    "pupil",
    "pure",
    "purple",
    "purpose",
    "push",
    "put",
    "putting",
    "quarter",
    "queen",
    "question",
    "quick",
    "quickly",
    "quiet",
    "quietly",
    "quite",
    "rabbit",
    "race",
    "radio",
    "railroad",
    "rain",
    "raise",
    "ran",
    "ranch",
    "range",
    "rapidly",
    "rate",
    "rather",
    "raw",
    "rays",
    "reach",
    "read",
    "reader",
    "ready",
    "real",
    "realize",
    "rear",
    "reason",
    "recall",
    "receive",
    "recent",
    "recently",
    "recognize",
    "record",
    "red",
    "refer",
    "refused",
    "region",
    "regular",
    "related",
    "relationship",
    "religious",
    "remain",
    "remarkable",
    "remember",
    "remove",
    "repeat",
    "replace",
    "replied",
    "report",
    "represent",
    "require",
    "research",
    "respect",
    "rest",
    "result",
    "return",
    "review",
    "rhyme",
    "rhythm",
    "rice",
    "rich",
    "ride",
    "riding",
    "right",
    "ring",
    "rise",
    "rising",
    "river",
    "road",
    "roar",
    "rock",
    "rocket",
    "rocky",
    "rod",
    "roll",
    "roof",
    "room",
    "root",
    "rope",
    "rose",
    "rough",
    "round",
    "route",
    "row",
    "rubbed",
    "rubber",
    "rule",
    "ruler",
    "run",
    "running",
    "rush",
    "sad",
    "saddle",
    "safe",
    "safety",
    "said",
    "sail",
    "sale",
    "salmon",
    "salt",
    "same",
    "sand",
    "sang",
    "sat",
    "satellites",
    "satisfied",
    "save",
    "saved",
    "saw",
    "say",
    "scale",
    "scared",
    "scene",
    "school",
    "science",
    "scientific",
    "scientist",
    "score",
    "screen",
    "sea",
    "search",
    "season",
    "seat",
    "second",
    "secret",
    "section",
    "see",
    "seed",
    "seeing",
    "seems",
    "seen",
    "seldom",
    "select",
    "selection",
    "sell",
    "send",
    "sense",
    "sent",
    "sentence",
    "separate",
    "series",
    "serious",
    "serve",
    "service",
    "sets",
    "setting",
    "settle",
    "settlers",
    "seven",
    "several",
    "shade",
    "shadow",
    "shake",
    "shaking",
    "shall",
    "shallow",
    "shape",
    "share",
    "sharp",
    "she",
    "sheep",
    "sheet",
    "shelf",
    "shells",
    "shelter",
    "shine",
    "shinning",
    "ship",
    "shirt",
    "shoe",
    "shoot",
    "shop",
    "shore",
    "short",
    "shorter",
    "shot",
    "should",
    "shoulder",
    "shout",
    "show",
    "shown",
    "shut",
    "sick",
    "sides",
    "sight",
    "sign",
    "signal",
    "silence",
    "silent",
    "silk",
    "silly",
    "silver",
    "similar",
    "simple",
    "simplest",
    "simply",
    "since",
    "sing",
    "single",
    "sink",
    "sister",
    "sit",
    "sitting",
    "situation",
    "six",
    "size",
    "skill",
    "skin",
    "sky",
    "slabs",
    "slave",
    "sleep",
    "slept",
    "slide",
    "slight",
    "slightly",
    "slip",
    "slipped",
    "slope",
    "slow",
    "slowly",
    "small",
    "smaller",
    "smallest",
    "smell",
    "smile",
    "smoke",
    "smooth",
    "snake",
    "snow",
    "so",
    "soap",
    "social",
    "society",
    "soft",
    "softly",
    "soil",
    "solar",
    "sold",
    "soldier",
    "solid",
    "solution",
    "solve",
    "some",
    "somebody",
    "somehow",
    "someone",
    "something",
    "sometime",
    "somewhere",
    "son",
    "song",
    "soon",
    "sort",
    "sound",
    "source",
    "south",
    "southern",
    "space",
    "speak",
    "special",
    "species",
    "specific",
    "speech",
    "speed",
    "spell",
    "spend",
    "spent",
    "spider",
    "spin",
    "spirit",
    "spite",
    "split",
    "spoken",
    "sport",
    "spread",
    "spring",
    "square",
    "stage",
    "stairs",
    "stand",
    "standard",
    "star",
    "stared",
    "start",
    "state",
    "statement",
    "station",
    "stay",
    "steady",
    "steam",
    "steel",
    "steep",
    "stems",
    "step",
    "stepped",
    "stick",
    "stiff",
    "still",
    "stock",
    "stomach",
    "stone",
    "stood",
    "stop",
    "stopped",
    "store",
    "storm",
    "story",
    "stove",
    "straight",
    "strange",
    "stranger",
    "straw",
    "stream",
    "street",
    "strength",
    "stretch",
    "strike",
    "string",
    "strip",
    "strong",
    "stronger",
    "struck",
    "structure",
    "struggle",
    "stuck",
    "student",
    "studied",
    "studying",
    "subject",
    "substance",
    "success",
    "successful",
    "such",
    "sudden",
    "suddenly",
    "sugar",
    "suggest",
    "suit",
    "sum",
    "summer",
    "sun",
    "sunlight",
    "supper",
    "supply",
    "support",
    "suppose",
    "sure",
    "surface",
    "surprise",
    "surrounded",
    "swam",
    "sweet",
    "swept",
    "swim",
    "swimming",
    "swing",
    "swung",
    "syllable",
    "symbol",
    "system",
    "table",
    "tail",
    "take",
    "taken",
    "tales",
    "talk",
    "tall",
    "tank",
    "tape",
    "task",
    "taste",
    "taught",
    "tax",
    "tea",
    "teach",
    "teacher",
    "team",
    "tears",
    "teeth",
    "telephone",
    "television",
    "tell",
    "temperature",
    "ten",
    "tent",
    "term",
    "terrible",
    "test",
    "than",
    "thank",
    "that",
    "thee",
    "them",
    "themselves",
    "then",
    "theory",
    "there",
    "therefore",
    "these",
    "they",
    "thick",
    "thin",
    "thing",
    "think",
    "third",
    "thirty",
    "this",
    "those",
    "thou",
    "though",
    "thought",
    "thousand",
    "thread",
    "three",
    "threw",
    "throat",
    "through",
    "throughout",
    "throw",
    "thrown",
    "thumb",
    "thus",
    "thy",
    "tide",
    "tie",
    "tight",
    "tightly",
    "till",
    "time",
    "tin",
    "tiny",
    "tip",
    "tired",
    "title",
    "to",
    "tobacco",
    "today",
    "together",
    "told",
    "tomorrow",
    "tone",
    "tongue",
    "tonight",
    "too",
    "took",
    "tool",
    "top",
    "topic",
    "torn",
    "total",
    "touch",
    "toward",
    "tower",
    "town",
    "toy",
    "trace",
    "track",
    "trade",
    "traffic",
    "trail",
    "train",
    "transportation",
    "trap",
    "travel",
    "treated",
    "tree",
    "triangle",
    "tribe",
    "trick",
    "tried",
    "trip",
    "troops",
    "tropical",
    "trouble",
    "truck",
    "trunk",
    "truth",
    "try",
    "tube",
    "tune",
    "turn",
    "twelve",
    "twenty",
    "twice",
    "two",
    "type",
    "typical",
    "uncle",
    "under",
    "underline",
    "understanding",
    "unhappy",
    "union",
    "unit",
    "universe",
    "unknown",
    "unless",
    "until",
    "unusual",
    "up",
    "upon",
    "upper",
    "upward",
    "us",
    "use",
    "useful",
    "using",
    "usual",
    "usually",
    "valley",
    "valuable",
    "value",
    "vapor",
    "variety",
    "various",
    "vast",
    "vegetable",
    "verb",
    "vertical",
    "very",
    "vessels",
    "victory",
    "view",
    "village",
    "visit",
    "visitor",
    "voice",
    "volume",
    "vote",
    "vowel",
    "voyage",
    "wagon",
    "wait",
    "walk",
    "wall",
    "want",
    "war",
    "warm",
    "warn",
    "was",
    "wash",
    "waste",
    "watch",
    "water",
    "wave",
    "way",
    "we",
    "weak",
    "wealth",
    "wear",
    "weather",
    "week",
    "weigh",
    "weight",
    "welcome",
    "well",
    "went",
    "were",
    "west",
    "western",
    "wet",
    "whale",
    "what",
    "whatever",
    "wheat",
    "wheel",
    "when",
    "whenever",
    "where",
    "wherever",
    "whether",
    "which",
    "while",
    "whispered",
    "whistle",
    "white",
    "who",
    "whole",
    "whom",
    "whose",
    "why",
    "wide",
    "widely",
    "wife",
    "wild",
    "will",
    "willing",
    "win",
    "wind",
    "window",
    "wing",
    "winter",
    "wire",
    "wise",
    "wish",
    "with",
    "within",
    "without",
    "wolf",
    "women",
    "won",
    "wonder",
    "wonderful",
    "wood",
    "wooden",
    "wool",
    "word",
    "wore",
    "work",
    "worker",
    "world",
    "worried",
    "worry",
    "worse",
    "worth",
    "would",
    "wrapped",
    "write",
    "writer",
    "writing",
    "written",
    "wrong",
    "wrote",
    "yard",
    "year",
    "yellow",
    "yes",
    "yesterday",
    "yet",
    "you",
    "young",
    "younger",
    "your",
    "yourself",
    "youth",
    "zero",
    "zebra",
    "zipper",
    "zoo",
    "zulu"
];
function $5b3182bea2919cf8$var$words(options) {
    // initalize random number generator for words if options.seed is provided
    const random = (options === null || options === void 0 ? void 0 : options.seed) ? new $lLWva(options.seed) : null;
    function word() {
        if (options && options.maxLength > 1) return generateWordWithMaxLength();
        else return generateRandomWord();
    }
    function generateWordWithMaxLength() {
        var rightSize = false;
        var wordUsed;
        while(!rightSize){
            wordUsed = generateRandomWord();
            if (wordUsed.length <= options.maxLength) rightSize = true;
        }
        return wordUsed;
    }
    function generateRandomWord() {
        return $5b3182bea2919cf8$var$wordList[randInt($5b3182bea2919cf8$var$wordList.length)];
    }
    // random int as seeded by options.seed if applicable, or Math.random() otherwise
    function randInt(lessThan) {
        const r = random ? random() : Math.random();
        return Math.floor(r * lessThan);
    }
    // No arguments = generate one word
    if (typeof options === "undefined") return word();
    // Just a number = return that many words
    if (typeof options === "number") options = {
        exactly: options
    };
    // options supported: exactly, min, max, join
    if (options.exactly) {
        options.min = options.exactly;
        options.max = options.exactly;
    }
    // not a number = one word par string
    if (typeof options.wordsPerString !== "number") options.wordsPerString = 1;
    //not a function = returns the raw word
    if (typeof options.formatter !== "function") options.formatter = (word)=>word;
    //not a string = separator is a space
    if (typeof options.separator !== "string") options.separator = " ";
    var total = options.min + randInt(options.max + 1 - options.min);
    var results = [];
    var token = "";
    var relativeIndex = 0;
    for(var i = 0; i < total * options.wordsPerString; i++){
        if (relativeIndex === options.wordsPerString - 1) token += options.formatter(word(), relativeIndex);
        else token += options.formatter(word(), relativeIndex) + options.separator;
        relativeIndex++;
        if ((i + 1) % options.wordsPerString === 0) {
            results.push(token);
            token = "";
            relativeIndex = 0;
        }
    }
    if (typeof options.join === "string") results = results.join(options.join);
    return results;
}
module.exports = $5b3182bea2919cf8$var$words;
// Export the word list as it is often useful
$5b3182bea2919cf8$var$words.wordList = $5b3182bea2919cf8$var$wordList;

});
parcelRegister("lLWva", function(module, exports) {
// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.
// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.

var $fMkAt = parcelRequire("fMkAt");

var $bxATj = parcelRequire("bxATj");

var $50dos = parcelRequire("50dos");

var $6nkCm = parcelRequire("6nkCm");

var $iCpRQ = parcelRequire("iCpRQ");

var $6j8N8 = parcelRequire("6j8N8");

var $9x7LM = parcelRequire("9x7LM");
$9x7LM.alea = $fMkAt;
$9x7LM.xor128 = $bxATj;
$9x7LM.xorwow = $50dos;
$9x7LM.xorshift7 = $6nkCm;
$9x7LM.xor4096 = $iCpRQ;
$9x7LM.tychei = $6j8N8;
module.exports = $9x7LM;

});
parcelRegister("fMkAt", function(module, exports) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -
// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
(function(global, module1, define1) {
    function Alea(seed) {
        var me = this, mash = Mash();
        me.next = function() {
            var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
            me.s0 = me.s1;
            me.s1 = me.s2;
            return me.s2 = t - (me.c = t | 0);
        };
        // Apply the seeding algorithm from Baagoe.
        me.c = 1;
        me.s0 = mash(" ");
        me.s1 = mash(" ");
        me.s2 = mash(" ");
        me.s0 -= mash(seed);
        if (me.s0 < 0) me.s0 += 1;
        me.s1 -= mash(seed);
        if (me.s1 < 0) me.s1 += 1;
        me.s2 -= mash(seed);
        if (me.s2 < 0) me.s2 += 1;
        mash = null;
    }
    function copy(f, t) {
        t.c = f.c;
        t.s0 = f.s0;
        t.s1 = f.s1;
        t.s2 = f.s2;
        return t;
    }
    function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
            return xg.next() * 0x100000000 | 0;
        };
        prng.double = function() {
            return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
        };
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = String(data);
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.alea = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("bxATj", function(module, exports) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x << 11;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            return me.w ^= me.w >>> 19 ^ t ^ t >>> 8;
        };
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor128 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("50dos", function(module, exports) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x >>> 2;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            me.w = me.v;
            return (me.d = me.d + 362437 | 0) + (me.v = me.v ^ me.v << 4 ^ (t ^ t << 1)) | 0;
        };
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        me.v = 0;
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            if (k == strseed.length) me.d = me.x << 10 ^ me.x >>> 4;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        t.v = f.v;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorwow = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("6nkCm", function(module, exports) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            // Update xor generator.
            var X = me.x, i = me.i, t, v, w;
            t = X[i];
            t ^= t >>> 7;
            v = t ^ t << 24;
            t = X[i + 1 & 7];
            v ^= t ^ t >>> 10;
            t = X[i + 3 & 7];
            v ^= t ^ t >>> 3;
            t = X[i + 4 & 7];
            v ^= t ^ t << 7;
            t = X[i + 7 & 7];
            t = t ^ t << 13;
            v ^= t ^ t << 9;
            X[i] = v;
            me.i = i + 1 & 7;
            return v;
        };
        function init(me, seed) {
            var j, w, X = [];
            if (seed === (seed | 0)) // Seed state array using a 32-bit integer.
            w = X[0] = seed;
            else {
                // Seed state using a string.
                seed = "" + seed;
                for(j = 0; j < seed.length; ++j)X[j & 7] = X[j & 7] << 15 ^ seed.charCodeAt(j) + X[j + 1 & 7] << 13;
            }
            // Enforce an array length of 8, not all zeroes.
            while(X.length < 8)X.push(0);
            for(j = 0; j < 8 && X[j] === 0; ++j);
            if (j == 8) w = X[7] = -1;
            else w = X[j];
            me.x = X;
            me.i = 0;
            // Discard an initial 256 values.
            for(j = 256; j > 0; --j)me.next();
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.x = f.x.slice();
        t.i = f.i;
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.x) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorshift7 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("iCpRQ", function(module, exports) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            var w = me.w, X = me.X, i = me.i, t, v;
            // Update Weyl generator.
            me.w = w = w + 0x61c88647 | 0;
            // Update xor generator.
            v = X[i + 34 & 127];
            t = X[i = i + 1 & 127];
            v ^= v << 13;
            t ^= t << 17;
            v ^= v >>> 15;
            t ^= t >>> 12;
            // Update Xor generator array state.
            v = X[i] = v ^ t;
            me.i = i;
            // Result is the combination.
            return v + (w ^ w >>> 16) | 0;
        };
        function init(me, seed) {
            var t, v, i, j, w, X = [], limit = 128;
            if (seed === (seed | 0)) {
                // Numeric seeds initialize v, which is used to generates X.
                v = seed;
                seed = null;
            } else {
                // String seeds are mixed into v and X one character at a time.
                seed = seed + "\0";
                v = 0;
                limit = Math.max(limit, seed.length);
            }
            // Initialize circular array and weyl value.
            for(i = 0, j = -32; j < limit; ++j){
                // Put the unicode characters into the array, and shuffle them.
                if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
                // After 32 shuffles, take v as the starting w value.
                if (j === 0) w = v;
                v ^= v << 10;
                v ^= v >>> 15;
                v ^= v << 4;
                v ^= v >>> 13;
                if (j >= 0) {
                    w = w + 0x61c88647 | 0; // Weyl.
                    t = X[j & 127] ^= v + w; // Combine xor and weyl to init array.
                    i = 0 == t ? i + 1 : 0; // Count zeroes.
                }
            }
            // We have detected all zeroes; make the key nonzero.
            if (i >= 128) X[(seed && seed.length || 0) & 127] = -1;
            // Run the generator 512 times to further mix the state before using it.
            // Factoring this as a function slows the main generator, so it is just
            // unrolled here.  The weyl generator is not advanced while warming up.
            i = 127;
            for(j = 512; j > 0; --j){
                v = X[i + 34 & 127];
                t = X[i = i + 1 & 127];
                v ^= v << 13;
                t ^= t << 17;
                v ^= v >>> 15;
                t ^= t >>> 12;
                X[i] = v ^ t;
            }
            // Storing state as object members is faster than using closure variables.
            me.w = w;
            me.X = X;
            me.i = i;
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.i = f.i;
        t.w = f.w;
        t.X = f.X.slice();
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.X) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor4096 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("6j8N8", function(module, exports) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        // Set up generator function.
        me.next = function() {
            var b = me.b, c = me.c, d = me.d, a = me.a;
            b = b << 25 ^ b >>> 7 ^ c;
            c = c - d | 0;
            d = d << 24 ^ d >>> 8 ^ a;
            a = a - b | 0;
            me.b = b = b << 20 ^ b >>> 12 ^ c;
            me.c = c = c - d | 0;
            me.d = d << 16 ^ c >>> 16 ^ a;
            return me.a = a - b | 0;
        };
        /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */ me.a = 0;
        me.b = 0;
        me.c = -1640531527;
        me.d = 1367130551;
        if (seed === Math.floor(seed)) {
            // Integer seed.
            me.a = seed / 0x100000000 | 0;
            me.b = seed | 0;
        } else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 20; k++){
            me.b ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.a = f.a;
        t.b = f.b;
        t.c = f.c;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.tychei = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("9x7LM", function(module, exports) {

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ (function(global, pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var width = 256, chunks = 6, digits = 52, rngname = "random", startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //
    function seedrandom(seed, options, callback) {
        var key = [];
        options = options == true ? {
            entropy: true
        } : options || {};
        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(options.entropy ? [
            seed,
            tostring(pool)
        ] : seed == null ? autoseed() : seed, 3), key);
        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);
        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks), d = startdenom, x = 0; //   and no 'extra last byte'.
            while(n < significance){
                n = (n + x) * width; //   shifting numerator and
                d *= width; //   denominator and generating a
                x = arc4.g(1); //   new least-significant-byte.
            }
            while(n >= overflow){
                n /= 2; //   last byte, shift everything
                d /= 2; //   right using integer math until
                x >>>= 1; //   we have exactly the desired bits.
            }
            return (n + x) / d; // Form the number within [0, 1).
        };
        prng.int32 = function() {
            return arc4.g(4) | 0;
        };
        prng.quick = function() {
            return arc4.g(4) / 0x100000000;
        };
        prng.double = prng;
        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);
        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback || function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) copy(state, arc4);
                // Only provide the .state method if requested via options.state.
                prng.state = function() {
                    return copy(arc4, {});
                };
            }
            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) {
                math[rngname] = prng;
                return seed;
            } else return prng;
        })(prng, shortseed, "global" in options ? options.global : this == math, options.state);
    }
    //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //
    function ARC4(key) {
        var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
        // The empty key [] is treated as [0].
        if (!keylen) key = [
            keylen++
        ];
        // Set up S using the standard key scheduling algorithm.
        while(i < width)s[i] = i++;
        for(i = 0; i < width; i++){
            s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
            s[j] = t;
        }
        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0, i = me.i, j = me.j, s = me.S;
            while(count--){
                t = s[i = mask & i + 1];
                r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
            }
            me.i = i;
            me.j = j;
            return r;
        // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }
    //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }
    //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //
    function flatten(obj, depth) {
        var result = [], typ = typeof obj, prop;
        if (depth && typ == "object") {
            for(prop in obj)try {
                result.push(flatten(obj[prop], depth - 1));
            } catch (e) {}
        }
        return result.length ? result : typ == "string" ? obj : obj + "\0";
    }
    //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //
    function mixkey(seed, key) {
        var stringseed = seed + "", smear, j = 0;
        while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
        return tostring(key);
    }
    //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //
    function autoseed() {
        try {
            var out;
            if (nodecrypto && (out = nodecrypto.randomBytes)) // The use of 'out' to remember randomBytes makes tight minified code.
            out = out(width);
            else {
                out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
            }
            return tostring(out);
        } catch (e) {
            var browser = global.navigator, plugins = browser && browser.plugins;
            return [
                +new Date,
                global,
                plugins,
                global.screen,
                tostring(pool)
            ];
        }
    }
    //
    // tostring()
    // Converts an array of charcodes to a string
    //
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }
    //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //
    mixkey(math.random(), pool);
    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    if (0, module.exports) {
        module.exports = seedrandom;
        // When in node.js, try using crypto package for autoseeding.
        try {
            nodecrypto = (parcelRequire("133LX"));
        } catch (ex) {}
    } else if (typeof define == "function" && define.amd) define(function() {
        return seedrandom;
    });
    else // When included as a plain script, set up Math.seedrandom global.
    math["seed" + rngname] = seedrandom;
// End anonymous scope, and pass initial values.
})(// global: `self` in browsers (including strict mode and web workers),
// otherwise `this` in Node and other environments
typeof self !== "undefined" ? self : module.exports, [], Math // math: package containing random, pow, and seedrandom
);

});
parcelRegister("133LX", function(module, exports) {
"use strict";

});




parcelRegister("4ae0y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $jMmZt.default;
    }
});

var $jMmZt = parcelRequire("jMmZt");

});
parcelRegister("jMmZt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6645570d2812ca5$export$2e2bcd8739ae039; });

var $kO11b = parcelRequire("kO11b");

var $a2gHv = parcelRequire("a2gHv");

var $fKNZr = parcelRequire("fKNZr");
function $e6645570d2812ca5$export$2e2bcd8739ae039(path, displayName) {
    var Component = function Component(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).createElement((0, $fKNZr.default), (0, $kO11b.default)({
            ref: ref
        }, props), path);
    };
    Component.muiName = (0, $fKNZr.default).muiName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).forwardRef(Component));
}

});
parcelRegister("fKNZr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b781ede1ae75e94f$export$2e2bcd8739ae039; });

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");


var $ljK7E = parcelRequire("ljK7E");

var $lrWdp = parcelRequire("lrWdp");
var $b781ede1ae75e94f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: "none",
            width: "1em",
            height: "1em",
            display: "inline-block",
            fill: "currentColor",
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(24),
            transition: theme.transitions.create("fill", {
                duration: theme.transitions.duration.shorter
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: "inherit"
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(35)
        }
    };
};
var $b781ede1ae75e94f$var$SvgIcon = /*#__PURE__*/ $a2gHv.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "inherit" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "svg" : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? "medium" : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? "0 0 24 24" : _props$viewBox, other = (0, $hmzQs.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "titleAccess",
        "viewBox"
    ]);
    return /*#__PURE__*/ $a2gHv.createElement(Component, (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className, color !== "inherit" && classes["color".concat((0, $lrWdp.default)(color))], fontSize !== "default" && fontSize !== "medium" && classes["fontSize".concat((0, $lrWdp.default)(fontSize))]),
        focusable: "false",
        viewBox: viewBox,
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, other), children, titleAccess ? /*#__PURE__*/ $a2gHv.createElement("title", null, titleAccess) : null);
});
$b781ede1ae75e94f$var$SvgIcon.muiName = "SvgIcon";
var $b781ede1ae75e94f$export$2e2bcd8739ae039 = (0, $ljK7E.default)($b781ede1ae75e94f$export$9dd6ff9ea0189349, {
    name: "MuiSvgIcon"
})($b781ede1ae75e94f$var$SvgIcon);

});
parcelRegister("hmzQs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca404bd6e643dd42$export$2e2bcd8739ae039; });

var $lqlJt = parcelRequire("lqlJt");
function $ca404bd6e643dd42$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $lqlJt.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});

parcelRegister("1r7hW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10bdf764a186204e$export$2e2bcd8739ae039; });
function $10bdf764a186204e$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $10bdf764a186204e$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $10bdf764a186204e$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $10bdf764a186204e$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $10bdf764a186204e$export$2e2bcd8739ae039 = $10bdf764a186204e$export$4f5d2d50c9deca37;

});

parcelRegister("ljK7E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f84f26402bea1e1d$export$2e2bcd8739ae039; });

var $kO11b = parcelRequire("kO11b");

var $7TBsR = parcelRequire("7TBsR");

var $hhxkg = parcelRequire("hhxkg");
function $f84f26402bea1e1d$var$withStyles(stylesOrCreator, options) {
    return (0, $7TBsR.default)(stylesOrCreator, (0, $kO11b.default)({
        defaultTheme: (0, $hhxkg.default)
    }, options));
}
var $f84f26402bea1e1d$export$2e2bcd8739ae039 = $f84f26402bea1e1d$var$withStyles;

});
parcelRegister("7TBsR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bfabb205194ecaa$export$2e2bcd8739ae039; });

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $5aifU = parcelRequire("5aifU");


var $f8Yg6 = parcelRequire("f8Yg6");

var $2f2hR = parcelRequire("2f2hR");

var $k7gVl = parcelRequire("k7gVl");
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $5bfabb205194ecaa$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $hmzQs.default)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = (0, $f8Yg6.default)(stylesOrCreator, (0, $kO11b.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $hmzQs.default)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $kO11b.default)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === "string" || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $k7gVl.default)() || defaultTheme;
                if (name) more = (0, $2f2hR.default)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).createElement(Component, (0, $kO11b.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5aifU)))(WithStyles, Component);
        return WithStyles;
    };
};
var $5bfabb205194ecaa$export$2e2bcd8739ae039 = $5bfabb205194ecaa$var$withStyles;

});
parcelRegister("5aifU", function(module, exports) {
"use strict";

var $gnuGk = parcelRequire("gnuGk");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $3c2c0c18dc9eaa45$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3c2c0c18dc9eaa45$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3c2c0c18dc9eaa45$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3c2c0c18dc9eaa45$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3c2c0c18dc9eaa45$var$TYPE_STATICS = {};
$3c2c0c18dc9eaa45$var$TYPE_STATICS[$gnuGk.ForwardRef] = $3c2c0c18dc9eaa45$var$FORWARD_REF_STATICS;
$3c2c0c18dc9eaa45$var$TYPE_STATICS[$gnuGk.Memo] = $3c2c0c18dc9eaa45$var$MEMO_STATICS;
function $3c2c0c18dc9eaa45$var$getStatics(component) {
    // React v16.11 and below
    if ($gnuGk.isMemo(component)) return $3c2c0c18dc9eaa45$var$MEMO_STATICS;
     // React v16.12 and above
    return $3c2c0c18dc9eaa45$var$TYPE_STATICS[component["$$typeof"]] || $3c2c0c18dc9eaa45$var$REACT_STATICS;
}
var $3c2c0c18dc9eaa45$var$defineProperty = Object.defineProperty;
var $3c2c0c18dc9eaa45$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3c2c0c18dc9eaa45$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3c2c0c18dc9eaa45$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3c2c0c18dc9eaa45$var$getPrototypeOf = Object.getPrototypeOf;
var $3c2c0c18dc9eaa45$var$objectPrototype = Object.prototype;
function $3c2c0c18dc9eaa45$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($3c2c0c18dc9eaa45$var$objectPrototype) {
            var inheritedComponent = $3c2c0c18dc9eaa45$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3c2c0c18dc9eaa45$var$objectPrototype) $3c2c0c18dc9eaa45$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $3c2c0c18dc9eaa45$var$getOwnPropertyNames(sourceComponent);
        if ($3c2c0c18dc9eaa45$var$getOwnPropertySymbols) keys = keys.concat($3c2c0c18dc9eaa45$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $3c2c0c18dc9eaa45$var$getStatics(targetComponent);
        var sourceStatics = $3c2c0c18dc9eaa45$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$3c2c0c18dc9eaa45$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $3c2c0c18dc9eaa45$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $3c2c0c18dc9eaa45$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $3c2c0c18dc9eaa45$var$hoistNonReactStatics;

});
parcelRegister("gnuGk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("69fdi"));

});


parcelRegister("f8Yg6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b066587e30e242ca$export$2e2bcd8739ae039; });

var $hmzQs = parcelRequire("hmzQs");

var $kO11b = parcelRequire("kO11b");

var $a2gHv = parcelRequire("a2gHv");

var $b9AqM = parcelRequire("b9AqM");

var $9cDAr = parcelRequire("9cDAr");

var $lAiQ9 = parcelRequire("lAiQ9");

var $k7gVl = parcelRequire("k7gVl");

var $g1MGQ = parcelRequire("g1MGQ");

var $gNxrM = parcelRequire("gNxrM");

var $bvlgU = parcelRequire("bvlgU");

var $ctGgB = parcelRequire("ctGgB");
function $b066587e30e242ca$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $9cDAr.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $b066587e30e242ca$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $lAiQ9.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $lAiQ9.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $kO11b.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === "boolean" ? stylesOptions.flip : theme.direction === "rtl"
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $lAiQ9.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $kO11b.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $lAiQ9.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $b9AqM.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $kO11b.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $9cDAr.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $b066587e30e242ca$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $b066587e30e242ca$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $lAiQ9.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $lAiQ9.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $b066587e30e242ca$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $b066587e30e242ca$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $ctGgB.default) : _options$defaultTheme, stylesOptions2 = (0, $hmzQs.default)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $bvlgU.default)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || "makeStyles";
    stylesCreator.options = {
        index: (0, $gNxrM.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $k7gVl.default)() || defaultTheme;
        var stylesOptions = (0, $kO11b.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).useContext((0, $g1MGQ.StylesContext)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).useRef();
        $b066587e30e242ca$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $b066587e30e242ca$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $b066587e30e242ca$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).useEffect(function() {
            if (shouldUpdate.current) $b066587e30e242ca$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $b066587e30e242ca$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("9cDAr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b33f124f9ae1a89$export$2e2bcd8739ae039; });

var $kO11b = parcelRequire("kO11b");

function $6b33f124f9ae1a89$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $kO11b.default)({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}

});

parcelRegister("lAiQ9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb6b93024699b8a2$export$2e2bcd8739ae039; });
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $fb6b93024699b8a2$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $fb6b93024699b8a2$export$2e2bcd8739ae039 = $fb6b93024699b8a2$var$multiKeyStore;

});

parcelRegister("k7gVl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea5196d83d83794b$export$2e2bcd8739ae039; });

var $a2gHv = parcelRequire("a2gHv");

var $6WN8R = parcelRequire("6WN8R");
function $ea5196d83d83794b$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).useContext((0, $6WN8R.default));
    return theme;
}

});
parcelRegister("6WN8R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50ee47681261f9c6$export$2e2bcd8739ae039; });

var $a2gHv = parcelRequire("a2gHv");
var $50ee47681261f9c6$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).createContext(null);
var $50ee47681261f9c6$export$2e2bcd8739ae039 = $50ee47681261f9c6$var$ThemeContext;

});


parcelRegister("g1MGQ", function(module, exports) {

$parcel$export(module.exports, "StylesContext", function () { return $bab282242492e785$export$f4de434b269fe487; });

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");



var $eSs43 = parcelRequire("eSs43");

var $b9AqM = parcelRequire("b9AqM");

var $itstC = parcelRequire("itstC");
var $bab282242492e785$var$jss = (0, $b9AqM.create)((0, $itstC.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $bab282242492e785$var$generateClassName = (0, $eSs43.default)(); // Exported for test purposes
var $bab282242492e785$export$70a8aea9ff58d1cd = new Map();
var $bab282242492e785$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $bab282242492e785$var$generateClassName,
    jss: $bab282242492e785$var$jss,
    sheetsCache: null,
    sheetsManager: $bab282242492e785$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $bab282242492e785$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).createContext($bab282242492e785$var$defaultOptions);
var $bab282242492e785$var$injectFirstNode;
function $bab282242492e785$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $hmzQs.default)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).useContext($bab282242492e785$export$f4de434b269fe487);
    var context = (0, $kO11b.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== "undefined") {
        if (!$bab282242492e785$var$injectFirstNode) {
            var head = document.head;
            $bab282242492e785$var$injectFirstNode = document.createComment("mui-inject-first");
            head.insertBefore($bab282242492e785$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $b9AqM.create)({
            plugins: (0, $itstC.default)().plugins,
            insertionPoint: $bab282242492e785$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).createElement($bab282242492e785$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}

});
parcelRegister("eSs43", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad4be0dc9ee677be$export$2e2bcd8739ae039; });

var $1kVOJ = parcelRequire("1kVOJ");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $ad4be0dc9ee677be$var$pseudoClasses = [
    "checked",
    "disabled",
    "error",
    "focused",
    "focusVisible",
    "required",
    "expanded",
    "selected"
]; // Returns a function which generates unique class names based on counters.
function $ad4be0dc9ee677be$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? "jss" : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? "" : _options$seed;
    var seedPrefix = seed === "" ? "" : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf("Mui") === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($ad4be0dc9ee677be$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $1kVOJ.default] || seed !== "") return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}

});
parcelRegister("1kVOJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f94820552d49f7c$export$2e2bcd8739ae039; });
var $0f94820552d49f7c$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $0f94820552d49f7c$export$2e2bcd8739ae039 = $0f94820552d49f7c$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

});


parcelRegister("itstC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7310650043ba274$export$2e2bcd8739ae039; });

var $hAD5p = parcelRequire("hAD5p");

var $2GKzt = parcelRequire("2GKzt");

var $fbn7J = parcelRequire("fbn7J");

var $Fhsm5 = parcelRequire("Fhsm5");

var $d5tEK = parcelRequire("d5tEK");

var $O4Rfm = parcelRequire("O4Rfm");

var $ftdqB = parcelRequire("ftdqB");
function $d7310650043ba274$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $hAD5p.default)(),
            (0, $2GKzt.default)(),
            (0, $fbn7J.default)(),
            (0, $Fhsm5.default)(),
            (0, $d5tEK.default)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === "undefined" ? null : (0, $O4Rfm.default)(),
            (0, $ftdqB.default)()
        ]
    };
}

});
parcelRegister("hAD5p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cce41e324c6ef116$export$2e2bcd8739ae039; });


var $b9AqM = parcelRequire("b9AqM");
var $cce41e324c6ef116$var$now = Date.now();
var $cce41e324c6ef116$var$fnValuesNs = "fnValues" + $cce41e324c6ef116$var$now;
var $cce41e324c6ef116$var$fnRuleNs = "fnStyle" + ++$cce41e324c6ef116$var$now;
var $cce41e324c6ef116$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== "function") return null;
            var rule = (0, $b9AqM.createRule)(name, {}, options);
            rule[$cce41e324c6ef116$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($cce41e324c6ef116$var$fnValuesNs in rule || $cce41e324c6ef116$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== "function") continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$cce41e324c6ef116$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$cce41e324c6ef116$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$cce41e324c6ef116$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $cce41e324c6ef116$export$2e2bcd8739ae039 = $cce41e324c6ef116$var$functionPlugin;

});

parcelRegister("2GKzt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f53a11610a866f8$export$2e2bcd8739ae039; });

var $kO11b = parcelRequire("kO11b");

var $b9AqM = parcelRequire("b9AqM");
var $1f53a11610a866f8$var$at = "@global";
var $1f53a11610a866f8$var$atPrefix = "@global ";
var $1f53a11610a866f8$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = "global";
        this.at = $1f53a11610a866f8$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $b9AqM.RuleList)((0, $kO11b.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $1f53a11610a866f8$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = "global";
        this.at = $1f53a11610a866f8$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($1f53a11610a866f8$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $kO11b.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : "";
    };
    return GlobalPrefixedRule;
}();
var $1f53a11610a866f8$var$separatorRegExp = /\s*,\s*/g;
function $1f53a11610a866f8$var$addScope(selector, scope) {
    var parts = selector.split($1f53a11610a866f8$var$separatorRegExp);
    var scoped = "";
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ", ";
    }
    return scoped;
}
function $1f53a11610a866f8$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$1f53a11610a866f8$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $kO11b.default)({}, options, {
        selector: $1f53a11610a866f8$var$addScope(name, rule.selector)
    }));
    delete style[$1f53a11610a866f8$var$at];
}
function $1f53a11610a866f8$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== "@" || prop.substr(0, $1f53a11610a866f8$var$at.length) !== $1f53a11610a866f8$var$at) continue;
        var selector = $1f53a11610a866f8$var$addScope(prop.substr($1f53a11610a866f8$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $kO11b.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $1f53a11610a866f8$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $1f53a11610a866f8$var$at) return new $1f53a11610a866f8$var$GlobalContainerRule(name, styles, options);
        if (name[0] === "@" && name.substr(0, $1f53a11610a866f8$var$atPrefix.length) === $1f53a11610a866f8$var$atPrefix) return new $1f53a11610a866f8$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== "style" || !sheet) return;
        $1f53a11610a866f8$var$handleNestedGlobalContainerRule(rule, sheet);
        $1f53a11610a866f8$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $1f53a11610a866f8$export$2e2bcd8739ae039 = $1f53a11610a866f8$var$jssGlobal;

});

parcelRegister("fbn7J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0d9d1fb3a1ed1c8$export$2e2bcd8739ae039; });

var $kO11b = parcelRequire("kO11b");

var $b0d9d1fb3a1ed1c8$var$separatorRegExp = /\s*,\s*/g;
var $b0d9d1fb3a1ed1c8$var$parentRegExp = /&/g;
var $b0d9d1fb3a1ed1c8$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $b0d9d1fb3a1ed1c8$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($b0d9d1fb3a1ed1c8$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($b0d9d1fb3a1ed1c8$var$separatorRegExp);
        var result = "";
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ", "; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf("&") !== -1 ? nested.replace($b0d9d1fb3a1ed1c8$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $kO11b.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $kO11b.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style") return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf("&") !== -1;
            var isNestedConditional = prop[0] === "@";
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($b0d9d1fb3a1ed1c8$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ("replaceRule" in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $kO11b.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $kO11b.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $b0d9d1fb3a1ed1c8$export$2e2bcd8739ae039 = $b0d9d1fb3a1ed1c8$var$jssNested;

});

parcelRegister("Fhsm5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07c15eea9090372e$export$2e2bcd8739ae039; });

var $eZ7Ih = parcelRequire("eZ7Ih");
/**
 * Convert camel cased property names to dash separated.
 */ function $07c15eea9090372e$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf("--") === 0 ? prop : (0, $eZ7Ih.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($07c15eea9090372e$var$convertCase);
        else converted.fallbacks = $07c15eea9090372e$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $07c15eea9090372e$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $07c15eea9090372e$var$convertCase(style[index]);
            return style;
        }
        return $07c15eea9090372e$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf("--") === 0) return value;
        var hyphenatedProp = (0, $eZ7Ih.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $07c15eea9090372e$export$2e2bcd8739ae039 = $07c15eea9090372e$var$camelCase;

});
parcelRegister("eZ7Ih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae8cbedee5a0e244$export$2e2bcd8739ae039; });
/* eslint-disable no-var, prefer-template */ var $ae8cbedee5a0e244$var$uppercasePattern = /[A-Z]/g;
var $ae8cbedee5a0e244$var$msPattern = /^ms-/;
var $ae8cbedee5a0e244$var$cache = {};
function $ae8cbedee5a0e244$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $ae8cbedee5a0e244$var$hyphenateStyleName(name) {
    if ($ae8cbedee5a0e244$var$cache.hasOwnProperty(name)) return $ae8cbedee5a0e244$var$cache[name];
    var hName = name.replace($ae8cbedee5a0e244$var$uppercasePattern, $ae8cbedee5a0e244$var$toHyphenLower);
    return $ae8cbedee5a0e244$var$cache[name] = $ae8cbedee5a0e244$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $ae8cbedee5a0e244$export$2e2bcd8739ae039 = $ae8cbedee5a0e244$var$hyphenateStyleName;

});


parcelRegister("d5tEK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9872bf1eee939dc1$export$2e2bcd8739ae039; });

var $b9AqM = parcelRequire("b9AqM");
var $9872bf1eee939dc1$var$px = (0, $b9AqM.hasCSSTOMSupport) && CSS ? CSS.px : "px";
var $9872bf1eee939dc1$var$ms = (0, $b9AqM.hasCSSTOMSupport) && CSS ? CSS.ms : "ms";
var $9872bf1eee939dc1$var$percent = (0, $b9AqM.hasCSSTOMSupport) && CSS ? CSS.percent : "%";
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $9872bf1eee939dc1$var$defaultUnits = {
    // Animation properties
    "animation-delay": $9872bf1eee939dc1$var$ms,
    "animation-duration": $9872bf1eee939dc1$var$ms,
    // Background properties
    "background-position": $9872bf1eee939dc1$var$px,
    "background-position-x": $9872bf1eee939dc1$var$px,
    "background-position-y": $9872bf1eee939dc1$var$px,
    "background-size": $9872bf1eee939dc1$var$px,
    // Border Properties
    border: $9872bf1eee939dc1$var$px,
    "border-bottom": $9872bf1eee939dc1$var$px,
    "border-bottom-left-radius": $9872bf1eee939dc1$var$px,
    "border-bottom-right-radius": $9872bf1eee939dc1$var$px,
    "border-bottom-width": $9872bf1eee939dc1$var$px,
    "border-left": $9872bf1eee939dc1$var$px,
    "border-left-width": $9872bf1eee939dc1$var$px,
    "border-radius": $9872bf1eee939dc1$var$px,
    "border-right": $9872bf1eee939dc1$var$px,
    "border-right-width": $9872bf1eee939dc1$var$px,
    "border-top": $9872bf1eee939dc1$var$px,
    "border-top-left-radius": $9872bf1eee939dc1$var$px,
    "border-top-right-radius": $9872bf1eee939dc1$var$px,
    "border-top-width": $9872bf1eee939dc1$var$px,
    "border-width": $9872bf1eee939dc1$var$px,
    "border-block": $9872bf1eee939dc1$var$px,
    "border-block-end": $9872bf1eee939dc1$var$px,
    "border-block-end-width": $9872bf1eee939dc1$var$px,
    "border-block-start": $9872bf1eee939dc1$var$px,
    "border-block-start-width": $9872bf1eee939dc1$var$px,
    "border-block-width": $9872bf1eee939dc1$var$px,
    "border-inline": $9872bf1eee939dc1$var$px,
    "border-inline-end": $9872bf1eee939dc1$var$px,
    "border-inline-end-width": $9872bf1eee939dc1$var$px,
    "border-inline-start": $9872bf1eee939dc1$var$px,
    "border-inline-start-width": $9872bf1eee939dc1$var$px,
    "border-inline-width": $9872bf1eee939dc1$var$px,
    "border-start-start-radius": $9872bf1eee939dc1$var$px,
    "border-start-end-radius": $9872bf1eee939dc1$var$px,
    "border-end-start-radius": $9872bf1eee939dc1$var$px,
    "border-end-end-radius": $9872bf1eee939dc1$var$px,
    // Margin properties
    margin: $9872bf1eee939dc1$var$px,
    "margin-bottom": $9872bf1eee939dc1$var$px,
    "margin-left": $9872bf1eee939dc1$var$px,
    "margin-right": $9872bf1eee939dc1$var$px,
    "margin-top": $9872bf1eee939dc1$var$px,
    "margin-block": $9872bf1eee939dc1$var$px,
    "margin-block-end": $9872bf1eee939dc1$var$px,
    "margin-block-start": $9872bf1eee939dc1$var$px,
    "margin-inline": $9872bf1eee939dc1$var$px,
    "margin-inline-end": $9872bf1eee939dc1$var$px,
    "margin-inline-start": $9872bf1eee939dc1$var$px,
    // Padding properties
    padding: $9872bf1eee939dc1$var$px,
    "padding-bottom": $9872bf1eee939dc1$var$px,
    "padding-left": $9872bf1eee939dc1$var$px,
    "padding-right": $9872bf1eee939dc1$var$px,
    "padding-top": $9872bf1eee939dc1$var$px,
    "padding-block": $9872bf1eee939dc1$var$px,
    "padding-block-end": $9872bf1eee939dc1$var$px,
    "padding-block-start": $9872bf1eee939dc1$var$px,
    "padding-inline": $9872bf1eee939dc1$var$px,
    "padding-inline-end": $9872bf1eee939dc1$var$px,
    "padding-inline-start": $9872bf1eee939dc1$var$px,
    // Mask properties
    "mask-position-x": $9872bf1eee939dc1$var$px,
    "mask-position-y": $9872bf1eee939dc1$var$px,
    "mask-size": $9872bf1eee939dc1$var$px,
    // Width and height properties
    height: $9872bf1eee939dc1$var$px,
    width: $9872bf1eee939dc1$var$px,
    "min-height": $9872bf1eee939dc1$var$px,
    "max-height": $9872bf1eee939dc1$var$px,
    "min-width": $9872bf1eee939dc1$var$px,
    "max-width": $9872bf1eee939dc1$var$px,
    // Position properties
    bottom: $9872bf1eee939dc1$var$px,
    left: $9872bf1eee939dc1$var$px,
    top: $9872bf1eee939dc1$var$px,
    right: $9872bf1eee939dc1$var$px,
    inset: $9872bf1eee939dc1$var$px,
    "inset-block": $9872bf1eee939dc1$var$px,
    "inset-block-end": $9872bf1eee939dc1$var$px,
    "inset-block-start": $9872bf1eee939dc1$var$px,
    "inset-inline": $9872bf1eee939dc1$var$px,
    "inset-inline-end": $9872bf1eee939dc1$var$px,
    "inset-inline-start": $9872bf1eee939dc1$var$px,
    // Shadow properties
    "box-shadow": $9872bf1eee939dc1$var$px,
    "text-shadow": $9872bf1eee939dc1$var$px,
    // Column properties
    "column-gap": $9872bf1eee939dc1$var$px,
    "column-rule": $9872bf1eee939dc1$var$px,
    "column-rule-width": $9872bf1eee939dc1$var$px,
    "column-width": $9872bf1eee939dc1$var$px,
    // Font and text properties
    "font-size": $9872bf1eee939dc1$var$px,
    "font-size-delta": $9872bf1eee939dc1$var$px,
    "letter-spacing": $9872bf1eee939dc1$var$px,
    "text-decoration-thickness": $9872bf1eee939dc1$var$px,
    "text-indent": $9872bf1eee939dc1$var$px,
    "text-stroke": $9872bf1eee939dc1$var$px,
    "text-stroke-width": $9872bf1eee939dc1$var$px,
    "word-spacing": $9872bf1eee939dc1$var$px,
    // Motion properties
    motion: $9872bf1eee939dc1$var$px,
    "motion-offset": $9872bf1eee939dc1$var$px,
    // Outline properties
    outline: $9872bf1eee939dc1$var$px,
    "outline-offset": $9872bf1eee939dc1$var$px,
    "outline-width": $9872bf1eee939dc1$var$px,
    // Perspective properties
    perspective: $9872bf1eee939dc1$var$px,
    "perspective-origin-x": $9872bf1eee939dc1$var$percent,
    "perspective-origin-y": $9872bf1eee939dc1$var$percent,
    // Transform properties
    "transform-origin": $9872bf1eee939dc1$var$percent,
    "transform-origin-x": $9872bf1eee939dc1$var$percent,
    "transform-origin-y": $9872bf1eee939dc1$var$percent,
    "transform-origin-z": $9872bf1eee939dc1$var$percent,
    // Transition properties
    "transition-delay": $9872bf1eee939dc1$var$ms,
    "transition-duration": $9872bf1eee939dc1$var$ms,
    // Alignment properties
    "vertical-align": $9872bf1eee939dc1$var$px,
    "flex-basis": $9872bf1eee939dc1$var$px,
    // Some random properties
    "shape-margin": $9872bf1eee939dc1$var$px,
    size: $9872bf1eee939dc1$var$px,
    gap: $9872bf1eee939dc1$var$px,
    // Grid properties
    grid: $9872bf1eee939dc1$var$px,
    "grid-gap": $9872bf1eee939dc1$var$px,
    "row-gap": $9872bf1eee939dc1$var$px,
    "grid-row-gap": $9872bf1eee939dc1$var$px,
    "grid-column-gap": $9872bf1eee939dc1$var$px,
    "grid-template-rows": $9872bf1eee939dc1$var$px,
    "grid-template-columns": $9872bf1eee939dc1$var$px,
    "grid-auto-rows": $9872bf1eee939dc1$var$px,
    "grid-auto-columns": $9872bf1eee939dc1$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    "box-shadow-x": $9872bf1eee939dc1$var$px,
    "box-shadow-y": $9872bf1eee939dc1$var$px,
    "box-shadow-blur": $9872bf1eee939dc1$var$px,
    "box-shadow-spread": $9872bf1eee939dc1$var$px,
    "font-line-height": $9872bf1eee939dc1$var$px,
    "text-shadow-x": $9872bf1eee939dc1$var$px,
    "text-shadow-y": $9872bf1eee939dc1$var$px,
    "text-shadow-blur": $9872bf1eee939dc1$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $9872bf1eee939dc1$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $9872bf1eee939dc1$var$units = $9872bf1eee939dc1$var$addCamelCasedVersion($9872bf1eee939dc1$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $9872bf1eee939dc1$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $9872bf1eee939dc1$var$iterate(prop, value[i], options);
    else if (typeof value === "object") {
        if (prop === "fallbacks") for(var innerProp in value)value[innerProp] = $9872bf1eee939dc1$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $9872bf1eee939dc1$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === "number" && isNaN(value) === false) {
        var unit = options[prop] || $9872bf1eee939dc1$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $9872bf1eee939dc1$var$px)) return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $9872bf1eee939dc1$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $9872bf1eee939dc1$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        for(var prop in style)style[prop] = $9872bf1eee939dc1$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $9872bf1eee939dc1$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $9872bf1eee939dc1$export$2e2bcd8739ae039 = $9872bf1eee939dc1$var$defaultUnit;

});

parcelRegister("O4Rfm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09687049c24ff9bd$export$2e2bcd8739ae039; });

var $eVZGJ = parcelRequire("eVZGJ");

var $b9AqM = parcelRequire("b9AqM");
/**
 * Add vendor prefix to a property name when needed.
 */ function $09687049c24ff9bd$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === "keyframes") {
            var atRule = rule;
            atRule.at = (0, $eVZGJ.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === "fallbacks" && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $eVZGJ.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $eVZGJ.supportedValue)(supportedProp, (0, $b9AqM.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $eVZGJ.supportedValue)(prop, (0, $b9AqM.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $09687049c24ff9bd$export$2e2bcd8739ae039 = $09687049c24ff9bd$var$jssVendorPrefixer;

});
parcelRegister("eVZGJ", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", function () { return $adf63d90cf0a3bc4$export$b6aa0648d950180a; });
$parcel$export(module.exports, "supportedProperty", function () { return $adf63d90cf0a3bc4$export$ce097f82c2e4551a; });
$parcel$export(module.exports, "supportedValue", function () { return $adf63d90cf0a3bc4$export$511766124059c277; });

var $jMQug = parcelRequire("jMQug");

var $ifOOi = parcelRequire("ifOOi");
// Export javascript style and css style vendor prefixes.
var $adf63d90cf0a3bc4$var$js = "";
var $adf63d90cf0a3bc4$var$css = "";
var $adf63d90cf0a3bc4$var$vendor = "";
var $adf63d90cf0a3bc4$var$browser = "";
var $adf63d90cf0a3bc4$var$isTouch = (0, $jMQug.default) && "ontouchstart" in document.documentElement; // We should not do anything if required serverside.
if (0, $jMQug.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $adf63d90cf0a3bc4$var$jsCssMap = {
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-",
        Webkit: "-webkit-"
    };
    var $adf63d90cf0a3bc4$var$_document$createEleme = document.createElement("p"), $adf63d90cf0a3bc4$var$style = $adf63d90cf0a3bc4$var$_document$createEleme.style;
    var $adf63d90cf0a3bc4$var$testProp = "Transform";
    for(var $adf63d90cf0a3bc4$var$key in $adf63d90cf0a3bc4$var$jsCssMap)if ($adf63d90cf0a3bc4$var$key + $adf63d90cf0a3bc4$var$testProp in $adf63d90cf0a3bc4$var$style) {
        $adf63d90cf0a3bc4$var$js = $adf63d90cf0a3bc4$var$key;
        $adf63d90cf0a3bc4$var$css = $adf63d90cf0a3bc4$var$jsCssMap[$adf63d90cf0a3bc4$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($adf63d90cf0a3bc4$var$js === "Webkit" && "msHyphens" in $adf63d90cf0a3bc4$var$style) {
        $adf63d90cf0a3bc4$var$js = "ms";
        $adf63d90cf0a3bc4$var$css = $adf63d90cf0a3bc4$var$jsCssMap.ms;
        $adf63d90cf0a3bc4$var$browser = "edge";
    } // Correctly detect the Safari browser.
    if ($adf63d90cf0a3bc4$var$js === "Webkit" && "-apple-trailing-word" in $adf63d90cf0a3bc4$var$style) $adf63d90cf0a3bc4$var$vendor = "apple";
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $adf63d90cf0a3bc4$export$82e9f45cca5ba907 = {
    js: $adf63d90cf0a3bc4$var$js,
    css: $adf63d90cf0a3bc4$var$css,
    vendor: $adf63d90cf0a3bc4$var$vendor,
    browser: $adf63d90cf0a3bc4$var$browser,
    isTouch: $adf63d90cf0a3bc4$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $adf63d90cf0a3bc4$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === "-") return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($adf63d90cf0a3bc4$export$82e9f45cca5ba907.js === "ms") return key;
    return "@" + $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $adf63d90cf0a3bc4$var$appearence = {
    noPrefill: [
        "appearance"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "appearance") return false;
        if ($adf63d90cf0a3bc4$export$82e9f45cca5ba907.js === "ms") return "-webkit-" + prop;
        return $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $adf63d90cf0a3bc4$var$colorAdjust = {
    noPrefill: [
        "color-adjust"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "color-adjust") return false;
        if ($adf63d90cf0a3bc4$export$82e9f45cca5ba907.js === "Webkit") return $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $adf63d90cf0a3bc4$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $adf63d90cf0a3bc4$var$toUpper(match, c) {
    return c ? c.toUpperCase() : "";
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $adf63d90cf0a3bc4$var$camelize(str) {
    return str.replace($adf63d90cf0a3bc4$var$regExp, $adf63d90cf0a3bc4$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $adf63d90cf0a3bc4$var$pascalize(str) {
    return $adf63d90cf0a3bc4$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $adf63d90cf0a3bc4$var$mask = {
    noPrefill: [
        "mask"
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($adf63d90cf0a3bc4$export$82e9f45cca5ba907.js === "Webkit") {
            var longhand = "mask-image";
            if ($adf63d90cf0a3bc4$var$camelize(longhand) in style) return prop;
            if ($adf63d90cf0a3bc4$export$82e9f45cca5ba907.js + $adf63d90cf0a3bc4$var$pascalize(longhand) in style) return $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $adf63d90cf0a3bc4$var$textOrientation = {
    noPrefill: [
        "text-orientation"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "text-orientation") return false;
        if ($adf63d90cf0a3bc4$export$82e9f45cca5ba907.vendor === "apple" && !$adf63d90cf0a3bc4$export$82e9f45cca5ba907.isTouch) return $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $adf63d90cf0a3bc4$var$transform = {
    noPrefill: [
        "transform"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transform") return false;
        if (options.transform) return prop;
        return $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $adf63d90cf0a3bc4$var$transition = {
    noPrefill: [
        "transition"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transition") return false;
        if (options.transition) return prop;
        return $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $adf63d90cf0a3bc4$var$writingMode = {
    noPrefill: [
        "writing-mode"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "writing-mode") return false;
        if ($adf63d90cf0a3bc4$export$82e9f45cca5ba907.js === "Webkit" || $adf63d90cf0a3bc4$export$82e9f45cca5ba907.js === "ms" && $adf63d90cf0a3bc4$export$82e9f45cca5ba907.browser !== "edge") return $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $adf63d90cf0a3bc4$var$userSelect = {
    noPrefill: [
        "user-select"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "user-select") return false;
        if ($adf63d90cf0a3bc4$export$82e9f45cca5ba907.js === "Moz" || $adf63d90cf0a3bc4$export$82e9f45cca5ba907.js === "ms" || $adf63d90cf0a3bc4$export$82e9f45cca5ba907.vendor === "apple") return $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $adf63d90cf0a3bc4$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($adf63d90cf0a3bc4$export$82e9f45cca5ba907.js === "Webkit") {
            var jsProp = "WebkitColumn" + $adf63d90cf0a3bc4$var$pascalize(prop);
            return jsProp in style ? $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($adf63d90cf0a3bc4$export$82e9f45cca5ba907.js === "Moz") {
            var _jsProp = "page" + $adf63d90cf0a3bc4$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $adf63d90cf0a3bc4$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($adf63d90cf0a3bc4$export$82e9f45cca5ba907.js === "Moz") return prop;
        var newProp = prop.replace("-inline", "");
        return $adf63d90cf0a3bc4$export$82e9f45cca5ba907.js + $adf63d90cf0a3bc4$var$pascalize(newProp) in style ? $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $adf63d90cf0a3bc4$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $adf63d90cf0a3bc4$var$camelize(prop) in style ? prop : false;
    }
};
var $adf63d90cf0a3bc4$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $adf63d90cf0a3bc4$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === "-") return prop; // Return already prefixed value without prefixing.
        if (prop[0] === "-" && prop[1] === "-") return prop;
        if ($adf63d90cf0a3bc4$export$82e9f45cca5ba907.js + pascalized in style) return $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($adf63d90cf0a3bc4$export$82e9f45cca5ba907.js !== "Webkit" && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $adf63d90cf0a3bc4$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== "scroll-snap") return false;
        if ($adf63d90cf0a3bc4$export$82e9f45cca5ba907.js === "ms") return "" + $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $adf63d90cf0a3bc4$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "overscroll-behavior") return false;
        if ($adf63d90cf0a3bc4$export$82e9f45cca5ba907.js === "ms") return $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $adf63d90cf0a3bc4$var$propMap = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack" // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $adf63d90cf0a3bc4$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $adf63d90cf0a3bc4$var$propMap[prop];
        if (!newProp) return false;
        return $adf63d90cf0a3bc4$export$82e9f45cca5ba907.js + $adf63d90cf0a3bc4$var$pascalize(newProp) in style ? $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $adf63d90cf0a3bc4$var$propMap$1 = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": [
        "box-orient",
        "box-direction"
    ],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": [
        "box-orient",
        "box-direction"
    ],
    "justify-content": "box-pack"
};
var $adf63d90cf0a3bc4$var$propKeys = Object.keys($adf63d90cf0a3bc4$var$propMap$1);
var $adf63d90cf0a3bc4$var$prefixCss = function prefixCss(p) {
    return $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $adf63d90cf0a3bc4$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($adf63d90cf0a3bc4$var$propKeys.indexOf(prop) > -1) {
            var newProp = $adf63d90cf0a3bc4$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $adf63d90cf0a3bc4$export$82e9f45cca5ba907.js + $adf63d90cf0a3bc4$var$pascalize(newProp) in style ? $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($adf63d90cf0a3bc4$export$82e9f45cca5ba907.js + $adf63d90cf0a3bc4$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($adf63d90cf0a3bc4$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $adf63d90cf0a3bc4$var$plugins = [
    $adf63d90cf0a3bc4$var$appearence,
    $adf63d90cf0a3bc4$var$colorAdjust,
    $adf63d90cf0a3bc4$var$mask,
    $adf63d90cf0a3bc4$var$textOrientation,
    $adf63d90cf0a3bc4$var$transform,
    $adf63d90cf0a3bc4$var$transition,
    $adf63d90cf0a3bc4$var$writingMode,
    $adf63d90cf0a3bc4$var$userSelect,
    $adf63d90cf0a3bc4$var$breakPropsOld,
    $adf63d90cf0a3bc4$var$inlineLogicalOld,
    $adf63d90cf0a3bc4$var$unprefixed,
    $adf63d90cf0a3bc4$var$prefixed,
    $adf63d90cf0a3bc4$var$scrollSnap,
    $adf63d90cf0a3bc4$var$overscrollBehavior,
    $adf63d90cf0a3bc4$var$flex2012,
    $adf63d90cf0a3bc4$var$flex2009
];
var $adf63d90cf0a3bc4$var$propertyDetectors = $adf63d90cf0a3bc4$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $adf63d90cf0a3bc4$var$noPrefill = $adf63d90cf0a3bc4$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $ifOOi.default)(p.noPrefill));
    return a;
}, []);
var $adf63d90cf0a3bc4$var$el;
var $adf63d90cf0a3bc4$var$cache = {};
if (0, $jMQug.default) {
    $adf63d90cf0a3bc4$var$el = document.createElement("p"); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $adf63d90cf0a3bc4$var$computed = window.getComputedStyle(document.documentElement, "");
    for(var $adf63d90cf0a3bc4$var$key$1 in $adf63d90cf0a3bc4$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($adf63d90cf0a3bc4$var$key$1)) $adf63d90cf0a3bc4$var$cache[$adf63d90cf0a3bc4$var$computed[$adf63d90cf0a3bc4$var$key$1]] = $adf63d90cf0a3bc4$var$computed[$adf63d90cf0a3bc4$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $adf63d90cf0a3bc4$var$noPrefill.forEach(function(x) {
        return delete $adf63d90cf0a3bc4$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $adf63d90cf0a3bc4$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$adf63d90cf0a3bc4$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($adf63d90cf0a3bc4$var$cache[prop] != null) return $adf63d90cf0a3bc4$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === "transition" || prop === "transform") options[prop] = prop in $adf63d90cf0a3bc4$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $adf63d90cf0a3bc4$var$propertyDetectors.length; i++){
        $adf63d90cf0a3bc4$var$cache[prop] = $adf63d90cf0a3bc4$var$propertyDetectors[i](prop, $adf63d90cf0a3bc4$var$el.style, options); // Break loop, if value found.
        if ($adf63d90cf0a3bc4$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $adf63d90cf0a3bc4$var$el.style[prop] = "";
    } catch (err) {
        return false;
    }
    return $adf63d90cf0a3bc4$var$cache[prop];
}
var $adf63d90cf0a3bc4$var$cache$1 = {};
var $adf63d90cf0a3bc4$var$transitionProperties = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
};
var $adf63d90cf0a3bc4$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $adf63d90cf0a3bc4$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $adf63d90cf0a3bc4$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === "var") return "var";
    if (p1 === "all") return "all";
    if (p2 === "all") return ", all";
    var prefixedValue = p1 ? $adf63d90cf0a3bc4$export$ce097f82c2e4551a(p1) : ", " + $adf63d90cf0a3bc4$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $jMQug.default) $adf63d90cf0a3bc4$var$el$1 = document.createElement("p");
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $adf63d90cf0a3bc4$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$adf63d90cf0a3bc4$var$el$1 || property === "content") return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($adf63d90cf0a3bc4$var$cache$1[cacheKey] != null) return $adf63d90cf0a3bc4$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $adf63d90cf0a3bc4$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $adf63d90cf0a3bc4$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($adf63d90cf0a3bc4$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($adf63d90cf0a3bc4$var$transPropsRegExp, $adf63d90cf0a3bc4$var$prefixTransitionCallback);
    else if ($adf63d90cf0a3bc4$var$el$1.style[property] === "") {
        // Value with a vendor prefix.
        prefixedValue = $adf63d90cf0a3bc4$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === "-ms-flex") $adf63d90cf0a3bc4$var$el$1.style[property] = "-ms-flexbox"; // Test prefixed value.
        $adf63d90cf0a3bc4$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($adf63d90cf0a3bc4$var$el$1.style[property] === "") {
            $adf63d90cf0a3bc4$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $adf63d90cf0a3bc4$var$el$1.style[property] = ""; // Write current value to cache.
    $adf63d90cf0a3bc4$var$cache$1[cacheKey] = prefixedValue;
    return $adf63d90cf0a3bc4$var$cache$1[cacheKey];
}

});
parcelRegister("ifOOi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4a10a956d2194bd$export$2e2bcd8739ae039; });

var $bH0r2 = parcelRequire("bH0r2");

var $6Ziml = parcelRequire("6Ziml");

var $k5dkO = parcelRequire("k5dkO");

var $7IlAx = parcelRequire("7IlAx");
function $d4a10a956d2194bd$export$2e2bcd8739ae039(arr) {
    return (0, $bH0r2.default)(arr) || (0, $6Ziml.default)(arr) || (0, $k5dkO.default)(arr) || (0, $7IlAx.default)();
}

});
parcelRegister("bH0r2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88340c3f4d7e8008$export$2e2bcd8739ae039; });

var $2rgMT = parcelRequire("2rgMT");
function $88340c3f4d7e8008$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $2rgMT.default)(arr);
}

});
parcelRegister("2rgMT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c6b200939dd7811$export$2e2bcd8739ae039; });
function $1c6b200939dd7811$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("6Ziml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5166ae66a883edbc$export$2e2bcd8739ae039; });
function $5166ae66a883edbc$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("k5dkO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9ee9e47376c093b$export$2e2bcd8739ae039; });

var $2rgMT = parcelRequire("2rgMT");
function $e9ee9e47376c093b$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2rgMT.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2rgMT.default)(o, minLen);
}

});

parcelRegister("7IlAx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59dd637599fbdb55$export$2e2bcd8739ae039; });
function $59dd637599fbdb55$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("ftdqB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b433faf6927e0dcb$export$2e2bcd8739ae039; });
/**
 * Sort props by length.
 */ function $b433faf6927e0dcb$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== "style") return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $b433faf6927e0dcb$export$2e2bcd8739ae039 = $b433faf6927e0dcb$var$jssPropsSort;

});



parcelRegister("gNxrM", function(module, exports) {

$parcel$export(module.exports, "increment", function () { return $c3ab2ad113c553b9$export$a2647aa13413c947; });
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $c3ab2ad113c553b9$var$indexCounter = -1000000000;
function $c3ab2ad113c553b9$export$a2647aa13413c947() {
    $c3ab2ad113c553b9$var$indexCounter += 1;
    return $c3ab2ad113c553b9$var$indexCounter;
}

});

parcelRegister("bvlgU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8603171517efa159$export$2e2bcd8739ae039; });

var $kO11b = parcelRequire("kO11b");
parcelRequire("gvXaa");

var $hA1Dm = parcelRequire("hA1Dm");

function $8603171517efa159$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === "function";
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $kO11b.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = (0, $hA1Dm.default)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRegister("hA1Dm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccc710ed1e098dc5$export$2e2bcd8739ae039; });

var $kO11b = parcelRequire("kO11b");

var $gvXaa = parcelRequire("gvXaa");
function $ccc710ed1e098dc5$export$53b83ca8eaab0383(item) {
    return item && (0, $gvXaa.default)(item) === "object" && item.constructor === Object;
}
function $ccc710ed1e098dc5$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $kO11b.default)({}, target) : target;
    if ($ccc710ed1e098dc5$export$53b83ca8eaab0383(target) && $ccc710ed1e098dc5$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($ccc710ed1e098dc5$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $ccc710ed1e098dc5$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});


parcelRegister("ctGgB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9158facb42661e40$export$2e2bcd8739ae039; });
// We use the same empty object to ref count the styles that don't need a theme object.
var $9158facb42661e40$var$noopTheme = {};
var $9158facb42661e40$export$2e2bcd8739ae039 = $9158facb42661e40$var$noopTheme;

});


parcelRegister("2f2hR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a1ec1ab321f713a$export$2e2bcd8739ae039; });
/* eslint-disable no-restricted-syntax */ function $1a1ec1ab321f713a$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}

});


parcelRegister("hhxkg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c94ddffff3f57350$export$2e2bcd8739ae039; });

var $hnlwu = parcelRequire("hnlwu");
var $c94ddffff3f57350$var$defaultTheme = (0, $hnlwu.default)();
var $c94ddffff3f57350$export$2e2bcd8739ae039 = $c94ddffff3f57350$var$defaultTheme;

});
parcelRegister("hnlwu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca6547ac07140932$export$2e2bcd8739ae039; });
parcelRequire("epFuc");

var $hmzQs = parcelRequire("hmzQs");

var $hA1Dm = parcelRequire("hA1Dm");

var $3BDle = parcelRequire("3BDle");

var $1dQs6 = parcelRequire("1dQs6");

var $gT3Hc = parcelRequire("gT3Hc");

var $keVXU = parcelRequire("keVXU");

var $HbImH = parcelRequire("HbImH");

var $bNOjR = parcelRequire("bNOjR");

var $baGUV = parcelRequire("baGUV");

var $bd5qU = parcelRequire("bd5qU");

var $loW7s = parcelRequire("loW7s");
function $ca6547ac07140932$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $hmzQs.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $gT3Hc.default)(paletteInput);
    var breakpoints = (0, $3BDle.default)(breakpointsInput);
    var spacing = (0, $baGUV.default)(spacingInput);
    var muiTheme = (0, $hA1Dm.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        mixins: (0, $1dQs6.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $HbImH.default),
        typography: (0, $keVXU.default)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $bNOjR.default),
        transitions: (0, $bd5qU.default),
        zIndex: (0, $loW7s.default)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $hA1Dm.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $ca6547ac07140932$var$warnedOnce = false;
function $ca6547ac07140932$export$c469355549431d9b() {
    return $ca6547ac07140932$var$createTheme.apply(void 0, arguments);
}
var $ca6547ac07140932$export$2e2bcd8739ae039 = $ca6547ac07140932$var$createTheme;

});
parcelRegister("epFuc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7e394c2f0c44751$export$2e2bcd8739ae039; });

var $aO4E3 = parcelRequire("aO4E3");
function $a7e394c2f0c44751$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $aO4E3.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("3BDle", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a035835700d8da9$export$2e2bcd8739ae039; });

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");
var $2a035835700d8da9$export$ed97f33186d4b816 = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
]; // Keep in mind that @media is inclusive by the CSS specification.
function $2a035835700d8da9$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? "px" : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $hmzQs.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === "number" ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $2a035835700d8da9$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$2a035835700d8da9$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $2a035835700d8da9$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up("xs");
        var value = typeof upperbound === "number" && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $2a035835700d8da9$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $2a035835700d8da9$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === "number" ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$2a035835700d8da9$export$ed97f33186d4b816[endIndex + 1]] === "number" ? values[$2a035835700d8da9$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $kO11b.default)({
        keys: $2a035835700d8da9$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});

parcelRegister("1dQs6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e3fb144bf97cc48$export$2e2bcd8739ae039; });

var $epFuc = parcelRequire("epFuc");

var $kO11b = parcelRequire("kO11b");
function $0e3fb144bf97cc48$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $kO11b.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                "Material-UI: theme.mixins.gutters() is deprecated.",
                "You can use the source of the mixin directly:",
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join("\n"));
            return (0, $kO11b.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $epFuc.default)({}, breakpoints.up("sm"), (0, $kO11b.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up("sm")])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $epFuc.default)(_toolbar, "".concat(breakpoints.up("xs"), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $epFuc.default)(_toolbar, breakpoints.up("sm"), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRegister("gT3Hc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4b4a64a028ded9e$export$2e2bcd8739ae039; });

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $hA1Dm = parcelRequire("hA1Dm");
var $7pDoN = parcelRequire("7pDoN");

var $cGh84 = parcelRequire("cGh84");

var $iWOIM = parcelRequire("iWOIM");

var $kY4ps = parcelRequire("kY4ps");

var $cancG = parcelRequire("cancG");

var $37utf = parcelRequire("37utf");

var $hGwc0 = parcelRequire("hGwc0");

var $epkEY = parcelRequire("epkEY");

var $3iGto = parcelRequire("3iGto");

var $3u5jc = parcelRequire("3u5jc");
var $c4b4a64a028ded9e$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.54)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)",
        // Text hints.
        hint: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $cGh84.default).white,
        default: (0, $iWOIM.default)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $c4b4a64a028ded9e$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $cGh84.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        hint: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: (0, $iWOIM.default)[800],
        default: "#303030"
    },
    action: {
        active: (0, $cGh84.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $c4b4a64a028ded9e$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $3u5jc.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $3u5jc.darken)(intent.main, tonalOffsetDark);
    }
}
function $c4b4a64a028ded9e$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $kY4ps.default)[300],
        main: (0, $kY4ps.default)[500],
        dark: (0, $kY4ps.default)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $cancG.default).A200,
        main: (0, $cancG.default).A400,
        dark: (0, $cancG.default).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $37utf.default)[300],
        main: (0, $37utf.default)[500],
        dark: (0, $37utf.default)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $hGwc0.default)[300],
        main: (0, $hGwc0.default)[500],
        dark: (0, $hGwc0.default)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $epkEY.default)[300],
        main: (0, $epkEY.default)[500],
        dark: (0, $epkEY.default)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $3iGto.default)[300],
        main: (0, $3iGto.default)[500],
        dark: (0, $3iGto.default)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? "light" : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $hmzQs.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $3u5jc.getContrastRatio)(background, $c4b4a64a028ded9e$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $c4b4a64a028ded9e$export$55ce6f3a06c59543.text.primary : $c4b4a64a028ded9e$export$a43af521ac8c3202.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $kO11b.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $7pDoN.default)(4, mainShade));
        if (typeof color.main !== "string") throw new Error((0, $7pDoN.default)(5, JSON.stringify(color.main)));
        $c4b4a64a028ded9e$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $c4b4a64a028ded9e$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $c4b4a64a028ded9e$export$55ce6f3a06c59543,
        light: $c4b4a64a028ded9e$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $hA1Dm.default)((0, $kO11b.default)({
        // A collection of common colors.
        common: (0, $cGh84.default),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, "A400", "A200", "A700"),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $iWOIM.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRegister("7pDoN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56596e07a24a5960$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $56596e07a24a5960$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = "https://mui.com/production-error/?code=" + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified Material-UI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});

parcelRegister("cGh84", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93b6b1c72ff08fd1$export$2e2bcd8739ae039; });
var $93b6b1c72ff08fd1$var$common = {
    black: "#000",
    white: "#fff"
};
var $93b6b1c72ff08fd1$export$2e2bcd8739ae039 = $93b6b1c72ff08fd1$var$common;

});

parcelRegister("iWOIM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcb4fcef726178c1$export$2e2bcd8739ae039; });
var $dcb4fcef726178c1$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161"
};
var $dcb4fcef726178c1$export$2e2bcd8739ae039 = $dcb4fcef726178c1$var$grey;

});

parcelRegister("kY4ps", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f43cd4e2ec821f47$export$2e2bcd8739ae039; });
var $f43cd4e2ec821f47$var$indigo = {
    50: "#e8eaf6",
    100: "#c5cae9",
    200: "#9fa8da",
    300: "#7986cb",
    400: "#5c6bc0",
    500: "#3f51b5",
    600: "#3949ab",
    700: "#303f9f",
    800: "#283593",
    900: "#1a237e",
    A100: "#8c9eff",
    A200: "#536dfe",
    A400: "#3d5afe",
    A700: "#304ffe"
};
var $f43cd4e2ec821f47$export$2e2bcd8739ae039 = $f43cd4e2ec821f47$var$indigo;

});

parcelRegister("cancG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8db86af7bbfd41ef$export$2e2bcd8739ae039; });
var $8db86af7bbfd41ef$var$pink = {
    50: "#fce4ec",
    100: "#f8bbd0",
    200: "#f48fb1",
    300: "#f06292",
    400: "#ec407a",
    500: "#e91e63",
    600: "#d81b60",
    700: "#c2185b",
    800: "#ad1457",
    900: "#880e4f",
    A100: "#ff80ab",
    A200: "#ff4081",
    A400: "#f50057",
    A700: "#c51162"
};
var $8db86af7bbfd41ef$export$2e2bcd8739ae039 = $8db86af7bbfd41ef$var$pink;

});

parcelRegister("37utf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2459a96a2cc06bd0$export$2e2bcd8739ae039; });
var $2459a96a2cc06bd0$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $2459a96a2cc06bd0$export$2e2bcd8739ae039 = $2459a96a2cc06bd0$var$red;

});

parcelRegister("hGwc0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdff54af7008c576$export$2e2bcd8739ae039; });
var $cdff54af7008c576$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $cdff54af7008c576$export$2e2bcd8739ae039 = $cdff54af7008c576$var$orange;

});

parcelRegister("epkEY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7d36d1f3c19f692$export$2e2bcd8739ae039; });
var $a7d36d1f3c19f692$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $a7d36d1f3c19f692$export$2e2bcd8739ae039 = $a7d36d1f3c19f692$var$blue;

});

parcelRegister("3iGto", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2673ffd10863d7c6$export$2e2bcd8739ae039; });
var $2673ffd10863d7c6$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $2673ffd10863d7c6$export$2e2bcd8739ae039 = $2673ffd10863d7c6$var$green;

});

parcelRegister("3u5jc", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $28984aa0d4233c8d$export$d061e26956a60b0a; });
$parcel$export(module.exports, "emphasize", function () { return $28984aa0d4233c8d$export$e665714f76e581fd; });
$parcel$export(module.exports, "darken", function () { return $28984aa0d4233c8d$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $28984aa0d4233c8d$export$c0816ed86df316af; });
$parcel$export(module.exports, "alpha", function () { return $28984aa0d4233c8d$export$58f0f39f63f3cf42; });

var $7pDoN = parcelRequire("7pDoN");
/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $28984aa0d4233c8d$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $28984aa0d4233c8d$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), "g");
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? "a" : "", "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", "), ")") : "";
}
function $28984aa0d4233c8d$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $28984aa0d4233c8d$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    var _decomposeColor = $28984aa0d4233c8d$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $28984aa0d4233c8d$var$intToHex(n);
    }).join(""));
}
function $28984aa0d4233c8d$export$29fb7152bd3f781a(color) {
    color = $28984aa0d4233c8d$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = "rgb";
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $28984aa0d4233c8d$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $28984aa0d4233c8d$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $28984aa0d4233c8d$export$677b39864803984e($28984aa0d4233c8d$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf("(");
    var type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla"
    ].indexOf(type) === -1) throw new Error((0, $7pDoN.default)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(",");
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $28984aa0d4233c8d$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf("hsl") !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(", "), ")");
}
function $28984aa0d4233c8d$export$d061e26956a60b0a(foreground, background) {
    var lumA = $28984aa0d4233c8d$export$c852d90bf7403b62(foreground);
    var lumB = $28984aa0d4233c8d$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $28984aa0d4233c8d$export$c852d90bf7403b62(color) {
    color = $28984aa0d4233c8d$export$677b39864803984e(color);
    var rgb = color.type === "hsl" ? $28984aa0d4233c8d$export$677b39864803984e($28984aa0d4233c8d$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $28984aa0d4233c8d$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $28984aa0d4233c8d$export$c852d90bf7403b62(color) > 0.5 ? $28984aa0d4233c8d$export$4b073707ff63303(color, coefficient) : $28984aa0d4233c8d$export$c0816ed86df316af(color, coefficient);
}
var $28984aa0d4233c8d$var$warnedOnce = false;
function $28984aa0d4233c8d$export$cbea29d068a2e18f(color, value) {
    return $28984aa0d4233c8d$export$58f0f39f63f3cf42(color, value);
}
function $28984aa0d4233c8d$export$58f0f39f63f3cf42(color, value) {
    color = $28984aa0d4233c8d$export$677b39864803984e(color);
    value = $28984aa0d4233c8d$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    color.values[3] = value;
    return $28984aa0d4233c8d$export$211a73f2b8c10ce4(color);
}
function $28984aa0d4233c8d$export$4b073707ff63303(color, coefficient) {
    color = $28984aa0d4233c8d$export$677b39864803984e(color);
    coefficient = $28984aa0d4233c8d$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $28984aa0d4233c8d$export$211a73f2b8c10ce4(color);
}
function $28984aa0d4233c8d$export$c0816ed86df316af(color, coefficient) {
    color = $28984aa0d4233c8d$export$677b39864803984e(color);
    coefficient = $28984aa0d4233c8d$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $28984aa0d4233c8d$export$211a73f2b8c10ce4(color);
}

});


parcelRegister("keVXU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebc2142a19828a4b$export$2e2bcd8739ae039; });

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $hA1Dm = parcelRequire("hA1Dm");
function $ebc2142a19828a4b$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $ebc2142a19828a4b$var$warnedOnce = false;
function $ebc2142a19828a4b$var$roundWithDeprecationWarning(value) {
    return $ebc2142a19828a4b$var$round(value);
}
var $ebc2142a19828a4b$var$caseAllCaps = {
    textTransform: "uppercase"
};
var $ebc2142a19828a4b$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $ebc2142a19828a4b$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === "function" ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $ebc2142a19828a4b$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $hmzQs.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $kO11b.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $ebc2142a19828a4b$var$defaultFontFamily ? {
            letterSpacing: "".concat($ebc2142a19828a4b$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $ebc2142a19828a4b$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $ebc2142a19828a4b$var$caseAllCaps)
    };
    return (0, $hA1Dm.default)((0, $kO11b.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $ebc2142a19828a4b$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("HbImH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $081d1a8924c5bb04$export$2e2bcd8739ae039; });
var $081d1a8924c5bb04$var$shadowKeyUmbraOpacity = 0.2;
var $081d1a8924c5bb04$var$shadowKeyPenumbraOpacity = 0.14;
var $081d1a8924c5bb04$var$shadowAmbientShadowOpacity = 0.12;
function $081d1a8924c5bb04$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($081d1a8924c5bb04$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($081d1a8924c5bb04$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($081d1a8924c5bb04$var$shadowAmbientShadowOpacity, ")")
    ].join(",");
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $081d1a8924c5bb04$var$shadows = [
    "none",
    $081d1a8924c5bb04$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $081d1a8924c5bb04$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $081d1a8924c5bb04$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $081d1a8924c5bb04$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $081d1a8924c5bb04$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $081d1a8924c5bb04$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $081d1a8924c5bb04$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $081d1a8924c5bb04$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $081d1a8924c5bb04$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $081d1a8924c5bb04$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $081d1a8924c5bb04$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $081d1a8924c5bb04$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $081d1a8924c5bb04$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $081d1a8924c5bb04$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $081d1a8924c5bb04$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $081d1a8924c5bb04$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $081d1a8924c5bb04$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $081d1a8924c5bb04$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $081d1a8924c5bb04$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $081d1a8924c5bb04$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $081d1a8924c5bb04$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $081d1a8924c5bb04$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $081d1a8924c5bb04$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $081d1a8924c5bb04$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $081d1a8924c5bb04$export$2e2bcd8739ae039 = $081d1a8924c5bb04$var$shadows;

});

parcelRegister("bNOjR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $897b4daec1f26ae8$export$2e2bcd8739ae039; });
var $897b4daec1f26ae8$var$shape = {
    borderRadius: 4
};
var $897b4daec1f26ae8$export$2e2bcd8739ae039 = $897b4daec1f26ae8$var$shape;

});

parcelRegister("baGUV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8221eb5258fb6658$export$2e2bcd8739ae039; });

var $jmAEb = parcelRequire("jmAEb");
var $8221eb5258fb6658$var$warnOnce;
function $8221eb5258fb6658$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $jmAEb.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === "string") return argument;
            var output = transform(argument);
            return typeof output === "number" ? "".concat(output, "px") : output;
        }).join(" ");
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, "unit", {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("jmAEb", function(module, exports) {

$parcel$export(module.exports, "createUnarySpacing", function () { return $e18c7fc5b6598e00$export$1def6f833384e3d1; });
$parcel$export(module.exports, "default", function () { return $e18c7fc5b6598e00$export$2e2bcd8739ae039; });

var $lbAml = parcelRequire("lbAml");


var $8TK5t = parcelRequire("8TK5t");

var $jLzWX = parcelRequire("jLzWX");

var $5tTDQ = parcelRequire("5tTDQ");
var $e18c7fc5b6598e00$var$properties = {
    m: "margin",
    p: "padding"
};
var $e18c7fc5b6598e00$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
var $e18c7fc5b6598e00$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $e18c7fc5b6598e00$var$getCssProperties = (0, $5tTDQ.default)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($e18c7fc5b6598e00$var$aliases[prop]) prop = $e18c7fc5b6598e00$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(""), _prop$split2 = (0, $lbAml.default)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $e18c7fc5b6598e00$var$properties[a];
    var direction = $e18c7fc5b6598e00$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $e18c7fc5b6598e00$var$spacingKeys = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY"
];
function $e18c7fc5b6598e00$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === "number") return function(abs) {
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return function() {
        return undefined;
    };
}
function $e18c7fc5b6598e00$var$getValue(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return "-".concat(transformed);
}
function $e18c7fc5b6598e00$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $e18c7fc5b6598e00$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $e18c7fc5b6598e00$var$spacing(props) {
    var theme = props.theme;
    var transformer = $e18c7fc5b6598e00$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($e18c7fc5b6598e00$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $e18c7fc5b6598e00$var$getCssProperties(prop);
        var styleFromPropValue = $e18c7fc5b6598e00$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $8TK5t.handleBreakpoints)(props, propValue, styleFromPropValue);
    }).reduce((0, $jLzWX.default), {});
}
$e18c7fc5b6598e00$var$spacing.propTypes = {};
$e18c7fc5b6598e00$var$spacing.filterProps = $e18c7fc5b6598e00$var$spacingKeys;
var $e18c7fc5b6598e00$export$2e2bcd8739ae039 = $e18c7fc5b6598e00$var$spacing;

});
parcelRegister("lbAml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6c6d4482431b7c3$export$2e2bcd8739ae039; });

var $gUXCs = parcelRequire("gUXCs");

var $bR3ml = parcelRequire("bR3ml");

var $k5dkO = parcelRequire("k5dkO");

var $73zke = parcelRequire("73zke");
function $f6c6d4482431b7c3$export$2e2bcd8739ae039(arr, i) {
    return (0, $gUXCs.default)(arr) || (0, $bR3ml.default)(arr, i) || (0, $k5dkO.default)(arr, i) || (0, $73zke.default)();
}

});
parcelRegister("gUXCs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5101f78cdc80df5$export$2e2bcd8739ae039; });
function $c5101f78cdc80df5$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("bR3ml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a174007974adb34$export$2e2bcd8739ae039; });
function $8a174007974adb34$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("73zke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52343715a0fb9612$export$2e2bcd8739ae039; });
function $52343715a0fb9612$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("8TK5t", function(module, exports) {

$parcel$export(module.exports, "handleBreakpoints", function () { return $67a735c6a309447f$export$88347efdb2e19abd; });

var $ifOOi = parcelRequire("ifOOi");

var $kO11b = parcelRequire("kO11b");

var $gvXaa = parcelRequire("gvXaa");


var $jLzWX = parcelRequire("jLzWX");
// For instance with the first breakpoint xs: [xs, sm[.
var $67a735c6a309447f$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $67a735c6a309447f$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: function up(key) {
        return "@media (min-width:".concat($67a735c6a309447f$var$values[key], "px)");
    }
};
function $67a735c6a309447f$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $67a735c6a309447f$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $gvXaa.default)(propValue) === "object") {
        var _themeBreakpoints = props.theme.breakpoints || $67a735c6a309447f$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $67a735c6a309447f$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $67a735c6a309447f$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $kO11b.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $jLzWX.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ].concat((0, $ifOOi.default)(styleFunction.filterProps));
    return newStyleFunction;
}
var $67a735c6a309447f$export$2e2bcd8739ae039 = $67a735c6a309447f$var$breakpoints;

});
parcelRegister("jLzWX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e63e4b059d21a74f$export$2e2bcd8739ae039; });

var $hA1Dm = parcelRequire("hA1Dm");
function $e63e4b059d21a74f$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $hA1Dm.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $e63e4b059d21a74f$export$2e2bcd8739ae039 = $e63e4b059d21a74f$var$merge;

});


parcelRegister("5tTDQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fdad278a3c5a4cd$export$2e2bcd8739ae039; });
function $3fdad278a3c5a4cd$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("bd5qU", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $82951f77dda621b7$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $82951f77dda621b7$export$2e2bcd8739ae039; });

var $hmzQs = parcelRequire("hmzQs");
var $82951f77dda621b7$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $82951f77dda621b7$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $82951f77dda621b7$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $82951f77dda621b7$export$2e2bcd8739ae039 = {
    easing: $82951f77dda621b7$export$24c5ac7c37452e7d,
    duration: $82951f77dda621b7$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            "all"
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $82951f77dda621b7$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $82951f77dda621b7$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $hmzQs.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === "string" ? durationOption : $82951f77dda621b7$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === "string" ? delay : $82951f77dda621b7$var$formatMs(delay));
        }).join(",");
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};

});

parcelRegister("loW7s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f948ec26fbcf2502$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $f948ec26fbcf2502$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f948ec26fbcf2502$export$2e2bcd8739ae039 = $f948ec26fbcf2502$var$zIndex;

});




parcelRegister("lrWdp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9d946f1af413fde$export$2e2bcd8739ae039; });

var $7pDoN = parcelRequire("7pDoN");
function $f9d946f1af413fde$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $7pDoN.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});




var $e7ff860c3d8cb912$exports = {};
"use strict";

$e7ff860c3d8cb912$exports = (parcelRequire("5kZqT"));



var $a2gHv = parcelRequire("a2gHv");
var $fcd36364b46ce6ed$exports = {};
"use strict";
function $fcd36364b46ce6ed$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($fcd36364b46ce6ed$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$fcd36364b46ce6ed$var$checkDCE();

$fcd36364b46ce6ed$exports = (parcelRequire("dPbfa"));





var $a2gHv = parcelRequire("a2gHv");


var $a2gHv = parcelRequire("a2gHv");

var $epFuc = parcelRequire("epFuc");


var $8TK5t = parcelRequire("8TK5t");
function $be72ee4a85221444$var$getPath(obj, path) {
    if (!path || typeof path !== "string") return null;
    return path.split(".").reduce(function(acc, item) {
        return acc && acc[item] ? acc[item] : null;
    }, obj);
}
function $be72ee4a85221444$var$style(options) {
    var prop = options.prop, _options$cssProperty = options.cssProperty, cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty, themeKey = options.themeKey, transform = options.transform;
    var fn = function fn(props) {
        if (props[prop] == null) return null;
        var propValue = props[prop];
        var theme = props.theme;
        var themeMapping = $be72ee4a85221444$var$getPath(theme, themeKey) || {};
        var styleFromPropValue = function styleFromPropValue(propValueFinal) {
            var value;
            if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
            else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || propValueFinal;
            else {
                value = $be72ee4a85221444$var$getPath(themeMapping, propValueFinal) || propValueFinal;
                if (transform) value = transform(value);
            }
            if (cssProperty === false) return value;
            return (0, $epFuc.default)({}, cssProperty, value);
        };
        return (0, $8TK5t.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $be72ee4a85221444$export$2e2bcd8739ae039 = $be72ee4a85221444$var$style;


parcelRequire("kO11b");

var $jLzWX = parcelRequire("jLzWX");
function $b141a153685e2069$var$compose() {
    for(var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++)styles[_key] = arguments[_key];
    var fn = function fn(props) {
        return styles.reduce(function(acc, style) {
            var output = style(props);
            if (output) return (0, $jLzWX.default)(acc, output);
            return acc;
        }, {});
    }; // Alternative approach that doesn't yield any performance gain.
    // const handlers = styles.reduce((acc, style) => {
    //   style.filterProps.forEach(prop => {
    //     acc[prop] = style;
    //   });
    //   return acc;
    // }, {});
    // const fn = props => {
    //   return Object.keys(props).reduce((acc, prop) => {
    //     if (handlers[prop]) {
    //       return merge(acc, handlers[prop](props));
    //     }
    //     return acc;
    //   }, {});
    // };
    fn.propTypes = {};
    fn.filterProps = styles.reduce(function(acc, style) {
        return acc.concat(style.filterProps);
    }, []);
    return fn;
}
var $b141a153685e2069$export$2e2bcd8739ae039 = $b141a153685e2069$var$compose;


function $6df84207df69f5ef$var$getBorder(value) {
    if (typeof value !== "number") return value;
    return "".concat(value, "px solid");
}
var $6df84207df69f5ef$export$1edee58a52776cd9 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "border",
    themeKey: "borders",
    transform: $6df84207df69f5ef$var$getBorder
});
var $6df84207df69f5ef$export$f9a7b6bd24892946 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $6df84207df69f5ef$var$getBorder
});
var $6df84207df69f5ef$export$5abca33e6be905d2 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $6df84207df69f5ef$var$getBorder
});
var $6df84207df69f5ef$export$e2ce9f12a980a822 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $6df84207df69f5ef$var$getBorder
});
var $6df84207df69f5ef$export$47658cca1a909427 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $6df84207df69f5ef$var$getBorder
});
var $6df84207df69f5ef$export$e7fb0694ba2404fc = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "borderColor",
    themeKey: "palette"
});
var $6df84207df69f5ef$export$7a57f79000377ca2 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "borderRadius",
    themeKey: "shape"
});
var $6df84207df69f5ef$var$borders = (0, $b141a153685e2069$export$2e2bcd8739ae039)($6df84207df69f5ef$export$1edee58a52776cd9, $6df84207df69f5ef$export$f9a7b6bd24892946, $6df84207df69f5ef$export$5abca33e6be905d2, $6df84207df69f5ef$export$e2ce9f12a980a822, $6df84207df69f5ef$export$47658cca1a909427, $6df84207df69f5ef$export$e7fb0694ba2404fc, $6df84207df69f5ef$export$7a57f79000377ca2);
var $6df84207df69f5ef$export$2e2bcd8739ae039 = $6df84207df69f5ef$var$borders;



var $3c93e125d0b8c642$export$95a5c40fb210fe3e = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "displayPrint",
    cssProperty: false,
    transform: function transform(value) {
        return {
            "@media print": {
                display: value
            }
        };
    }
});
var $3c93e125d0b8c642$export$e5efd59aba9975ad = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "display"
});
var $3c93e125d0b8c642$export$f6530fb6e67e00bd = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "overflow"
});
var $3c93e125d0b8c642$export$f00f69a6f0e8c5b6 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "textOverflow"
});
var $3c93e125d0b8c642$export$91fa9ac3f4021ce4 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "visibility"
});
var $3c93e125d0b8c642$export$9ef81298ca34ad41 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "whiteSpace"
});
var $3c93e125d0b8c642$export$2e2bcd8739ae039 = (0, $b141a153685e2069$export$2e2bcd8739ae039)($3c93e125d0b8c642$export$95a5c40fb210fe3e, $3c93e125d0b8c642$export$e5efd59aba9975ad, $3c93e125d0b8c642$export$f6530fb6e67e00bd, $3c93e125d0b8c642$export$f00f69a6f0e8c5b6, $3c93e125d0b8c642$export$91fa9ac3f4021ce4, $3c93e125d0b8c642$export$9ef81298ca34ad41);



var $4eef666988a1ab97$export$d2ad290394bbc49d = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "flexBasis"
});
var $4eef666988a1ab97$export$84c3c16c9ed6c908 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "flexDirection"
});
var $4eef666988a1ab97$export$9a4bcd01f5c204bc = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "flexWrap"
});
var $4eef666988a1ab97$export$8dea3061ba53bfd1 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "justifyContent"
});
var $4eef666988a1ab97$export$898d9006406726bd = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "alignItems"
});
var $4eef666988a1ab97$export$38c32c6918694134 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "alignContent"
});
var $4eef666988a1ab97$export$aaaeab0fac9a3ccb = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "order"
});
var $4eef666988a1ab97$export$97691fbb80847c19 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "flex"
});
var $4eef666988a1ab97$export$36c65c169152373d = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "flexGrow"
});
var $4eef666988a1ab97$export$2670ac60b02109d2 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "flexShrink"
});
var $4eef666988a1ab97$export$4545dd3632cb520b = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "alignSelf"
});
var $4eef666988a1ab97$export$55e6b7a7f0eaa3ff = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "justifyItems"
});
var $4eef666988a1ab97$export$d012640ac9a6446f = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "justifySelf"
});
var $4eef666988a1ab97$var$flexbox = (0, $b141a153685e2069$export$2e2bcd8739ae039)($4eef666988a1ab97$export$d2ad290394bbc49d, $4eef666988a1ab97$export$84c3c16c9ed6c908, $4eef666988a1ab97$export$9a4bcd01f5c204bc, $4eef666988a1ab97$export$8dea3061ba53bfd1, $4eef666988a1ab97$export$898d9006406726bd, $4eef666988a1ab97$export$38c32c6918694134, $4eef666988a1ab97$export$aaaeab0fac9a3ccb, $4eef666988a1ab97$export$97691fbb80847c19, $4eef666988a1ab97$export$36c65c169152373d, $4eef666988a1ab97$export$2670ac60b02109d2, $4eef666988a1ab97$export$4545dd3632cb520b, $4eef666988a1ab97$export$55e6b7a7f0eaa3ff, $4eef666988a1ab97$export$d012640ac9a6446f);
var $4eef666988a1ab97$export$2e2bcd8739ae039 = $4eef666988a1ab97$var$flexbox;



var $430b0d59b4cb21dd$export$62ffeaf1cd78b2a6 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "gridGap"
});
var $430b0d59b4cb21dd$export$d6171c086ca0de0 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "gridColumnGap"
});
var $430b0d59b4cb21dd$export$8bb113508eaa54d = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "gridRowGap"
});
var $430b0d59b4cb21dd$export$baf44164ca3a34e8 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "gridColumn"
});
var $430b0d59b4cb21dd$export$8f7213a1cd01e832 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "gridRow"
});
var $430b0d59b4cb21dd$export$b0e0abbc49ba668 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "gridAutoFlow"
});
var $430b0d59b4cb21dd$export$bcd8b929d4b4142 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "gridAutoColumns"
});
var $430b0d59b4cb21dd$export$e5039a674e14c828 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "gridAutoRows"
});
var $430b0d59b4cb21dd$export$42bd9088661ffb03 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "gridTemplateColumns"
});
var $430b0d59b4cb21dd$export$920682ae05b999bc = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "gridTemplateRows"
});
var $430b0d59b4cb21dd$export$1b88fbdd482fd33a = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "gridTemplateAreas"
});
var $430b0d59b4cb21dd$export$bdb486e40d52d26f = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "gridArea"
});
var $430b0d59b4cb21dd$var$grid = (0, $b141a153685e2069$export$2e2bcd8739ae039)($430b0d59b4cb21dd$export$62ffeaf1cd78b2a6, $430b0d59b4cb21dd$export$d6171c086ca0de0, $430b0d59b4cb21dd$export$8bb113508eaa54d, $430b0d59b4cb21dd$export$baf44164ca3a34e8, $430b0d59b4cb21dd$export$8f7213a1cd01e832, $430b0d59b4cb21dd$export$b0e0abbc49ba668, $430b0d59b4cb21dd$export$bcd8b929d4b4142, $430b0d59b4cb21dd$export$e5039a674e14c828, $430b0d59b4cb21dd$export$42bd9088661ffb03, $430b0d59b4cb21dd$export$920682ae05b999bc, $430b0d59b4cb21dd$export$1b88fbdd482fd33a, $430b0d59b4cb21dd$export$bdb486e40d52d26f);
var $430b0d59b4cb21dd$export$2e2bcd8739ae039 = $430b0d59b4cb21dd$var$grid;



var $c717ec5f1e590f77$export$35e9368ef982300f = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "color",
    themeKey: "palette"
});
var $c717ec5f1e590f77$export$2506f56c10355b33 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette"
});
var $c717ec5f1e590f77$var$palette = (0, $b141a153685e2069$export$2e2bcd8739ae039)($c717ec5f1e590f77$export$35e9368ef982300f, $c717ec5f1e590f77$export$2506f56c10355b33);
var $c717ec5f1e590f77$export$2e2bcd8739ae039 = $c717ec5f1e590f77$var$palette;



var $3247e751c3535cbc$export$5880b8b5730aff45 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "position"
});
var $3247e751c3535cbc$export$56446adcecbeec34 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "zIndex",
    themeKey: "zIndex"
});
var $3247e751c3535cbc$export$1e95b668f3b82d = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "top"
});
var $3247e751c3535cbc$export$79ffe56a765070d2 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "right"
});
var $3247e751c3535cbc$export$40e543e69a8b3fbb = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "bottom"
});
var $3247e751c3535cbc$export$eabcd2c8791e7bf4 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "left"
});
var $3247e751c3535cbc$export$2e2bcd8739ae039 = (0, $b141a153685e2069$export$2e2bcd8739ae039)($3247e751c3535cbc$export$5880b8b5730aff45, $3247e751c3535cbc$export$56446adcecbeec34, $3247e751c3535cbc$export$1e95b668f3b82d, $3247e751c3535cbc$export$79ffe56a765070d2, $3247e751c3535cbc$export$40e543e69a8b3fbb, $3247e751c3535cbc$export$eabcd2c8791e7bf4);


var $67b0138c1c90519e$var$boxShadow = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "boxShadow",
    themeKey: "shadows"
});
var $67b0138c1c90519e$export$2e2bcd8739ae039 = $67b0138c1c90519e$var$boxShadow;



function $2de1c46ff41ed0cc$var$transform(value) {
    return value <= 1 ? "".concat(value * 100, "%") : value;
}
var $2de1c46ff41ed0cc$export$7e3df82ee760448c = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "width",
    transform: $2de1c46ff41ed0cc$var$transform
});
var $2de1c46ff41ed0cc$export$488fda99655ff65a = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "maxWidth",
    transform: $2de1c46ff41ed0cc$var$transform
});
var $2de1c46ff41ed0cc$export$ee148fbbe8357dd2 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "minWidth",
    transform: $2de1c46ff41ed0cc$var$transform
});
var $2de1c46ff41ed0cc$export$ac607276a8fe9f0a = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "height",
    transform: $2de1c46ff41ed0cc$var$transform
});
var $2de1c46ff41ed0cc$export$dc0d8bd0b94f8570 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "maxHeight",
    transform: $2de1c46ff41ed0cc$var$transform
});
var $2de1c46ff41ed0cc$export$a43cf604e12f3b17 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "minHeight",
    transform: $2de1c46ff41ed0cc$var$transform
});
var $2de1c46ff41ed0cc$export$ffed9f14fb65e276 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "width",
    transform: $2de1c46ff41ed0cc$var$transform
});
var $2de1c46ff41ed0cc$export$905076ed6620e671 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "height",
    transform: $2de1c46ff41ed0cc$var$transform
});
var $2de1c46ff41ed0cc$export$6ccc93f785106a58 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "boxSizing"
});
var $2de1c46ff41ed0cc$var$sizing = (0, $b141a153685e2069$export$2e2bcd8739ae039)($2de1c46ff41ed0cc$export$7e3df82ee760448c, $2de1c46ff41ed0cc$export$488fda99655ff65a, $2de1c46ff41ed0cc$export$ee148fbbe8357dd2, $2de1c46ff41ed0cc$export$ac607276a8fe9f0a, $2de1c46ff41ed0cc$export$dc0d8bd0b94f8570, $2de1c46ff41ed0cc$export$a43cf604e12f3b17, $2de1c46ff41ed0cc$export$6ccc93f785106a58);
var $2de1c46ff41ed0cc$export$2e2bcd8739ae039 = $2de1c46ff41ed0cc$var$sizing;


var $jmAEb = parcelRequire("jmAEb");
var $ifOOi = parcelRequire("ifOOi");

var $kO11b = parcelRequire("kO11b");



var $jLzWX = parcelRequire("jLzWX");
function $c6c503f4ed8ff1a4$var$omit(input, fields) {
    var output = {};
    Object.keys(input).forEach(function(prop) {
        if (fields.indexOf(prop) === -1) output[prop] = input[prop];
    });
    return output;
}
var $c6c503f4ed8ff1a4$var$warnedOnce = false;
function $c6c503f4ed8ff1a4$var$styleFunctionSx(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var output = styleFunction(props);
        if (props.css) return (0, $kO11b.default)({}, (0, $jLzWX.default)(output, styleFunction((0, $kO11b.default)({
            theme: props.theme
        }, props.css))), $c6c503f4ed8ff1a4$var$omit(props.css, [
            styleFunction.filterProps
        ]));
        if (props.sx) return (0, $kO11b.default)({}, (0, $jLzWX.default)(output, styleFunction((0, $kO11b.default)({
            theme: props.theme
        }, props.sx))), $c6c503f4ed8ff1a4$var$omit(props.sx, [
            styleFunction.filterProps
        ]));
        return output;
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "css",
        "sx"
    ].concat((0, $ifOOi.default)(styleFunction.filterProps));
    return newStyleFunction;
}
function $c6c503f4ed8ff1a4$export$dbf350e5966cf602(styleFunction) {
    return $c6c503f4ed8ff1a4$var$styleFunctionSx(styleFunction);
}
var $c6c503f4ed8ff1a4$export$2e2bcd8739ae039 = $c6c503f4ed8ff1a4$var$styleFunctionSx;



var $8100233b3cbef30a$export$a5975749f0374264 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "fontFamily",
    themeKey: "typography"
});
var $8100233b3cbef30a$export$85e3c3ca0c6fb93 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "fontSize",
    themeKey: "typography"
});
var $8100233b3cbef30a$export$a827189a08c5a3a3 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "fontStyle",
    themeKey: "typography"
});
var $8100233b3cbef30a$export$bc0b29e67df3229e = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "fontWeight",
    themeKey: "typography"
});
var $8100233b3cbef30a$export$3eb52878e4502ad1 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "letterSpacing"
});
var $8100233b3cbef30a$export$c9b91427b594e14 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "lineHeight"
});
var $8100233b3cbef30a$export$a87999391cd10ae9 = (0, $be72ee4a85221444$export$2e2bcd8739ae039)({
    prop: "textAlign"
});
var $8100233b3cbef30a$var$typography = (0, $b141a153685e2069$export$2e2bcd8739ae039)($8100233b3cbef30a$export$a5975749f0374264, $8100233b3cbef30a$export$85e3c3ca0c6fb93, $8100233b3cbef30a$export$a827189a08c5a3a3, $8100233b3cbef30a$export$bc0b29e67df3229e, $8100233b3cbef30a$export$3eb52878e4502ad1, $8100233b3cbef30a$export$c9b91427b594e14, $8100233b3cbef30a$export$a87999391cd10ae9);
var $8100233b3cbef30a$export$2e2bcd8739ae039 = $8100233b3cbef30a$var$typography;



var $kO11b = parcelRequire("kO11b");

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");

var $1r7hW = parcelRequire("1r7hW");



var $5aifU = parcelRequire("5aifU");

var $f8Yg6 = parcelRequire("f8Yg6");
function $f97ed5189af8da8b$var$omit(input, fields) {
    var output = {};
    Object.keys(input).forEach(function(prop) {
        if (fields.indexOf(prop) === -1) output[prop] = input[prop];
    });
    return output;
} // styled-components's API removes the mapping between components and styles.
function $f97ed5189af8da8b$export$2e2bcd8739ae039(Component) {
    var componentCreator = function componentCreator(style) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var name = options.name, stylesOptions = (0, $hmzQs.default)(options, [
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var stylesOrCreator = typeof style === "function" ? function(theme) {
            return {
                root: function root(props) {
                    return style((0, $kO11b.default)({
                        theme: theme
                    }, props));
                }
            };
        } : {
            root: style
        };
        var useStyles = (0, $f8Yg6.default)(stylesOrCreator, (0, $kO11b.default)({
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var filterProps;
        var propTypes = {};
        if (style.filterProps) {
            filterProps = style.filterProps;
            delete style.filterProps;
        }
        /* eslint-disable react/forbid-foreign-prop-types */ if (style.propTypes) {
            propTypes = style.propTypes;
            delete style.propTypes;
        }
        /* eslint-enable react/forbid-foreign-prop-types */ var StyledComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).forwardRef(function StyledComponent(props, ref) {
            var children = props.children, classNameProp = props.className, clone = props.clone, ComponentProp = props.component, other = (0, $hmzQs.default)(props, [
                "children",
                "className",
                "clone",
                "component"
            ]);
            var classes = useStyles(props);
            var className = (0, $1r7hW.default)(classes.root, classNameProp);
            var spread = other;
            if (filterProps) spread = $f97ed5189af8da8b$var$omit(spread, filterProps);
            if (clone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).cloneElement(children, (0, $kO11b.default)({
                className: (0, $1r7hW.default)(children.props.className, className)
            }, spread));
            if (typeof children === "function") return children((0, $kO11b.default)({
                className: className
            }, spread));
            var FinalComponent = ComponentProp || Component;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).createElement(FinalComponent, (0, $kO11b.default)({
                ref: ref,
                className: className
            }, spread), children);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5aifU)))(StyledComponent, Component);
        return StyledComponent;
    };
    return componentCreator;
}



var $hhxkg = parcelRequire("hhxkg");
var $26831edecbb26a93$var$styled = function styled(Component) {
    var componentCreator = (0, $f97ed5189af8da8b$export$2e2bcd8739ae039)(Component);
    return function(style, options) {
        return componentCreator(style, (0, $kO11b.default)({
            defaultTheme: (0, $hhxkg.default)
        }, options));
    };
};
var $26831edecbb26a93$export$2e2bcd8739ae039 = $26831edecbb26a93$var$styled;


var $c913521d1795623a$export$8b4cd039ebcc4f7b = (0, $c6c503f4ed8ff1a4$export$2e2bcd8739ae039)((0, $b141a153685e2069$export$2e2bcd8739ae039)((0, $6df84207df69f5ef$export$2e2bcd8739ae039), (0, $3c93e125d0b8c642$export$2e2bcd8739ae039), (0, $4eef666988a1ab97$export$2e2bcd8739ae039), (0, $430b0d59b4cb21dd$export$2e2bcd8739ae039), (0, $3247e751c3535cbc$export$2e2bcd8739ae039), (0, $c717ec5f1e590f77$export$2e2bcd8739ae039), (0, $67b0138c1c90519e$export$2e2bcd8739ae039), (0, $2de1c46ff41ed0cc$export$2e2bcd8739ae039), (0, $jmAEb.default), (0, $8100233b3cbef30a$export$2e2bcd8739ae039)));
/**
 * @ignore - do not document.
 */ var $c913521d1795623a$var$Box = (0, $26831edecbb26a93$export$2e2bcd8739ae039)("div")($c913521d1795623a$export$8b4cd039ebcc4f7b, {
    name: "MuiBox"
});
var $c913521d1795623a$export$2e2bcd8739ae039 = $c913521d1795623a$var$Box;


var $hmzQs = parcelRequire("hmzQs");

var $kO11b = parcelRequire("kO11b");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $ljK7E = parcelRequire("ljK7E");

var $3u5jc = parcelRequire("3u5jc");

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");



var $1r7hW = parcelRequire("1r7hW");


var $a2gHv = parcelRequire("a2gHv");
// TODO v5: consider to make it private
function $3f9d91311c0ceddb$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


function $9df4720cccd64f53$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $a2gHv.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $3f9d91311c0ceddb$export$2e2bcd8739ae039)(refA, refValue);
            (0, $3f9d91311c0ceddb$export$2e2bcd8739ae039)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}



var $a2gHv = parcelRequire("a2gHv");
var $73a36d95a5fcfdd3$var$useEnhancedEffect = typeof window !== "undefined" ? $a2gHv.useLayoutEffect : $a2gHv.useEffect;
function $73a36d95a5fcfdd3$export$2e2bcd8739ae039(fn) {
    var ref = $a2gHv.useRef(fn);
    $73a36d95a5fcfdd3$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $a2gHv.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}




var $ljK7E = parcelRequire("ljK7E");
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $a2gHv = parcelRequire("a2gHv");

var $1bf8ad49e12296a3$var$hadKeyboardEvent = true;
var $1bf8ad49e12296a3$var$hadFocusVisibleRecently = false;
var $1bf8ad49e12296a3$var$hadFocusVisibleRecentlyTimeout = null;
var $1bf8ad49e12296a3$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $1bf8ad49e12296a3$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === "INPUT" && $1bf8ad49e12296a3$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $1bf8ad49e12296a3$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $1bf8ad49e12296a3$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $1bf8ad49e12296a3$var$handlePointerDown() {
    $1bf8ad49e12296a3$var$hadKeyboardEvent = false;
}
function $1bf8ad49e12296a3$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($1bf8ad49e12296a3$var$hadFocusVisibleRecently) $1bf8ad49e12296a3$var$hadKeyboardEvent = true;
    }
}
function $1bf8ad49e12296a3$var$prepare(doc) {
    doc.addEventListener("keydown", $1bf8ad49e12296a3$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $1bf8ad49e12296a3$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $1bf8ad49e12296a3$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $1bf8ad49e12296a3$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $1bf8ad49e12296a3$var$handleVisibilityChange, true);
}
function $1bf8ad49e12296a3$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $1bf8ad49e12296a3$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $1bf8ad49e12296a3$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $1bf8ad49e12296a3$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $1bf8ad49e12296a3$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $1bf8ad49e12296a3$var$handleVisibilityChange, true);
}
function $1bf8ad49e12296a3$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(":focus-visible");
    } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $1bf8ad49e12296a3$var$hadKeyboardEvent || $1bf8ad49e12296a3$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $1bf8ad49e12296a3$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $1bf8ad49e12296a3$var$hadFocusVisibleRecently = true;
    window.clearTimeout($1bf8ad49e12296a3$var$hadFocusVisibleRecentlyTimeout);
    $1bf8ad49e12296a3$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $1bf8ad49e12296a3$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $1bf8ad49e12296a3$export$2e2bcd8739ae039() {
    var ref = $a2gHv.useCallback(function(instance) {
        var node = $fcd36364b46ce6ed$exports.findDOMNode(instance);
        if (node != null) $1bf8ad49e12296a3$var$prepare(node.ownerDocument);
    }, []);
    return {
        isFocusVisible: $1bf8ad49e12296a3$var$isFocusVisible,
        onBlurVisible: $1bf8ad49e12296a3$var$handleBlurVisible,
        ref: ref
    };
}



var $kO11b = parcelRequire("kO11b");

var $ifOOi = parcelRequire("ifOOi");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $lqlJt = parcelRequire("lqlJt");

var $kO11b = parcelRequire("kO11b");

var $eKk9x = parcelRequire("eKk9x");

var $8XKFn = parcelRequire("8XKFn");


var $a2gHv = parcelRequire("a2gHv");

var $a2gHv = parcelRequire("a2gHv");
var $145c0696b5312bb9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).createContext(null);



var $a2gHv = parcelRequire("a2gHv");
function $55227bbcf22129a3$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $a2gHv.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $a2gHv.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $55227bbcf22129a3$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $55227bbcf22129a3$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $55227bbcf22129a3$export$fa71e2345c31d7a2(props, onExited) {
    return $55227bbcf22129a3$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $a2gHv.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $55227bbcf22129a3$var$getProp(child, "appear", props),
            enter: $55227bbcf22129a3$var$getProp(child, "enter", props),
            exit: $55227bbcf22129a3$var$getProp(child, "exit", props)
        });
    });
}
function $55227bbcf22129a3$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $55227bbcf22129a3$export$bbc8a025727ea824(nextProps.children);
    var children = $55227bbcf22129a3$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $a2gHv.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $a2gHv.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $a2gHv.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $55227bbcf22129a3$var$getProp(child, "exit", nextProps),
            enter: $55227bbcf22129a3$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $a2gHv.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $a2gHv.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $a2gHv.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $55227bbcf22129a3$var$getProp(child, "exit", nextProps),
            enter: $55227bbcf22129a3$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $6429a21cf31d8662$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $6429a21cf31d8662$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $6429a21cf31d8662$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $8XKFn.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $eKk9x.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $55227bbcf22129a3$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $55227bbcf22129a3$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $55227bbcf22129a3$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $kO11b.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $lqlJt.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $6429a21cf31d8662$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).createElement((0, $145c0696b5312bb9$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).createElement((0, $145c0696b5312bb9$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).Component);
$6429a21cf31d8662$var$TransitionGroup.propTypes = {};
$6429a21cf31d8662$var$TransitionGroup.defaultProps = $6429a21cf31d8662$var$defaultProps;
var $6429a21cf31d8662$export$2e2bcd8739ae039 = $6429a21cf31d8662$var$TransitionGroup;



var $1r7hW = parcelRequire("1r7hW");

var $ljK7E = parcelRequire("ljK7E");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $785882eee18e8891$var$useEnhancedEffect = typeof window === "undefined" ? $a2gHv.useEffect : $a2gHv.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $785882eee18e8891$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $a2gHv.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $1r7hW.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $1r7hW.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $73a36d95a5fcfdd3$export$2e2bcd8739ae039)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $785882eee18e8891$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $a2gHv.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $a2gHv.createElement("span", {
        className: childClassName
    }));
}
var $785882eee18e8891$export$2e2bcd8739ae039 = $785882eee18e8891$var$Ripple;


var $5161614b91f297df$var$DURATION = 550;
var $5161614b91f297df$export$95d0c9356b2231a3 = 80;
var $5161614b91f297df$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: "hidden",
            pointerEvents: "none",
            position: "absolute",
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: "inherit"
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: "absolute"
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: "scale(1)",
            animation: "$enter ".concat($5161614b91f297df$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: "block",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundColor: "currentColor"
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($5161614b91f297df$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: "absolute",
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        "@keyframes enter": {
            "0%": {
                transform: "scale(0)",
                opacity: 0.1
            },
            "100%": {
                transform: "scale(1)",
                opacity: 0.3
            }
        },
        "@keyframes exit": {
            "0%": {
                opacity: 1
            },
            "100%": {
                opacity: 0
            }
        },
        "@keyframes pulsate": {
            "0%": {
                transform: "scale(1)"
            },
            "50%": {
                transform: "scale(0.92)"
            },
            "100%": {
                transform: "scale(1)"
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $5161614b91f297df$var$TouchRipple = /*#__PURE__*/ $a2gHv.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $hmzQs.default)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $a2gHv.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $a2gHv.useRef(0);
    var rippleCallback = $a2gHv.useRef(null);
    $a2gHv.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $a2gHv.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $a2gHv.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $a2gHv.useRef(null);
    var container = $a2gHv.useRef(null);
    $a2gHv.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $a2gHv.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $ifOOi.default)(oldRipples), [
                /*#__PURE__*/ $a2gHv.createElement((0, $785882eee18e8891$export$2e2bcd8739ae039), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $5161614b91f297df$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $a2gHv.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === "touchstart") ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $5161614b91f297df$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $a2gHv.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $a2gHv.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === "touchend" && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $a2gHv.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $a2gHv.createElement("span", (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $a2gHv.createElement((0, $6429a21cf31d8662$export$2e2bcd8739ae039), {
        component: null,
        exit: true
    }, ripples));
});
var $5161614b91f297df$export$2e2bcd8739ae039 = (0, $ljK7E.default)($5161614b91f297df$export$9dd6ff9ea0189349, {
    flip: false,
    name: "MuiTouchRipple"
})(/*#__PURE__*/ $a2gHv.memo($5161614b91f297df$var$TouchRipple));


var $c97a62cb8718b66f$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        "-moz-appearance": "none",
        // Reset
        "-webkit-appearance": "none",
        // Reset
        textDecoration: "none",
        // So we take precedent over the style of a native <a /> element.
        color: "inherit",
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        "&$disabled": {
            pointerEvents: "none",
            // Disable link interactions
            cursor: "default"
        },
        "@media print": {
            colorAdjust: "exact"
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $c97a62cb8718b66f$var$ButtonBase = /*#__PURE__*/ $a2gHv.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, other = (0, $hmzQs.default)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $a2gHv.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $fcd36364b46ce6ed$exports.findDOMNode(buttonRef.current);
    }
    var rippleRef = $a2gHv.useRef(null);
    var _React$useState = $a2gHv.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $1bf8ad49e12296a3$export$2e2bcd8739ae039)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $a2gHv.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $a2gHv.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $73a36d95a5fcfdd3$export$2e2bcd8739ae039)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler("start", onMouseDown);
    var handleDragLeave = useRippleHandler("stop", onDragLeave);
    var handleMouseUp = useRippleHandler("stop", onMouseUp);
    var handleMouseLeave = useRippleHandler("stop", function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler("start", onTouchStart);
    var handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    var handleTouchMove = useRippleHandler("stop", onTouchMove);
    var handleBlur = useRippleHandler("stop", function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $73a36d95a5fcfdd3$export$2e2bcd8739ae039)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $a2gHv.useRef(false);
    var handleKeyDown = (0, $73a36d95a5fcfdd3$export$2e2bcd8739ae039)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $73a36d95a5fcfdd3$export$2e2bcd8739ae039)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === "button" && other.href) ComponentProp = "a";
    var buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== "a" || !other.href) buttonProps.role = "button";
        buttonProps["aria-disabled"] = disabled;
    }
    var handleUserRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(buttonRefProp, ref);
    var handleOwnRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(focusVisibleRef, buttonRef);
    var handleRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(handleUserRef, handleOwnRef);
    var _React$useState2 = $a2gHv.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $a2gHv.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    return /*#__PURE__*/ $a2gHv.createElement(ComponentProp, (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $a2gHv.createElement((0, $5161614b91f297df$export$2e2bcd8739ae039), (0, $kO11b.default)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
var $c97a62cb8718b66f$export$2e2bcd8739ae039 = (0, $ljK7E.default)($c97a62cb8718b66f$export$9dd6ff9ea0189349, {
    name: "MuiButtonBase"
})($c97a62cb8718b66f$var$ButtonBase);



var $lrWdp = parcelRequire("lrWdp");
var $34124a96edc1da32$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $kO11b.default)({}, theme.typography.button, {
            boxSizing: "border-box",
            minWidth: 64,
            padding: "6px 16px",
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            transition: theme.transitions.create([
                "background-color",
                "box-shadow",
                "border"
            ], {
                duration: theme.transitions.duration.short
            }),
            "&:hover": {
                textDecoration: "none",
                backgroundColor: (0, $3u5jc.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                },
                "&$disabled": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: "100%",
            // Ensure the correct width for iOS Safari
            display: "inherit",
            alignItems: "inherit",
            justifyContent: "inherit"
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            padding: "6px 8px"
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $3u5jc.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $3u5jc.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            padding: "5px 15px",
            border: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabledBackground)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat((0, $3u5jc.alpha)(theme.palette.primary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.primary.main),
                backgroundColor: (0, $3u5jc.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat((0, $3u5jc.alpha)(theme.palette.secondary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.secondary.main),
                backgroundColor: (0, $3u5jc.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabled)
            }
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            boxShadow: theme.shadows[2],
            "&:hover": {
                backgroundColor: theme.palette.grey.A100,
                boxShadow: theme.shadows[4],
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    boxShadow: theme.shadows[2],
                    backgroundColor: theme.palette.grey[300]
                },
                "&$disabled": {
                    backgroundColor: theme.palette.action.disabledBackground
                }
            },
            "&$focusVisible": {
                boxShadow: theme.shadows[6]
            },
            "&:active": {
                boxShadow: theme.shadows[8]
            },
            "&$disabled": {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */ containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */ containedSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: "none",
            "&:hover": {
                boxShadow: "none"
            },
            "&$focusVisible": {
                boxShadow: "none"
            },
            "&:active": {
                boxShadow: "none"
            },
            "&$disabled": {
                boxShadow: "none"
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit",
            borderColor: "currentColor"
        },
        /* Styles applied to the root element if `size="small"` and `variant="text"`. */ textSizeSmall: {
            padding: "4px 5px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="text"`. */ textSizeLarge: {
            padding: "8px 11px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */ outlinedSizeSmall: {
            padding: "3px 9px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */ outlinedSizeLarge: {
            padding: "7px 21px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="contained"`. */ containedSizeSmall: {
            padding: "4px 10px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="contained"`. */ containedSizeLarge: {
            padding: "8px 22px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {},
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Styles applied to the startIcon element if supplied. */ startIcon: {
            display: "inherit",
            marginRight: 8,
            marginLeft: -4,
            "&$iconSizeSmall": {
                marginLeft: -2
            }
        },
        /* Styles applied to the endIcon element if supplied. */ endIcon: {
            display: "inherit",
            marginRight: -4,
            marginLeft: 8,
            "&$iconSizeSmall": {
                marginRight: -2
            }
        },
        /* Styles applied to the icon element if supplied and `size="small"`. */ iconSizeSmall: {
            "& > *:first-child": {
                fontSize: 18
            }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */ iconSizeMedium: {
            "& > *:first-child": {
                fontSize: 20
            }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */ iconSizeLarge: {
            "& > *:first-child": {
                fontSize: 22
            }
        }
    };
};
var $34124a96edc1da32$var$Button = /*#__PURE__*/ $a2gHv.forwardRef(function Button(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? "text" : _props$variant, other = (0, $hmzQs.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    var startIcon = startIconProp && /*#__PURE__*/ $a2gHv.createElement("span", {
        className: (0, $1r7hW.default)(classes.startIcon, classes["iconSize".concat((0, $lrWdp.default)(size))])
    }, startIconProp);
    var endIcon = endIconProp && /*#__PURE__*/ $a2gHv.createElement("span", {
        className: (0, $1r7hW.default)(classes.endIcon, classes["iconSize".concat((0, $lrWdp.default)(size))])
    }, endIconProp);
    return /*#__PURE__*/ $a2gHv.createElement((0, $c97a62cb8718b66f$export$2e2bcd8739ae039), (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, classes[variant], className, color === "inherit" ? classes.colorInherit : color !== "default" && classes["".concat(variant).concat((0, $lrWdp.default)(color))], size !== "medium" && [
            classes["".concat(variant, "Size").concat((0, $lrWdp.default)(size))],
            classes["size".concat((0, $lrWdp.default)(size))]
        ], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $1r7hW.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other), /*#__PURE__*/ $a2gHv.createElement("span", {
        className: classes.label
    }, startIcon, children, endIcon));
});
var $34124a96edc1da32$export$2e2bcd8739ae039 = (0, $ljK7E.default)($34124a96edc1da32$export$9dd6ff9ea0189349, {
    name: "MuiButton"
})($34124a96edc1da32$var$Button);


var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");


var $kO11b = parcelRequire("kO11b");

var $lbAml = parcelRequire("lbAml");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $a2gHv = parcelRequire("a2gHv");
function $bd274624964d2c2e$export$2e2bcd8739ae039(_ref) {
    var controlled = _ref.controlled, defaultProp = _ref.default, name = _ref.name, _ref$state = _ref.state, state = _ref$state === void 0 ? "value" : _ref$state;
    var _React$useRef = $a2gHv.useRef(controlled !== undefined), isControlled = _React$useRef.current;
    var _React$useState = $a2gHv.useState(defaultProp), valueState = _React$useState[0], setValue = _React$useState[1];
    var value = isControlled ? controlled : valueState;
    var _React$useRef2, defaultValue;
    var setValueIfUncontrolled = $a2gHv.useCallback(function(newValue) {
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}



var $a2gHv = parcelRequire("a2gHv");

var $a2gHv = parcelRequire("a2gHv");
/**
 * @ignore - internal component.
 */ var $b8bda1a043b52a3c$var$FormControlContext = $a2gHv.createContext();
function $b8bda1a043b52a3c$export$62ecd8ad1bbe1a18() {
    return $a2gHv.useContext($b8bda1a043b52a3c$var$FormControlContext);
}
var $b8bda1a043b52a3c$export$2e2bcd8739ae039 = $b8bda1a043b52a3c$var$FormControlContext;


function $9d2a21945a86adb6$export$2e2bcd8739ae039() {
    return $a2gHv.useContext((0, $b8bda1a043b52a3c$export$2e2bcd8739ae039));
}



var $ljK7E = parcelRequire("ljK7E");

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");


var $ljK7E = parcelRequire("ljK7E");

var $3u5jc = parcelRequire("3u5jc");


var $lrWdp = parcelRequire("lrWdp");
var $48d49a7e403badb5$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            textAlign: "center",
            flex: "0 0 auto",
            fontSize: theme.typography.pxToRem(24),
            padding: 12,
            borderRadius: "50%",
            overflow: "visible",
            // Explicitly set the default value to solve a bug on IE 11.
            color: theme.palette.action.active,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shortest
            }),
            "&:hover": {
                backgroundColor: (0, $3u5jc.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                backgroundColor: "transparent",
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -12,
            "$sizeSmall&": {
                marginLeft: -3
            }
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -12,
            "$sizeSmall&": {
                marginRight: -3
            }
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $3u5jc.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $3u5jc.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 3,
            fontSize: theme.typography.pxToRem(18)
        },
        /* Styles applied to the children container element. */ label: {
            width: "100%",
            display: "flex",
            alignItems: "inherit",
            justifyContent: "inherit"
        }
    };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ var $48d49a7e403badb5$var$IconButton = /*#__PURE__*/ $a2gHv.forwardRef(function IconButton(props, ref) {
    var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $hmzQs.default)(props, [
        "edge",
        "children",
        "classes",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size"
    ]);
    return /*#__PURE__*/ $a2gHv.createElement((0, $c97a62cb8718b66f$export$2e2bcd8739ae039), (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className, color !== "default" && classes["color".concat((0, $lrWdp.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, $lrWdp.default)(size))], {
            "start": classes.edgeStart,
            "end": classes.edgeEnd
        }[edge]),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other), /*#__PURE__*/ $a2gHv.createElement("span", {
        className: classes.label
    }, children));
});
var $48d49a7e403badb5$export$2e2bcd8739ae039 = (0, $ljK7E.default)($48d49a7e403badb5$export$9dd6ff9ea0189349, {
    name: "MuiIconButton"
})($48d49a7e403badb5$var$IconButton);


var $7aef6b23f7362608$export$9dd6ff9ea0189349 = {
    root: {
        padding: 9
    },
    checked: {},
    disabled: {},
    input: {
        cursor: "inherit",
        position: "absolute",
        opacity: 0,
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        margin: 0,
        padding: 0,
        zIndex: 1
    }
};
/**
 * @ignore - internal component.
 */ var $7aef6b23f7362608$var$SwitchBase = /*#__PURE__*/ $a2gHv.forwardRef(function SwitchBase(props, ref) {
    var autoFocus = props.autoFocus, checkedProp = props.checked, checkedIcon = props.checkedIcon, classes = props.classes, className = props.className, defaultChecked = props.defaultChecked, disabledProp = props.disabled, icon = props.icon, id = props.id, inputProps = props.inputProps, inputRef = props.inputRef, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, readOnly = props.readOnly, required = props.required, tabIndex = props.tabIndex, type = props.type, value = props.value, other = (0, $hmzQs.default)(props, [
        "autoFocus",
        "checked",
        "checkedIcon",
        "classes",
        "className",
        "defaultChecked",
        "disabled",
        "icon",
        "id",
        "inputProps",
        "inputRef",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "readOnly",
        "required",
        "tabIndex",
        "type",
        "value"
    ]);
    var _useControlled = (0, $bd274624964d2c2e$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    }), _useControlled2 = (0, $lbAml.default)(_useControlled, 2), checked = _useControlled2[0], setCheckedState = _useControlled2[1];
    var muiFormControl = (0, $9d2a21945a86adb6$export$2e2bcd8739ae039)();
    var handleFocus = function handleFocus(event) {
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    var handleInputChange = function handleInputChange(event) {
        var newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v5: remove the second argument.
        onChange(event, newChecked);
    };
    var disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    var hasLabelFor = type === "checkbox" || type === "radio";
    return /*#__PURE__*/ $a2gHv.createElement((0, $48d49a7e403badb5$export$2e2bcd8739ae039), (0, $kO11b.default)({
        component: "span",
        className: (0, $1r7hW.default)(classes.root, className, checked && classes.checked, disabled && classes.disabled),
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ref: ref
    }, other), /*#__PURE__*/ $a2gHv.createElement("input", (0, $kO11b.default)({
        autoFocus: autoFocus,
        checked: checkedProp,
        defaultChecked: defaultChecked,
        className: classes.input,
        disabled: disabled,
        id: hasLabelFor && id,
        name: name,
        onChange: handleInputChange,
        readOnly: readOnly,
        ref: inputRef,
        required: required,
        tabIndex: tabIndex,
        type: type,
        value: value
    }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
var $7aef6b23f7362608$export$2e2bcd8739ae039 = (0, $ljK7E.default)($7aef6b23f7362608$export$9dd6ff9ea0189349, {
    name: "PrivateSwitchBase"
})($7aef6b23f7362608$var$SwitchBase);



var $a2gHv = parcelRequire("a2gHv");

var $jMmZt = parcelRequire("jMmZt");
var /**
 * @ignore - internal component.
 */ $3617466aac8fb84c$export$2e2bcd8739ae039 = (0, $jMmZt.default)(/*#__PURE__*/ $a2gHv.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");



var $a2gHv = parcelRequire("a2gHv");

var $jMmZt = parcelRequire("jMmZt");
var /**
 * @ignore - internal component.
 */ $5ba9dee53dda2d5d$export$2e2bcd8739ae039 = (0, $jMmZt.default)(/*#__PURE__*/ $a2gHv.createElement("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");



var $3u5jc = parcelRequire("3u5jc");

var $a2gHv = parcelRequire("a2gHv");

var $jMmZt = parcelRequire("jMmZt");
var /**
 * @ignore - internal component.
 */ $332a49446b7895c5$export$2e2bcd8739ae039 = (0, $jMmZt.default)(/*#__PURE__*/ $a2gHv.createElement("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");



var $lrWdp = parcelRequire("lrWdp");

var $ljK7E = parcelRequire("ljK7E");
var $625db5ece639fdf7$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: theme.palette.text.secondary
        },
        /* Pseudo-class applied to the root element if `checked={true}`. */ checked: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `indeterminate={true}`. */ indeterminate: {},
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            "&$checked": {
                color: theme.palette.primary.main,
                "&:hover": {
                    backgroundColor: (0, $3u5jc.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            "&$checked": {
                color: theme.palette.secondary.main,
                "&:hover": {
                    backgroundColor: (0, $3u5jc.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        }
    };
};
var $625db5ece639fdf7$var$defaultCheckedIcon = /*#__PURE__*/ $a2gHv.createElement((0, $5ba9dee53dda2d5d$export$2e2bcd8739ae039), null);
var $625db5ece639fdf7$var$defaultIcon = /*#__PURE__*/ $a2gHv.createElement((0, $3617466aac8fb84c$export$2e2bcd8739ae039), null);
var $625db5ece639fdf7$var$defaultIndeterminateIcon = /*#__PURE__*/ $a2gHv.createElement((0, $332a49446b7895c5$export$2e2bcd8739ae039), null);
var $625db5ece639fdf7$var$Checkbox = /*#__PURE__*/ $a2gHv.forwardRef(function Checkbox(props, ref) {
    var _props$checkedIcon = props.checkedIcon, checkedIcon = _props$checkedIcon === void 0 ? $625db5ece639fdf7$var$defaultCheckedIcon : _props$checkedIcon, classes = props.classes, _props$color = props.color, color = _props$color === void 0 ? "secondary" : _props$color, _props$icon = props.icon, iconProp = _props$icon === void 0 ? $625db5ece639fdf7$var$defaultIcon : _props$icon, _props$indeterminate = props.indeterminate, indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate, _props$indeterminateI = props.indeterminateIcon, indeterminateIconProp = _props$indeterminateI === void 0 ? $625db5ece639fdf7$var$defaultIndeterminateIcon : _props$indeterminateI, inputProps = props.inputProps, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $hmzQs.default)(props, [
        "checkedIcon",
        "classes",
        "color",
        "icon",
        "indeterminate",
        "indeterminateIcon",
        "inputProps",
        "size"
    ]);
    var icon = indeterminate ? indeterminateIconProp : iconProp;
    var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    return /*#__PURE__*/ $a2gHv.createElement((0, $7aef6b23f7362608$export$2e2bcd8739ae039), (0, $kO11b.default)({
        type: "checkbox",
        classes: {
            root: (0, $1r7hW.default)(classes.root, classes["color".concat((0, $lrWdp.default)(color))], indeterminate && classes.indeterminate),
            checked: classes.checked,
            disabled: classes.disabled
        },
        color: color,
        inputProps: (0, $kO11b.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $a2gHv.cloneElement(icon, {
            fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
        }),
        checkedIcon: /*#__PURE__*/ $a2gHv.cloneElement(indeterminateIcon, {
            fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
        }),
        ref: ref
    }, other));
});
var $625db5ece639fdf7$export$2e2bcd8739ae039 = (0, $ljK7E.default)($625db5ece639fdf7$export$9dd6ff9ea0189349, {
    name: "MuiCheckbox"
})($625db5ece639fdf7$var$Checkbox);


var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $epFuc = parcelRequire("epFuc");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $ljK7E = parcelRequire("ljK7E");

var $lrWdp = parcelRequire("lrWdp");
var $7aa797f1a6f09677$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $epFuc.default)({
            width: "100%",
            marginLeft: "auto",
            boxSizing: "border-box",
            marginRight: "auto",
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            display: "block"
        }, theme.breakpoints.up("sm"), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }),
        /* Styles applied to the root element if `disableGutters={true}`. */ disableGutters: {
            paddingLeft: 0,
            paddingRight: 0
        },
        /* Styles applied to the root element if `fixed={true}`. */ fixed: Object.keys(theme.breakpoints.values).reduce(function(acc, breakpoint) {
            var value = theme.breakpoints.values[breakpoint];
            if (value !== 0) acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: value
            };
            return acc;
        }, {}),
        /* Styles applied to the root element if `maxWidth="xs"`. */ maxWidthXs: (0, $epFuc.default)({}, theme.breakpoints.up("xs"), {
            maxWidth: Math.max(theme.breakpoints.values.xs, 444)
        }),
        /* Styles applied to the root element if `maxWidth="sm"`. */ maxWidthSm: (0, $epFuc.default)({}, theme.breakpoints.up("sm"), {
            maxWidth: theme.breakpoints.values.sm
        }),
        /* Styles applied to the root element if `maxWidth="md"`. */ maxWidthMd: (0, $epFuc.default)({}, theme.breakpoints.up("md"), {
            maxWidth: theme.breakpoints.values.md
        }),
        /* Styles applied to the root element if `maxWidth="lg"`. */ maxWidthLg: (0, $epFuc.default)({}, theme.breakpoints.up("lg"), {
            maxWidth: theme.breakpoints.values.lg
        }),
        /* Styles applied to the root element if `maxWidth="xl"`. */ maxWidthXl: (0, $epFuc.default)({}, theme.breakpoints.up("xl"), {
            maxWidth: theme.breakpoints.values.xl
        })
    };
};
var $7aa797f1a6f09677$var$Container = /*#__PURE__*/ $a2gHv.forwardRef(function Container(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$fixed = props.fixed, fixed = _props$fixed === void 0 ? false : _props$fixed, _props$maxWidth = props.maxWidth, maxWidth = _props$maxWidth === void 0 ? "lg" : _props$maxWidth, other = (0, $hmzQs.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "fixed",
        "maxWidth"
    ]);
    return /*#__PURE__*/ $a2gHv.createElement(Component, (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat((0, $lrWdp.default)(String(maxWidth)))]),
        ref: ref
    }, other));
});
var $7aa797f1a6f09677$export$2e2bcd8739ae039 = (0, $ljK7E.default)($7aa797f1a6f09677$export$9dd6ff9ea0189349, {
    name: "MuiContainer"
})($7aa797f1a6f09677$var$Container);


var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $d02852b4bd458b43$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
function $d02852b4bd458b43$export$d652b828d7fdeff8(obj) {
    var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return obj && ($d02852b4bd458b43$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $d02852b4bd458b43$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
} // Determine if an Input is adorned on start.
function $d02852b4bd458b43$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $ljK7E = parcelRequire("ljK7E");

var $lrWdp = parcelRequire("lrWdp");

var $a2gHv = parcelRequire("a2gHv");
function $d5b3549fe549b228$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $a2gHv.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}



var $6727a78a8880f40f$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top" // Fix alignment issue on Safari.
    },
    /* Styles applied to the root element if `margin="normal"`. */ marginNormal: {
        marginTop: 16,
        marginBottom: 8
    },
    /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
        marginTop: 8,
        marginBottom: 4
    },
    /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
        width: "100%"
    }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */ var $6727a78a8880f40f$var$FormControl = /*#__PURE__*/ $a2gHv.forwardRef(function FormControl(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, visuallyFocused = props.focused, _props$hiddenLabel = props.hiddenLabel, hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel, _props$margin = props.margin, margin = _props$margin === void 0 ? "none" : _props$margin, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, size = props.size, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $hmzQs.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "fullWidth",
        "focused",
        "hiddenLabel",
        "margin",
        "required",
        "size",
        "variant"
    ]);
    var _React$useState = $a2gHv.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialAdornedStart = false;
        if (children) $a2gHv.Children.forEach(children, function(child) {
            if (!(0, $d5b3549fe549b228$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            var input = (0, $d5b3549fe549b228$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $d02852b4bd458b43$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    }), adornedStart = _React$useState[0], setAdornedStart = _React$useState[1];
    var _React$useState2 = $a2gHv.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialFilled = false;
        if (children) $a2gHv.Children.forEach(children, function(child) {
            if (!(0, $d5b3549fe549b228$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $d02852b4bd458b43$export$d652b828d7fdeff8)(child.props, true)) initialFilled = true;
        });
        return initialFilled;
    }), filled = _React$useState2[0], setFilled = _React$useState2[1];
    var _React$useState3 = $a2gHv.useState(false), _focused = _React$useState3[0], setFocused = _React$useState3[1];
    var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
    if (disabled && focused) setFocused(false);
    var registerEffect;
    var registeredInput;
    var onFilled = $a2gHv.useCallback(function() {
        setFilled(true);
    }, []);
    var onEmpty = $a2gHv.useCallback(function() {
        setFilled(false);
    }, []);
    var childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        color: color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: (size === "small" ? "dense" : undefined) || margin,
        onBlur: function onBlur() {
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: function onFocus() {
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant
    };
    return /*#__PURE__*/ $a2gHv.createElement((0, $b8bda1a043b52a3c$export$2e2bcd8739ae039).Provider, {
        value: childContext
    }, /*#__PURE__*/ $a2gHv.createElement(Component, (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className, margin !== "none" && classes["margin".concat((0, $lrWdp.default)(margin))], fullWidth && classes.fullWidth),
        ref: ref
    }, other), children));
});
var $6727a78a8880f40f$export$2e2bcd8739ae039 = (0, $ljK7E.default)($6727a78a8880f40f$export$9dd6ff9ea0189349, {
    name: "MuiFormControl"
})($6727a78a8880f40f$var$FormControl);


var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");



var $ljK7E = parcelRequire("ljK7E");

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $ljK7E = parcelRequire("ljK7E");

var $lrWdp = parcelRequire("lrWdp");
var $93cbf38278f83b48$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            margin: 0
        },
        /* Styles applied to the root element if `variant="body2"`. */ body2: theme.typography.body2,
        /* Styles applied to the root element if `variant="body1"`. */ body1: theme.typography.body1,
        /* Styles applied to the root element if `variant="caption"`. */ caption: theme.typography.caption,
        /* Styles applied to the root element if `variant="button"`. */ button: theme.typography.button,
        /* Styles applied to the root element if `variant="h1"`. */ h1: theme.typography.h1,
        /* Styles applied to the root element if `variant="h2"`. */ h2: theme.typography.h2,
        /* Styles applied to the root element if `variant="h3"`. */ h3: theme.typography.h3,
        /* Styles applied to the root element if `variant="h4"`. */ h4: theme.typography.h4,
        /* Styles applied to the root element if `variant="h5"`. */ h5: theme.typography.h5,
        /* Styles applied to the root element if `variant="h6"`. */ h6: theme.typography.h6,
        /* Styles applied to the root element if `variant="subtitle1"`. */ subtitle1: theme.typography.subtitle1,
        /* Styles applied to the root element if `variant="subtitle2"`. */ subtitle2: theme.typography.subtitle2,
        /* Styles applied to the root element if `variant="overline"`. */ overline: theme.typography.overline,
        /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */ srOnly: {
            position: "absolute",
            height: 1,
            width: 1,
            overflow: "hidden"
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: "left"
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: "center"
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: "right"
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: "justify"
        },
        /* Styles applied to the root element if `nowrap={true}`. */ noWrap: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        /* Styles applied to the root element if `gutterBottom={true}`. */ gutterBottom: {
            marginBottom: "0.35em"
        },
        /* Styles applied to the root element if `paragraph={true}`. */ paragraph: {
            marginBottom: 16
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="textPrimary"`. */ colorTextPrimary: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `color="textSecondary"`. */ colorTextSecondary: {
            color: theme.palette.text.secondary
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `display="inline"`. */ displayInline: {
            display: "inline"
        },
        /* Styles applied to the root element if `display="block"`. */ displayBlock: {
            display: "block"
        }
    };
};
var $93cbf38278f83b48$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p"
};
var $93cbf38278f83b48$var$Typography = /*#__PURE__*/ $a2gHv.forwardRef(function Typography(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? "inherit" : _props$align, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "initial" : _props$color, component = props.component, _props$display = props.display, display = _props$display === void 0 ? "initial" : _props$display, _props$gutterBottom = props.gutterBottom, gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom, _props$noWrap = props.noWrap, noWrap = _props$noWrap === void 0 ? false : _props$noWrap, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? false : _props$paragraph, _props$variant = props.variant, variant = _props$variant === void 0 ? "body1" : _props$variant, _props$variantMapping = props.variantMapping, variantMapping = _props$variantMapping === void 0 ? $93cbf38278f83b48$var$defaultVariantMapping : _props$variantMapping, other = (0, $hmzQs.default)(props, [
        "align",
        "classes",
        "className",
        "color",
        "component",
        "display",
        "gutterBottom",
        "noWrap",
        "paragraph",
        "variant",
        "variantMapping"
    ]);
    var Component = component || (paragraph ? "p" : variantMapping[variant] || $93cbf38278f83b48$var$defaultVariantMapping[variant]) || "span";
    return /*#__PURE__*/ $a2gHv.createElement(Component, (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className, variant !== "inherit" && classes[variant], color !== "initial" && classes["color".concat((0, $lrWdp.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== "inherit" && classes["align".concat((0, $lrWdp.default)(align))], display !== "initial" && classes["display".concat((0, $lrWdp.default)(display))]),
        ref: ref
    }, other));
});
var $93cbf38278f83b48$export$2e2bcd8739ae039 = (0, $ljK7E.default)($93cbf38278f83b48$export$9dd6ff9ea0189349, {
    name: "MuiTypography"
})($93cbf38278f83b48$var$Typography);



var $lrWdp = parcelRequire("lrWdp");
var $4c43d2b64a18b512$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "inline-flex",
            alignItems: "center",
            cursor: "pointer",
            // For correct alignment with the text.
            verticalAlign: "middle",
            WebkitTapHighlightColor: "transparent",
            marginLeft: -11,
            marginRight: 16,
            // used for row presentation of radio/checkbox
            "&$disabled": {
                cursor: "default"
            }
        },
        /* Styles applied to the root element if `labelPlacement="start"`. */ labelPlacementStart: {
            flexDirection: "row-reverse",
            marginLeft: 16,
            // used for row presentation of radio/checkbox
            marginRight: -11
        },
        /* Styles applied to the root element if `labelPlacement="top"`. */ labelPlacementTop: {
            flexDirection: "column-reverse",
            marginLeft: 16
        },
        /* Styles applied to the root element if `labelPlacement="bottom"`. */ labelPlacementBottom: {
            flexDirection: "column",
            marginLeft: 16
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the label's Typography component. */ label: {
            "&$disabled": {
                color: theme.palette.text.disabled
            }
        }
    };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ var $4c43d2b64a18b512$var$FormControlLabel = /*#__PURE__*/ $a2gHv.forwardRef(function FormControlLabel(props, ref) {
    var checked = props.checked, classes = props.classes, className = props.className, control = props.control, disabledProp = props.disabled, inputRef = props.inputRef, label = props.label, _props$labelPlacement = props.labelPlacement, labelPlacement = _props$labelPlacement === void 0 ? "end" : _props$labelPlacement, name = props.name, onChange = props.onChange, value = props.value, other = (0, $hmzQs.default)(props, [
        "checked",
        "classes",
        "className",
        "control",
        "disabled",
        "inputRef",
        "label",
        "labelPlacement",
        "name",
        "onChange",
        "value"
    ]);
    var muiFormControl = (0, $9d2a21945a86adb6$export$2e2bcd8739ae039)();
    var disabled = disabledProp;
    if (typeof disabled === "undefined" && typeof control.props.disabled !== "undefined") disabled = control.props.disabled;
    if (typeof disabled === "undefined" && muiFormControl) disabled = muiFormControl.disabled;
    var controlProps = {
        disabled: disabled
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach(function(key) {
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    return /*#__PURE__*/ $a2gHv.createElement("label", (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className, labelPlacement !== "end" && classes["labelPlacement".concat((0, $lrWdp.default)(labelPlacement))], disabled && classes.disabled),
        ref: ref
    }, other), /*#__PURE__*/ $a2gHv.cloneElement(control, controlProps), /*#__PURE__*/ $a2gHv.createElement((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
        component: "span",
        className: (0, $1r7hW.default)(classes.label, disabled && classes.disabled)
    }, label));
});
var $4c43d2b64a18b512$export$2e2bcd8739ae039 = (0, $ljK7E.default)($4c43d2b64a18b512$export$9dd6ff9ea0189349, {
    name: "MuiFormControlLabel"
})($4c43d2b64a18b512$var$FormControlLabel);


var $hmzQs = parcelRequire("hmzQs");

var $kO11b = parcelRequire("kO11b");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");
function $02d20181ee06a14b$export$2e2bcd8739ae039(_ref) {
    var props = _ref.props, states = _ref.states, muiFormControl = _ref.muiFormControl;
    return states.reduce(function(acc, state) {
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}




var $lrWdp = parcelRequire("lrWdp");

var $ljK7E = parcelRequire("ljK7E");
var $a200f36ca8fadba2$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $kO11b.default)({
            color: theme.palette.text.secondary
        }, theme.typography.body1, {
            lineHeight: 1,
            padding: 0,
            "&$focused": {
                color: theme.palette.primary.main
            },
            "&$disabled": {
                color: theme.palette.text.disabled
            },
            "&$error": {
                color: theme.palette.error.main
            }
        }),
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            "&$focused": {
                color: theme.palette.secondary.main
            }
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Styles applied to the asterisk element. */ asterisk: {
            "&$error": {
                color: theme.palette.error.main
            }
        }
    };
};
var $a200f36ca8fadba2$var$FormLabel = /*#__PURE__*/ $a2gHv.forwardRef(function FormLabel(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, color = props.color, _props$component = props.component, Component = _props$component === void 0 ? "label" : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, required = props.required, other = (0, $hmzQs.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "required"
    ]);
    var muiFormControl = (0, $9d2a21945a86adb6$export$2e2bcd8739ae039)();
    var fcs = (0, $02d20181ee06a14b$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    return /*#__PURE__*/ $a2gHv.createElement(Component, (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, classes["color".concat((0, $lrWdp.default)(fcs.color || "primary"))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
        ref: ref
    }, other), children, fcs.required && /*#__PURE__*/ $a2gHv.createElement("span", {
        "aria-hidden": true,
        className: (0, $1r7hW.default)(classes.asterisk, fcs.error && classes.error)
    }, "\u2009", "*"));
});
var $a200f36ca8fadba2$export$2e2bcd8739ae039 = (0, $ljK7E.default)($a200f36ca8fadba2$export$9dd6ff9ea0189349, {
    name: "MuiFormLabel"
})($a200f36ca8fadba2$var$FormLabel);


var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");



var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $a2gHv = parcelRequire("a2gHv");

var $jMmZt = parcelRequire("jMmZt");
var /**
 * @ignore - internal component.
 */ $aef59aaf04d6298a$export$2e2bcd8739ae039 = (0, $jMmZt.default)(/*#__PURE__*/ $a2gHv.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");



var $a2gHv = parcelRequire("a2gHv");

var $jMmZt = parcelRequire("jMmZt");
var /**
 * @ignore - internal component.
 */ $b9480914e9160d3b$export$2e2bcd8739ae039 = (0, $jMmZt.default)(/*#__PURE__*/ $a2gHv.createElement("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked");



var $ljK7E = parcelRequire("ljK7E");
var $01f005d4266f0e9a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        root: {
            position: "relative",
            display: "flex",
            "&$checked $layer": {
                transform: "scale(1)",
                transition: theme.transitions.create("transform", {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.shortest
                })
            }
        },
        layer: {
            left: 0,
            position: "absolute",
            transform: "scale(0)",
            transition: theme.transitions.create("transform", {
                easing: theme.transitions.easing.easeIn,
                duration: theme.transitions.duration.shortest
            })
        },
        checked: {}
    };
};
/**
 * @ignore - internal component.
 */ function $01f005d4266f0e9a$var$RadioButtonIcon(props) {
    var checked = props.checked, classes = props.classes, fontSize = props.fontSize;
    return /*#__PURE__*/ $a2gHv.createElement("div", {
        className: (0, $1r7hW.default)(classes.root, checked && classes.checked)
    }, /*#__PURE__*/ $a2gHv.createElement((0, $aef59aaf04d6298a$export$2e2bcd8739ae039), {
        fontSize: fontSize
    }), /*#__PURE__*/ $a2gHv.createElement((0, $b9480914e9160d3b$export$2e2bcd8739ae039), {
        fontSize: fontSize,
        className: classes.layer
    }));
}
var $01f005d4266f0e9a$export$2e2bcd8739ae039 = (0, $ljK7E.default)($01f005d4266f0e9a$export$9dd6ff9ea0189349, {
    name: "PrivateRadioButtonIcon"
})($01f005d4266f0e9a$var$RadioButtonIcon);



var $3u5jc = parcelRequire("3u5jc");

var $lrWdp = parcelRequire("lrWdp");
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $2d1f2023da2fae25$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.reduce(function(acc, func) {
        if (func == null) return acc;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, function() {});
}



var $ljK7E = parcelRequire("ljK7E");

var $a2gHv = parcelRequire("a2gHv");

var $a2gHv = parcelRequire("a2gHv");
/**
 * @ignore - internal component.
 */ var $44a6dff538b98c33$var$RadioGroupContext = $a2gHv.createContext();
var $44a6dff538b98c33$export$2e2bcd8739ae039 = $44a6dff538b98c33$var$RadioGroupContext;


function $0dc291fe7f9d1c7f$export$2e2bcd8739ae039() {
    return $a2gHv.useContext((0, $44a6dff538b98c33$export$2e2bcd8739ae039));
}


var $b92c9bbcec4f0aef$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: theme.palette.text.secondary
        },
        /* Pseudo-class applied to the root element if `checked={true}`. */ checked: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            "&$checked": {
                color: theme.palette.primary.main,
                "&:hover": {
                    backgroundColor: (0, $3u5jc.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            "&$checked": {
                color: theme.palette.secondary.main,
                "&:hover": {
                    backgroundColor: (0, $3u5jc.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        }
    };
};
var $b92c9bbcec4f0aef$var$defaultCheckedIcon = /*#__PURE__*/ $a2gHv.createElement((0, $01f005d4266f0e9a$export$2e2bcd8739ae039), {
    checked: true
});
var $b92c9bbcec4f0aef$var$defaultIcon = /*#__PURE__*/ $a2gHv.createElement((0, $01f005d4266f0e9a$export$2e2bcd8739ae039), null);
var $b92c9bbcec4f0aef$var$Radio = /*#__PURE__*/ $a2gHv.forwardRef(function Radio(props, ref) {
    var checkedProp = props.checked, classes = props.classes, _props$color = props.color, color = _props$color === void 0 ? "secondary" : _props$color, nameProp = props.name, onChangeProp = props.onChange, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $hmzQs.default)(props, [
        "checked",
        "classes",
        "color",
        "name",
        "onChange",
        "size"
    ]);
    var radioGroup = (0, $0dc291fe7f9d1c7f$export$2e2bcd8739ae039)();
    var checked = checkedProp;
    var onChange = (0, $2d1f2023da2fae25$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    var name = nameProp;
    if (radioGroup) {
        if (typeof checked === "undefined") checked = radioGroup.value === props.value;
        if (typeof name === "undefined") name = radioGroup.name;
    }
    return /*#__PURE__*/ $a2gHv.createElement((0, $7aef6b23f7362608$export$2e2bcd8739ae039), (0, $kO11b.default)({
        color: color,
        type: "radio",
        icon: /*#__PURE__*/ $a2gHv.cloneElement($b92c9bbcec4f0aef$var$defaultIcon, {
            fontSize: size === "small" ? "small" : "medium"
        }),
        checkedIcon: /*#__PURE__*/ $a2gHv.cloneElement($b92c9bbcec4f0aef$var$defaultCheckedIcon, {
            fontSize: size === "small" ? "small" : "medium"
        }),
        classes: {
            root: (0, $1r7hW.default)(classes.root, classes["color".concat((0, $lrWdp.default)(color))]),
            checked: classes.checked,
            disabled: classes.disabled
        },
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref
    }, other));
});
var $b92c9bbcec4f0aef$export$2e2bcd8739ae039 = (0, $ljK7E.default)($b92c9bbcec4f0aef$export$9dd6ff9ea0189349, {
    name: "MuiRadio"
})($b92c9bbcec4f0aef$var$Radio);


var $kO11b = parcelRequire("kO11b");

var $lbAml = parcelRequire("lbAml");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $ljK7E = parcelRequire("ljK7E");
var $7c35130601b7465d$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    },
    /* Styles applied to the root element if `row={true}`. */ row: {
        flexDirection: "row"
    }
};
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ var $7c35130601b7465d$var$FormGroup = /*#__PURE__*/ $a2gHv.forwardRef(function FormGroup(props, ref) {
    var classes = props.classes, className = props.className, _props$row = props.row, row = _props$row === void 0 ? false : _props$row, other = (0, $hmzQs.default)(props, [
        "classes",
        "className",
        "row"
    ]);
    return /*#__PURE__*/ $a2gHv.createElement("div", (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className, row && classes.row),
        ref: ref
    }, other));
});
var $7c35130601b7465d$export$2e2bcd8739ae039 = (0, $ljK7E.default)($7c35130601b7465d$export$9dd6ff9ea0189349, {
    name: "MuiFormGroup"
})($7c35130601b7465d$var$FormGroup);






var $a2gHv = parcelRequire("a2gHv");
function $afe051b6804db85d$export$2e2bcd8739ae039(idOverride) {
    var _React$useState = $a2gHv.useState(idOverride), defaultId = _React$useState[0], setDefaultId = _React$useState[1];
    var id = idOverride || defaultId;
    $a2gHv.useEffect(function() {
        if (defaultId == null) // Fallback to this default id when possible.
        // Use the random value for client-side rendering only.
        // We can't use it server-side.
        setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }, [
        defaultId
    ]);
    return id;
}


var $4737ab9e3044a099$var$RadioGroup = /*#__PURE__*/ $a2gHv.forwardRef(function RadioGroup(props, ref) {
    var actions = props.actions, children = props.children, nameProp = props.name, valueProp = props.value, onChange = props.onChange, other = (0, $hmzQs.default)(props, [
        "actions",
        "children",
        "name",
        "value",
        "onChange"
    ]);
    var rootRef = $a2gHv.useRef(null);
    var _useControlled = (0, $bd274624964d2c2e$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: props.defaultValue,
        name: "RadioGroup"
    }), _useControlled2 = (0, $lbAml.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    $a2gHv.useImperativeHandle(actions, function() {
        return {
            focus: function focus() {
                var input = rootRef.current.querySelector("input:not(:disabled):checked");
                if (!input) input = rootRef.current.querySelector("input:not(:disabled)");
                if (input) input.focus();
            }
        };
    }, []);
    var handleRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(ref, rootRef);
    var handleChange = function handleChange(event) {
        setValue(event.target.value);
        if (onChange) onChange(event, event.target.value);
    };
    var name = (0, $afe051b6804db85d$export$2e2bcd8739ae039)(nameProp);
    return /*#__PURE__*/ $a2gHv.createElement((0, $44a6dff538b98c33$export$2e2bcd8739ae039).Provider, {
        value: {
            name: name,
            onChange: handleChange,
            value: value
        }
    }, /*#__PURE__*/ $a2gHv.createElement((0, $7c35130601b7465d$export$2e2bcd8739ae039), (0, $kO11b.default)({
        role: "radiogroup",
        ref: handleRef
    }, other), children));
});
var $4737ab9e3044a099$export$2e2bcd8739ae039 = $4737ab9e3044a099$var$RadioGroup;


var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");



var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");


var $hmzQs = parcelRequire("hmzQs");

var $kO11b = parcelRequire("kO11b");

var $7pDoN = parcelRequire("7pDoN");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");



var $ljK7E = parcelRequire("ljK7E");

var $lrWdp = parcelRequire("lrWdp");


var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $6b9219180f06a7e7$export$2e2bcd8739ae039(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
    var timeout;
    function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // eslint-disable-next-line consistent-this
        var that = this;
        var later = function later() {
            func.apply(that, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}




function $588dd13f58dadf42$var$getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
}
var $588dd13f58dadf42$var$useEnhancedEffect = typeof window !== "undefined" ? $a2gHv.useLayoutEffect : $a2gHv.useEffect;
var $588dd13f58dadf42$var$styles = {
    /* Styles applied to the shadow textarea element. */ shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
var $588dd13f58dadf42$var$TextareaAutosize = /*#__PURE__*/ $a2gHv.forwardRef(function TextareaAutosize(props, ref) {
    var onChange = props.onChange, rows = props.rows, rowsMax = props.rowsMax, rowsMinProp = props.rowsMin, maxRowsProp = props.maxRows, _props$minRows = props.minRows, minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows, style = props.style, value = props.value, other = (0, $hmzQs.default)(props, [
        "onChange",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "style",
        "value"
    ]);
    var maxRows = maxRowsProp || rowsMax;
    var minRows = rows || rowsMinProp || minRowsProp;
    var _React$useRef = $a2gHv.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $a2gHv.useRef(null);
    var handleRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(ref, inputRef);
    var shadowRef = $a2gHv.useRef(null);
    var renders = $a2gHv.useRef(0);
    var _React$useState = $a2gHv.useState({}), state = _React$useState[0], setState = _React$useState[1];
    var syncHeight = $a2gHv.useCallback(function() {
        var input = inputRef.current;
        var computedStyle = window.getComputedStyle(input);
        var inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        var boxSizing = computedStyle["box-sizing"];
        var padding = $588dd13f58dadf42$var$getStyleValue(computedStyle, "padding-bottom") + $588dd13f58dadf42$var$getStyleValue(computedStyle, "padding-top");
        var border = $588dd13f58dadf42$var$getStyleValue(computedStyle, "border-bottom-width") + $588dd13f58dadf42$var$getStyleValue(computedStyle, "border-top-width"); // The height of the inner content
        var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
        inputShallow.value = "x";
        var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
        var outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
        var outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        var overflow = Math.abs(outerHeight - innerHeight) <= 1;
        setState(function(prevState) {
            // Need a large enough difference to update the height.
            // This prevents infinite rendering loop.
            if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
                renders.current += 1;
                return {
                    overflow: overflow,
                    outerHeightStyle: outerHeightStyle
                };
            }
            return prevState;
        });
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    $a2gHv.useEffect(function() {
        var handleResize = (0, $6b9219180f06a7e7$export$2e2bcd8739ae039)(function() {
            renders.current = 0;
            syncHeight();
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        syncHeight
    ]);
    $588dd13f58dadf42$var$useEnhancedEffect(function() {
        syncHeight();
    });
    $a2gHv.useEffect(function() {
        renders.current = 0;
    }, [
        value
    ]);
    var handleChange = function handleChange(event) {
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ $a2gHv.createElement($a2gHv.Fragment, null, /*#__PURE__*/ $a2gHv.createElement("textarea", (0, $kO11b.default)({
        value: value,
        onChange: handleChange,
        ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
        ,
        rows: minRows,
        style: (0, $kO11b.default)({
            height: state.outerHeightStyle,
            // Need a large enough difference to allow scrolling.
            // This prevents infinite rendering loop.
            overflow: state.overflow ? "hidden" : null
        }, style)
    }, other)), /*#__PURE__*/ $a2gHv.createElement("textarea", {
        "aria-hidden": true,
        className: props.className,
        readOnly: true,
        ref: shadowRef,
        tabIndex: -1,
        style: (0, $kO11b.default)({}, $588dd13f58dadf42$var$styles.shadow, style)
    }));
});
var $588dd13f58dadf42$export$2e2bcd8739ae039 = $588dd13f58dadf42$var$TextareaAutosize;



var $0dd8f8b7b77f1a1e$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var placeholder = {
        color: "currentColor",
        opacity: light ? 0.42 : 0.5,
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    };
    var placeholderHidden = {
        opacity: "0 !important"
    };
    var placeholderVisible = {
        opacity: light ? 0.42 : 0.5
    };
    return {
        "@global": {
            "@keyframes mui-auto-fill": {},
            "@keyframes mui-auto-fill-cancel": {}
        },
        /* Styles applied to the root element. */ root: (0, $kO11b.default)({}, theme.typography.body1, {
            color: theme.palette.text.primary,
            lineHeight: "1.1876em",
            // Reset (19px), match the native input line-height
            boxSizing: "border-box",
            // Prevent padding issue with fullWidth.
            position: "relative",
            cursor: "text",
            display: "inline-flex",
            alignItems: "center",
            "&$disabled": {
                color: theme.palette.text.disabled,
                cursor: "default"
            }
        }),
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {},
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {},
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            "&$marginDense": {
                paddingTop: 3
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Styles applied to the `input` element. */ input: {
            font: "inherit",
            letterSpacing: "inherit",
            color: "currentColor",
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            border: 0,
            boxSizing: "content-box",
            background: "none",
            height: "1.1876em",
            // Reset (19px), match the native input line-height
            margin: 0,
            // Reset for Safari
            WebkitTapHighlightColor: "transparent",
            display: "block",
            // Make the flex item shrink with Firefox
            minWidth: 0,
            width: "100%",
            // Fix IE 11 width issue
            animationName: "mui-auto-fill-cancel",
            animationDuration: "10ms",
            "&::-webkit-input-placeholder": placeholder,
            "&::-moz-placeholder": placeholder,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholder,
            // IE 11
            "&::-ms-input-placeholder": placeholder,
            // Edge
            "&:focus": {
                outline: 0
            },
            // Reset Firefox invalid required input style
            "&:invalid": {
                boxShadow: "none"
            },
            "&::-webkit-search-decoration": {
                // Remove the padding when type=search.
                "-webkit-appearance": "none"
            },
            // Show and hide the placeholder logic
            "label[data-shrink=false] + $formControl &": {
                "&::-webkit-input-placeholder": placeholderHidden,
                "&::-moz-placeholder": placeholderHidden,
                // Firefox 19+
                "&:-ms-input-placeholder": placeholderHidden,
                // IE 11
                "&::-ms-input-placeholder": placeholderHidden,
                // Edge
                "&:focus::-webkit-input-placeholder": placeholderVisible,
                "&:focus::-moz-placeholder": placeholderVisible,
                // Firefox 19+
                "&:focus:-ms-input-placeholder": placeholderVisible,
                // IE 11
                "&:focus::-ms-input-placeholder": placeholderVisible // Edge
            },
            "&$disabled": {
                opacity: 1 // Reset iOS opacity
            },
            "&:-webkit-autofill": {
                animationDuration: "5000s",
                animationName: "mui-auto-fill"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 3
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            height: "auto",
            resize: "none",
            padding: 0
        },
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {
            // Improve type search style.
            "-moz-appearance": "textfield",
            "-webkit-appearance": "textfield"
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {},
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {},
        /* Styles applied to the `input` element if `hiddenLabel={true}`. */ inputHiddenLabel: {}
    };
};
var $0dd8f8b7b77f1a1e$var$useEnhancedEffect = typeof window === "undefined" ? $a2gHv.useEffect : $a2gHv.useLayoutEffect;
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ var $0dd8f8b7b77f1a1e$var$InputBase = /*#__PURE__*/ $a2gHv.forwardRef(function InputBase(props, ref) {
    var ariaDescribedby = props["aria-describedby"], autoComplete = props.autoComplete, autoFocus = props.autoFocus, classes = props.classes, className = props.className, color = props.color, defaultValue = props.defaultValue, disabled = props.disabled, endAdornment = props.endAdornment, error = props.error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, id = props.id, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$inputProps = props.inputProps, inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps, inputRefProp = props.inputRef, margin = props.margin, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, placeholder = props.placeholder, readOnly = props.readOnly, renderSuffix = props.renderSuffix, rows = props.rows, rowsMax = props.rowsMax, rowsMin = props.rowsMin, maxRows = props.maxRows, minRows = props.minRows, startAdornment = props.startAdornment, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, valueProp = props.value, other = (0, $hmzQs.default)(props, [
        "aria-describedby",
        "autoComplete",
        "autoFocus",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "endAdornment",
        "error",
        "fullWidth",
        "id",
        "inputComponent",
        "inputProps",
        "inputRef",
        "margin",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onClick",
        "onFocus",
        "onKeyDown",
        "onKeyUp",
        "placeholder",
        "readOnly",
        "renderSuffix",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "startAdornment",
        "type",
        "value"
    ]);
    var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    var _React$useRef = $a2gHv.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $a2gHv.useRef();
    var handleInputRefWarning = $a2gHv.useCallback(function(instance) {}, []);
    var handleInputPropsRefProp = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(inputPropsProp.ref, handleInputRefWarning);
    var handleInputRefProp = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(inputRefProp, handleInputPropsRefProp);
    var handleInputRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(inputRef, handleInputRefProp);
    var _React$useState = $a2gHv.useState(false), focused = _React$useState[0], setFocused = _React$useState[1];
    var muiFormControl = (0, $b8bda1a043b52a3c$export$62ecd8ad1bbe1a18)();
    var fcs = (0, $02d20181ee06a14b$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "margin",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $a2gHv.useEffect(function() {
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    var onFilled = muiFormControl && muiFormControl.onFilled;
    var onEmpty = muiFormControl && muiFormControl.onEmpty;
    var checkDirty = $a2gHv.useCallback(function(obj) {
        if ((0, $d02852b4bd458b43$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    $0dd8f8b7b77f1a1e$var$useEnhancedEffect(function() {
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    var handleFocus = function handleFocus(event) {
        // Fix a bug with IE 11 where the focus/blur events are triggered
        // while the input is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) {
            var element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $7pDoN.default)(1));
            checkDirty({
                value: element.value
            });
        }
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (inputPropsProp.onChange) inputPropsProp.onChange.apply(inputPropsProp, [
            event
        ].concat(args));
         // Perform in the willUpdate
        if (onChange) onChange.apply(void 0, [
            event
        ].concat(args));
    }; // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $a2gHv.useEffect(function() {
        checkDirty(inputRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var handleClick = function handleClick(event) {
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    var InputComponent = inputComponent;
    var inputProps = (0, $kO11b.default)({}, inputPropsProp, {
        ref: handleInputRef
    });
    if (typeof InputComponent !== "string") inputProps = (0, $kO11b.default)({
        // Rename ref to inputRef as we don't know the
        // provided `inputComponent` structure.
        inputRef: handleInputRef,
        type: type
    }, inputProps, {
        ref: null
    });
    else if (multiline) {
        if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) InputComponent = "textarea";
        else {
            inputProps = (0, $kO11b.default)({
                minRows: rows || minRows,
                rowsMax: rowsMax,
                maxRows: maxRows
            }, inputProps);
            InputComponent = (0, $588dd13f58dadf42$export$2e2bcd8739ae039);
        }
    } else inputProps = (0, $kO11b.default)({
        type: type
    }, inputProps);
    var handleAutoFill = function handleAutoFill(event) {
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $a2gHv.useEffect(function() {
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    return /*#__PURE__*/ $a2gHv.createElement("div", (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, classes["color".concat((0, $lrWdp.default)(fcs.color || "primary"))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === "dense" && classes.marginDense),
        onClick: handleClick,
        ref: ref
    }, other), startAdornment, /*#__PURE__*/ $a2gHv.createElement((0, $b8bda1a043b52a3c$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $a2gHv.createElement(InputComponent, (0, $kO11b.default)({
        "aria-invalid": fcs.error,
        "aria-describedby": ariaDescribedby,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        disabled: fcs.disabled,
        id: id,
        onAnimationStart: handleAutoFill,
        name: name,
        placeholder: placeholder,
        readOnly: readOnly,
        required: fcs.required,
        rows: rows,
        value: value,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    }, inputProps, {
        className: (0, $1r7hW.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === "search" && classes.inputTypeSearch, fcs.margin === "dense" && classes.inputMarginDense),
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus
    }))), endAdornment, renderSuffix ? renderSuffix((0, $kO11b.default)({}, fcs, {
        startAdornment: startAdornment
    })) : null);
});
var $0dd8f8b7b77f1a1e$export$2e2bcd8739ae039 = (0, $ljK7E.default)($0dd8f8b7b77f1a1e$export$9dd6ff9ea0189349, {
    name: "MuiInputBase"
})($0dd8f8b7b77f1a1e$var$InputBase);



var $ljK7E = parcelRequire("ljK7E");
var $666c5b9ebc68e510$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative"
        },
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            "label + &": {
                marginTop: 16
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            "&$underline:after": {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            "&:after": {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: "absolute",
                right: 0,
                transform: "scaleX(0)",
                transition: theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&$focused:after": {
                transform: "scaleX(1)"
            },
            "&$error:after": {
                borderBottomColor: theme.palette.error.main,
                transform: "scaleX(1)" // error is always underlined in red
            },
            "&:before": {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: "absolute",
                right: 0,
                transition: theme.transitions.create("border-bottom-color", {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&:hover:not($disabled):before": {
                borderBottom: "2px solid ".concat(theme.palette.text.primary),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    borderBottom: "1px solid ".concat(bottomLineColor)
                }
            },
            "&$disabled:before": {
                borderBottomStyle: "dotted"
            }
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {},
        /* Styles applied to the `input` element. */ input: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {},
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {},
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {}
    };
};
var $666c5b9ebc68e510$var$Input = /*#__PURE__*/ $a2gHv.forwardRef(function Input(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $hmzQs.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $a2gHv.createElement((0, $0dd8f8b7b77f1a1e$export$2e2bcd8739ae039), (0, $kO11b.default)({
        classes: (0, $kO11b.default)({}, classes, {
            root: (0, $1r7hW.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$666c5b9ebc68e510$var$Input.muiName = "Input";
var $666c5b9ebc68e510$export$2e2bcd8739ae039 = (0, $ljK7E.default)($666c5b9ebc68e510$export$9dd6ff9ea0189349, {
    name: "MuiInput"
})($666c5b9ebc68e510$var$Input);



var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");



var $ljK7E = parcelRequire("ljK7E");
var $ebf040de7172b6e1$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    var backgroundColor = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            backgroundColor: backgroundColor,
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            "&:hover": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.13)" : "rgba(255, 255, 255, 0.13)",
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: backgroundColor
                }
            },
            "&$focused": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)"
            },
            "&$disabled": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)"
            }
        },
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            "&$underline:after": {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            "&:after": {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: "absolute",
                right: 0,
                transform: "scaleX(0)",
                transition: theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&$focused:after": {
                transform: "scaleX(1)"
            },
            "&$error:after": {
                borderBottomColor: theme.palette.error.main,
                transform: "scaleX(1)" // error is always underlined in red
            },
            "&:before": {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: "absolute",
                right: 0,
                transition: theme.transitions.create("border-bottom-color", {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&:hover:before": {
                borderBottom: "1px solid ".concat(theme.palette.text.primary)
            },
            "&$disabled:before": {
                borderBottomStyle: "dotted"
            }
        },
        /* Pseudo-class applied to the root element if the component is focused. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 12
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 12
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "27px 12px 10px",
            "&$marginDense": {
                paddingTop: 23,
                paddingBottom: 6
            }
        },
        /* Styles applied to the `input` element. */ input: {
            padding: "27px 12px 10px",
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.type === "light" ? null : "#fff",
                caretColor: theme.palette.type === "light" ? null : "#fff",
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 23,
            paddingBottom: 6
        },
        /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */ inputHiddenLabel: {
            paddingTop: 18,
            paddingBottom: 19,
            "&$inputMarginDense": {
                paddingTop: 10,
                paddingBottom: 11
            }
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $ebf040de7172b6e1$var$FilledInput = /*#__PURE__*/ $a2gHv.forwardRef(function FilledInput(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $hmzQs.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $a2gHv.createElement((0, $0dd8f8b7b77f1a1e$export$2e2bcd8739ae039), (0, $kO11b.default)({
        classes: (0, $kO11b.default)({}, classes, {
            root: (0, $1r7hW.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$ebf040de7172b6e1$var$FilledInput.muiName = "Input";
var $ebf040de7172b6e1$export$2e2bcd8739ae039 = (0, $ljK7E.default)($ebf040de7172b6e1$export$9dd6ff9ea0189349, {
    name: "MuiFilledInput"
})($ebf040de7172b6e1$var$FilledInput);



var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");



var $epFuc = parcelRequire("epFuc");

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $ljK7E = parcelRequire("ljK7E");

var $k7gVl = parcelRequire("k7gVl");
parcelRequire("a2gHv");

var $hhxkg = parcelRequire("hhxkg");
function $8cf1e6908f234c8c$export$2e2bcd8739ae039() {
    var theme = (0, $k7gVl.default)() || (0, $hhxkg.default);
    return theme;
}



var $lrWdp = parcelRequire("lrWdp");
var $19391d52e91d714a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "absolute",
            bottom: 0,
            right: 0,
            top: -5,
            left: 0,
            margin: 0,
            padding: "0 8px",
            pointerEvents: "none",
            borderRadius: "inherit",
            borderStyle: "solid",
            borderWidth: 1,
            overflow: "hidden"
        },
        /* Styles applied to the legend element when `labelWidth` is provided. */ legend: {
            textAlign: "left",
            padding: 0,
            lineHeight: "11px",
            // sync with `height` in `legend` styles
            transition: theme.transitions.create("width", {
                duration: 150,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the legend element. */ legendLabelled: {
            display: "block",
            width: "auto",
            textAlign: "left",
            padding: 0,
            height: 11,
            // sync with `lineHeight` in `legend` styles
            fontSize: "0.75em",
            visibility: "hidden",
            maxWidth: 0.01,
            transition: theme.transitions.create("max-width", {
                duration: 50,
                easing: theme.transitions.easing.easeOut
            }),
            "& > span": {
                paddingLeft: 5,
                paddingRight: 5,
                display: "inline-block"
            }
        },
        /* Styles applied to the legend element is notched. */ legendNotched: {
            maxWidth: 1000,
            transition: theme.transitions.create("max-width", {
                duration: 100,
                easing: theme.transitions.easing.easeOut,
                delay: 50
            })
        }
    };
};
/**
 * @ignore - internal component.
 */ var $19391d52e91d714a$var$NotchedOutline = /*#__PURE__*/ $a2gHv.forwardRef(function NotchedOutline(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, label = props.label, labelWidthProp = props.labelWidth, notched = props.notched, style = props.style, other = (0, $hmzQs.default)(props, [
        "children",
        "classes",
        "className",
        "label",
        "labelWidth",
        "notched",
        "style"
    ]);
    var theme = (0, $8cf1e6908f234c8c$export$2e2bcd8739ae039)();
    var align = theme.direction === "rtl" ? "right" : "left";
    if (label !== undefined) return /*#__PURE__*/ $a2gHv.createElement("fieldset", (0, $kO11b.default)({
        "aria-hidden": true,
        className: (0, $1r7hW.default)(classes.root, className),
        ref: ref,
        style: style
    }, other), /*#__PURE__*/ $a2gHv.createElement("legend", {
        className: (0, $1r7hW.default)(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/ $a2gHv.createElement("span", null, label) : /*#__PURE__*/ $a2gHv.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    })));
    var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
    return /*#__PURE__*/ $a2gHv.createElement("fieldset", (0, $kO11b.default)({
        "aria-hidden": true,
        style: (0, $kO11b.default)((0, $epFuc.default)({}, "padding".concat((0, $lrWdp.default)(align)), 8), style),
        className: (0, $1r7hW.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $a2gHv.createElement("legend", {
        className: classes.legend,
        style: {
            // IE 11: fieldset with legend does not render
            // a border radius. This maintains consistency
            // by always having a legend rendered
            width: notched ? labelWidth : 0.01
        }
    }, /*#__PURE__*/ $a2gHv.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    })));
});
var $19391d52e91d714a$export$2e2bcd8739ae039 = (0, $ljK7E.default)($19391d52e91d714a$export$9dd6ff9ea0189349, {
    name: "PrivateNotchedOutline"
})($19391d52e91d714a$var$NotchedOutline);



var $ljK7E = parcelRequire("ljK7E");
var $b30db429396ba915$export$9dd6ff9ea0189349 = function styles(theme) {
    var borderColor = theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            borderRadius: theme.shape.borderRadius,
            "&:hover $notchedOutline": {
                borderColor: theme.palette.text.primary
            },
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                "&:hover $notchedOutline": {
                    borderColor: borderColor
                }
            },
            "&$focused $notchedOutline": {
                borderColor: theme.palette.primary.main,
                borderWidth: 2
            },
            "&$error $notchedOutline": {
                borderColor: theme.palette.error.main
            },
            "&$disabled $notchedOutline": {
                borderColor: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            "&$focused $notchedOutline": {
                borderColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 14
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 14
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "18.5px 14px",
            "&$marginDense": {
                paddingTop: 10.5,
                paddingBottom: 10.5
            }
        },
        /* Styles applied to the `NotchedOutline` element. */ notchedOutline: {
            borderColor: borderColor
        },
        /* Styles applied to the `input` element. */ input: {
            padding: "18.5px 14px",
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.type === "light" ? null : "#fff",
                caretColor: theme.palette.type === "light" ? null : "#fff",
                borderRadius: "inherit"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 10.5,
            paddingBottom: 10.5
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $b30db429396ba915$var$OutlinedInput = /*#__PURE__*/ $a2gHv.forwardRef(function OutlinedInput(props, ref) {
    var classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, label = props.label, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, notched = props.notched, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $hmzQs.default)(props, [
        "classes",
        "fullWidth",
        "inputComponent",
        "label",
        "labelWidth",
        "multiline",
        "notched",
        "type"
    ]);
    return /*#__PURE__*/ $a2gHv.createElement((0, $0dd8f8b7b77f1a1e$export$2e2bcd8739ae039), (0, $kO11b.default)({
        renderSuffix: function renderSuffix(state) {
            return /*#__PURE__*/ $a2gHv.createElement((0, $19391d52e91d714a$export$2e2bcd8739ae039), {
                className: classes.notchedOutline,
                label: label,
                labelWidth: labelWidth,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            });
        },
        classes: (0, $kO11b.default)({}, classes, {
            root: (0, $1r7hW.default)(classes.root, classes.underline),
            notchedOutline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$b30db429396ba915$var$OutlinedInput.muiName = "Input";
var $b30db429396ba915$export$2e2bcd8739ae039 = (0, $ljK7E.default)($b30db429396ba915$export$9dd6ff9ea0189349, {
    name: "MuiOutlinedInput"
})($b30db429396ba915$var$OutlinedInput);



var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");



var $ljK7E = parcelRequire("ljK7E");

var $1dd2e4a051caf598$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "block",
            transformOrigin: "top left"
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Pseudo-class applied to the asterisk element. */ asterisk: {},
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            position: "absolute",
            left: 0,
            top: 0,
            // slight alteration to spec spacing to match visual spec result
            transform: "translate(0, 24px) scale(1)"
        },
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            // Compensation for the `Input.inputDense` style.
            transform: "translate(0, 21px) scale(1)"
        },
        /* Styles applied to the `input` element if `shrink={true}`. */ shrink: {
            transform: "translate(0, 1.5px) scale(0.75)",
            transformOrigin: "top left"
        },
        /* Styles applied to the `input` element if `disableAnimation={false}`. */ animated: {
            transition: theme.transitions.create([
                "color",
                "transform"
            ], {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the root element if `variant="filled"`. */ filled: {
            // Chrome's autofill feature gives the input field a yellow background.
            // Since the input field is behind the label in the HTML tree,
            // the input field is drawn last and hides the label with an opaque background color.
            // zIndex: 1 will raise the label above opaque background-colors of input.
            zIndex: 1,
            pointerEvents: "none",
            transform: "translate(12px, 20px) scale(1)",
            "&$marginDense": {
                transform: "translate(12px, 17px) scale(1)"
            },
            "&$shrink": {
                transform: "translate(12px, 10px) scale(0.75)",
                "&$marginDense": {
                    transform: "translate(12px, 7px) scale(0.75)"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            // see comment above on filled.zIndex
            zIndex: 1,
            pointerEvents: "none",
            transform: "translate(14px, 20px) scale(1)",
            "&$marginDense": {
                transform: "translate(14px, 12px) scale(1)"
            },
            "&$shrink": {
                transform: "translate(14px, -6px) scale(0.75)"
            }
        }
    };
};
var $1dd2e4a051caf598$var$InputLabel = /*#__PURE__*/ $a2gHv.forwardRef(function InputLabel(props, ref) {
    var classes = props.classes, className = props.className, _props$disableAnimati = props.disableAnimation, disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati, margin = props.margin, shrinkProp = props.shrink, variant = props.variant, other = (0, $hmzQs.default)(props, [
        "classes",
        "className",
        "disableAnimation",
        "margin",
        "shrink",
        "variant"
    ]);
    var muiFormControl = (0, $9d2a21945a86adb6$export$2e2bcd8739ae039)();
    var shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    var fcs = (0, $02d20181ee06a14b$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "margin",
            "variant"
        ]
    });
    return /*#__PURE__*/ $a2gHv.createElement((0, $a200f36ca8fadba2$export$2e2bcd8739ae039), (0, $kO11b.default)({
        "data-shrink": shrink,
        className: (0, $1r7hW.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === "dense" && classes.marginDense, {
            "filled": classes.filled,
            "outlined": classes.outlined
        }[fcs.variant]),
        classes: {
            focused: classes.focused,
            disabled: classes.disabled,
            error: classes.error,
            required: classes.required,
            asterisk: classes.asterisk
        },
        ref: ref
    }, other));
});
var $1dd2e4a051caf598$export$2e2bcd8739ae039 = (0, $ljK7E.default)($1dd2e4a051caf598$export$9dd6ff9ea0189349, {
    name: "MuiInputLabel"
})($1dd2e4a051caf598$var$InputLabel);




var $hmzQs = parcelRequire("hmzQs");

var $kO11b = parcelRequire("kO11b");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");



var $ljK7E = parcelRequire("ljK7E");
var $b1c43402843431ed$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $kO11b.default)({
            color: theme.palette.text.secondary
        }, theme.typography.caption, {
            textAlign: "left",
            marginTop: 3,
            margin: 0,
            "&$disabled": {
                color: theme.palette.text.disabled
            },
            "&$error": {
                color: theme.palette.error.main
            }
        }),
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            marginTop: 4
        },
        /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */ contained: {
            marginLeft: 14,
            marginRight: 14
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {}
    };
};
var $b1c43402843431ed$var$FormHelperText = /*#__PURE__*/ $a2gHv.forwardRef(function FormHelperText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "p" : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, margin = props.margin, required = props.required, variant = props.variant, other = (0, $hmzQs.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "margin",
        "required",
        "variant"
    ]);
    var muiFormControl = (0, $9d2a21945a86adb6$export$2e2bcd8739ae039)();
    var fcs = (0, $02d20181ee06a14b$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "margin",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    return /*#__PURE__*/ $a2gHv.createElement(Component, (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, (fcs.variant === "filled" || fcs.variant === "outlined") && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === "dense" && classes.marginDense),
        ref: ref
    }, other), children === " " ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $a2gHv.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    }) : children);
});
var $b1c43402843431ed$export$2e2bcd8739ae039 = (0, $ljK7E.default)($b1c43402843431ed$export$9dd6ff9ea0189349, {
    name: "MuiFormHelperText"
})($b1c43402843431ed$var$FormHelperText);



var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $9cDAr = parcelRequire("9cDAr");

var $kO11b = parcelRequire("kO11b");

var $lbAml = parcelRequire("lbAml");

var $hmzQs = parcelRequire("hmzQs");

var $gvXaa = parcelRequire("gvXaa");

var $7pDoN = parcelRequire("7pDoN");

var $a2gHv = parcelRequire("a2gHv");
parcelRequire("gnuGk");


var $1r7hW = parcelRequire("1r7hW");
function $a773b260c1b71dbc$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $lrWdp = parcelRequire("lrWdp");

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");
parcelRequire("gnuGk");


var $1r7hW = parcelRequire("1r7hW");


var $ljK7E = parcelRequire("ljK7E");

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");





var $1r7hW = parcelRequire("1r7hW");


function $e65aee34dc534690$export$2e2bcd8739ae039(node) {
    var doc = (0, $a773b260c1b71dbc$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}





var $ljK7E = parcelRequire("ljK7E");

var $hmzQs = parcelRequire("hmzQs");

var $kO11b = parcelRequire("kO11b");

var $a2gHv = parcelRequire("a2gHv");



var $2f2hR = parcelRequire("2f2hR");
var $k7gVl = parcelRequire("k7gVl");




var $a2gHv = parcelRequire("a2gHv");






function $b72b558052e4f9dc$var$getContainer(container) {
    container = typeof container === "function" ? container() : container; // #StrictMode ready
    return $fcd36364b46ce6ed$exports.findDOMNode(container);
}
var $b72b558052e4f9dc$var$useEnhancedEffect = typeof window !== "undefined" ? $a2gHv.useLayoutEffect : $a2gHv.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ var $b72b558052e4f9dc$var$Portal = /*#__PURE__*/ $a2gHv.forwardRef(function Portal(props, ref) {
    var children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, onRendered = props.onRendered;
    var _React$useState = $a2gHv.useState(null), mountNode = _React$useState[0], setMountNode = _React$useState[1];
    var handleRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(/*#__PURE__*/ $a2gHv.isValidElement(children) ? children.ref : null, ref);
    $b72b558052e4f9dc$var$useEnhancedEffect(function() {
        if (!disablePortal) setMountNode($b72b558052e4f9dc$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    $b72b558052e4f9dc$var$useEnhancedEffect(function() {
        if (mountNode && !disablePortal) {
            (0, $3f9d91311c0ceddb$export$2e2bcd8739ae039)(ref, mountNode);
            return function() {
                (0, $3f9d91311c0ceddb$export$2e2bcd8739ae039)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    $b72b558052e4f9dc$var$useEnhancedEffect(function() {
        if (onRendered && (mountNode || disablePortal)) onRendered();
    }, [
        onRendered,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $a2gHv.isValidElement(children)) return /*#__PURE__*/ $a2gHv.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return mountNode ? /*#__PURE__*/ $fcd36364b46ce6ed$exports.createPortal(children, mountNode) : mountNode;
});
var $b72b558052e4f9dc$export$2e2bcd8739ae039 = $b72b558052e4f9dc$var$Portal;






var $loW7s = parcelRequire("loW7s");
function $bed5c4c5ce4ab7dc$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



var $5ly4m = parcelRequire("5ly4m");

var $ifOOi = parcelRequire("ifOOi");
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function $21866e6e87399210$export$2e2bcd8739ae039() {
    var scrollDiv = document.createElement("div");
    scrollDiv.style.width = "99px";
    scrollDiv.style.height = "99px";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.overflow = "scroll";
    document.body.appendChild(scrollDiv);
    var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarSize;
}




function $d28df720f8e5c9a8$var$isOverflowing(container) {
    var doc = (0, $a773b260c1b71dbc$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $e65aee34dc534690$export$2e2bcd8739ae039)(doc).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $d28df720f8e5c9a8$export$e1bd0c6150f13d96(node, show) {
    if (show) node.setAttribute("aria-hidden", "true");
    else node.removeAttribute("aria-hidden");
}
function $d28df720f8e5c9a8$var$getPaddingRight(node) {
    return parseInt(window.getComputedStyle(node)["padding-right"], 10) || 0;
}
function $d28df720f8e5c9a8$var$ariaHiddenSiblings(container, mountNode, currentNode) {
    var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var show = arguments.length > 4 ? arguments[4] : undefined;
    var blacklist = [
        mountNode,
        currentNode
    ].concat((0, $ifOOi.default)(nodesToExclude));
    var blacklistTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE"
    ];
    [].forEach.call(container.children, function(node) {
        if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) $d28df720f8e5c9a8$export$e1bd0c6150f13d96(node, show);
    });
}
function $d28df720f8e5c9a8$var$findIndexOf(containerInfo, callback) {
    var idx = -1;
    containerInfo.some(function(item, index) {
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $d28df720f8e5c9a8$var$handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var restorePaddings = [];
    var container = containerInfo.container;
    var fixedNodes;
    if (!props.disableScrollLock) {
        if ($d28df720f8e5c9a8$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            var scrollbarSize = (0, $21866e6e87399210$export$2e2bcd8739ae039)();
            restoreStyle.push({
                value: container.style.paddingRight,
                key: "padding-right",
                el: container
            }); // Use computed style, here to get the real padding to add our scrollbar width.
            container.style["padding-right"] = "".concat($d28df720f8e5c9a8$var$getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
            fixedNodes = (0, $a773b260c1b71dbc$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedNodes, function(node) {
                restorePaddings.push(node.style.paddingRight);
                node.style.paddingRight = "".concat($d28df720f8e5c9a8$var$getPaddingRight(node) + scrollbarSize, "px");
            });
        } // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        var parent = container.parentElement;
        var scrollContainer = parent.nodeName === "HTML" && window.getComputedStyle(parent)["overflow-y"] === "scroll" ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            key: "overflow",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    var restore = function restore() {
        if (fixedNodes) [].forEach.call(fixedNodes, function(node, i) {
            if (restorePaddings[i]) node.style.paddingRight = restorePaddings[i];
            else node.style.removeProperty("padding-right");
        });
        restoreStyle.forEach(function(_ref) {
            var value = _ref.value, el = _ref.el, key = _ref.key;
            if (value) el.style.setProperty(key, value);
            else el.style.removeProperty(key);
        });
    };
    return restore;
}
function $d28df720f8e5c9a8$var$getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function(node) {
        if (node.getAttribute && node.getAttribute("aria-hidden") === "true") hiddenSiblings.push(node);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ var $d28df720f8e5c9a8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ModalManager() {
        (0, $bed5c4c5ce4ab7dc$export$2e2bcd8739ae039)(this, ModalManager);
        // this.modals[modalIndex] = modal
        this.modals = []; // this.containers[containerIndex] = {
        //   modals: [],
        //   container,
        //   restore: null,
        // }
        this.containers = [];
    }
    (0, $5ly4m.default)(ModalManager, [
        {
            key: "add",
            value: function add(modal, container) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex !== -1) return modalIndex;
                modalIndex = this.modals.length;
                this.modals.push(modal); // If the modal we are adding is already in the DOM.
                if (modal.modalRef) $d28df720f8e5c9a8$export$e1bd0c6150f13d96(modal.modalRef, false);
                var hiddenSiblingNodes = $d28df720f8e5c9a8$var$getHiddenSiblings(container);
                $d28df720f8e5c9a8$var$ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
                var containerIndex = $d28df720f8e5c9a8$var$findIndexOf(this.containers, function(item) {
                    return item.container === container;
                });
                if (containerIndex !== -1) {
                    this.containers[containerIndex].modals.push(modal);
                    return modalIndex;
                }
                this.containers.push({
                    modals: [
                        modal
                    ],
                    container: container,
                    restore: null,
                    hiddenSiblingNodes: hiddenSiblingNodes
                });
                return modalIndex;
            }
        },
        {
            key: "mount",
            value: function mount(modal, props) {
                var containerIndex = $d28df720f8e5c9a8$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                if (!containerInfo.restore) containerInfo.restore = $d28df720f8e5c9a8$var$handleContainer(containerInfo, props);
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex === -1) return modalIndex;
                var containerIndex = $d28df720f8e5c9a8$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
                this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
                if (containerInfo.modals.length === 0) {
                    // The modal might be closed before it had the chance to be mounted in the DOM.
                    if (containerInfo.restore) containerInfo.restore();
                    if (modal.modalRef) // In case the modal wasn't in the DOM yet.
                    $d28df720f8e5c9a8$export$e1bd0c6150f13d96(modal.modalRef, true);
                    $d28df720f8e5c9a8$var$ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
                    this.containers.splice(containerIndex, 1);
                } else {
                    // Otherwise make sure the next top modal is visible to a screen reader.
                    var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
                    // aria-hidden because the dom element doesn't exist either
                    // when modal was unmounted before modalRef gets null
                    if (nextTop.modalRef) $d28df720f8e5c9a8$export$e1bd0c6150f13d96(nextTop.modalRef, false);
                }
                return modalIndex;
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();


/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */ 
var $a2gHv = parcelRequire("a2gHv");





/**
 * Utility component that locks focus inside the component.
 */ function $75be62dc98d16c9a$var$Unstable_TrapFocus(props) {
    var children = props.children, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, getDoc = props.getDoc, isEnabled = props.isEnabled, open = props.open;
    var ignoreNextEnforceFocus = $a2gHv.useRef();
    var sentinelStart = $a2gHv.useRef(null);
    var sentinelEnd = $a2gHv.useRef(null);
    var nodeToRestore = $a2gHv.useRef();
    var rootRef = $a2gHv.useRef(null); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $a2gHv.useCallback(function(instance) {
        // #StrictMode ready
        rootRef.current = $fcd36364b46ce6ed$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(children.ref, handleOwnRef);
    var prevOpenRef = $a2gHv.useRef();
    $a2gHv.useEffect(function() {
        prevOpenRef.current = open;
    }, [
        open
    ]);
    if (!prevOpenRef.current && open && typeof window !== "undefined") // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
    $a2gHv.useEffect(function() {
        if (!open) return;
        var doc = (0, $a773b260c1b71dbc$export$2e2bcd8739ae039)(rootRef.current); // We might render an empty child.
        if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", -1);
            rootRef.current.focus();
        }
        var contain = function contain() {
            var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (rootRef.current && !rootRef.current.contains(doc.activeElement)) rootRef.current.focus();
        };
        var loopFocus = function loopFocus(event) {
            // 9 = Tab
            if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) return;
             // Make sure the next tab starts from the right place.
            if (doc.activeElement === rootRef.current) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (event.shiftKey) sentinelEnd.current.focus();
                else sentinelStart.current.focus();
            }
        };
        doc.addEventListener("focus", contain, true);
        doc.addEventListener("keydown", loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        var interval = setInterval(function() {
            contain();
        }, 50);
        return function() {
            clearInterval(interval);
            doc.removeEventListener("focus", contain, true);
            doc.removeEventListener("keydown", loopFocus, true); // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE 11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE 11 have a focus method.
                // Once IE 11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) nodeToRestore.current.focus();
                nodeToRestore.current = null;
            }
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open
    ]);
    return /*#__PURE__*/ $a2gHv.createElement($a2gHv.Fragment, null, /*#__PURE__*/ $a2gHv.createElement("div", {
        tabIndex: 0,
        ref: sentinelStart,
        "data-test": "sentinelStart"
    }), /*#__PURE__*/ $a2gHv.cloneElement(children, {
        ref: handleRef
    }), /*#__PURE__*/ $a2gHv.createElement("div", {
        tabIndex: 0,
        ref: sentinelEnd,
        "data-test": "sentinelEnd"
    }));
}
var $75be62dc98d16c9a$export$2e2bcd8739ae039 = $75be62dc98d16c9a$var$Unstable_TrapFocus;



var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");

var $94749da792955e93$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        zIndex: -1,
        position: "fixed",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: "transparent"
    }
};
/**
 * @ignore - internal component.
 */ var $94749da792955e93$var$SimpleBackdrop = /*#__PURE__*/ $a2gHv.forwardRef(function SimpleBackdrop(props, ref) {
    var _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, other = (0, $hmzQs.default)(props, [
        "invisible",
        "open"
    ]);
    return open ? /*#__PURE__*/ $a2gHv.createElement("div", (0, $kO11b.default)({
        "aria-hidden": true,
        ref: ref
    }, other, {
        style: (0, $kO11b.default)({}, $94749da792955e93$export$9dd6ff9ea0189349.root, invisible ? $94749da792955e93$export$9dd6ff9ea0189349.invisible : {}, other.style)
    })) : null;
});
var $94749da792955e93$export$2e2bcd8739ae039 = $94749da792955e93$var$SimpleBackdrop;


function $ca3808f2da8d957e$var$getContainer(container) {
    container = typeof container === "function" ? container() : container;
    return $fcd36364b46ce6ed$exports.findDOMNode(container);
}
function $ca3808f2da8d957e$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty("in") : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var $ca3808f2da8d957e$var$defaultManager = new (0, $d28df720f8e5c9a8$export$2e2bcd8739ae039)();
var $ca3808f2da8d957e$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "fixed",
            zIndex: theme.zIndex.modal,
            right: 0,
            bottom: 0,
            top: 0,
            left: 0
        },
        /* Styles applied to the root element if the `Modal` has exited. */ hidden: {
            visibility: "hidden"
        }
    };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ var $ca3808f2da8d957e$var$Modal = /*#__PURE__*/ $a2gHv.forwardRef(function Modal(inProps, ref) {
    var theme = (0, $k7gVl.default)();
    var props = (0, $2f2hR.default)({
        name: "MuiModal",
        props: (0, $kO11b.default)({}, inProps),
        theme: theme
    });
    var _props$BackdropCompon = props.BackdropComponent, BackdropComponent = _props$BackdropCompon === void 0 ? (0, $94749da792955e93$export$2e2bcd8739ae039) : _props$BackdropCompon, BackdropProps = props.BackdropProps, children = props.children, _props$closeAfterTran = props.closeAfterTransition, closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran, container = props.container, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, _props$disableScrollL = props.disableScrollLock, disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL, _props$hideBackdrop = props.hideBackdrop, hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, _props$manager = props.manager, manager = _props$manager === void 0 ? $ca3808f2da8d957e$var$defaultManager : _props$manager, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEscapeKeyDown = props.onEscapeKeyDown, onRendered = props.onRendered, open = props.open, other = (0, $hmzQs.default)(props, [
        "BackdropComponent",
        "BackdropProps",
        "children",
        "closeAfterTransition",
        "container",
        "disableAutoFocus",
        "disableBackdropClick",
        "disableEnforceFocus",
        "disableEscapeKeyDown",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "hideBackdrop",
        "keepMounted",
        "manager",
        "onBackdropClick",
        "onClose",
        "onEscapeKeyDown",
        "onRendered",
        "open"
    ]);
    var _React$useState = $a2gHv.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var modal = $a2gHv.useRef({});
    var mountNodeRef = $a2gHv.useRef(null);
    var modalRef = $a2gHv.useRef(null);
    var handleRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(modalRef, ref);
    var hasTransition = $ca3808f2da8d957e$var$getHasTransition(props);
    var getDoc = function getDoc() {
        return (0, $a773b260c1b71dbc$export$2e2bcd8739ae039)(mountNodeRef.current);
    };
    var getModal = function getModal() {
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    var handleMounted = function handleMounted() {
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        }); // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    var handleOpen = (0, $73a36d95a5fcfdd3$export$2e2bcd8739ae039)(function() {
        var resolvedContainer = $ca3808f2da8d957e$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer); // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    var isTopModal = $a2gHv.useCallback(function() {
        return manager.isTopModal(getModal());
    }, [
        manager
    ]);
    var handlePortalRef = (0, $73a36d95a5fcfdd3$export$2e2bcd8739ae039)(function(node) {
        mountNodeRef.current = node;
        if (!node) return;
        if (onRendered) onRendered();
        if (open && isTopModal()) handleMounted();
        else (0, $d28df720f8e5c9a8$export$e1bd0c6150f13d96)(modalRef.current, true);
    });
    var handleClose = $a2gHv.useCallback(function() {
        manager.remove(getModal());
    }, [
        manager
    ]);
    $a2gHv.useEffect(function() {
        return function() {
            handleClose();
        };
    }, [
        handleClose
    ]);
    $a2gHv.useEffect(function() {
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleExited = function handleExited() {
        setExited(true);
        if (closeAfterTransition) handleClose();
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, "backdropClick");
    };
    var handleKeyDown = function handleKeyDown(event) {
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviours like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (onEscapeKeyDown) onEscapeKeyDown(event);
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    var inlineStyle = $ca3808f2da8d957e$export$9dd6ff9ea0189349(theme || {
        zIndex: (0, $loW7s.default)
    });
    var childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = children.props.tabIndex || "-1";
     // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $2d1f2023da2fae25$export$2e2bcd8739ae039)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $2d1f2023da2fae25$export$2e2bcd8739ae039)(handleExited, children.props.onExited);
    }
    return /*#__PURE__*/ $a2gHv.createElement((0, $b72b558052e4f9dc$export$2e2bcd8739ae039), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal
    }, /*#__PURE__*/ $a2gHv.createElement("div", (0, $kO11b.default)({
        ref: handleRef,
        onKeyDown: handleKeyDown,
        role: "presentation"
    }, other, {
        style: (0, $kO11b.default)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
    }), hideBackdrop ? null : /*#__PURE__*/ $a2gHv.createElement(BackdropComponent, (0, $kO11b.default)({
        open: open,
        onClick: handleBackdropClick
    }, BackdropProps)), /*#__PURE__*/ $a2gHv.createElement((0, $75be62dc98d16c9a$export$2e2bcd8739ae039), {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        getDoc: getDoc,
        isEnabled: isTopModal,
        open: open
    }, /*#__PURE__*/ $a2gHv.cloneElement(children, childProps))));
});
var $ca3808f2da8d957e$export$2e2bcd8739ae039 = $ca3808f2da8d957e$var$Modal;



var $kO11b = parcelRequire("kO11b");

var $lbAml = parcelRequire("lbAml");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $lqlJt = parcelRequire("lqlJt");

var $8XKFn = parcelRequire("8XKFn");


var $a2gHv = parcelRequire("a2gHv");

var $388f45f9846db192$export$2e2bcd8739ae039 = {
    disabled: false
};




var $2f737c96024fdf2a$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $8c5f27b528517b1a$export$bb38bb9a1161268 = "unmounted";
var $8c5f27b528517b1a$export$84cbff306f539230 = "exited";
var $8c5f27b528517b1a$export$df38205c966be359 = "entering";
var $8c5f27b528517b1a$export$78e9e6e3e014d60a = "entered";
var $8c5f27b528517b1a$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $8c5f27b528517b1a$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $8XKFn.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $8c5f27b528517b1a$export$84cbff306f539230;
                _this.appearStatus = $8c5f27b528517b1a$export$df38205c966be359;
            } else initialStatus = $8c5f27b528517b1a$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $8c5f27b528517b1a$export$bb38bb9a1161268;
        else initialStatus = $8c5f27b528517b1a$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $8c5f27b528517b1a$export$bb38bb9a1161268) return {
            status: $8c5f27b528517b1a$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $8c5f27b528517b1a$export$df38205c966be359 && status !== $8c5f27b528517b1a$export$78e9e6e3e014d60a) nextStatus = $8c5f27b528517b1a$export$df38205c966be359;
            } else if (status === $8c5f27b528517b1a$export$df38205c966be359 || status === $8c5f27b528517b1a$export$78e9e6e3e014d60a) nextStatus = $8c5f27b528517b1a$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $8c5f27b528517b1a$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fcd36364b46ce6ed$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $2f737c96024fdf2a$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $8c5f27b528517b1a$export$84cbff306f539230) this.setState({
            status: $8c5f27b528517b1a$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($fcd36364b46ce6ed$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $388f45f9846db192$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $8c5f27b528517b1a$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $8c5f27b528517b1a$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $8c5f27b528517b1a$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($fcd36364b46ce6ed$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $388f45f9846db192$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $8c5f27b528517b1a$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $8c5f27b528517b1a$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $8c5f27b528517b1a$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fcd36364b46ce6ed$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $8c5f27b528517b1a$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $lqlJt.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).createElement((0, $145c0696b5312bb9$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).Component);
$8c5f27b528517b1a$var$Transition.contextType = (0, $145c0696b5312bb9$export$2e2bcd8739ae039);
$8c5f27b528517b1a$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $8c5f27b528517b1a$var$noop() {}
$8c5f27b528517b1a$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $8c5f27b528517b1a$var$noop,
    onEntering: $8c5f27b528517b1a$var$noop,
    onEntered: $8c5f27b528517b1a$var$noop,
    onExit: $8c5f27b528517b1a$var$noop,
    onExiting: $8c5f27b528517b1a$var$noop,
    onExited: $8c5f27b528517b1a$var$noop
};
$8c5f27b528517b1a$var$Transition.UNMOUNTED = $8c5f27b528517b1a$export$bb38bb9a1161268;
$8c5f27b528517b1a$var$Transition.EXITED = $8c5f27b528517b1a$export$84cbff306f539230;
$8c5f27b528517b1a$var$Transition.ENTERING = $8c5f27b528517b1a$export$df38205c966be359;
$8c5f27b528517b1a$var$Transition.ENTERED = $8c5f27b528517b1a$export$78e9e6e3e014d60a;
$8c5f27b528517b1a$var$Transition.EXITING = $8c5f27b528517b1a$export$4aacc83d4d59139f;
var $8c5f27b528517b1a$export$2e2bcd8739ae039 = $8c5f27b528517b1a$var$Transition;



var $1664af78c1ef4732$export$b7a864e1eaef9de5 = function reflow(node) {
    return node.scrollTop;
};
function $1664af78c1ef4732$export$8cb1e9b404609ae9(props, options) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style;
    return {
        duration: style.transitionDuration || typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        delay: style.transitionDelay
    };
}



function $e5da9ad8be7c181b$var$getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var $e5da9ad8be7c181b$var$styles = {
    entering: {
        opacity: 1,
        transform: $e5da9ad8be7c181b$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $e5da9ad8be7c181b$var$Grow = /*#__PURE__*/ $a2gHv.forwardRef(function Grow(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? "auto" : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $8c5f27b528517b1a$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $hmzQs.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var timer = $a2gHv.useRef();
    var autoTimeout = $a2gHv.useRef();
    var theme = (0, $8cf1e6908f234c8c$export$2e2bcd8739ae039)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $a2gHv.useRef(null);
    var foreignRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(children.ref, ref);
    var handleRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $lbAml.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $1664af78c1ef4732$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        var _getTransitionProps = (0, $1664af78c1ef4732$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "enter"
        }), transitionDuration = _getTransitionProps.duration, delay = _getTransitionProps.delay;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var _getTransitionProps2 = (0, $1664af78c1ef4732$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "exit"
        }), transitionDuration = _getTransitionProps2.duration, delay = _getTransitionProps2.delay;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay || duration * 0.333
            })
        ].join(",");
        node.style.opacity = "0";
        node.style.transform = $e5da9ad8be7c181b$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
    };
    $a2gHv.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ $a2gHv.createElement(TransitionComponent, (0, $kO11b.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $a2gHv.cloneElement(children, (0, $kO11b.default)({
            style: (0, $kO11b.default)({
                opacity: 0,
                transform: $e5da9ad8be7c181b$var$getScale(0.75),
                visibility: state === "exited" && !inProp ? "hidden" : undefined
            }, $e5da9ad8be7c181b$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
$e5da9ad8be7c181b$var$Grow.muiSupportAuto = true;
var $e5da9ad8be7c181b$export$2e2bcd8739ae039 = $e5da9ad8be7c181b$var$Grow;



var $hmzQs = parcelRequire("hmzQs");

var $kO11b = parcelRequire("kO11b");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");


var $ljK7E = parcelRequire("ljK7E");
var $79ae84c416f068ea$export$9dd6ff9ea0189349 = function styles(theme) {
    var elevations = {};
    theme.shadows.forEach(function(shadow, index) {
        elevations["elevation".concat(index)] = {
            boxShadow: shadow
        };
    });
    return (0, $kO11b.default)({
        /* Styles applied to the root element. */ root: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            transition: theme.transitions.create("box-shadow")
        },
        /* Styles applied to the root element if `square={false}`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            border: "1px solid ".concat(theme.palette.divider)
        }
    }, elevations);
};
var $79ae84c416f068ea$var$Paper = /*#__PURE__*/ $a2gHv.forwardRef(function Paper(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 1 : _props$elevation, _props$variant = props.variant, variant = _props$variant === void 0 ? "elevation" : _props$variant, other = (0, $hmzQs.default)(props, [
        "classes",
        "className",
        "component",
        "square",
        "elevation",
        "variant"
    ]);
    return /*#__PURE__*/ $a2gHv.createElement(Component, (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className, variant === "outlined" ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
        ref: ref
    }, other));
});
var $79ae84c416f068ea$export$2e2bcd8739ae039 = (0, $ljK7E.default)($79ae84c416f068ea$export$9dd6ff9ea0189349, {
    name: "MuiPaper"
})($79ae84c416f068ea$var$Paper);


function $3d329cdbec8a375f$export$6fcff0dc60346367(rect, vertical) {
    var offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $3d329cdbec8a375f$export$a6a488ff68b1bf7b(rect, horizontal) {
    var offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $3d329cdbec8a375f$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map(function(n) {
        return typeof n === "number" ? "".concat(n, "px") : n;
    }).join(" ");
} // Sum the scrollTop between two elements.
function $3d329cdbec8a375f$var$getScrollParent(parent, child) {
    var element = child;
    var scrollTop = 0;
    while(element && element !== parent){
        element = element.parentElement;
        scrollTop += element.scrollTop;
    }
    return scrollTop;
}
function $3d329cdbec8a375f$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
var $3d329cdbec8a375f$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the `Paper` component. */ paper: {
        position: "absolute",
        overflowY: "auto",
        overflowX: "hidden",
        // So we see the popover when it's empty.
        // It's most likely on issue on userland.
        minWidth: 16,
        minHeight: 16,
        maxWidth: "calc(100% - 32px)",
        maxHeight: "calc(100% - 32px)",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $3d329cdbec8a375f$var$Popover = /*#__PURE__*/ $a2gHv.forwardRef(function Popover(props, ref) {
    var action = props.action, anchorEl = props.anchorEl, _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: "top",
        horizontal: "left"
    } : _props$anchorOrigin, anchorPosition = props.anchorPosition, _props$anchorReferenc = props.anchorReference, anchorReference = _props$anchorReferenc === void 0 ? "anchorEl" : _props$anchorReferenc, children = props.children, classes = props.classes, className = props.className, containerProp = props.container, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 8 : _props$elevation, getContentAnchorEl = props.getContentAnchorEl, _props$marginThreshol = props.marginThreshold, marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$transformOrigi = props.transformOrigin, transformOrigin = _props$transformOrigi === void 0 ? {
        vertical: "top",
        horizontal: "left"
    } : _props$transformOrigi, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $e5da9ad8be7c181b$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDurationProp = _props$transitionDura === void 0 ? "auto" : _props$transitionDura, _props$TransitionProp = props.TransitionProps, TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp, other = (0, $hmzQs.default)(props, [
        "action",
        "anchorEl",
        "anchorOrigin",
        "anchorPosition",
        "anchorReference",
        "children",
        "classes",
        "className",
        "container",
        "elevation",
        "getContentAnchorEl",
        "marginThreshold",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperProps",
        "transformOrigin",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var paperRef = $a2gHv.useRef(); // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    var getAnchorOffset = $a2gHv.useCallback(function(contentAnchorOffset) {
        if (anchorReference === "anchorPosition") return anchorPosition;
        var resolvedAnchorEl = $3d329cdbec8a375f$var$getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
        var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $a773b260c1b71dbc$export$2e2bcd8739ae039)(paperRef.current).body;
        var anchorRect = anchorElement.getBoundingClientRect();
        var box;
        var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : "center";
        return {
            top: anchorRect.top + $3d329cdbec8a375f$export$6fcff0dc60346367(anchorRect, anchorVertical),
            left: anchorRect.left + $3d329cdbec8a375f$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]); // Returns the vertical offset of inner content to anchor the transform on if provided
    var getContentAnchorOffset = $a2gHv.useCallback(function(element) {
        var contentAnchorOffset = 0;
        if (getContentAnchorEl && anchorReference === "anchorEl") {
            var contentAnchorEl = getContentAnchorEl(element);
            if (contentAnchorEl && element.contains(contentAnchorEl)) {
                var scrollTop = $3d329cdbec8a375f$var$getScrollParent(element, contentAnchorEl);
                contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
            } // != the default value
        }
        return contentAnchorOffset;
    }, [
        anchorOrigin.vertical,
        anchorReference,
        getContentAnchorEl
    ]); // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use
    var getTransformOrigin = $a2gHv.useCallback(function(elemRect) {
        var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return {
            vertical: $3d329cdbec8a375f$export$6fcff0dc60346367(elemRect, transformOrigin.vertical) + contentAnchorOffset,
            horizontal: $3d329cdbec8a375f$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    var getPositioningStyle = $a2gHv.useCallback(function(element) {
        // Check if the parent has requested anchoring on an inner content node
        var contentAnchorOffset = getContentAnchorOffset(element);
        var elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        }; // Get the transform origin point on the element itself
        var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $3d329cdbec8a375f$var$getTransformOriginValue(elemTransformOrigin)
        };
         // Get the offset of of the anchoring element
        var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
        var top = anchorOffset.top - elemTransformOrigin.vertical;
        var left = anchorOffset.left - elemTransformOrigin.horizontal;
        var bottom = top + elemRect.height;
        var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
        var containerWindow = (0, $e65aee34dc534690$export$2e2bcd8739ae039)($3d329cdbec8a375f$var$getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
        var heightThreshold = containerWindow.innerHeight - marginThreshold;
        var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            var diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            var _diff = bottom - heightThreshold;
            top -= _diff;
            elemTransformOrigin.vertical += _diff;
        }
        if (left < marginThreshold) {
            var _diff2 = left - marginThreshold;
            left -= _diff2;
            elemTransformOrigin.horizontal += _diff2;
        } else if (right > widthThreshold) {
            var _diff3 = right - widthThreshold;
            left -= _diff3;
            elemTransformOrigin.horizontal += _diff3;
        }
        return {
            top: "".concat(Math.round(top), "px"),
            left: "".concat(Math.round(left), "px"),
            transformOrigin: $3d329cdbec8a375f$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getContentAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    var setPositioningStyles = $a2gHv.useCallback(function() {
        var element = paperRef.current;
        if (!element) return;
        var positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
    }, [
        getPositioningStyle
    ]);
    var handleEntering = function handleEntering(element, isAppearing) {
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    var handlePaperRef = $a2gHv.useCallback(function(instance) {
        // #StrictMode ready
        paperRef.current = $fcd36364b46ce6ed$exports.findDOMNode(instance);
    }, []);
    $a2gHv.useEffect(function() {
        if (open) setPositioningStyles();
    });
    $a2gHv.useImperativeHandle(action, function() {
        return open ? {
            updatePosition: function updatePosition() {
                setPositioningStyles();
            }
        } : null;
    }, [
        open,
        setPositioningStyles
    ]);
    $a2gHv.useEffect(function() {
        if (!open) return undefined;
        var handleResize = (0, $6b9219180f06a7e7$export$2e2bcd8739ae039)(function() {
            setPositioningStyles();
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        open,
        setPositioningStyles
    ]);
    var transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    var container = containerProp || (anchorEl ? (0, $a773b260c1b71dbc$export$2e2bcd8739ae039)($3d329cdbec8a375f$var$getAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ $a2gHv.createElement((0, $ca3808f2da8d957e$export$2e2bcd8739ae039), (0, $kO11b.default)({
        container: container,
        open: open,
        ref: ref,
        BackdropProps: {
            invisible: true
        },
        className: (0, $1r7hW.default)(classes.root, className)
    }, other), /*#__PURE__*/ $a2gHv.createElement(TransitionComponent, (0, $kO11b.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        timeout: transitionDuration
    }, TransitionProps, {
        onEntering: (0, $2d1f2023da2fae25$export$2e2bcd8739ae039)(handleEntering, TransitionProps.onEntering)
    }), /*#__PURE__*/ $a2gHv.createElement((0, $79ae84c416f068ea$export$2e2bcd8739ae039), (0, $kO11b.default)({
        elevation: elevation,
        ref: handlePaperRef
    }, PaperProps, {
        className: (0, $1r7hW.default)(classes.paper, PaperProps.className)
    }), children)));
});
var $3d329cdbec8a375f$export$2e2bcd8739ae039 = (0, $ljK7E.default)($3d329cdbec8a375f$export$9dd6ff9ea0189349, {
    name: "MuiPopover"
})($3d329cdbec8a375f$var$Popover);



var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");
parcelRequire("gnuGk");




var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $ljK7E = parcelRequire("ljK7E");

var $a2gHv = parcelRequire("a2gHv");
/**
 * @ignore - internal component.
 */ var $2cf1aca5422f2d75$var$ListContext = $a2gHv.createContext({});
var $2cf1aca5422f2d75$export$2e2bcd8739ae039 = $2cf1aca5422f2d75$var$ListContext;


var $e92591bc93171834$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    },
    /* Styles applied to the root element if `disablePadding={false}`. */ padding: {
        paddingTop: 8,
        paddingBottom: 8
    },
    /* Styles applied to the root element if dense. */ dense: {},
    /* Styles applied to the root element if a `subheader` is provided. */ subheader: {
        paddingTop: 0
    }
};
var $e92591bc93171834$var$List = /*#__PURE__*/ $a2gHv.forwardRef(function List(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "ul" : _props$component, _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disablePadding = props.disablePadding, disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding, subheader = props.subheader, other = (0, $hmzQs.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "dense",
        "disablePadding",
        "subheader"
    ]);
    var context = $a2gHv.useMemo(function() {
        return {
            dense: dense
        };
    }, [
        dense
    ]);
    return /*#__PURE__*/ $a2gHv.createElement((0, $2cf1aca5422f2d75$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $a2gHv.createElement(Component, (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
        ref: ref
    }, other), subheader, children));
});
var $e92591bc93171834$export$2e2bcd8739ae039 = (0, $ljK7E.default)($e92591bc93171834$export$9dd6ff9ea0189349, {
    name: "MuiList"
})($e92591bc93171834$var$List);




function $f9f9b95703a1358e$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $f9f9b95703a1358e$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $f9f9b95703a1358e$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    var text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $f9f9b95703a1358e$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    var wrappedOnce = false;
    var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        } // Same logic as useAutocomplete.js
        var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$f9f9b95703a1358e$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return;
        }
    }
}
var $f9f9b95703a1358e$var$useEnhancedEffect = typeof window === "undefined" ? $a2gHv.useEffect : $a2gHv.useLayoutEffect;
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ var $f9f9b95703a1358e$var$MenuList = /*#__PURE__*/ $a2gHv.forwardRef(function MenuList(props, ref) {
    var actions = props.actions, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$autoFocusItem = props.autoFocusItem, autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem, children = props.children, className = props.className, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, onKeyDown = props.onKeyDown, _props$variant = props.variant, variant = _props$variant === void 0 ? "selectedMenu" : _props$variant, other = (0, $hmzQs.default)(props, [
        "actions",
        "autoFocus",
        "autoFocusItem",
        "children",
        "className",
        "disabledItemsFocusable",
        "disableListWrap",
        "onKeyDown",
        "variant"
    ]);
    var listRef = $a2gHv.useRef(null);
    var textCriteriaRef = $a2gHv.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    $f9f9b95703a1358e$var$useEnhancedEffect(function() {
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $a2gHv.useImperativeHandle(actions, function() {
        return {
            adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                var noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    var scrollbarSize = "".concat((0, $21866e6e87399210$export$2e2bcd8739ae039)(true), "px");
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
                }
                return listRef.current;
            }
        };
    }, []);
    var handleKeyDown = function handleKeyDown(event) {
        var list = listRef.current;
        var key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ var currentFocus = (0, $a773b260c1b71dbc$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $f9f9b95703a1358e$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $f9f9b95703a1358e$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $f9f9b95703a1358e$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $f9f9b95703a1358e$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $f9f9b95703a1358e$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $f9f9b95703a1358e$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $f9f9b95703a1358e$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $f9f9b95703a1358e$var$previousItem);
        } else if (key.length === 1) {
            var criteria = textCriteriaRef.current;
            var lowerKey = key.toLowerCase();
            var currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            var keepFocusOnCurrent = currentFocus && !criteria.repeating && $f9f9b95703a1358e$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $f9f9b95703a1358e$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $f9f9b95703a1358e$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    var handleOwnRef = $a2gHv.useCallback(function(instance) {
        // #StrictMode ready
        listRef.current = $fcd36364b46ce6ed$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(handleOwnRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $a2gHv.Children.forEach(children, function(child, index) {
        if (!/*#__PURE__*/ $a2gHv.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $a2gHv.Children.map(children, function(child, index) {
        if (index === activeItemIndex) {
            var newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $a2gHv.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ $a2gHv.createElement((0, $e92591bc93171834$export$2e2bcd8739ae039), (0, $kO11b.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other), items);
});
var $f9f9b95703a1358e$export$2e2bcd8739ae039 = $f9f9b95703a1358e$var$MenuList;






var $31fa5f2bc3ce8e79$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
var $31fa5f2bc3ce8e79$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
var $31fa5f2bc3ce8e79$export$9dd6ff9ea0189349 = {
    /* Styles applied to the `Paper` component. */ paper: {
        // specZ: The maximum height of a simple menu should be one or more rows less than the view
        // height. This ensures a tapable area outside of the simple menu with which to dismiss
        // the menu.
        maxHeight: "calc(100% - 96px)",
        // Add iOS momentum scrolling.
        WebkitOverflowScrolling: "touch"
    },
    /* Styles applied to the `List` component via `MenuList`. */ list: {
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $31fa5f2bc3ce8e79$var$Menu = /*#__PURE__*/ $a2gHv.forwardRef(function Menu(props, ref) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, children = props.children, classes = props.classes, _props$disableAutoFoc = props.disableAutoFocusItem, disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$MenuListProps = props.MenuListProps, MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps, onClose = props.onClose, onEnteringProp = props.onEntering, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, PopoverClasses = props.PopoverClasses, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? "auto" : _props$transitionDura, _props$TransitionProp = props.TransitionProps;
    _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;
    var onEntering = _props$TransitionProp.onEntering, TransitionProps = (0, $hmzQs.default)(_props$TransitionProp, [
        "onEntering"
    ]), _props$variant = props.variant, variant = _props$variant === void 0 ? "selectedMenu" : _props$variant, other = (0, $hmzQs.default)(props, [
        "autoFocus",
        "children",
        "classes",
        "disableAutoFocusItem",
        "MenuListProps",
        "onClose",
        "onEntering",
        "open",
        "PaperProps",
        "PopoverClasses",
        "transitionDuration",
        "TransitionProps",
        "variant"
    ]);
    var theme = (0, $8cf1e6908f234c8c$export$2e2bcd8739ae039)();
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = $a2gHv.useRef(null);
    var contentAnchorRef = $a2gHv.useRef(null);
    var getContentAnchorEl = function getContentAnchorEl() {
        return contentAnchorRef.current;
    };
    var handleEntering = function handleEntering(element, isAppearing) {
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEnteringProp) onEnteringProp(element, isAppearing);
        if (onEntering) onEntering(element, isAppearing);
    };
    var handleListKeyDown = function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $a2gHv.Children.map(children, function(child, index) {
        if (!/*#__PURE__*/ $a2gHv.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant !== "menu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $a2gHv.Children.map(children, function(child, index) {
        if (index === activeItemIndex) return /*#__PURE__*/ $a2gHv.cloneElement(child, {
            ref: function ref(instance) {
                // #StrictMode ready
                contentAnchorRef.current = $fcd36364b46ce6ed$exports.findDOMNode(instance);
                (0, $3f9d91311c0ceddb$export$2e2bcd8739ae039)(child.ref, instance);
            }
        });
        return child;
    });
    return /*#__PURE__*/ $a2gHv.createElement((0, $3d329cdbec8a375f$export$2e2bcd8739ae039), (0, $kO11b.default)({
        getContentAnchorEl: getContentAnchorEl,
        classes: PopoverClasses,
        onClose: onClose,
        TransitionProps: (0, $kO11b.default)({
            onEntering: handleEntering
        }, TransitionProps),
        anchorOrigin: theme.direction === "rtl" ? $31fa5f2bc3ce8e79$var$RTL_ORIGIN : $31fa5f2bc3ce8e79$var$LTR_ORIGIN,
        transformOrigin: theme.direction === "rtl" ? $31fa5f2bc3ce8e79$var$RTL_ORIGIN : $31fa5f2bc3ce8e79$var$LTR_ORIGIN,
        PaperProps: (0, $kO11b.default)({}, PaperProps, {
            classes: (0, $kO11b.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        open: open,
        ref: ref,
        transitionDuration: transitionDuration
    }, other), /*#__PURE__*/ $a2gHv.createElement((0, $f9f9b95703a1358e$export$2e2bcd8739ae039), (0, $kO11b.default)({
        onKeyDown: handleListKeyDown,
        actions: menuListActionsRef,
        autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
        autoFocusItem: autoFocusItem,
        variant: variant
    }, MenuListProps, {
        className: (0, $1r7hW.default)(classes.list, MenuListProps.className)
    }), items));
});
var $31fa5f2bc3ce8e79$export$2e2bcd8739ae039 = (0, $ljK7E.default)($31fa5f2bc3ce8e79$export$9dd6ff9ea0189349, {
    name: "MuiMenu"
})($31fa5f2bc3ce8e79$var$Menu);





function $7e6ec433c0c006f9$var$areEqualValues(a, b) {
    if ((0, $gvXaa.default)(b) === "object" && b !== null) return a === b;
    return String(a) === String(b);
}
function $7e6ec433c0c006f9$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
/**
 * @ignore - internal component.
 */ var $7e6ec433c0c006f9$var$SelectInput = /*#__PURE__*/ $a2gHv.forwardRef(function SelectInput(props, ref) {
    var ariaLabel = props["aria-label"], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, classes = props.classes, className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, IconComponent = props.IconComponent, inputRefProp = props.inputRef, labelId = props.labelId, _props$MenuProps = props.MenuProps, MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, readOnly = props.readOnly, renderValue = props.renderValue, _props$SelectDisplayP = props.SelectDisplayProps, SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP, tabIndexProp = props.tabIndex, type = props.type, valueProp = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $hmzQs.default)(props, [
        "aria-label",
        "autoFocus",
        "autoWidth",
        "children",
        "classes",
        "className",
        "defaultValue",
        "disabled",
        "displayEmpty",
        "IconComponent",
        "inputRef",
        "labelId",
        "MenuProps",
        "multiple",
        "name",
        "onBlur",
        "onChange",
        "onClose",
        "onFocus",
        "onOpen",
        "open",
        "readOnly",
        "renderValue",
        "SelectDisplayProps",
        "tabIndex",
        "type",
        "value",
        "variant"
    ]);
    var _useControlled = (0, $bd274624964d2c2e$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    }), _useControlled2 = (0, $lbAml.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    var inputRef = $a2gHv.useRef(null);
    var _React$useState = $a2gHv.useState(null), displayNode = _React$useState[0], setDisplayNode = _React$useState[1];
    var _React$useRef = $a2gHv.useRef(openProp != null), isOpenControlled = _React$useRef.current;
    var _React$useState2 = $a2gHv.useState(), menuMinWidthState = _React$useState2[0], setMenuMinWidthState = _React$useState2[1];
    var _React$useState3 = $a2gHv.useState(false), openState = _React$useState3[0], setOpenState = _React$useState3[1];
    var handleRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(ref, inputRefProp);
    $a2gHv.useImperativeHandle(handleRef, function() {
        return {
            focus: function focus() {
                displayNode.focus();
            },
            node: inputRef.current,
            value: value
        };
    }, [
        displayNode,
        value
    ]);
    $a2gHv.useEffect(function() {
        if (autoFocus && displayNode) displayNode.focus();
    }, [
        autoFocus,
        displayNode
    ]);
    $a2gHv.useEffect(function() {
        if (displayNode) {
            var label = (0, $a773b260c1b71dbc$export$2e2bcd8739ae039)(displayNode).getElementById(labelId);
            if (label) {
                var handler = function handler() {
                    if (getSelection().isCollapsed) displayNode.focus();
                };
                label.addEventListener("click", handler);
                return function() {
                    label.removeEventListener("click", handler);
                };
            }
        }
        return undefined;
    }, [
        labelId,
        displayNode
    ]);
    var update = function update(open, event) {
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    var handleMouseDown = function handleMouseDown(event) {
        // Ignore everything but left-click
        if (event.button !== 0) return;
         // Hijack the default focus behavior.
        event.preventDefault();
        displayNode.focus();
        update(true, event);
    };
    var handleClose = function handleClose(event) {
        update(false, event);
    };
    var childrenArray = $a2gHv.Children.toArray(children); // Support autofill.
    var handleChange = function handleChange(event) {
        var index = childrenArray.map(function(child) {
            return child.props.value;
        }).indexOf(event.target.value);
        if (index === -1) return;
        var child = childrenArray[index];
        setValue(child.props.value);
        if (onChange) onChange(event, child);
    };
    var handleItemClick = function handleItemClick(child) {
        return function(event) {
            if (!multiple) update(false, event);
            var newValue;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                var itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value === newValue) return;
            setValue(newValue);
            if (onChange) {
                event.persist(); // Preact support, target is read only property on a native event.
                Object.defineProperty(event, "target", {
                    writable: true,
                    value: {
                        value: newValue,
                        name: name
                    }
                });
                onChange(event, child);
            }
        };
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (!readOnly) {
            var validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    var open = displayNode !== null && (isOpenControlled ? openProp : openState);
    var handleBlur = function handleBlur(event) {
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            event.persist(); // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    var display;
    var displaySingle;
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false; // No need to display any value if the field is empty.
    if ((0, $d02852b4bd458b43$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    var items = childrenArray.map(function(child) {
        if (!/*#__PURE__*/ $a2gHv.isValidElement(child)) return null;
        var selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $7pDoN.default)(2));
            selected = value.some(function(v) {
                return $7e6ec433c0c006f9$var$areEqualValues(v, child.props.value);
            });
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $7e6ec433c0c006f9$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $a2gHv.cloneElement(child, {
            "aria-selected": selected ? "true" : undefined,
            onClick: handleItemClick(child),
            onKeyUp: function onKeyUp(event) {
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    if (computeDisplay) display = multiple ? displayMultiple.join(", ") : displaySingle;
     // Avoid performing a layout computation in the render method.
    var menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = displayNode.clientWidth;
    var tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
    return /*#__PURE__*/ $a2gHv.createElement($a2gHv.Fragment, null, /*#__PURE__*/ $a2gHv.createElement("div", (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
        ref: setDisplayNode,
        tabIndex: tabIndex,
        role: "button",
        "aria-disabled": disabled ? "true" : undefined,
        "aria-expanded": open ? "true" : undefined,
        "aria-haspopup": "listbox",
        "aria-label": ariaLabel,
        "aria-labelledby": [
            labelId,
            buttonId
        ].filter(Boolean).join(" ") || undefined,
        onKeyDown: handleKeyDown,
        onMouseDown: disabled || readOnly ? null : handleMouseDown,
        onBlur: handleBlur,
        onFocus: onFocus
    }, SelectDisplayProps, {
        // The id is required for proper a11y
        id: buttonId
    }), $7e6ec433c0c006f9$var$isEmpty(display) ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $a2gHv.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    }) : display), /*#__PURE__*/ $a2gHv.createElement("input", (0, $kO11b.default)({
        value: Array.isArray(value) ? value.join(",") : value,
        name: name,
        ref: inputRef,
        "aria-hidden": true,
        onChange: handleChange,
        tabIndex: -1,
        className: classes.nativeInput,
        autoFocus: autoFocus
    }, other)), /*#__PURE__*/ $a2gHv.createElement(IconComponent, {
        className: (0, $1r7hW.default)(classes.icon, classes["icon".concat((0, $lrWdp.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
    }), /*#__PURE__*/ $a2gHv.createElement((0, $31fa5f2bc3ce8e79$export$2e2bcd8739ae039), (0, $kO11b.default)({
        id: "menu-".concat(name || ""),
        anchorEl: displayNode,
        open: open,
        onClose: handleClose
    }, MenuProps, {
        MenuListProps: (0, $kO11b.default)({
            "aria-labelledby": labelId,
            role: "listbox",
            disableListWrap: true
        }, MenuProps.MenuListProps),
        PaperProps: (0, $kO11b.default)({}, MenuProps.PaperProps, {
            style: (0, $kO11b.default)({
                minWidth: menuMinWidth
            }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
    }), items));
});
var $7e6ec433c0c006f9$export$2e2bcd8739ae039 = $7e6ec433c0c006f9$var$SelectInput;





var $ljK7E = parcelRequire("ljK7E");

var $a2gHv = parcelRequire("a2gHv");

var $jMmZt = parcelRequire("jMmZt");
var /**
 * @ignore - internal component.
 */ $7397a7b3adb3c807$export$2e2bcd8739ae039 = (0, $jMmZt.default)(/*#__PURE__*/ $a2gHv.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");




var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");


var $lrWdp = parcelRequire("lrWdp");
/**
 * @ignore - internal component.
 */ var $346139cd084a824b$var$NativeSelectInput = /*#__PURE__*/ $a2gHv.forwardRef(function NativeSelectInput(props, ref) {
    var classes = props.classes, className = props.className, disabled = props.disabled, IconComponent = props.IconComponent, inputRef = props.inputRef, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $hmzQs.default)(props, [
        "classes",
        "className",
        "disabled",
        "IconComponent",
        "inputRef",
        "variant"
    ]);
    return /*#__PURE__*/ $a2gHv.createElement($a2gHv.Fragment, null, /*#__PURE__*/ $a2gHv.createElement("select", (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, classes.select, classes[variant], className, disabled && classes.disabled),
        disabled: disabled,
        ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/ $a2gHv.createElement(IconComponent, {
        className: (0, $1r7hW.default)(classes.icon, classes["icon".concat((0, $lrWdp.default)(variant))], disabled && classes.disabled)
    }));
});
var $346139cd084a824b$export$2e2bcd8739ae039 = $346139cd084a824b$var$NativeSelectInput;



var $ljK7E = parcelRequire("ljK7E");




var $75e491c8d43a9b8c$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the select component `root` class. */ root: {},
        /* Styles applied to the select component `select` class. */ select: {
            "-moz-appearance": "none",
            // Reset
            "-webkit-appearance": "none",
            // Reset
            // When interacting quickly, the text can end up selected.
            // Native select can't be selected either.
            userSelect: "none",
            borderRadius: 0,
            // Reset
            minWidth: 16,
            // So it doesn't collapse.
            cursor: "pointer",
            "&:focus": {
                // Show that it's not an text input
                backgroundColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
                borderRadius: 0 // Reset Chrome style
            },
            // Remove IE 11 arrow
            "&::-ms-expand": {
                display: "none"
            },
            "&$disabled": {
                cursor: "default"
            },
            "&[multiple]": {
                height: "auto"
            },
            "&:not([multiple]) option, &:not([multiple]) optgroup": {
                backgroundColor: theme.palette.background.paper
            },
            "&&": {
                paddingRight: 24
            }
        },
        /* Styles applied to the select component if `variant="filled"`. */ filled: {
            "&&": {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component if `variant="outlined"`. */ outlined: {
            borderRadius: theme.shape.borderRadius,
            "&&": {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component `selectMenu` class. */ selectMenu: {
            height: "auto",
            // Resets for multpile select with chips
            minHeight: "1.1876em",
            // Required for select\text-field height consistency
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden"
        },
        /* Pseudo-class applied to the select component `disabled` class. */ disabled: {},
        /* Styles applied to the icon component. */ icon: {
            // We use a position absolute over a flexbox in order to forward the pointer events
            // to the input and to support wrapping tags..
            position: "absolute",
            right: 0,
            top: "calc(50% - 12px)",
            // Center vertically
            pointerEvents: "none",
            // Don't block pointer events on the select under the icon.
            color: theme.palette.action.active,
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the icon component if the popup is open. */ iconOpen: {
            transform: "rotate(180deg)"
        },
        /* Styles applied to the icon component if `variant="filled"`. */ iconFilled: {
            right: 7
        },
        /* Styles applied to the icon component if `variant="outlined"`. */ iconOutlined: {
            right: 7
        },
        /* Styles applied to the underlying native input component. */ nativeInput: {
            bottom: 0,
            left: 0,
            position: "absolute",
            opacity: 0,
            pointerEvents: "none",
            width: "100%"
        }
    };
};
var $75e491c8d43a9b8c$var$defaultInput = /*#__PURE__*/ $a2gHv.createElement((0, $666c5b9ebc68e510$export$2e2bcd8739ae039), null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */ var $75e491c8d43a9b8c$var$NativeSelect = /*#__PURE__*/ $a2gHv.forwardRef(function NativeSelect(props, ref) {
    var children = props.children, classes = props.classes, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $7397a7b3adb3c807$export$2e2bcd8739ae039) : _props$IconComponent, _props$input = props.input, input = _props$input === void 0 ? $75e491c8d43a9b8c$var$defaultInput : _props$input, inputProps = props.inputProps, variant = props.variant, other = (0, $hmzQs.default)(props, [
        "children",
        "classes",
        "IconComponent",
        "input",
        "inputProps",
        "variant"
    ]);
    var muiFormControl = (0, $9d2a21945a86adb6$export$2e2bcd8739ae039)();
    var fcs = (0, $02d20181ee06a14b$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    return /*#__PURE__*/ $a2gHv.cloneElement(input, (0, $kO11b.default)({
        // Most of the logic is implemented in `NativeSelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: (0, $346139cd084a824b$export$2e2bcd8739ae039),
        inputProps: (0, $kO11b.default)({
            children: children,
            classes: classes,
            IconComponent: IconComponent,
            variant: fcs.variant,
            type: undefined
        }, inputProps, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$75e491c8d43a9b8c$var$NativeSelect.muiName = "Select";
var $75e491c8d43a9b8c$export$2e2bcd8739ae039 = (0, $ljK7E.default)($75e491c8d43a9b8c$export$9dd6ff9ea0189349, {
    name: "MuiNativeSelect"
})($75e491c8d43a9b8c$var$NativeSelect);





var $af8103b0cc26cda3$export$9dd6ff9ea0189349 = (0, $75e491c8d43a9b8c$export$9dd6ff9ea0189349);
var $af8103b0cc26cda3$var$_ref = /*#__PURE__*/ $a2gHv.createElement((0, $666c5b9ebc68e510$export$2e2bcd8739ae039), null);
var $af8103b0cc26cda3$var$_ref2 = /*#__PURE__*/ $a2gHv.createElement((0, $ebf040de7172b6e1$export$2e2bcd8739ae039), null);
var $af8103b0cc26cda3$var$Select = /*#__PURE__*/ $a2gHv.forwardRef(function Select(props, ref) {
    var _props$autoWidth = props.autoWidth, autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth, children = props.children, classes = props.classes, _props$displayEmpty = props.displayEmpty, displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $7397a7b3adb3c807$export$2e2bcd8739ae039) : _props$IconComponent, id = props.id, input = props.input, inputProps = props.inputProps, label = props.label, labelId = props.labelId, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, MenuProps = props.MenuProps, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$native = props.native, native = _props$native === void 0 ? false : _props$native, onClose = props.onClose, onOpen = props.onOpen, open = props.open, renderValue = props.renderValue, SelectDisplayProps = props.SelectDisplayProps, _props$variant = props.variant, variantProps = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $hmzQs.default)(props, [
        "autoWidth",
        "children",
        "classes",
        "displayEmpty",
        "IconComponent",
        "id",
        "input",
        "inputProps",
        "label",
        "labelId",
        "labelWidth",
        "MenuProps",
        "multiple",
        "native",
        "onClose",
        "onOpen",
        "open",
        "renderValue",
        "SelectDisplayProps",
        "variant"
    ]);
    var inputComponent = native ? (0, $346139cd084a824b$export$2e2bcd8739ae039) : (0, $7e6ec433c0c006f9$export$2e2bcd8739ae039);
    var muiFormControl = (0, $9d2a21945a86adb6$export$2e2bcd8739ae039)();
    var fcs = (0, $02d20181ee06a14b$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    var variant = fcs.variant || variantProps;
    var InputComponent = input || ({
        standard: $af8103b0cc26cda3$var$_ref,
        outlined: /*#__PURE__*/ $a2gHv.createElement((0, $b30db429396ba915$export$2e2bcd8739ae039), {
            label: label,
            labelWidth: labelWidth
        }),
        filled: $af8103b0cc26cda3$var$_ref2
    })[variant];
    return /*#__PURE__*/ $a2gHv.cloneElement(InputComponent, (0, $kO11b.default)({
        // Most of the logic is implemented in `SelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: inputComponent,
        inputProps: (0, $kO11b.default)({
            children: children,
            IconComponent: IconComponent,
            variant: variant,
            type: undefined,
            // We render a select. We can ignore the type provided by the `Input`.
            multiple: multiple
        }, native ? {
            id: id
        } : {
            autoWidth: autoWidth,
            displayEmpty: displayEmpty,
            labelId: labelId,
            MenuProps: MenuProps,
            onClose: onClose,
            onOpen: onOpen,
            open: open,
            renderValue: renderValue,
            SelectDisplayProps: (0, $kO11b.default)({
                id: id
            }, SelectDisplayProps)
        }, inputProps, {
            classes: inputProps ? (0, $9cDAr.default)({
                baseClasses: classes,
                newClasses: inputProps.classes,
                Component: Select
            }) : classes
        }, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$af8103b0cc26cda3$var$Select.muiName = "Select";
var $af8103b0cc26cda3$export$2e2bcd8739ae039 = (0, $ljK7E.default)($af8103b0cc26cda3$export$9dd6ff9ea0189349, {
    name: "MuiSelect"
})($af8103b0cc26cda3$var$Select);



var $ljK7E = parcelRequire("ljK7E");
var $c565a04f3d63af3f$var$variantComponent = {
    standard: (0, $666c5b9ebc68e510$export$2e2bcd8739ae039),
    filled: (0, $ebf040de7172b6e1$export$2e2bcd8739ae039),
    outlined: (0, $b30db429396ba915$export$2e2bcd8739ae039)
};
var $c565a04f3d63af3f$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ var $c565a04f3d63af3f$var$TextField = /*#__PURE__*/ $a2gHv.forwardRef(function TextField(props, ref) {
    var autoComplete = props.autoComplete, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, FormHelperTextProps = props.FormHelperTextProps, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, helperText = props.helperText, hiddenLabel = props.hiddenLabel, id = props.id, InputLabelProps = props.InputLabelProps, inputProps = props.inputProps, InputProps = props.InputProps, inputRef = props.inputRef, label = props.label, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, rows = props.rows, rowsMax = props.rowsMax, maxRows = props.maxRows, minRows = props.minRows, _props$select = props.select, select = _props$select === void 0 ? false : _props$select, SelectProps = props.SelectProps, type = props.type, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $hmzQs.default)(props, [
        "autoComplete",
        "autoFocus",
        "children",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "error",
        "FormHelperTextProps",
        "fullWidth",
        "helperText",
        "hiddenLabel",
        "id",
        "InputLabelProps",
        "inputProps",
        "InputProps",
        "inputRef",
        "label",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "placeholder",
        "required",
        "rows",
        "rowsMax",
        "maxRows",
        "minRows",
        "select",
        "SelectProps",
        "type",
        "value",
        "variant"
    ]);
    var InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        if (label) {
            var _InputLabelProps$requ;
            var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
            InputMore.label = /*#__PURE__*/ $a2gHv.createElement($a2gHv.Fragment, null, label, displayRequired && "\xa0*");
        }
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputComponent = $c565a04f3d63af3f$var$variantComponent[variant];
    var InputElement = /*#__PURE__*/ $a2gHv.createElement(InputComponent, (0, $kO11b.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        rowsMax: rowsMax,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ $a2gHv.createElement((0, $6727a78a8880f40f$export$2e2bcd8739ae039), (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        ref: ref,
        required: required,
        color: color,
        variant: variant
    }, other), label && /*#__PURE__*/ $a2gHv.createElement((0, $1dd2e4a051caf598$export$2e2bcd8739ae039), (0, $kO11b.default)({
        htmlFor: id,
        id: inputLabelId
    }, InputLabelProps), label), select ? /*#__PURE__*/ $a2gHv.createElement((0, $af8103b0cc26cda3$export$2e2bcd8739ae039), (0, $kO11b.default)({
        "aria-describedby": helperTextId,
        id: id,
        labelId: inputLabelId,
        value: value,
        input: InputElement
    }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/ $a2gHv.createElement((0, $b1c43402843431ed$export$2e2bcd8739ae039), (0, $kO11b.default)({
        id: helperTextId
    }, FormHelperTextProps), helperText));
});
var $c565a04f3d63af3f$export$2e2bcd8739ae039 = (0, $ljK7E.default)($c565a04f3d63af3f$export$9dd6ff9ea0189349, {
    name: "MuiTextField"
})($c565a04f3d63af3f$var$TextField);



var $a2gHv = parcelRequire("a2gHv");

var $jMmZt = parcelRequire("jMmZt");
var $76e8be73bc602b7c$export$2e2bcd8739ae039 = (0, $jMmZt.default)(/*#__PURE__*/ $a2gHv.createElement("path", {
    d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
}), "Autorenew");


var $d27ec4b38469a174$exports = {};
"use strict";
var $d27ec4b38469a174$var$__createBinding = $d27ec4b38469a174$exports && $d27ec4b38469a174$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d27ec4b38469a174$var$__exportStar = $d27ec4b38469a174$exports && $d27ec4b38469a174$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d27ec4b38469a174$var$__createBinding(exports1, m, p);
};
Object.defineProperty($d27ec4b38469a174$exports, "__esModule", {
    value: true
});

$d27ec4b38469a174$var$__exportStar((parcelRequire("byMj2")), $d27ec4b38469a174$exports);

$d27ec4b38469a174$var$__exportStar((parcelRequire("4x7K3")), $d27ec4b38469a174$exports);

$d27ec4b38469a174$var$__exportStar((parcelRequire("lir4a")), $d27ec4b38469a174$exports);



const $12c7e78df5ae9427$var$getRandomSessionId = ()=>{
    const randomWords = (parcelRequire("7Pq3L"));
    return randomWords({
        exactly: 1,
        wordsPerString: 2,
        separator: "-"
    })[0];
};
function $12c7e78df5ae9427$export$2e2bcd8739ae039(props) {
    let [session, setSession] = (0, $a2gHv.useState)(props.sessionId || $12c7e78df5ae9427$var$getRandomSessionId());
    let [userType, setUserType] = (0, $a2gHv.useState)(props.userType);
    let [player, setPlayer] = (0, $a2gHv.useState)(props.player);
    let [team, setTeam] = (0, $a2gHv.useState)(props.teamName);
    let [teamEnabled, setTeamEnabled] = (0, $a2gHv.useState)(player !== team); // if they are the same, we hide the field by default
    let [server, setServer] = (0, $a2gHv.useState)(props.server);
    const isPlayer = userType === $d27ec4b38469a174$exports.GUIUserType.PLAYER;
    const readyToGo = session && userType && (isPlayer && player && (!teamEnabled || teamEnabled && team) || !isPlayer);
    const handleRadioSelect = (e)=>{
        const userType = parseInt(e.target.value);
        setUserType(userType);
        switch(userType){
            case $d27ec4b38469a174$exports.GUIUserType.PLAYER:
                break;
            case $d27ec4b38469a174$exports.GUIUserType.ADMIN:
            case $d27ec4b38469a174$exports.GUIUserType.OBSERVER:
            case $d27ec4b38469a174$exports.GUIUserType.UNDEFINED:
            default:
                setPlayer(undefined);
                setTeam(undefined);
                setTeamEnabled(false);
        }
    };
    return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $7aa797f1a6f09677$export$2e2bcd8739ae039), {
        maxWidth: "sm",
        style: {
            alignContent: "center"
        },
        children: [
            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $c913521d1795623a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                    variant: "h4",
                    color: "primary",
                    align: "center",
                    children: "Jeoparty!"
                })
            }),
            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $c913521d1795623a$export$2e2bcd8739ae039), {
                paddingTop: 3,
                children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $c565a04f3d63af3f$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    margin: "normal",
                    label: "Game name",
                    variant: "outlined",
                    placeholder: "asdf",
                    value: session,
                    onChange: (e)=>setSession(e.target.value),
                    InputLabelProps: {
                        shrink: !!session
                    },
                    InputProps: {
                        endAdornment: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $48d49a7e403badb5$export$2e2bcd8739ae039), {
                            "aria-label": "generate",
                            onClick: ()=>setSession($12c7e78df5ae9427$var$getRandomSessionId),
                            children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $76e8be73bc602b7c$export$2e2bcd8739ae039), {})
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $c913521d1795623a$export$2e2bcd8739ae039), {
                paddingTop: 3,
                children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $6727a78a8880f40f$export$2e2bcd8739ae039), {
                    component: "fieldset",
                    children: [
                        /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $a200f36ca8fadba2$export$2e2bcd8739ae039), {
                            component: "legend",
                            children: "Choose your role"
                        }),
                        /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $4737ab9e3044a099$export$2e2bcd8739ae039), {
                            "aria-label": "role",
                            name: "role",
                            value: userType,
                            onChange: handleRadioSelect,
                            children: [
                                /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $4c43d2b64a18b512$export$2e2bcd8739ae039), {
                                    value: $d27ec4b38469a174$exports.GUIUserType.PLAYER,
                                    control: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $b92c9bbcec4f0aef$export$2e2bcd8739ae039), {}),
                                    label: "Play"
                                }),
                                /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $4c43d2b64a18b512$export$2e2bcd8739ae039), {
                                    value: $d27ec4b38469a174$exports.GUIUserType.OBSERVER,
                                    control: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $b92c9bbcec4f0aef$export$2e2bcd8739ae039), {}),
                                    label: "Watch"
                                }),
                                /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $4c43d2b64a18b512$export$2e2bcd8739ae039), {
                                    value: $d27ec4b38469a174$exports.GUIUserType.ADMIN,
                                    control: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $b92c9bbcec4f0aef$export$2e2bcd8739ae039), {}),
                                    label: "Admin"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $c913521d1795623a$export$2e2bcd8739ae039), {
                paddingTop: 3,
                children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $c565a04f3d63af3f$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    margin: "normal",
                    label: "Server URL (optional)",
                    variant: "outlined",
                    placeholder: "wss://ws.jeoparty.fun",
                    value: server,
                    onChange: (e)=>setServer(e.target.value),
                    helperText: "Leave blank to use default server"
                })
            }),
            userType === $d27ec4b38469a174$exports.GUIUserType.PLAYER && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $c913521d1795623a$export$2e2bcd8739ae039), {
                paddingTop: 3,
                children: [
                    /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $c565a04f3d63af3f$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        margin: "normal",
                        label: "Player name",
                        variant: "outlined",
                        placeholder: "Ken Jennings",
                        value: player,
                        onChange: (e)=>setPlayer(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $4c43d2b64a18b512$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $625db5ece639fdf7$export$2e2bcd8739ae039), {
                            checked: teamEnabled,
                            onChange: (e)=>{
                                setTeamEnabled(e.target.checked);
                            // if (e.target.checked === false) {
                            //   setTeam(undefined);
                            // }
                            },
                            name: "checkedB",
                            color: "primary"
                        }),
                        label: "Join a team (optional)"
                    }),
                    teamEnabled && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $c565a04f3d63af3f$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        margin: "normal",
                        label: "Team name",
                        variant: "outlined",
                        placeholder: "My Awesome Team",
                        value: team,
                        onChange: (e)=>setTeam(e.target.value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $c913521d1795623a$export$2e2bcd8739ae039), {
                paddingTop: 3,
                children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $34124a96edc1da32$export$2e2bcd8739ae039), {
                    variant: "contained",
                    color: "primary",
                    onClick: ()=>props.goCallback(session, userType, player, team, server),
                    disabled: !readyToGo,
                    children: "Go!"
                })
            })
        ]
    });
}




var $a2gHv = parcelRequire("a2gHv");

const $6411eb162f43eccf$var$trebekTeam = "___trebekTeam___";
const $6411eb162f43eccf$var$trebekPlayer = "___trebekPlayer___";
const $6411eb162f43eccf$var$spectatorTeam = "___spectatorTeam___";
const $6411eb162f43eccf$var$spectatorPlayer = "___spectatorPlayer___";
class $6411eb162f43eccf$export$2e2bcd8739ae039 {
    // eg. sendMessage(new ModifyScoreMessage("game_id", -1000, "isaac"))
    sendMessage(msg) {
        this.socket.send(JSON.stringify(msg));
    }
    constructor(setState, anAdmin, sessionId, teamName, player){
        this.addSocket = (socket)=>{
            this.socket = socket;
        };
        this.onSocketOpen = (event)=>{
            console.log("Successfully opened websocket");
            if (this.isAdmin) this.sendMessage(new $d27ec4b38469a174$exports.TrebekJoinMessage(this.id));
            else // If no team name or player name is known at time of sockets creation
            // this client is joining as a spectator
            if (this.isSpectator()) this.sendMessage(new $d27ec4b38469a174$exports.ContestantSpectate(this.id));
            else this.sendMessage(new $d27ec4b38469a174$exports.ContestantJoin(this.id, this.teamName, this.player));
        };
        this.onSocketMessage = (event, currentClientState)=>{
            // TODO: might not need to pass in state
            // TODO: Add types to the input parameters
            let message = JSON.parse(event.data);
            console.debug("Received event from jeoparty server of type", $d27ec4b38469a174$exports.ServerMessageType[message.type]);
            switch(message.type){
                case $d27ec4b38469a174$exports.ServerMessageType.DAILY_DOUBLE_WAGER:
                    this.updateState(message.newState, currentClientState);
                    break;
                case $d27ec4b38469a174$exports.ServerMessageType.OPEN_BUZZER:
                    this.buzzerOpenTime = Date.now();
                    this.updateState(message.newState, currentClientState);
                    break;
                case $d27ec4b38469a174$exports.ServerMessageType.STATE_UPDATE:
                    this.updateState(message.newState, currentClientState);
                    break;
                case $d27ec4b38469a174$exports.ServerMessageType.GAMES_LIST:
                    this.updateGameList(message.games);
                    break;
                case $d27ec4b38469a174$exports.ServerMessageType.ERROR:
                    console.warn("Error from server: ", message.error);
            }
        };
        this.updateState = (stateUpdate, clientState)=>{
            this.setClientState({
                ...clientState,
                ...stateUpdate
            });
        };
        this.updateGameList = (gameList)=>{
            console.log("Received list of games: " + gameList);
            this.gameList = gameList.reverse();
        };
        this.onSocketError = (event)=>{
            console.error(event);
        };
        this.onSocketClose = (event)=>{
            console.log("Closing connection with jeoparty server");
        };
        this.isSpectator = ()=>{
            return this.player === $6411eb162f43eccf$var$spectatorPlayer && this.teamName === $6411eb162f43eccf$var$spectatorTeam;
        };
        this.buzz = ()=>{
            const responseTime = Date.now() - this.buzzerOpenTime;
            this.sendMessage(new $d27ec4b38469a174$exports.ContestantBuzzIn(this.id, this.teamName, responseTime));
        };
        this.openBuzzer = ()=>{
            if (this.isAdmin) this.sendMessage(new $d27ec4b38469a174$exports.OpenBuzzer(this.id));
        };
        this.setTeamName = (teamName)=>{
            this.teamName = teamName;
        };
        this.setPlayerName = (playerName)=>{
            this.player = playerName;
        };
        this.contestantRejoin = ()=>{
            this.sendMessage(new $d27ec4b38469a174$exports.ContestantJoin(this.id, this.teamName, this.player));
        };
        this.selectClue = (clueId)=>{
            if (this.isAdmin) this.sendMessage(new $d27ec4b38469a174$exports.SelectClueMessage(this.id, clueId));
        };
        this.closeClue = ()=>{
            if (this.isAdmin) this.sendMessage(new $d27ec4b38469a174$exports.CloseClueMessage(this.id));
        };
        this.modifyScore = (team, delta)=>{
            if (this.isAdmin) this.sendMessage(new $d27ec4b38469a174$exports.ModifyScoreMessage(this.id, delta, team));
        };
        this.setScore = (team, newScore)=>{
            if (this.isAdmin) {
                console.log("setting score for team", team, newScore);
                this.sendMessage(new $d27ec4b38469a174$exports.SetScoreMessage(this.id, newScore, team));
            }
        };
        this.sendWager = (wager)=>{
            this.sendMessage(new $d27ec4b38469a174$exports.ContestantWager(this.id, this.teamName, wager));
        };
        this.closeWagers = ()=>{
            if (this.isAdmin) this.sendMessage(new $d27ec4b38469a174$exports.CloseWagersMessage(this.id));
        };
        this.closeSubmissions = ()=>{
            if (this.isAdmin) this.sendMessage(new $d27ec4b38469a174$exports.CloseSubmissionsMessage(this.id));
        };
        this.sendSubmission = (submission)=>{
            this.sendMessage(new $d27ec4b38469a174$exports.ContestantSubmission(this.id, this.teamName, submission));
            console.log("submitted");
        };
        this.reveal = (team)=>{
            if (this.isAdmin) this.sendMessage(new $d27ec4b38469a174$exports.RevealMessage(this.id, team));
        };
        this.selectGame = (game)=>{
            this.sendMessage(new $d27ec4b38469a174$exports.SelectGameMessage(this.id, game));
            console.log("Chose game ", game);
        };
        this.removeContestant = (teamName)=>{
            if (this.isAdmin) this.sendMessage(new $d27ec4b38469a174$exports.ContestantRemoveMessage(this.id, teamName));
        };
        this.setClientState = setState;
        // register message handler for onmessage in the caller
        this.id = sessionId;
        this.lockedOut = false;
        this.isAdmin = anAdmin;
        this.buzzerOpenTime = 0;
        this.player = player ? player : anAdmin ? $6411eb162f43eccf$var$trebekPlayer : $6411eb162f43eccf$var$spectatorPlayer;
        this.teamName = teamName ? teamName : anAdmin ? $6411eb162f43eccf$var$trebekTeam : $6411eb162f43eccf$var$spectatorTeam;
        this.gameList = [];
    }
}




var $a2gHv = parcelRequire("a2gHv");

function $ee4ab827ff8e0618$export$2e2bcd8739ae039({ isAdmin: isAdmin, buzzerOpen: buzzerOpen, apiClientBuzz: apiClientBuzz, openBuzzer: openBuzzer, openClue: openClue }) {
    const [isLocked, setLocked] = (0, $a2gHv.useState)(false);
    // const [timeoutID, setTimeoutID] = useRef(null)
    const [timeoutID, setTimeoutID] = (0, $a2gHv.useState)(0);
    const buzzIn = ()=>{
        if (buzzerOpen) {
            if (!isLocked) apiClientBuzz();
        } else lockBuzzer();
    };
    const lockBuzzer = ()=>{
        setLocked(true);
        if (isLocked) window.clearTimeout(timeoutID);
        const to = window.setTimeout(()=>{
            setLocked(false);
        }, 1000); // 1s
        setTimeoutID(to);
        setLocked(true);
    };
    let buzzerColor = "default";
    let buzzerString;
    if (isLocked) {
        buzzerColor = "secondary";
        buzzerString = "Buzz (locked)";
    } else if (buzzerOpen) {
        buzzerColor = "primary";
        buzzerString = "Buzz (open)";
    } else {
        buzzerColor = "default";
        buzzerString = "Buzz";
    }
    // "Buzzer Closed" = Colour1 --> "Buzzer Open" = Colour2 / "Buzzer Locked" = Colour3
    return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $e7ff860c3d8cb912$exports.Fragment), {
        children: [
            !isAdmin && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $34124a96edc1da32$export$2e2bcd8739ae039), {
                variant: "contained",
                color: buzzerColor,
                onMouseDown: buzzIn,
                size: "large",
                fullWidth: true,
                disableRipple: true,
                children: buzzerString
            }),
            isAdmin && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $34124a96edc1da32$export$2e2bcd8739ae039), {
                variant: "contained",
                color: "primary",
                onClick: openBuzzer,
                disabled: !openClue || buzzerOpen,
                size: "large",
                fullWidth: true,
                disableRipple: true,
                children: buzzerOpen ? "Buzzer" : "Open Buzzer"
            })
        ]
    });
}



parcelRequire("a2gHv");

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");


var $ljK7E = parcelRequire("ljK7E");
var $57558111709a20ab$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        overflow: "hidden"
    }
};
var $57558111709a20ab$var$Card = /*#__PURE__*/ $a2gHv.forwardRef(function Card(props, ref) {
    var classes = props.classes, className = props.className, _props$raised = props.raised, raised = _props$raised === void 0 ? false : _props$raised, other = (0, $hmzQs.default)(props, [
        "classes",
        "className",
        "raised"
    ]);
    return /*#__PURE__*/ $a2gHv.createElement((0, $79ae84c416f068ea$export$2e2bcd8739ae039), (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className),
        elevation: raised ? 8 : 1,
        ref: ref
    }, other));
});
var $57558111709a20ab$export$2e2bcd8739ae039 = (0, $ljK7E.default)($57558111709a20ab$export$9dd6ff9ea0189349, {
    name: "MuiCard"
})($57558111709a20ab$var$Card);


var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $ljK7E = parcelRequire("ljK7E");

var $a91d22d305e073c5$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "block",
            textAlign: "inherit",
            width: "100%",
            "&:hover $focusHighlight": {
                opacity: theme.palette.action.hoverOpacity
            },
            "&$focusVisible $focusHighlight": {
                opacity: 0.12
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the action area is keyboard focused. */ focusVisible: {},
        /* Styles applied to the overlay that covers the action area when it is keyboard focused. */ focusHighlight: {
            overflow: "hidden",
            pointerEvents: "none",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: "inherit",
            opacity: 0,
            backgroundColor: "currentcolor",
            transition: theme.transitions.create("opacity", {
                duration: theme.transitions.duration.short
            })
        }
    };
};
var $a91d22d305e073c5$var$CardActionArea = /*#__PURE__*/ $a2gHv.forwardRef(function CardActionArea(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, focusVisibleClassName = props.focusVisibleClassName, other = (0, $hmzQs.default)(props, [
        "children",
        "classes",
        "className",
        "focusVisibleClassName"
    ]);
    return /*#__PURE__*/ $a2gHv.createElement((0, $c97a62cb8718b66f$export$2e2bcd8739ae039), (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className),
        focusVisibleClassName: (0, $1r7hW.default)(focusVisibleClassName, classes.focusVisible),
        ref: ref
    }, other), children, /*#__PURE__*/ $a2gHv.createElement("span", {
        className: classes.focusHighlight
    }));
});
var $a91d22d305e073c5$export$2e2bcd8739ae039 = (0, $ljK7E.default)($a91d22d305e073c5$export$9dd6ff9ea0189349, {
    name: "MuiCardActionArea"
})($a91d22d305e073c5$var$CardActionArea);


var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $ljK7E = parcelRequire("ljK7E");
var $089b7780a33d27b4$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        padding: 16,
        "&:last-child": {
            paddingBottom: 24
        }
    }
};
var $089b7780a33d27b4$var$CardContent = /*#__PURE__*/ $a2gHv.forwardRef(function CardContent(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, other = (0, $hmzQs.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $a2gHv.createElement(Component, (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className),
        ref: ref
    }, other));
});
var $089b7780a33d27b4$export$2e2bcd8739ae039 = (0, $ljK7E.default)($089b7780a33d27b4$export$9dd6ff9ea0189349, {
    name: "MuiCardContent"
})($089b7780a33d27b4$var$CardContent);


var $hmzQs = parcelRequire("hmzQs");

var $kO11b = parcelRequire("kO11b");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $ljK7E = parcelRequire("ljK7E");


var $3b28009b0b9cdf5a$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $3b28009b0b9cdf5a$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
function $3b28009b0b9cdf5a$var$generateGrid(globalStyles, theme, breakpoint) {
    var styles = {};
    $3b28009b0b9cdf5a$var$GRID_SIZES.forEach(function(size) {
        var key = "grid-".concat(breakpoint, "-").concat(size);
        if (size === true) {
            // For the auto layouting
            styles[key] = {
                flexBasis: 0,
                flexGrow: 1,
                maxWidth: "100%"
            };
            return;
        }
        if (size === "auto") {
            styles[key] = {
                flexBasis: "auto",
                flexGrow: 0,
                maxWidth: "none"
            };
            return;
        } // Keep 7 significant numbers.
        var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
        // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
        styles[key] = {
            flexBasis: width,
            flexGrow: 0,
            maxWidth: width
        };
    }); // No need for a media query for the first size.
    if (breakpoint === "xs") (0, $kO11b.default)(globalStyles, styles);
    else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
}
function $3b28009b0b9cdf5a$var$getOffset(val) {
    var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var parse = parseFloat(val);
    return "".concat(parse / div).concat(String(val).replace(String(parse), "") || "px");
}
function $3b28009b0b9cdf5a$var$generateGutter(theme, breakpoint) {
    var styles = {};
    $3b28009b0b9cdf5a$var$SPACINGS.forEach(function(spacing) {
        var themeSpacing = theme.spacing(spacing);
        if (themeSpacing === 0) return;
        styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
            margin: "-".concat($3b28009b0b9cdf5a$var$getOffset(themeSpacing, 2)),
            width: "calc(100% + ".concat($3b28009b0b9cdf5a$var$getOffset(themeSpacing), ")"),
            "& > $item": {
                padding: $3b28009b0b9cdf5a$var$getOffset(themeSpacing, 2)
            }
        };
    });
    return styles;
} // Default CSS values
var $3b28009b0b9cdf5a$export$9dd6ff9ea0189349 = function styles(theme) {
    return (0, $kO11b.default)({
        /* Styles applied to the root element. */ root: {},
        /* Styles applied to the root element if `container={true}`. */ container: {
            boxSizing: "border-box",
            display: "flex",
            flexWrap: "wrap",
            width: "100%"
        },
        /* Styles applied to the root element if `item={true}`. */ item: {
            boxSizing: "border-box",
            margin: "0" // For instance, it's useful when used with a `figure` element.
        },
        /* Styles applied to the root element if `zeroMinWidth={true}`. */ zeroMinWidth: {
            minWidth: 0
        },
        /* Styles applied to the root element if `direction="column"`. */ "direction-xs-column": {
            flexDirection: "column"
        },
        /* Styles applied to the root element if `direction="column-reverse"`. */ "direction-xs-column-reverse": {
            flexDirection: "column-reverse"
        },
        /* Styles applied to the root element if `direction="row-reverse"`. */ "direction-xs-row-reverse": {
            flexDirection: "row-reverse"
        },
        /* Styles applied to the root element if `wrap="nowrap"`. */ "wrap-xs-nowrap": {
            flexWrap: "nowrap"
        },
        /* Styles applied to the root element if `wrap="reverse"`. */ "wrap-xs-wrap-reverse": {
            flexWrap: "wrap-reverse"
        },
        /* Styles applied to the root element if `alignItems="center"`. */ "align-items-xs-center": {
            alignItems: "center"
        },
        /* Styles applied to the root element if `alignItems="flex-start"`. */ "align-items-xs-flex-start": {
            alignItems: "flex-start"
        },
        /* Styles applied to the root element if `alignItems="flex-end"`. */ "align-items-xs-flex-end": {
            alignItems: "flex-end"
        },
        /* Styles applied to the root element if `alignItems="baseline"`. */ "align-items-xs-baseline": {
            alignItems: "baseline"
        },
        /* Styles applied to the root element if `alignContent="center"`. */ "align-content-xs-center": {
            alignContent: "center"
        },
        /* Styles applied to the root element if `alignContent="flex-start"`. */ "align-content-xs-flex-start": {
            alignContent: "flex-start"
        },
        /* Styles applied to the root element if `alignContent="flex-end"`. */ "align-content-xs-flex-end": {
            alignContent: "flex-end"
        },
        /* Styles applied to the root element if `alignContent="space-between"`. */ "align-content-xs-space-between": {
            alignContent: "space-between"
        },
        /* Styles applied to the root element if `alignContent="space-around"`. */ "align-content-xs-space-around": {
            alignContent: "space-around"
        },
        /* Styles applied to the root element if `justifyContent="center"`. */ "justify-content-xs-center": {
            justifyContent: "center"
        },
        /* Styles applied to the root element if `justifyContent="flex-end"`. */ "justify-content-xs-flex-end": {
            justifyContent: "flex-end"
        },
        /* Styles applied to the root element if `justifyContent="space-between"`. */ "justify-content-xs-space-between": {
            justifyContent: "space-between"
        },
        /* Styles applied to the root element if `justifyContent="space-around"`. */ "justify-content-xs-space-around": {
            justifyContent: "space-around"
        },
        /* Styles applied to the root element if `justifyContent="space-evenly"`. */ "justify-content-xs-space-evenly": {
            justifyContent: "space-evenly"
        }
    }, $3b28009b0b9cdf5a$var$generateGutter(theme, "xs"), theme.breakpoints.keys.reduce(function(accumulator, key) {
        // Use side effect over immutability for better performance.
        $3b28009b0b9cdf5a$var$generateGrid(accumulator, theme, key);
        return accumulator;
    }, {}));
};
var $3b28009b0b9cdf5a$var$Grid = /*#__PURE__*/ $a2gHv.forwardRef(function Grid(props, ref) {
    var _props$alignContent = props.alignContent, alignContent = _props$alignContent === void 0 ? "stretch" : _props$alignContent, _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? "stretch" : _props$alignItems, classes = props.classes, classNameProp = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$container = props.container, container = _props$container === void 0 ? false : _props$container, _props$direction = props.direction, direction = _props$direction === void 0 ? "row" : _props$direction, _props$item = props.item, item = _props$item === void 0 ? false : _props$item, justify = props.justify, _props$justifyContent = props.justifyContent, justifyContent = _props$justifyContent === void 0 ? "flex-start" : _props$justifyContent, _props$lg = props.lg, lg = _props$lg === void 0 ? false : _props$lg, _props$md = props.md, md = _props$md === void 0 ? false : _props$md, _props$sm = props.sm, sm = _props$sm === void 0 ? false : _props$sm, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 0 : _props$spacing, _props$wrap = props.wrap, wrap = _props$wrap === void 0 ? "wrap" : _props$wrap, _props$xl = props.xl, xl = _props$xl === void 0 ? false : _props$xl, _props$xs = props.xs, xs = _props$xs === void 0 ? false : _props$xs, _props$zeroMinWidth = props.zeroMinWidth, zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth, other = (0, $hmzQs.default)(props, [
        "alignContent",
        "alignItems",
        "classes",
        "className",
        "component",
        "container",
        "direction",
        "item",
        "justify",
        "justifyContent",
        "lg",
        "md",
        "sm",
        "spacing",
        "wrap",
        "xl",
        "xs",
        "zeroMinWidth"
    ]);
    var className = (0, $1r7hW.default)(classes.root, classNameProp, container && [
        classes.container,
        spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]
    ], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== "row" && classes["direction-xs-".concat(String(direction))], wrap !== "wrap" && classes["wrap-xs-".concat(String(wrap))], alignItems !== "stretch" && classes["align-items-xs-".concat(String(alignItems))], alignContent !== "stretch" && classes["align-content-xs-".concat(String(alignContent))], (justify || justifyContent) !== "flex-start" && classes["justify-content-xs-".concat(String(justify || justifyContent))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
    return /*#__PURE__*/ $a2gHv.createElement(Component, (0, $kO11b.default)({
        className: className,
        ref: ref
    }, other));
});
var $3b28009b0b9cdf5a$var$StyledGrid = (0, $ljK7E.default)($3b28009b0b9cdf5a$export$9dd6ff9ea0189349, {
    name: "MuiGrid"
})($3b28009b0b9cdf5a$var$Grid);
var $3b28009b0b9cdf5a$var$requireProp;
var $3b28009b0b9cdf5a$export$2e2bcd8739ae039 = $3b28009b0b9cdf5a$var$StyledGrid;



// TODO: Resize the size of categories since some are too long to fit; make taller
function $e1cd06dd3277338f$var$BoardClue({ clue: clue, id: id, selectClue: selectClue }) {
    if (!clue) return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $3b28009b0b9cdf5a$export$2e2bcd8739ae039), {
        item: true,
        xs: 2
    }, id);
    let clueProps = {
        style: {}
    };
    switch(clue.status){
        case $d27ec4b38469a174$exports.Status.UNPLAYED:
            break;
        case $d27ec4b38469a174$exports.Status.INPLAY:
            clueProps.style = {
                background: "#6C6CE0"
            };
            break;
        case $d27ec4b38469a174$exports.Status.PLAYED:
            clueProps.style = {
                background: "#333333"
            };
            break;
    }
    if (selectClue) clueProps = {
        ...clueProps,
        onClick: ()=>selectClue(id)
    };
    const onClickFunction = selectClue ? ()=>selectClue(id) : ()=>{};
    const isDisabled = clue.status === $d27ec4b38469a174$exports.Status.PLAYED;
    const isPrimary = clue.status === $d27ec4b38469a174$exports.Status.INPLAY;
    let color = "primary";
    if (isPrimary) color = undefined;
    return(// todo: better handling of final jeopardy
    /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $3b28009b0b9cdf5a$export$2e2bcd8739ae039), {
        item: true,
        xs: 2,
        zeroMinWidth: true,
        children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $57558111709a20ab$export$2e2bcd8739ae039), {
            style: {
                padding: 12
            },
            children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $a91d22d305e073c5$export$2e2bcd8739ae039), {
                onClick: onClickFunction,
                disabled: isDisabled,
                children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                    color: color,
                    align: "center",
                    children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)("strong", {
                        children: !isDisabled ? clue.value || "Final Jeopardy" : "\xa0"
                    })
                })
            })
        })
    }, id));
}
function $e1cd06dd3277338f$export$2e2bcd8739ae039({ currentRound: currentRound, selectClue: selectClue }) {
    return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $3b28009b0b9cdf5a$export$2e2bcd8739ae039), {
        container: true,
        spacing: 1,
        alignItems: "stretch",
        children: [
            currentRound.categories.map((cat)=>/*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $3b28009b0b9cdf5a$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 2,
                    style: {
                        marginBottom: 10
                    },
                    children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $57558111709a20ab$export$2e2bcd8739ae039), {
                        style: {
                            height: "100%"
                        },
                        children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $089b7780a33d27b4$export$2e2bcd8739ae039), {
                            style: {
                                padding: 20,
                                height: "100%"
                            },
                            children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                                align: "center",
                                style: {
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    placeItems: "center"
                                },
                                children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)("strong", {
                                    children: cat
                                })
                            })
                        })
                    })
                }, cat)),
            currentRound.clues.map((row, row_number)=>row.map((clue, col_number)=>{
                    const id = 6 * row_number + col_number;
                    return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)($e1cd06dd3277338f$var$BoardClue, {
                        clue: clue,
                        id: id,
                        selectClue: selectClue
                    }, id);
                }))
        ]
    });
}



parcelRequire("a2gHv");

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $ljK7E = parcelRequire("ljK7E");
var $7cc9311a90bc1adb$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "flex",
        alignItems: "center",
        padding: 8
    },
    /* Styles applied to the root element if `disableSpacing={false}`. */ spacing: {
        "& > :not(:first-child)": {
            marginLeft: 8
        }
    }
};
var $7cc9311a90bc1adb$var$CardActions = /*#__PURE__*/ $a2gHv.forwardRef(function CardActions(props, ref) {
    var _props$disableSpacing = props.disableSpacing, disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing, classes = props.classes, className = props.className, other = (0, $hmzQs.default)(props, [
        "disableSpacing",
        "classes",
        "className"
    ]);
    return /*#__PURE__*/ $a2gHv.createElement("div", (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className, !disableSpacing && classes.spacing),
        ref: ref
    }, other));
});
var $7cc9311a90bc1adb$export$2e2bcd8739ae039 = (0, $ljK7E.default)($7cc9311a90bc1adb$export$9dd6ff9ea0189349, {
    name: "MuiCardActions"
})($7cc9311a90bc1adb$var$CardActions);




var $a2gHv = parcelRequire("a2gHv");

function $e62bebf7a330657e$export$2e2bcd8739ae039({ submitWager: submitWager, validateWager: validateWager }) {
    const [hasSubmitted, setHasSubmitted] = (0, $a2gHv.useState)(false);
    const [wager, setWager] = (0, $a2gHv.useState)(0);
    const [displayWager, setDisplayWager] = (0, $a2gHv.useState)("");
    const updateWagers = (wager)=>{
        setWager(Number(wager));
        setDisplayWager(wager);
    };
    const sendWager = ()=>{
        if (!hasSubmitted) submitWager(wager);
        setHasSubmitted(true);
    };
    return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $c913521d1795623a$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $c565a04f3d63af3f$export$2e2bcd8739ae039), {
                fullWidth: true,
                margin: "normal",
                label: "Wager Amount",
                type: "number",
                variant: "outlined",
                error: validateWager(wager) ? true : false,
                helperText: validateWager(wager),
                value: displayWager,
                onChange: (e)=>updateWagers(e.target.value)
            }),
            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $34124a96edc1da32$export$2e2bcd8739ae039), {
                variant: "outlined",
                color: "primary",
                onClick: sendWager,
                disabled: validateWager(wager) ? true : false,
                children: "Submit"
            })
        ]
    });
}



function $9be567f56fd64721$export$2e2bcd8739ae039({ isAdmin: isAdmin, currentClue: currentClue, closeClue: closeClue, controlsBoard: controlsBoard, currentScore: currentScore, submitWager: sendWagerFunc, dailyDoubleWager: dailyDoubleWager, buzzedInTeam: buzzedInTeam, modifyScore: modifyScore, teamInControl: teamInControl }) {
    let checkDailyDoubleWagerFunc = (wager)=>{
        const maxWager = Math.max(currentScore, currentClue.value);
        if (wager > maxWager) return "Maximum wager is " + maxWager.toString();
        else if (wager <= 0) return "You must wager some money.";
    };
    // Probably fine to have this be local state, but if a person refreshes
    // the page they will be able to submit again. With the input likely ignored
    const clueValue = currentClue.dailyDouble ? dailyDoubleWager : currentClue.value;
    const team = currentClue.dailyDouble ? teamInControl : buzzedInTeam;
    const canShowQuestion = isAdmin || !currentClue.dailyDouble || currentClue.dailyDouble && dailyDoubleWager !== $d27ec4b38469a174$exports.NO_DAILY_DOUBLE_WAGER;
    return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $57558111709a20ab$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $089b7780a33d27b4$export$2e2bcd8739ae039), {
                children: [
                    currentClue.dailyDouble && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                        gutterBottom: true,
                        variant: "h5",
                        children: "Daily Double!"
                    }),
                    /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                        gutterBottom: true,
                        variant: "h5",
                        color: "primary",
                        children: [
                            currentClue.value,
                            " points"
                        ]
                    }),
                    controlsBoard && currentClue.dailyDouble && dailyDoubleWager === $d27ec4b38469a174$exports.NO_DAILY_DOUBLE_WAGER && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $e62bebf7a330657e$export$2e2bcd8739ae039), {
                        submitWager: sendWagerFunc,
                        validateWager: checkDailyDoubleWagerFunc
                    }),
                    canShowQuestion && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                        variant: "body1",
                        component: "p",
                        children: [
                            currentClue.media && "Media clue:",
                            " ",
                            currentClue.question
                        ]
                    }),
                    isAdmin && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                        variant: "body2",
                        component: "p",
                        color: "textSecondary",
                        children: [
                            "Answer: ",
                            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)("em", {
                                children: currentClue.answer
                            })
                        ]
                    })
                ]
            }),
            isAdmin && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $7cc9311a90bc1adb$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $34124a96edc1da32$export$2e2bcd8739ae039), {
                        color: "secondary",
                        onClick: ()=>modifyScore(team, -clueValue),
                        disabled: team === "" || clueValue === $d27ec4b38469a174$exports.NO_DAILY_DOUBLE_WAGER,
                        children: "Incorrect"
                    }),
                    /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $34124a96edc1da32$export$2e2bcd8739ae039), {
                        color: "primary",
                        onClick: ()=>modifyScore(team, clueValue),
                        disabled: team === "" || clueValue === $d27ec4b38469a174$exports.NO_DAILY_DOUBLE_WAGER,
                        children: "Correct"
                    }),
                    /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $34124a96edc1da32$export$2e2bcd8739ae039), {
                        onClick: closeClue,
                        style: {
                            marginLeft: "auto"
                        },
                        disabled: currentClue.dailyDouble,
                        children: "Close"
                    })
                ]
            })
        ]
    });
}




var $a2gHv = parcelRequire("a2gHv");

var $kO11b = parcelRequire("kO11b");

var $lbAml = parcelRequire("lbAml");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");

var $1r7hW = parcelRequire("1r7hW");




var $ljK7E = parcelRequire("ljK7E");

var $bd5qU = parcelRequire("bd5qU");




var $ed851d2ae4d940ef$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            height: 0,
            overflow: "hidden",
            transition: theme.transitions.create("height")
        },
        /* Styles applied to the root element when the transition has entered. */ entered: {
            height: "auto",
            overflow: "visible"
        },
        /* Styles applied to the root element when the transition has exited and `collapsedSize` != 0px. */ hidden: {
            visibility: "hidden"
        },
        /* Styles applied to the outer wrapper element. */ wrapper: {
            // Hack to get children with a negative margin to not falsify the height computation.
            display: "flex"
        },
        /* Styles applied to the inner wrapper element. */ wrapperInner: {
            width: "100%"
        }
    };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $ed851d2ae4d940ef$var$Collapse = /*#__PURE__*/ $a2gHv.forwardRef(function Collapse(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, collapsedHeight = props.collapsedHeight, _props$collapsedSize = props.collapsedSize, collapsedSizeProp = _props$collapsedSize === void 0 ? "0px" : _props$collapsedSize, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? (0, $bd5qU.duration).standard : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $8c5f27b528517b1a$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $hmzQs.default)(props, [
        "children",
        "classes",
        "className",
        "collapsedHeight",
        "collapsedSize",
        "component",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var theme = (0, $8cf1e6908f234c8c$export$2e2bcd8739ae039)();
    var timer = $a2gHv.useRef();
    var wrapperRef = $a2gHv.useRef(null);
    var autoTransitionDuration = $a2gHv.useRef();
    var collapsedSize = typeof (collapsedHeight || collapsedSizeProp) === "number" ? "".concat(collapsedHeight || collapsedSizeProp, "px") : collapsedHeight || collapsedSizeProp;
    $a2gHv.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $a2gHv.useRef(null);
    var handleRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(ref, enableStrictModeCompat ? nodeRef : undefined);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $lbAml.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        node.style.height = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntering = normalizedTransitionCallback(function(node, isAppearing) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        var _getTransitionProps = (0, $1664af78c1ef4732$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "enter"
        }), transitionDuration = _getTransitionProps.duration;
        if (timeout === "auto") {
            var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
            node.style.transitionDuration = "".concat(duration2, "ms");
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : "".concat(transitionDuration, "ms");
        node.style.height = "".concat(wrapperHeight, "px");
        if (onEntering) onEntering(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(function(node, isAppearing) {
        node.style.height = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    var handleExit = normalizedTransitionCallback(function(node) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        node.style.height = "".concat(wrapperHeight, "px");
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var handleExiting = normalizedTransitionCallback(function(node) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        var _getTransitionProps2 = (0, $1664af78c1ef4732$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "exit"
        }), transitionDuration = _getTransitionProps2.duration;
        if (timeout === "auto") {
            var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
            node.style.transitionDuration = "".concat(duration2, "ms");
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : "".concat(transitionDuration, "ms");
        node.style.height = collapsedSize;
        if (onExiting) onExiting(node);
    });
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === "auto") timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    };
    return /*#__PURE__*/ $a2gHv.createElement(TransitionComponent, (0, $kO11b.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        timeout: timeout === "auto" ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $a2gHv.createElement(Component, (0, $kO11b.default)({
            className: (0, $1r7hW.default)(classes.root, classes.container, className, {
                "entered": classes.entered,
                "exited": !inProp && collapsedSize === "0px" && classes.hidden
            }[state]),
            style: (0, $kO11b.default)({
                minHeight: collapsedSize
            }, style),
            ref: handleRef
        }, childProps), /*#__PURE__*/ $a2gHv.createElement("div", {
            className: classes.wrapper,
            ref: wrapperRef
        }, /*#__PURE__*/ $a2gHv.createElement("div", {
            className: classes.wrapperInner
        }, children)));
    });
});
$ed851d2ae4d940ef$var$Collapse.muiSupportAuto = true;
var $ed851d2ae4d940ef$export$2e2bcd8739ae039 = (0, $ljK7E.default)($ed851d2ae4d940ef$export$9dd6ff9ea0189349, {
    name: "MuiCollapse"
})($ed851d2ae4d940ef$var$Collapse);



var $kO11b = parcelRequire("kO11b");

var $f8Yg6 = parcelRequire("f8Yg6");

var $hhxkg = parcelRequire("hhxkg");
function $f63ffd3a20e89ad9$var$makeStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, $f8Yg6.default)(stylesOrCreator, (0, $kO11b.default)({
        defaultTheme: (0, $hhxkg.default)
    }, options));
}
var $f63ffd3a20e89ad9$export$2e2bcd8739ae039 = $f63ffd3a20e89ad9$var$makeStyles;



var $kY4ps = parcelRequire("kY4ps");
var $hGwc0 = parcelRequire("hGwc0");

const $d763388109c930a9$var$useStyles = (0, $f63ffd3a20e89ad9$export$2e2bcd8739ae039)(()=>({
        buzzedInCard: {
            border: "2px solid",
            borderColor: (0, $hGwc0.default)[500],
            borderRadius: 6
        },
        inControlCard: {
            border: "2px solid",
            borderColor: (0, $kY4ps.default)[400],
            borderRadius: 6
        },
        card: {}
    }));
function $d763388109c930a9$export$2e2bcd8739ae039({ contestants: contestants, currentClue: currentClue, modifyScore: modifyScore, setScore: setScore, removeContestant: removeContestant, isAdmin: isAdmin, buzzedInTeam: buzzedInTeam, myTeam: myTeam, teamInControl: teamInControl }) {
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).useState(false);
    const styles = $d763388109c930a9$var$useStyles();
    if (!contestants) return null;
    const teamNames = Object.keys(contestants);
    const handleExpandClick = ()=>{
        setExpanded(!expanded);
    };
    return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $e7ff860c3d8cb912$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $3b28009b0b9cdf5a$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            children: [
                teamNames.map((name)=>{
                    const team = contestants[name];
                    const players = team.players;
                    let style = styles.card;
                    if (name === teamInControl) style = styles.inControlCard;
                    if (name === buzzedInTeam) style = styles.buzzedInCard;
                    return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $3b28009b0b9cdf5a$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 6,
                        sm: 4,
                        md: 2,
                        children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $57558111709a20ab$export$2e2bcd8739ae039), {
                            className: style,
                            id: name,
                            children: [
                                /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $089b7780a33d27b4$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                                            variant: "h6",
                                            color: "primary",
                                            children: name
                                        }),
                                        players.length > 1 && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                                            variant: "h6",
                                            children: players.join(", ")
                                        }),
                                        /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                                            variant: "body1",
                                            component: "p",
                                            children: [
                                                team.score,
                                                " points"
                                            ]
                                        }),
                                        team.dailyDoubleWager !== $d27ec4b38469a174$exports.NO_DAILY_DOUBLE_WAGER && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)("p", {
                                            children: [
                                                "Wager ",
                                                team.dailyDoubleWager
                                            ]
                                        }),
                                        team.buzzInTime !== $d27ec4b38469a174$exports.NO_BUZZ_IN_TIME && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)("p", {
                                            children: [
                                                "Buzz in ",
                                                team.buzzInTime / 1000,
                                                "s"
                                            ]
                                        })
                                    ]
                                }),
                                isAdmin && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $ed851d2ae4d940ef$export$2e2bcd8739ae039), {
                                    in: expanded,
                                    timeout: "auto",
                                    unmountOnExit: true,
                                    children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $089b7780a33d27b4$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $c565a04f3d63af3f$export$2e2bcd8739ae039), {
                                                id: "text-input-id",
                                                label: "Score",
                                                variant: "outlined",
                                                onChange: (e)=>{
                                                    if (e.target.value) setScore(name, Number(e.target.value));
                                                }
                                            }),
                                            isAdmin && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $34124a96edc1da32$export$2e2bcd8739ae039), {
                                                onClick: ()=>removeContestant(name),
                                                children: "Remove"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, name)
                    }, name);
                }),
                isAdmin && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $3b28009b0b9cdf5a$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 1,
                    children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $34124a96edc1da32$export$2e2bcd8739ae039), {
                        onClick: handleExpandClick,
                        "aria-expanded": expanded,
                        "aria-label": "edit contestants",
                        children: "Edit"
                    })
                })
            ]
        })
    });
}



parcelRequire("a2gHv");





var $a2gHv = parcelRequire("a2gHv");

var $hmzQs = parcelRequire("hmzQs");

var $epFuc = parcelRequire("epFuc");

var $kO11b = parcelRequire("kO11b");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $ljK7E = parcelRequire("ljK7E");

var $bd5qU = parcelRequire("bd5qU");

var $a2gHv = parcelRequire("a2gHv");






function $cdaf424b93ea759e$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $cdaf424b93ea759e$var$clickedRootScrollbar(event) {
    return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */ function $cdaf424b93ea759e$var$ClickAwayListener(props) {
    var children = props.children, _props$disableReactTr = props.disableReactTree, disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr, _props$mouseEvent = props.mouseEvent, mouseEvent = _props$mouseEvent === void 0 ? "onClick" : _props$mouseEvent, onClickAway = props.onClickAway, _props$touchEvent = props.touchEvent, touchEvent = _props$touchEvent === void 0 ? "onTouchEnd" : _props$touchEvent;
    var movedRef = $a2gHv.useRef(false);
    var nodeRef = $a2gHv.useRef(null);
    var activatedRef = $a2gHv.useRef(false);
    var syntheticEventRef = $a2gHv.useRef(false);
    $a2gHv.useEffect(function() {
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(function() {
            activatedRef.current = true;
        }, 0);
        return function() {
            activatedRef.current = false;
        };
    }, []); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $a2gHv.useCallback(function(instance) {
        // #StrictMode ready
        nodeRef.current = $fcd36364b46ce6ed$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    var handleClickAway = (0, $73a36d95a5fcfdd3$export$2e2bcd8739ae039)(function(event) {
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        var insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || $cdaf424b93ea759e$var$clickedRootScrollbar(event)) return;
         // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else {
            // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
            var doc = (0, $a773b260c1b71dbc$export$2e2bcd8739ae039)(nodeRef.current);
            insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        }
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    }); // Keep track of mouse/touch events that bubbled up through the portal.
    var createHandleSynthetic = function createHandleSynthetic(handlerName) {
        return function(event) {
            syntheticEventRef.current = true;
            var childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    };
    var childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $a2gHv.useEffect(function() {
        if (touchEvent !== false) {
            var mappedTouchEvent = $cdaf424b93ea759e$var$mapEventPropToEvent(touchEvent);
            var doc = (0, $a773b260c1b71dbc$export$2e2bcd8739ae039)(nodeRef.current);
            var handleTouchMove = function handleTouchMove() {
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return function() {
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $a2gHv.useEffect(function() {
        if (mouseEvent !== false) {
            var mappedMouseEvent = $cdaf424b93ea759e$var$mapEventPropToEvent(mouseEvent);
            var doc = (0, $a773b260c1b71dbc$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return function() {
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $a2gHv.createElement($a2gHv.Fragment, null, /*#__PURE__*/ $a2gHv.cloneElement(children, childrenProps));
}
var $cdaf424b93ea759e$export$2e2bcd8739ae039 = $cdaf424b93ea759e$var$ClickAwayListener;




var $lrWdp = parcelRequire("lrWdp");




var $hmzQs = parcelRequire("hmzQs");

var $epFuc = parcelRequire("epFuc");

var $kO11b = parcelRequire("kO11b");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $ljK7E = parcelRequire("ljK7E");


var $3u5jc = parcelRequire("3u5jc");
var $2322d7c50792a1b9$export$9dd6ff9ea0189349 = function styles(theme) {
    var emphasis = theme.palette.type === "light" ? 0.8 : 0.98;
    var backgroundColor = (0, $3u5jc.emphasize)(theme.palette.background.default, emphasis);
    return {
        /* Styles applied to the root element. */ root: (0, $kO11b.default)({}, theme.typography.body2, (0, $epFuc.default)({
            color: theme.palette.getContrastText(backgroundColor),
            backgroundColor: backgroundColor,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            padding: "6px 16px",
            borderRadius: theme.shape.borderRadius,
            flexGrow: 1
        }, theme.breakpoints.up("sm"), {
            flexGrow: "initial",
            minWidth: 288
        })),
        /* Styles applied to the message wrapper element. */ message: {
            padding: "8px 0"
        },
        /* Styles applied to the action wrapper element if `action` is provided. */ action: {
            display: "flex",
            alignItems: "center",
            marginLeft: "auto",
            paddingLeft: 16,
            marginRight: -8
        }
    };
};
var $2322d7c50792a1b9$var$SnackbarContent = /*#__PURE__*/ $a2gHv.forwardRef(function SnackbarContent(props, ref) {
    var action = props.action, classes = props.classes, className = props.className, message = props.message, _props$role = props.role, role = _props$role === void 0 ? "alert" : _props$role, other = (0, $hmzQs.default)(props, [
        "action",
        "classes",
        "className",
        "message",
        "role"
    ]);
    return /*#__PURE__*/ $a2gHv.createElement((0, $79ae84c416f068ea$export$2e2bcd8739ae039), (0, $kO11b.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $1r7hW.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $a2gHv.createElement("div", {
        className: classes.message
    }, message), action ? /*#__PURE__*/ $a2gHv.createElement("div", {
        className: classes.action
    }, action) : null);
});
var $2322d7c50792a1b9$export$2e2bcd8739ae039 = (0, $ljK7E.default)($2322d7c50792a1b9$export$9dd6ff9ea0189349, {
    name: "MuiSnackbarContent"
})($2322d7c50792a1b9$var$SnackbarContent);


var $f2bd8677bb8c194d$export$9dd6ff9ea0189349 = function styles(theme) {
    var top1 = {
        top: 8
    };
    var bottom1 = {
        bottom: 8
    };
    var right = {
        justifyContent: "flex-end"
    };
    var left = {
        justifyContent: "flex-start"
    };
    var top3 = {
        top: 24
    };
    var bottom3 = {
        bottom: 24
    };
    var right3 = {
        right: 24
    };
    var left3 = {
        left: 24
    };
    var center = {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    };
    return {
        /* Styles applied to the root element. */ root: {
            zIndex: theme.zIndex.snackbar,
            position: "fixed",
            display: "flex",
            left: 8,
            right: 8,
            justifyContent: "center",
            alignItems: "center"
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */ anchorOriginTopCenter: (0, $kO11b.default)({}, top1, (0, $epFuc.default)({}, theme.breakpoints.up("sm"), (0, $kO11b.default)({}, top3, center))),
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */ anchorOriginBottomCenter: (0, $kO11b.default)({}, bottom1, (0, $epFuc.default)({}, theme.breakpoints.up("sm"), (0, $kO11b.default)({}, bottom3, center))),
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */ anchorOriginTopRight: (0, $kO11b.default)({}, top1, right, (0, $epFuc.default)({}, theme.breakpoints.up("sm"), (0, $kO11b.default)({
            left: "auto"
        }, top3, right3))),
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */ anchorOriginBottomRight: (0, $kO11b.default)({}, bottom1, right, (0, $epFuc.default)({}, theme.breakpoints.up("sm"), (0, $kO11b.default)({
            left: "auto"
        }, bottom3, right3))),
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */ anchorOriginTopLeft: (0, $kO11b.default)({}, top1, left, (0, $epFuc.default)({}, theme.breakpoints.up("sm"), (0, $kO11b.default)({
            right: "auto"
        }, top3, left3))),
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */ anchorOriginBottomLeft: (0, $kO11b.default)({}, bottom1, left, (0, $epFuc.default)({}, theme.breakpoints.up("sm"), (0, $kO11b.default)({
            right: "auto"
        }, bottom3, left3)))
    };
};
var $f2bd8677bb8c194d$var$Snackbar = /*#__PURE__*/ $a2gHv.forwardRef(function Snackbar(props, ref) {
    var action = props.action, _props$anchorOrigin = props.anchorOrigin;
    _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: "bottom",
        horizontal: "center"
    } : _props$anchorOrigin;
    var vertical = _props$anchorOrigin.vertical, horizontal = _props$anchorOrigin.horizontal, _props$autoHideDurati = props.autoHideDuration, autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati, children = props.children, classes = props.classes, className = props.className, ClickAwayListenerProps = props.ClickAwayListenerProps, ContentProps = props.ContentProps, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, message = props.message, onClose = props.onClose, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, open = props.open, resumeHideDuration = props.resumeHideDuration, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $e5da9ad8be7c181b$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? {
        enter: (0, $bd5qU.duration).enteringScreen,
        exit: (0, $bd5qU.duration).leavingScreen
    } : _props$transitionDura, TransitionProps = props.TransitionProps, other = (0, $hmzQs.default)(props, [
        "action",
        "anchorOrigin",
        "autoHideDuration",
        "children",
        "classes",
        "className",
        "ClickAwayListenerProps",
        "ContentProps",
        "disableWindowBlurListener",
        "message",
        "onClose",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "onMouseEnter",
        "onMouseLeave",
        "open",
        "resumeHideDuration",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var timerAutoHide = $a2gHv.useRef();
    var _React$useState = $a2gHv.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var handleClose = (0, $73a36d95a5fcfdd3$export$2e2bcd8739ae039)(function() {
        if (onClose) onClose.apply(void 0, arguments);
    });
    var setAutoHideTimer = (0, $73a36d95a5fcfdd3$export$2e2bcd8739ae039)(function(autoHideDurationParam) {
        if (!onClose || autoHideDurationParam == null) return;
        clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(function() {
            handleClose(null, "timeout");
        }, autoHideDurationParam);
    });
    $a2gHv.useEffect(function() {
        if (open) setAutoHideTimer(autoHideDuration);
        return function() {
            clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]); // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    var handlePause = function handlePause() {
        clearTimeout(timerAutoHide.current);
    }; // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    var handleResume = $a2gHv.useCallback(function() {
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    var handleMouseEnter = function handleMouseEnter(event) {
        if (onMouseEnter) onMouseEnter(event);
        handlePause();
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (onMouseLeave) onMouseLeave(event);
        handleResume();
    };
    var handleClickAway = function handleClickAway(event) {
        if (onClose) onClose(event, "clickaway");
    };
    var handleExited = function handleExited() {
        setExited(true);
    };
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    $a2gHv.useEffect(function() {
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return function() {
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]); // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ $a2gHv.createElement((0, $cdaf424b93ea759e$export$2e2bcd8739ae039), (0, $kO11b.default)({
        onClickAway: handleClickAway
    }, ClickAwayListenerProps), /*#__PURE__*/ $a2gHv.createElement("div", (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, classes["anchorOrigin".concat((0, $lrWdp.default)(vertical)).concat((0, $lrWdp.default)(horizontal))], className),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: ref
    }, other), /*#__PURE__*/ $a2gHv.createElement(TransitionComponent, (0, $kO11b.default)({
        appear: true,
        in: open,
        onEnter: (0, $2d1f2023da2fae25$export$2e2bcd8739ae039)(handleEnter, onEnter),
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: (0, $2d1f2023da2fae25$export$2e2bcd8739ae039)(handleExited, onExited),
        onExiting: onExiting,
        timeout: transitionDuration,
        direction: vertical === "top" ? "down" : "up"
    }, TransitionProps), children || /*#__PURE__*/ $a2gHv.createElement((0, $2322d7c50792a1b9$export$2e2bcd8739ae039), (0, $kO11b.default)({
        message: message,
        action: action
    }, ContentProps)))));
});
var $f2bd8677bb8c194d$export$2e2bcd8739ae039 = (0, $ljK7E.default)($f2bd8677bb8c194d$export$9dd6ff9ea0189349, {
    flip: false,
    name: "MuiSnackbar"
})($f2bd8677bb8c194d$var$Snackbar);



var $hmzQs = parcelRequire("hmzQs");

var $kO11b = parcelRequire("kO11b");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $3u5jc = parcelRequire("3u5jc");
var $ljK7E = parcelRequire("ljK7E");


var $a2gHv = parcelRequire("a2gHv");

var $jMmZt = parcelRequire("jMmZt");
var /**
 * @ignore - internal component.
 */ $13a05e0a5028a36b$export$2e2bcd8739ae039 = (0, $jMmZt.default)(/*#__PURE__*/ $a2gHv.createElement("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");



var $a2gHv = parcelRequire("a2gHv");

var $jMmZt = parcelRequire("jMmZt");
var /**
 * @ignore - internal component.
 */ $45b077b736303870$export$2e2bcd8739ae039 = (0, $jMmZt.default)(/*#__PURE__*/ $a2gHv.createElement("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");



var $a2gHv = parcelRequire("a2gHv");

var $jMmZt = parcelRequire("jMmZt");
var /**
 * @ignore - internal component.
 */ $190f1ad378cc9cd3$export$2e2bcd8739ae039 = (0, $jMmZt.default)(/*#__PURE__*/ $a2gHv.createElement("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");



var $a2gHv = parcelRequire("a2gHv");

var $jMmZt = parcelRequire("jMmZt");
var /**
 * @ignore - internal component.
 */ $8e4ffeede23a3e77$export$2e2bcd8739ae039 = (0, $jMmZt.default)(/*#__PURE__*/ $a2gHv.createElement("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");



var $a2gHv = parcelRequire("a2gHv");

var $jMmZt = parcelRequire("jMmZt");
var /**
 * @ignore - internal component.
 */ $d81fbdb47041e8eb$export$2e2bcd8739ae039 = (0, $jMmZt.default)(/*#__PURE__*/ $a2gHv.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");




var $lrWdp = parcelRequire("lrWdp");
var $2e6a9e3662799fd1$export$9dd6ff9ea0189349 = function styles(theme) {
    var getColor = theme.palette.type === "light" ? (0, $3u5jc.darken) : (0, $3u5jc.lighten);
    var getBackgroundColor = theme.palette.type === "light" ? (0, $3u5jc.lighten) : (0, $3u5jc.darken);
    return {
        /* Styles applied to the root element. */ root: (0, $kO11b.default)({}, theme.typography.body2, {
            borderRadius: theme.shape.borderRadius,
            backgroundColor: "transparent",
            display: "flex",
            padding: "6px 16px"
        }),
        /* Styles applied to the root element if `variant="standard"` and `color="success"`. */ standardSuccess: {
            color: getColor(theme.palette.success.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.success.main, 0.9),
            "& $icon": {
                color: theme.palette.success.main
            }
        },
        /* Styles applied to the root element if `variant="standard"` and `color="info"`. */ standardInfo: {
            color: getColor(theme.palette.info.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.info.main, 0.9),
            "& $icon": {
                color: theme.palette.info.main
            }
        },
        /* Styles applied to the root element if `variant="standard"` and `color="warning"`. */ standardWarning: {
            color: getColor(theme.palette.warning.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.warning.main, 0.9),
            "& $icon": {
                color: theme.palette.warning.main
            }
        },
        /* Styles applied to the root element if `variant="standard"` and `color="error"`. */ standardError: {
            color: getColor(theme.palette.error.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.error.main, 0.9),
            "& $icon": {
                color: theme.palette.error.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="success"`. */ outlinedSuccess: {
            color: getColor(theme.palette.success.main, 0.6),
            border: "1px solid ".concat(theme.palette.success.main),
            "& $icon": {
                color: theme.palette.success.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="info"`. */ outlinedInfo: {
            color: getColor(theme.palette.info.main, 0.6),
            border: "1px solid ".concat(theme.palette.info.main),
            "& $icon": {
                color: theme.palette.info.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="warning"`. */ outlinedWarning: {
            color: getColor(theme.palette.warning.main, 0.6),
            border: "1px solid ".concat(theme.palette.warning.main),
            "& $icon": {
                color: theme.palette.warning.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="error"`. */ outlinedError: {
            color: getColor(theme.palette.error.main, 0.6),
            border: "1px solid ".concat(theme.palette.error.main),
            "& $icon": {
                color: theme.palette.error.main
            }
        },
        /* Styles applied to the root element if `variant="filled"` and `color="success"`. */ filledSuccess: {
            color: "#fff",
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.success.main
        },
        /* Styles applied to the root element if `variant="filled"` and `color="info"`. */ filledInfo: {
            color: "#fff",
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.info.main
        },
        /* Styles applied to the root element if `variant="filled"` and `color="warning"`. */ filledWarning: {
            color: "#fff",
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.warning.main
        },
        /* Styles applied to the root element if `variant="filled"` and `color="error"`. */ filledError: {
            color: "#fff",
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.error.main
        },
        /* Styles applied to the icon wrapper element. */ icon: {
            marginRight: 12,
            padding: "7px 0",
            display: "flex",
            fontSize: 22,
            opacity: 0.9
        },
        /* Styles applied to the message wrapper element. */ message: {
            padding: "8px 0"
        },
        /* Styles applied to the action wrapper element if `action` is provided. */ action: {
            display: "flex",
            alignItems: "center",
            marginLeft: "auto",
            paddingLeft: 16,
            marginRight: -8
        }
    };
};
var $2e6a9e3662799fd1$var$defaultIconMapping = {
    success: /*#__PURE__*/ $a2gHv.createElement((0, $13a05e0a5028a36b$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ $a2gHv.createElement((0, $45b077b736303870$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ $a2gHv.createElement((0, $190f1ad378cc9cd3$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ $a2gHv.createElement((0, $8e4ffeede23a3e77$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
var $2e6a9e3662799fd1$var$_ref = /*#__PURE__*/ $a2gHv.createElement((0, $d81fbdb47041e8eb$export$2e2bcd8739ae039), {
    fontSize: "small"
});
var $2e6a9e3662799fd1$var$Alert = /*#__PURE__*/ $a2gHv.forwardRef(function Alert(props, ref) {
    var action = props.action, children = props.children, classes = props.classes, className = props.className, _props$closeText = props.closeText, closeText = _props$closeText === void 0 ? "Close" : _props$closeText, color = props.color, icon = props.icon, _props$iconMapping = props.iconMapping, iconMapping = _props$iconMapping === void 0 ? $2e6a9e3662799fd1$var$defaultIconMapping : _props$iconMapping, onClose = props.onClose, _props$role = props.role, role = _props$role === void 0 ? "alert" : _props$role, _props$severity = props.severity, severity = _props$severity === void 0 ? "success" : _props$severity, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $hmzQs.default)(props, [
        "action",
        "children",
        "classes",
        "className",
        "closeText",
        "color",
        "icon",
        "iconMapping",
        "onClose",
        "role",
        "severity",
        "variant"
    ]);
    return /*#__PURE__*/ $a2gHv.createElement((0, $79ae84c416f068ea$export$2e2bcd8739ae039), (0, $kO11b.default)({
        role: role,
        square: true,
        elevation: 0,
        className: (0, $1r7hW.default)(classes.root, classes["".concat(variant).concat((0, $lrWdp.default)(color || severity))], className),
        ref: ref
    }, other), icon !== false ? /*#__PURE__*/ $a2gHv.createElement("div", {
        className: classes.icon
    }, icon || iconMapping[severity] || $2e6a9e3662799fd1$var$defaultIconMapping[severity]) : null, /*#__PURE__*/ $a2gHv.createElement("div", {
        className: classes.message
    }, children), action != null ? /*#__PURE__*/ $a2gHv.createElement("div", {
        className: classes.action
    }, action) : null, action == null && onClose ? /*#__PURE__*/ $a2gHv.createElement("div", {
        className: classes.action
    }, /*#__PURE__*/ $a2gHv.createElement((0, $48d49a7e403badb5$export$2e2bcd8739ae039), {
        size: "small",
        "aria-label": closeText,
        title: closeText,
        color: "inherit",
        onClick: onClose
    }, $2e6a9e3662799fd1$var$_ref)) : null);
});
var $2e6a9e3662799fd1$export$2e2bcd8739ae039 = (0, $ljK7E.default)($2e6a9e3662799fd1$export$9dd6ff9ea0189349, {
    name: "MuiAlert"
})($2e6a9e3662799fd1$var$Alert);


function $468a31bb20b25d36$var$Alert(props) {
    return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $2e6a9e3662799fd1$export$2e2bcd8739ae039), {
        elevation: 6,
        variant: "filled",
        ...props
    });
}
function $468a31bb20b25d36$export$2e2bcd8739ae039({ submit: submit }) {
    const [submission, setSubmission] = (0, $a2gHv.useState)("");
    const [snackbarOpen, setSnackbarOpen] = (0, $a2gHv.useState)(false);
    const onClickHandler = ()=>{
        submit(submission);
        setSnackbarOpen(true);
    };
    const handleClose = (event, reason)=>{
        if (reason === "clickaway") return;
        setSnackbarOpen(false);
    };
    return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $c913521d1795623a$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $c565a04f3d63af3f$export$2e2bcd8739ae039), {
                fullWidth: true,
                margin: "normal",
                label: "Final Jeopardy Answer",
                variant: "outlined",
                placeholder: "Enter answer",
                value: submission,
                onChange: (e)=>setSubmission(e.target.value)
            }),
            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $34124a96edc1da32$export$2e2bcd8739ae039), {
                variant: "outlined",
                color: "primary",
                onClick: onClickHandler,
                children: "Submit"
            }),
            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $f2bd8677bb8c194d$export$2e2bcd8739ae039), {
                open: snackbarOpen,
                autoHideDuration: 1500,
                onClose: handleClose,
                children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)($468a31bb20b25d36$var$Alert, {
                    onClose: handleClose,
                    severity: "info",
                    children: "Submitted"
                })
            })
        ]
    });
}


function $79d8e4249715f9c5$export$2e2bcd8739ae039({ finalJeopardyBoard: finalJeopardyBoard, team: team, isAdmin: isAdmin, isSpectator: isSpectator, submitWager: submitWager, submitFinal: submitFinal, currentScore: currentScore, wagersOpen: wagersOpen, closeWagers: closeWagers, closeSubmissions: closeSubmissions, submissionsOpen: submissionsOpen }) {
    // TOOD: Better error handling when there are no contestants
    let checkFinalJeopardyWager = (wager)=>{
        if (wager > currentScore) return "Maximum wager is " + currentScore;
        else if (wager < 0) return "You must wager some money.";
    };
    const canShowAnswer = !wagersOpen && isAdmin; // TODO reveal if all contestants answers are revealed
    // TODO: Consider centering submit/wager diaglogue on form
    return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $57558111709a20ab$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $089b7780a33d27b4$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                    variant: "h6",
                    color: "primary",
                    children: finalJeopardyBoard.categories[0]
                }),
                !wagersOpen && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                    variant: "subtitle1",
                    children: finalJeopardyBoard.clues[0][0].question
                }),
                canShowAnswer && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                    variant: "subtitle1",
                    color: "textSecondary",
                    children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)("em", {
                        children: finalJeopardyBoard.clues[0][0].answer
                    })
                }),
                !isAdmin && !isSpectator && team && team.finalJeopardyWager === $d27ec4b38469a174$exports.NO_FINAL_JEOPARDY_WAGER && wagersOpen && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $e62bebf7a330657e$export$2e2bcd8739ae039), {
                    submitWager: submitWager,
                    validateWager: checkFinalJeopardyWager
                }),
                !isAdmin && !isSpectator && team && submissionsOpen && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $468a31bb20b25d36$export$2e2bcd8739ae039), {
                    submit: submitFinal
                }),
                isAdmin && wagersOpen && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $34124a96edc1da32$export$2e2bcd8739ae039), {
                    variant: "contained",
                    color: "primary",
                    onClick: closeWagers,
                    children: "Close Wagering Period"
                }),
                isAdmin && !wagersOpen && submissionsOpen && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $34124a96edc1da32$export$2e2bcd8739ae039), {
                    variant: "contained",
                    color: "primary",
                    onClick: closeSubmissions,
                    children: "Close Submission Period"
                })
            ]
        })
    });
}



parcelRequire("a2gHv");


function $15b9a745c5edf6fa$export$2e2bcd8739ae039({ contestants: contestants, modifyScore: modifyScore, isAdmin: isAdmin, reveal: reveal, submissionsOpen: submissionsOpen, wageringOpen: wageringOpen }) {
    if (!contestants) return null;
    const teamNames = Object.keys(contestants);
    // Sort by score in ascending order
    teamNames.sort((t1, t2)=>{
        return contestants[t1].score - contestants[t2].score;
    });
    return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $3b28009b0b9cdf5a$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        children: teamNames.map((name)=>{
            var _contestants_name, _contestants_name1;
            let wager = contestants[name].finalJeopardyWager;
            let answer = contestants[name].submission;
            const revealed = contestants[name].revealed;
            answer = answer !== $d27ec4b38469a174$exports.NO_FINAL_JEOPARDY_SUBMISSION ? answer : "No answer";
            wager = wager !== $d27ec4b38469a174$exports.NO_FINAL_JEOPARDY_WAGER ? wager : 0;
            return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $3b28009b0b9cdf5a$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                sm: 4,
                md: 2,
                children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $57558111709a20ab$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $089b7780a33d27b4$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                                    variant: "h6",
                                    color: "primary",
                                    children: name
                                }),
                                isAdmin && !revealed && ((_contestants_name = contestants[name]) === null || _contestants_name === void 0 ? void 0 : _contestants_name.finalJeopardyWager) !== $d27ec4b38469a174$exports.NO_FINAL_JEOPARDY_WAGER && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                                    children: "Wager submitted"
                                }),
                                isAdmin && !revealed && ((_contestants_name1 = contestants[name]) === null || _contestants_name1 === void 0 ? void 0 : _contestants_name1.submission) !== $d27ec4b38469a174$exports.NO_FINAL_JEOPARDY_SUBMISSION && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                                    children: "Answer submitted"
                                }),
                                revealed && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    children: [
                                        " Answer: ",
                                        answer,
                                        " "
                                    ]
                                }),
                                revealed && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    children: [
                                        " Wager: ",
                                        wager
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $7cc9311a90bc1adb$export$2e2bcd8739ae039), {
                            children: [
                                isAdmin && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $34124a96edc1da32$export$2e2bcd8739ae039), {
                                    variant: "outlined",
                                    onClick: ()=>reveal(name),
                                    disabled: submissionsOpen || wageringOpen,
                                    children: "Reveal"
                                }),
                                isAdmin && revealed && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $e7ff860c3d8cb912$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $34124a96edc1da32$export$2e2bcd8739ae039), {
                                            color: "secondary",
                                            onClick: ()=>modifyScore(name, -wager),
                                            children: "Incorrect"
                                        }),
                                        /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $34124a96edc1da32$export$2e2bcd8739ae039), {
                                            color: "primary",
                                            onClick: ()=>modifyScore(name, wager),
                                            children: "Correct"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, name)
            }, name);
        })
    });
}




var $a2gHv = parcelRequire("a2gHv");

var $de654a56d92f46a1$exports = {};
"use strict";
var $f2629092a247ba76$exports = {};
function $f2629092a247ba76$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$f2629092a247ba76$exports = $f2629092a247ba76$var$_interopRequireDefault, $f2629092a247ba76$exports.__esModule = true, $f2629092a247ba76$exports["default"] = $f2629092a247ba76$exports;


var $2624e24997dc299b$exports = {};
var $63a77e299589c2ee$exports = {};
function $63a77e299589c2ee$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $63a77e299589c2ee$exports = $63a77e299589c2ee$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $63a77e299589c2ee$exports.__esModule = true, $63a77e299589c2ee$exports["default"] = $63a77e299589c2ee$exports, $63a77e299589c2ee$var$_typeof(o);
}
$63a77e299589c2ee$exports = $63a77e299589c2ee$var$_typeof, $63a77e299589c2ee$exports.__esModule = true, $63a77e299589c2ee$exports["default"] = $63a77e299589c2ee$exports;


var $2624e24997dc299b$var$_typeof = $63a77e299589c2ee$exports.default;
function $2624e24997dc299b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2624e24997dc299b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2624e24997dc299b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $2624e24997dc299b$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $2624e24997dc299b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
$2624e24997dc299b$exports = $2624e24997dc299b$var$_interopRequireWildcard, $2624e24997dc299b$exports.__esModule = true, $2624e24997dc299b$exports["default"] = $2624e24997dc299b$exports;


Object.defineProperty($de654a56d92f46a1$exports, "__esModule", {
    value: true
});
$de654a56d92f46a1$exports.default = void 0;

var $de654a56d92f46a1$var$React = $2624e24997dc299b$exports((parcelRequire("a2gHv")));

var $de654a56d92f46a1$var$_createSvgIcon = $f2629092a247ba76$exports((parcelRequire("4ae0y")));
var $de654a56d92f46a1$var$_default = (0, $de654a56d92f46a1$var$_createSvgIcon.default)(/*#__PURE__*/ $de654a56d92f46a1$var$React.createElement("path", {
    d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
}), "Share");
$de654a56d92f46a1$exports.default = $de654a56d92f46a1$var$_default;



function $72c2bbd121ed66ef$var$Alert(props) {
    return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $2e6a9e3662799fd1$export$2e2bcd8739ae039), {
        elevation: 6,
        variant: "filled",
        ...props
    });
}
function $72c2bbd121ed66ef$export$2e2bcd8739ae039({ shareableLink: shareableLink }) {
    const [open, setOpen] = (0, $a2gHv.useState)(false);
    const handleClick = ()=>{
        setOpen(true);
    };
    const handleClose = (event, reason)=>{
        if (reason === "clickaway") return;
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $e7ff860c3d8cb912$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $48d49a7e403badb5$export$2e2bcd8739ae039), {
                "aria-label": "share",
                size: "small",
                onClick: ()=>{
                    navigator.clipboard.writeText(shareableLink);
                    handleClick();
                },
                children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($de654a56d92f46a1$exports))), {})
            }),
            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $f2bd8677bb8c194d$export$2e2bcd8739ae039), {
                open: open,
                autoHideDuration: 3000,
                onClose: handleClose,
                children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)($72c2bbd121ed66ef$var$Alert, {
                    onClose: handleClose,
                    severity: "info",
                    children: "Link copied!"
                })
            })
        ]
    });
}



var $hmzQs = parcelRequire("hmzQs");

var $epFuc = parcelRequire("epFuc");

var $kO11b = parcelRequire("kO11b");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");

var $ljK7E = parcelRequire("ljK7E");

var $kO11b = parcelRequire("kO11b");

var $hmzQs = parcelRequire("hmzQs");

var $a2gHv = parcelRequire("a2gHv");


var $1r7hW = parcelRequire("1r7hW");


var $ljK7E = parcelRequire("ljK7E");





var $51f71752a7fef48e$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */ root: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            position: "relative",
            textDecoration: "none",
            width: "100%",
            boxSizing: "border-box",
            textAlign: "left",
            paddingTop: 8,
            paddingBottom: 8,
            "&$focusVisible": {
                backgroundColor: theme.palette.action.selected
            },
            "&$selected, &$selected:hover": {
                backgroundColor: theme.palette.action.selected
            },
            "&$disabled": {
                opacity: 0.5
            }
        },
        /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */ container: {
            position: "relative"
        },
        /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */ focusVisible: {},
        /* Styles applied to the `component` element if dense. */ dense: {
            paddingTop: 4,
            paddingBottom: 4
        },
        /* Styles applied to the `component` element if `alignItems="flex-start"`. */ alignItemsFlexStart: {
            alignItems: "flex-start"
        },
        /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the inner `component` element if `divider={true}`. */ divider: {
            borderBottom: "1px solid ".concat(theme.palette.divider),
            backgroundClip: "padding-box"
        },
        /* Styles applied to the inner `component` element if `disableGutters={false}`. */ gutters: {
            paddingLeft: 16,
            paddingRight: 16
        },
        /* Styles applied to the inner `component` element if `button={true}`. */ button: {
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shortest
            }),
            "&:hover": {
                textDecoration: "none",
                backgroundColor: theme.palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */ secondaryAction: {
            // Add some space to avoid collision as `ListItemSecondaryAction`
            // is absolutely positioned.
            paddingRight: 48
        },
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {}
    };
};
var $51f71752a7fef48e$var$useEnhancedEffect = typeof window === "undefined" ? $a2gHv.useEffect : $a2gHv.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ var $51f71752a7fef48e$var$ListItem = /*#__PURE__*/ $a2gHv.forwardRef(function ListItem(props, ref) {
    var _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? "center" : _props$alignItems, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$button = props.button, button = _props$button === void 0 ? false : _props$button, childrenProp = props.children, classes = props.classes, className = props.className, componentProp = props.component, _props$ContainerCompo = props.ContainerComponent, ContainerComponent = _props$ContainerCompo === void 0 ? "li" : _props$ContainerCompo, _props$ContainerProps = props.ContainerProps;
    _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
    var ContainerClassName = _props$ContainerProps.className, ContainerProps = (0, $hmzQs.default)(_props$ContainerProps, [
        "className"
    ]), _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$divider = props.divider, divider = _props$divider === void 0 ? false : _props$divider, focusVisibleClassName = props.focusVisibleClassName, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0, $hmzQs.default)(props, [
        "alignItems",
        "autoFocus",
        "button",
        "children",
        "classes",
        "className",
        "component",
        "ContainerComponent",
        "ContainerProps",
        "dense",
        "disabled",
        "disableGutters",
        "divider",
        "focusVisibleClassName",
        "selected"
    ]);
    var context = $a2gHv.useContext((0, $2cf1aca5422f2d75$export$2e2bcd8739ae039));
    var childContext = {
        dense: dense || context.dense || false,
        alignItems: alignItems
    };
    var listItemRef = $a2gHv.useRef(null);
    $51f71752a7fef48e$var$useEnhancedEffect(function() {
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    var children = $a2gHv.Children.toArray(childrenProp);
    var hasSecondaryAction = children.length && (0, $d5b3549fe549b228$export$2e2bcd8739ae039)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    var handleOwnRef = $a2gHv.useCallback(function(instance) {
        // #StrictMode ready
        listItemRef.current = $fcd36364b46ce6ed$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $9df4720cccd64f53$export$2e2bcd8739ae039)(handleOwnRef, ref);
    var componentProps = (0, $kO11b.default)({
        className: (0, $1r7hW.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
        disabled: disabled
    }, other);
    var Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $1r7hW.default)(classes.focusVisible, focusVisibleClassName);
        Component = (0, $c97a62cb8718b66f$export$2e2bcd8739ae039);
    }
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component; // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ $a2gHv.createElement((0, $2cf1aca5422f2d75$export$2e2bcd8739ae039).Provider, {
            value: childContext
        }, /*#__PURE__*/ $a2gHv.createElement(ContainerComponent, (0, $kO11b.default)({
            className: (0, $1r7hW.default)(classes.container, ContainerClassName),
            ref: handleRef
        }, ContainerProps), /*#__PURE__*/ $a2gHv.createElement(Component, componentProps, children), children.pop()));
    }
    return /*#__PURE__*/ $a2gHv.createElement((0, $2cf1aca5422f2d75$export$2e2bcd8739ae039).Provider, {
        value: childContext
    }, /*#__PURE__*/ $a2gHv.createElement(Component, (0, $kO11b.default)({
        ref: handleRef
    }, componentProps), children));
});
var $51f71752a7fef48e$export$2e2bcd8739ae039 = (0, $ljK7E.default)($51f71752a7fef48e$export$9dd6ff9ea0189349, {
    name: "MuiListItem"
})($51f71752a7fef48e$var$ListItem);


var $fe20f7a1c8dd7324$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $kO11b.default)({}, theme.typography.body1, (0, $epFuc.default)({
            minHeight: 48,
            paddingTop: 6,
            paddingBottom: 6,
            boxSizing: "border-box",
            width: "auto",
            overflow: "hidden",
            whiteSpace: "nowrap"
        }, theme.breakpoints.up("sm"), {
            minHeight: "auto"
        })),
        // TODO v5: remove
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: {},
        /* Styles applied to the root element if `selected={true}`. */ selected: {},
        /* Styles applied to the root element if dense. */ dense: (0, $kO11b.default)({}, theme.typography.body2, {
            minHeight: "auto"
        })
    };
};
var $fe20f7a1c8dd7324$var$MenuItem = /*#__PURE__*/ $a2gHv.forwardRef(function MenuItem(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "li" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, ListItemClasses = props.ListItemClasses, _props$role = props.role, role = _props$role === void 0 ? "menuitem" : _props$role, selected = props.selected, tabIndexProp = props.tabIndex, other = (0, $hmzQs.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "ListItemClasses",
        "role",
        "selected",
        "tabIndex"
    ]);
    var tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ $a2gHv.createElement((0, $51f71752a7fef48e$export$2e2bcd8739ae039), (0, $kO11b.default)({
        button: true,
        role: role,
        tabIndex: tabIndex,
        component: component,
        selected: selected,
        disableGutters: disableGutters,
        classes: (0, $kO11b.default)({
            dense: classes.dense
        }, ListItemClasses),
        className: (0, $1r7hW.default)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $fe20f7a1c8dd7324$export$2e2bcd8739ae039 = (0, $ljK7E.default)($fe20f7a1c8dd7324$export$9dd6ff9ea0189349, {
    name: "MuiMenuItem"
})($fe20f7a1c8dd7324$var$MenuItem);



const $44ab9a2efa914633$var$isLocalhost = Boolean(window.location.hostname === "localhost" || // [::1] is the IPv6 localhost address.
window.location.hostname === "[::1]" || // 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
class $44ab9a2efa914633$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).Component {
    // Similar to componentDidMount and componentDidUpdate:
    // Runs when a user first loads page
    componentDidMount() {
        let socket;
        if (this.props.serverUrl) // Use custom server URL if provided
        socket = new WebSocket(this.props.serverUrl);
        else if ($44ab9a2efa914633$var$isLocalhost) socket = new WebSocket("ws://localhost:8080");
        else socket = new WebSocket("wss://ws.jeoparty.fun/ws");
        this.apiClient.addSocket(socket);
        // This could be moved to the constructor
        // if (!this.apiClient.isAdmin) {
        //   this.apiClient.setTeamName(this.props.match.params.teamName)
        // }
        socket.onopen = this.apiClient.onSocketOpen;
        socket.onmessage = (event)=>{
            console.debug("got message");
            this.apiClient.onSocketMessage(event, this.state);
        };
        socket.onerror = this.apiClient.onSocketError;
        socket.onclose = this.apiClient.onSocketClose;
    }
    componentDidUpdate(prevProps) {
        if (this.props.teamName && prevProps.teamName !== this.props.teamName) {
            console.debug("did update");
            this.apiClient.setTeamName(this.props.teamName);
            if (this.props.player) this.apiClient.setPlayerName(this.props.player);
            this.apiClient.contestantRejoin();
        }
    }
    render() {
        const isAdmin = this.apiClient.isAdmin;
        const isSpectator = this.apiClient.isSpectator();
        let currentRound;
        if (this.state.currentRound !== undefined) switch(this.state.currentRound){
            case $d27ec4b38469a174$exports.Round.SINGLE:
                currentRound = this.state.singleJeopardy;
                break;
            case $d27ec4b38469a174$exports.Round.DOUBLE:
                currentRound = this.state.doubleJeopardy;
                break;
            case $d27ec4b38469a174$exports.Round.FINAL:
                currentRound = this.state.finalJeopardy;
                break;
            case $d27ec4b38469a174$exports.Round.DONE:
                break;
        }
        let cq = this.state.currentQuestion;
        let currentClue;
        if (currentRound && cq !== undefined && cq !== $d27ec4b38469a174$exports.NO_QUESTION) {
            const row = Math.floor(cq / 6);
            const col = cq % 6;
            currentClue = currentRound.clues[row][col];
        }
        let selectClue;
        if (isAdmin && !currentClue) selectClue = this.apiClient.selectClue;
        let roundName;
        switch(this.state.currentRound){
            case $d27ec4b38469a174$exports.Round.SINGLE:
                roundName = "Jeoparty!";
                break;
            case $d27ec4b38469a174$exports.Round.DOUBLE:
                roundName = "Double Jeoparty!";
                break;
            case $d27ec4b38469a174$exports.Round.FINAL:
                roundName = "FINAL JEOPARTY!!!";
                break;
            default:
                roundName = "";
        }
        let shareableLink = window.location.origin + "/" + this.props.sessionId;
        // sanity checks
        if (isAdmin !== (this.props.userType === $d27ec4b38469a174$exports.GUIUserType.ADMIN)) {
            console.error("admin state mismatch");
            return "error";
        }
        if (this.props.userType === $d27ec4b38469a174$exports.GUIUserType.PLAYER && (!this.props.teamName || !this.props.player)) {
            console.error("team or player should be defined");
            return "error";
        }
        return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $3b28009b0b9cdf5a$export$2e2bcd8739ae039), {
            container: true,
            spacing: 4,
            children: [
                /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $3b28009b0b9cdf5a$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    children: [
                        /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                            variant: "h4",
                            component: "h1",
                            color: "primary",
                            children: roundName
                        }),
                        !isAdmin && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                            variant: "subtitle1",
                            color: "textSecondary",
                            children: [
                                this.state.airdate,
                                "\xa0",
                                /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $72c2bbd121ed66ef$export$2e2bcd8739ae039), {
                                    shareableLink: shareableLink
                                })
                            ]
                        }),
                        isAdmin && this.apiClient.gameList.length > 0 && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $e7ff860c3d8cb912$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $6727a78a8880f40f$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $af8103b0cc26cda3$export$2e2bcd8739ae039), {
                                        value: this.state.airdate,
                                        variant: "outlined",
                                        onChange: (e)=>this.apiClient.selectGame(e.target.value),
                                        children: this.apiClient.gameList.map((item)=>/*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $fe20f7a1c8dd7324$export$2e2bcd8739ae039), {
                                                value: item,
                                                children: item
                                            }, item))
                                    })
                                }),
                                /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $72c2bbd121ed66ef$export$2e2bcd8739ae039), {
                                    shareableLink: shareableLink
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $3b28009b0b9cdf5a$export$2e2bcd8739ae039), {
                    item: true,
                    md: 8,
                    xs: 12,
                    children: [
                        currentRound !== undefined && this.state.currentRound !== $d27ec4b38469a174$exports.Round.FINAL && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $e1cd06dd3277338f$export$2e2bcd8739ae039), {
                            currentRound: currentRound,
                            selectClue: selectClue
                        }),
                        currentRound !== undefined && this.state.currentRound === $d27ec4b38469a174$exports.Round.FINAL && this.state.contestants && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $79d8e4249715f9c5$export$2e2bcd8739ae039), {
                            finalJeopardyBoard: currentRound,
                            team: this.state.contestants[this.props.teamName || ""],
                            submitWager: this.apiClient.sendWager,
                            submitFinal: this.apiClient.sendSubmission,
                            isAdmin: isAdmin,
                            isSpectator: isSpectator,
                            closeWagers: this.apiClient.closeWagers,
                            closeSubmissions: this.apiClient.closeSubmissions,
                            wagersOpen: this.state.finalJeopardyWagersOpen || false,
                            submissionsOpen: this.state.submissionsOpen || false,
                            currentScore: this.state.contestants && !isAdmin && !isSpectator ? this.state.contestants[this.apiClient.teamName].score : 0
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $3b28009b0b9cdf5a$export$2e2bcd8739ae039), {
                    item: true,
                    md: 4,
                    xs: 12,
                    children: [
                        !this.apiClient.isSpectator() && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $ee4ab827ff8e0618$export$2e2bcd8739ae039), {
                            isAdmin: isAdmin,
                            buzzerOpen: this.state.buzzerOpen ? this.state.buzzerOpen : false,
                            openClue: !!currentClue,
                            apiClientBuzz: this.apiClient.buzz,
                            openBuzzer: this.apiClient.openBuzzer
                        }),
                        currentClue !== undefined && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $9be567f56fd64721$export$2e2bcd8739ae039), {
                            currentClue: currentClue,
                            isAdmin: isAdmin,
                            buzzedInTeam: this.state.buzzedInTeam ? this.state.buzzedInTeam : "",
                            teamInControl: this.state.teamInControl ? this.state.teamInControl : "",
                            modifyScore: this.apiClient.modifyScore,
                            dailyDoubleWager: this.state.dailyDoubleWager ? this.state.dailyDoubleWager : $d27ec4b38469a174$exports.NO_DAILY_DOUBLE_WAGER,
                            closeClue: this.apiClient.closeClue,
                            controlsBoard: this.apiClient.teamName === this.state.teamInControl,
                            currentScore: this.state.contestants && !isAdmin && !isSpectator ? this.state.contestants[this.apiClient.teamName].score : 0,
                            submitWager: this.apiClient.sendWager
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $3b28009b0b9cdf5a$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $d763388109c930a9$export$2e2bcd8739ae039), {
                        contestants: this.state.contestants,
                        currentClue: currentClue,
                        isAdmin: isAdmin,
                        modifyScore: this.apiClient.modifyScore,
                        setScore: this.apiClient.setScore,
                        removeContestant: this.apiClient.removeContestant,
                        buzzedInTeam: this.state.buzzedInTeam,
                        myTeam: this.props.teamName,
                        teamInControl: this.state.teamInControl
                    })
                }),
                currentRound !== undefined && this.state.currentRound === $d27ec4b38469a174$exports.Round.FINAL && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $3b28009b0b9cdf5a$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    children: [
                        /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $93cbf38278f83b48$export$2e2bcd8739ae039), {
                            variant: "h5",
                            children: "Final Jeopardy Answers"
                        }),
                        /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $15b9a745c5edf6fa$export$2e2bcd8739ae039), {
                            contestants: this.state.contestants,
                            modifyScore: this.apiClient.modifyScore,
                            isAdmin: isAdmin,
                            reveal: this.apiClient.reveal,
                            wageringOpen: this.state.finalJeopardyWagersOpen || false,
                            submissionsOpen: this.state.submissionsOpen || false
                        })
                    ]
                })
            ]
        });
    }
    // TODO: Because of routing memory leak introduced by callback to this.setState in apiClient
    //       Follow the below link to fix it
    //       https://www.robinwieruch.de/react-warning-cant-call-setstate-on-an-unmounted-component
    constructor(props){
        super(props);
        this.state = {};
        let anAdmin = props.userType === $d27ec4b38469a174$exports.GUIUserType.ADMIN;
        this.apiClient = new (0, $6411eb162f43eccf$export$2e2bcd8739ae039)(this.setState.bind(this), anAdmin, props.sessionId, props.teamName, props.player);
    }
}



var $kO11b = parcelRequire("kO11b");

var $a2gHv = parcelRequire("a2gHv");


var $ljK7E = parcelRequire("ljK7E");

var $9d10fee954e833de$export$c0bb0b647f701bb5 = {
    WebkitFontSmoothing: "antialiased",
    // Antialiasing.
    MozOsxFontSmoothing: "grayscale",
    // Antialiasing.
    // Change from `box-sizing: content-box` so that `width`
    // is not affected by `padding` or `border`.
    boxSizing: "border-box"
};
var $9d10fee954e833de$export$32180ef41b15b513 = function body(theme) {
    return (0, $kO11b.default)({
        color: theme.palette.text.primary
    }, theme.typography.body2, {
        backgroundColor: theme.palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: theme.palette.common.white
        }
    });
};
var $9d10fee954e833de$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        "@global": {
            html: $9d10fee954e833de$export$c0bb0b647f701bb5,
            "*, *::before, *::after": {
                boxSizing: "inherit"
            },
            "strong, b": {
                fontWeight: theme.typography.fontWeightBold
            },
            body: (0, $kO11b.default)({
                margin: 0
            }, $9d10fee954e833de$export$32180ef41b15b513(theme), {
                // Add support for document.body.requestFullScreen().
                // Other elements, if background transparent, are not supported.
                "&::backdrop": {
                    backgroundColor: theme.palette.background.default
                }
            })
        }
    };
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $9d10fee954e833de$var$CssBaseline(props) {
    /* eslint-disable no-unused-vars */ var _props$children = props.children, children = _props$children === void 0 ? null : _props$children, classes = props.classes;
    /* eslint-enable no-unused-vars */ return /*#__PURE__*/ $a2gHv.createElement($a2gHv.Fragment, null, children);
}
var $9d10fee954e833de$export$2e2bcd8739ae039 = (0, $ljK7E.default)($9d10fee954e833de$export$9dd6ff9ea0189349, {
    name: "MuiCssBaseline"
})($9d10fee954e833de$var$CssBaseline);



var $hnlwu = parcelRequire("hnlwu");
var $kO11b = parcelRequire("kO11b");

var $a2gHv = parcelRequire("a2gHv");



var $6WN8R = parcelRequire("6WN8R");

var $k7gVl = parcelRequire("k7gVl");

var $1kVOJ = parcelRequire("1kVOJ");
function $10d2bd753fff351d$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        var mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $kO11b.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $10d2bd753fff351d$var$ThemeProvider(props) {
    var children = props.children, localTheme = props.theme;
    var outerTheme = (0, $k7gVl.default)();
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).useMemo(function() {
        var output = outerTheme === null ? localTheme : $10d2bd753fff351d$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $1kVOJ.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).createElement((0, $6WN8R.default).Provider, {
        value: theme
    }, children);
}
var $10d2bd753fff351d$export$2e2bcd8739ae039 = $10d2bd753fff351d$var$ThemeProvider;



var $epkEY = parcelRequire("epkEY");
var $kY4ps = parcelRequire("kY4ps");
var $hGwc0 = parcelRequire("hGwc0");

// https://material-ui.com/customization/theming/
// https://material.io/resources/color/
const $c8099f6012506ae7$var$muiTheme = (0, $hnlwu.default)({
    palette: {
        type: "dark",
        primary: {
            main: (0, $hGwc0.default)[500]
        },
        secondary: {
            main: (0, $epkEY.default)[400]
        },
        info: {
            main: (0, $kY4ps.default)[800]
        },
        background: {
            paper: "#343970"
        }
    },
    props: {
        MuiTypography: {
            variantMapping: {
                h4: "h1",
                h5: "h2",
                h6: "h3"
            }
        }
    },
    typography: {
        fontSize: 15,
        fontFamily: "Public Sans"
    }
});
function $c8099f6012506ae7$var$parseURL(url) {
    const urlPath = url.pathname;
    const urlParams = url.searchParams;
    const splitURL = urlPath.split("/");
    const session = splitURL[1];
    let userType = $d27ec4b38469a174$exports.GUIUserType.UNDEFINED;
    let player = undefined;
    let team = undefined;
    let server = undefined;
    if (session !== "") // parse team and player params
    switch(splitURL[2]){
        case "admin":
            userType = $d27ec4b38469a174$exports.GUIUserType.ADMIN;
            break;
        case "play":
            // parse out team and player names
            userType = $d27ec4b38469a174$exports.GUIUserType.PLAYER;
            player = urlParams.get("player") || undefined;
            team = urlParams.get("team") || player;
            break;
        case "watch":
            userType = $d27ec4b38469a174$exports.GUIUserType.OBSERVER;
            break;
    }
    // parse server URL parameter
    server = urlParams.get("server") || undefined;
    return {
        session: session,
        userType: userType,
        player: player,
        team: team,
        server: server
    };
}
function $c8099f6012506ae7$var$updateURL(session, userType, player, team, server) {
    const url = new URL(window.location.toString());
    url.pathname = "/" + session;
    switch(userType){
        case $d27ec4b38469a174$exports.GUIUserType.ADMIN:
            url.pathname += "/admin";
            break;
        case $d27ec4b38469a174$exports.GUIUserType.PLAYER:
            url.pathname += "/play";
            break;
        case $d27ec4b38469a174$exports.GUIUserType.OBSERVER:
            url.pathname += "/watch";
            break;
    }
    if (player) url.searchParams.set("player", player);
    if (team) url.searchParams.set("team", team);
    if (server) url.searchParams.set("server", server);
    const historyState = {
        session: session,
        userType: userType,
        player: player,
        team: team,
        server: server
    };
    console.log("pushing history state with new url", url.toString(), "and state object", historyState);
    window.history.pushState(historyState, "", url.toString());
}
function $c8099f6012506ae7$export$2e2bcd8739ae039() {
    const parsedURL = $c8099f6012506ae7$var$parseURL(new URL(window.location.toString()));
    // define state
    const [session, setSession] = (0, $a2gHv.useState)(parsedURL.session);
    const [userType, setUserType] = (0, $a2gHv.useState)(parsedURL.userType);
    const [player, setPlayer] = (0, $a2gHv.useState)(parsedURL.player);
    const [team, setTeam] = (0, $a2gHv.useState)(parsedURL.team || parsedURL.player); // behavior with no team is undefined, so we fallback on player name
    const [server, setServer] = (0, $a2gHv.useState)(parsedURL.server);
    (0, $a2gHv.useEffect)(()=>{
        // needed if user goes back or forward
        window.addEventListener("popstate", (event)=>{
            console.log("window popstate at location: " + document.location);
            if (event.state) {
                // use state that we earlier provided to history.pushState earlier if it exists
                console.log("popstate state: " + JSON.stringify(event.state));
                setSession(event.state.session);
                setUserType(event.state.userType);
                setPlayer(event.state.player);
                setTeam(event.state.team || event.state.player);
                setServer(event.state.server);
            } else {
                // otherwise parse the url again
                const parsedURL = $c8099f6012506ae7$var$parseURL(new URL(window.location.toString()));
                setSession(parsedURL.session);
                setUserType(parsedURL.userType);
                setPlayer(parsedURL.player);
                setTeam(parsedURL.team || parsedURL.player);
                setServer(parsedURL.server);
            }
        });
    });
    const updateAndGo = (sessionArg, userTypeArg, playerArg, teamArg, serverArg)=>{
        setSession(sessionArg);
        setUserType(userTypeArg);
        setPlayer(playerArg);
        setTeam(teamArg || playerArg); // behavior with no team is undefined, so we fallback on player name
        setServer(serverArg);
        $c8099f6012506ae7$var$updateURL(sessionArg, userTypeArg, playerArg, teamArg, serverArg);
    };
    const readyToPlay = session && session !== "" && userType && (userType === $d27ec4b38469a174$exports.GUIUserType.PLAYER && player && team || userType === $d27ec4b38469a174$exports.GUIUserType.ADMIN || userType === $d27ec4b38469a174$exports.GUIUserType.OBSERVER);
    return /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $10d2bd753fff351d$export$2e2bcd8739ae039), {
        theme: $c8099f6012506ae7$var$muiTheme,
        children: [
            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $9d10fee954e833de$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsxs)((0, $7aa797f1a6f09677$export$2e2bcd8739ae039), {
                maxWidth: "xl",
                style: {
                    padding: 20
                },
                children: [
                    !readyToPlay && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $12c7e78df5ae9427$export$2e2bcd8739ae039), {
                        sessionId: session,
                        userType: userType,
                        player: player,
                        teamName: team,
                        server: server,
                        goCallback: updateAndGo
                    }),
                    readyToPlay && /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $44ab9a2efa914633$export$2e2bcd8739ae039), {
                        sessionId: session,
                        userType: userType,
                        player: player,
                        teamName: team,
                        serverUrl: server
                    })
                ]
            })
        ]
    });
}


(0, (/*@__PURE__*/$parcel$interopDefault($fcd36364b46ce6ed$exports))).render(/*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a2gHv))).StrictMode, {
    children: /*#__PURE__*/ (0, $e7ff860c3d8cb912$exports.jsx)((0, $c8099f6012506ae7$export$2e2bcd8739ae039), {})
}), document.getElementById("root"));

})();
//# sourceMappingURL=index.e463beba.js.map
